import { createElementBlock as g, openBlock as h, createElementVNode as o, createCommentVNode as B, toDisplayString as j, renderSlot as ae, resolveComponent as Y, normalizeClass as z, createVNode as k, withCtx as P, createBlock as H, resolveDynamicComponent as ie, Fragment as se, renderList as fe, withKeys as Oe, withModifiers as xe, withDirectives as ht, vShow as S0, Transition as $n, normalizeStyle as Fe, createTextVNode as me, createStaticVNode as Dn, reactive as W0, effectScope as zl, watch as Ie, computed as $, defineComponent as Ee, ref as pe, onMounted as kn, onUnmounted as Sa, toRefs as li, nextTick as L0, unref as C, normalizeProps as pn, mergeProps as Xt, inject as Ln, toRef as Zn, watchEffect as ui, provide as On, guardReactiveProps as fr, isRef as M0, resolveDirective as Tr, toHandlers as hr, h as Yl, getCurrentInstance as Ar, vModelText as Vl } from "vue";
const S = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, r] of t)
    n[a] = r;
  return n;
}, Hl = {
  name: "LuxIconAdd",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Nl(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: `M11.5,0C5.159,0,0,5.159,0,11.5S5.159,23,11.5,23S23,17.841,23,11.5S17.841,0,11.5,0z M11.5,22C5.71,22,1,17.29,1,11.5
  		S5.71,1,11.5,1S22,5.71,22,11.5S17.29,22,11.5,22z` }, null, -1),
    o("path", { d: `M17.5,11H12V5.5C12,5.224,11.776,5,11.5,5S11,5.224,11,5.5V11H5.5C5.224,11,5,11.224,5,11.5S5.224,12,5.5,12H11v5.5
  		c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V12h5.5c0.276,0,0.5-0.224,0.5-0.5S17.776,11,17.5,11z` }, null, -1)
  ]));
}
const Rl = /* @__PURE__ */ S(Hl, [["render", Nl]]), Bl = {
  name: "LuxIconAlert",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Fl(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M11.3,24C5.1,24,0.1,19.1,0,12.7c-0.1-3.1,1.1-6,3.3-8.2C5.5,2.3,8.4,1.1,11.5,1c3.1,0,5.9,1.1,8.1,3.2
          c2.1,2.1,3.4,5,3.4,8.1l0,0c0.1,6.3-5,11.6-11.5,11.7C11.4,24,11.4,24,11.3,24z M11.7,2c-0.1,0-0.1,0-0.2,0
          C8.7,2.1,6,3.2,4,5.2c-2,2-3.1,4.7-3,7.5C1.1,18.6,5.7,23.1,11.5,23c5.9-0.1,10.6-4.9,10.5-10.7l0,0c0-2.8-1.2-5.4-3.1-7.4
          C17,3,14.4,2,11.7,2z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M11.5,14.5c-0.3,0-0.5-0.2-0.5-0.5V7c0-0.3,0.2-0.5,0.5-0.5S12,6.7,12,7v7C12,14.3,11.8,14.5,11.5,14.5z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M11.5,18.5c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.1,18.5,11.5,18.5z M11.5,17.5C11.5,17.5,11.5,17.5,11.5,17.5
          l0.5,0L11.5,17.5z` })
    ], -1)
  ]));
}
const ci = /* @__PURE__ */ S(Bl, [["render", Fl]]), jl = {
  name: "LuxIconApproved",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Wl(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M9.5,16c-0.1,0-0.3,0-0.4-0.1l-2.5-2.5c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l2.2,2.2l7.1-6.7c0.2-0.2,0.5-0.2,0.7,0
          s0.2,0.5,0,0.7l-7.5,7C9.7,16,9.6,16,9.5,16z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,24C5.4,24,0,18.6,0,12C0,5.4,5.4,0,12,0c6.6,0,12,5.4,12,12C24,18.6,18.6,24,12,24z M12,1C5.9,1,1,5.9,1,12
          s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z` })
    ], -1)
  ]));
}
const di = /* @__PURE__ */ S(jl, [["render", Wl]]), Ul = {
  name: "LuxIconArrowDown",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function ql(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", {
      stroke: "black",
      "stroke-width": "3",
      d: `M12,19c-0.1,0-0.3-0.1-0.4-0.2L0.1,5.8c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0L12,17.7L23.1,5.2
              c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-11.5,13C12.3,18.9,12.1,19,12,19z`
    }, null, -1)
  ]));
}
const fi = /* @__PURE__ */ S(Ul, [["render", ql]]), Gl = {
  name: "LuxIconArrowRight",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Kl(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: `M5.5,24c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.2-0.5,0-0.7L17.7,12L5.2,0.9C5,0.7,4.9,0.4,5.1,0.2c0.2-0.2,0.5-0.2,0.7,0
              l13,11.5c0.1,0.1,0.2,0.2,0.2,0.4s-0.1,0.3-0.2,0.4l-13,11.5C5.7,24,5.6,24,5.5,24z` }, null, -1)
  ]));
}
const Zl = /* @__PURE__ */ S(Gl, [["render", Kl]]), Xl = {
  name: "LuxIconArrowUp",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Jl(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", {
      stroke: "black",
      "stroke-width": "3",
      d: "M11.6,5.1L.1,18.1c-.2.2-.2.5,0,.7s.5.2.7,0L11.9,6.2l11.2,12.6c.2.2.5.2.7,0,.2-.2.2-.5,0-.7L12.3,5.2c0-.1-.3-.2-.4-.2s-.3.1-.3.1Z"
    }, null, -1)
  ]));
}
const hi = /* @__PURE__ */ S(Xl, [["render", Jl]]), Ql = {
  name: "LuxIconAscending",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function e2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("circle", {
      class: "st0",
      cx: "12",
      cy: "12",
      r: "2"
    }, null, -1),
    o("polygon", {
      class: "st1",
      points: "17.5,6.5 12,0.5 6.5,6.5 	"
    }, null, -1),
    o("polygon", {
      class: "st2",
      points: "6.5,17.5 12,23.5 17.5,17.5 	"
    }, null, -1)
  ]));
}
const t2 = /* @__PURE__ */ S(Ql, [["render", e2], ["__scopeId", "data-v-0853f743"]]), n2 = {
  name: "LuxIconBase",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The name of the icon to display. Also used as the accessible name of the icon.
     */
    iconName: {
      required: !1,
      type: String,
      default: ""
    },
    /**
     * The width of the icon. For square icons use values of `11px, 13px,
     * 16px, 24px, 36px, 48px, 64px` to follow visual heirachy set by
     * typography.
     */
    width: {
      type: [Number, String],
      default: 24
    },
    /**
     * The height of the icon. For square icons use values of `11px, 13px,
     * 16px, 24px, 36px, 48px, 64px` to follow visual heirachy set by
     * typography.
     */
    height: {
      type: [Number, String],
      default: 24
    },
    /**
     * The fill color of the SVG icon.
     */
    iconColor: {
      type: String,
      default: "currentColor"
    },
    /**
     * Hides decorative icon from screen readers
     */
    iconHide: {
      type: [String, Boolean],
      default: !1
    }
  },
  computed: {
    // Present the iconName prop in a format suitable for use as an element's ID.
    // Only ASCII letters, digits, '_', and '-' should be used in an id, per
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id
    iconTitleId() {
      return this.iconName.toLowerCase().replace(/[^\w\d\s-_]/g, "").trim().replace(/\s/g, "-");
    }
  }
}, a2 = { class: "lux-icon" }, r2 = ["width", "height", "aria-labelledby", "aria-hidden"], s2 = ["id"], i2 = ["fill"];
function o2(e, t, n, a, r, s) {
  return h(), g("div", a2, [
    (h(), g("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: n.width,
      height: n.height,
      viewBox: "0 0 24 24",
      "aria-labelledby": s.iconTitleId,
      "aria-hidden": n.iconHide,
      role: "img"
    }, [
      n.iconName ? (h(), g("title", {
        key: 0,
        id: s.iconTitleId,
        lang: "en"
      }, j(n.iconName), 9, s2)) : B("", !0),
      o("g", { fill: n.iconColor }, [
        ae(e.$slots, "default", {}, void 0, !0)
      ], 8, i2)
    ], 8, r2))
  ]);
}
const In = /* @__PURE__ */ S(n2, [["render", o2], ["__scopeId", "data-v-a0b79c7f"]]), l2 = {
  name: "LuxIconClock",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function u2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M12,24C5.4,24,0,18.6,0,12C0,5.4,5.4,0,12,0c6.6,0,12,5.4,12,12C24,18.6,18.6,24,12,24z M12,1C5.9,1,1,5.9,1,12
        s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M17.5,18c-0.1,0-0.2,0-0.3-0.1l-6-5.5C11.1,12.3,11,12.1,11,12V6.5C11,6.2,11.2,6,11.5,6S12,6.2,12,6.5v5.3l5.8,5.4
        c0.2,0.2,0.2,0.5,0,0.7C17.8,17.9,17.6,18,17.5,18z` })
    ], -1)
  ]));
}
const c2 = /* @__PURE__ */ S(l2, [["render", u2]]), d2 = {
  name: "LuxIconConsulting",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function f2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M10.5,13c-0.1,0-0.3-0.1-0.4-0.1L7.3,10H6.5C5.7,10,5,9.3,5,8.5v-7C5,0.7,5.7,0,6.5,0h11C18.3,0,19,0.7,19,1.5v7
          c0,0.8-0.7,1.5-1.5,1.5H11v2.5c0,0.2-0.1,0.4-0.3,0.5C10.6,13,10.6,13,10.5,13z M6.5,1C6.2,1,6,1.2,6,1.5v7C6,8.8,6.2,9,6.5,9
          h1C7.6,9,7.8,9,7.9,9.1l2.1,2.1V9.5C10,9.2,10.2,9,10.5,9h7C17.8,9,18,8.8,18,8.5v-7C18,1.2,17.8,1,17.5,1H6.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M19.5,17c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S21.2,17,19.5,17z M19.5,12c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2
          S20.6,12,19.5,12z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M23.5,21h-8c-0.3,0-0.5-0.2-0.5-0.5c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5C24,20.8,23.8,21,23.5,21z M16,20H23
          c-0.2-1.7-1.7-3-3.5-3S16.3,18.3,16,20z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M4.5,17c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S6.2,17,4.5,17z M4.5,12c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2
          S5.6,12,4.5,12z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M8.5,21h-8C0.2,21,0,20.8,0,20.5C0,18,2,16,4.5,16S9,18,9,20.5C9,20.8,8.8,21,8.5,21z M1,20H8c-0.2-1.7-1.7-3-3.5-3
          S1.3,18.3,1,20z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,20c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,20,12,20z M12,15c-1.1,0-2,0.9-2,2s0.9,2,2,2c1.1,0,2-0.9,2-2
          S13.1,15,12,15z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M16,24H8c-0.3,0-0.5-0.2-0.5-0.5c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5C16.5,23.8,16.3,24,16,24z M8.5,23h6.9
          c-0.2-1.7-1.7-3-3.5-3C10.2,20,8.8,21.3,8.5,23z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M15.5,3h-7C8.2,3,8,2.8,8,2.5S8.2,2,8.5,2h7C15.7,2,16,2.2,16,2.5S15.7,3,15.5,3z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M15.5,5h-7C8.2,5,8,4.8,8,4.5S8.2,4,8.5,4h7C15.7,4,16,4.2,16,4.5S15.7,5,15.5,5z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M15.5,7h-7C8.2,7,8,6.8,8,6.5S8.2,6,8.5,6h7C15.7,6,16,6.2,16,6.5S15.7,7,15.5,7z" })
    ], -1)
  ]));
}
const h2 = /* @__PURE__ */ S(d2, [["render", f2]]), p2 = {
  name: "LuxIconDelivery",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function v2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: `M23.9,16.2l-2.5-4C21.3,12.1,21.2,12,21,12h-4V9.5C17,9.2,16.8,9,16.5,9H11v1h5v9l-4.8,0c-0.3-0.6-1-1-1.7-1
            s-1.4,0.4-1.7,1H6v-7H5v7.5C5,19.8,5.2,20,5.5,20h2c0,1.1,0.9,2,2,2s2-0.9,2-2l5,0c0,0,0.1,0,0.1,0h0.9c0,0,0,0,0,0
            c0,1.1,0.9,2,2,2s2-0.9,2-2c0,0,0,0,0,0h2c0.3,0,0.5-0.2,0.5-0.5v-3C24,16.4,24,16.3,23.9,16.2z M9.5,21c-0.6,0-1-0.4-1-1
            s0.4-1,1-1s1,0.4,1,1S10.1,21,9.5,21z M20.7,13l1.9,3H17v-3H20.7z M19.5,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.1,21,19.5,21z
             M21.2,19c-0.4-0.6-1-1-1.7-1c-0.7,0-1.4,0.4-1.7,1H17v-2h6v2L21.2,19L21.2,19z` }, null, -1),
    o("path", { d: "M5,11c2.7,0,5-2.3,5-5S7.7,1,5,1S0,3.3,0,6S2.3,11,5,11z M5,2c2.2,0,4,1.8,4,4s-1.8,4-4,4S1,8.2,1,6S2.8,2,5,2z" }, null, -1),
    o("path", { d: "M4.5,7h2C6.8,7,7,6.8,7,6.5S6.8,6,6.5,6H5V3.5C5,3.2,4.8,3,4.5,3S4,3.2,4,3.5v3C4,6.8,4.2,7,4.5,7z" }, null, -1),
    o("path", { d: "M3.5,14l-3,0h0C0.2,14,0,14.2,0,14.5C0,14.8,0.2,15,0.5,15l3,0h0C3.8,15,4,14.8,4,14.5C4,14.2,3.8,14,3.5,14z" }, null, -1),
    o("path", { d: "M3.5,16L2,16c0,0,0,0,0,0c-0.3,0-0.5,0.2-0.5,0.5S1.7,17,2,17l1.5,0c0,0,0,0,0,0C3.8,17,4,16.8,4,16.5S3.8,16,3.5,16z" }, null, -1),
    o("path", { d: "M3.5,18L3,18c-0.3,0-0.5,0.2-0.5,0.5C2.5,18.8,2.7,19,3,19l0.5,0c0,0,0,0,0,0C3.8,19,4,18.8,4,18.5C4,18.2,3.8,18,3.5,18z" }, null, -1)
  ]));
}
const m2 = /* @__PURE__ */ S(p2, [["render", v2]]), g2 = {
  name: "LuxIconDenied",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function y2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M11.5,23C5.2,23,0,17.8,0,11.5C0,5.2,5.2,0,11.5,0C17.8,0,23,5.2,23,11.5C23,17.8,17.8,23,11.5,23z M11.5,1
          C5.7,1,1,5.7,1,11.5C1,17.3,5.7,22,11.5,22C17.3,22,22,17.3,22,11.5C22,5.7,17.3,1,11.5,1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M7.3,16.2c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7l8.5-8.5c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7l-8.5,8.5
          C7.5,16.2,7.4,16.2,7.3,16.2z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M15.7,16.2c-0.1,0-0.3,0-0.4-0.1L6.9,7.6c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l8.5,8.5c0.2,0.2,0.2,0.5,0,0.7
          C16,16.2,15.9,16.2,15.7,16.2z` })
    ], -1)
  ]));
}
const pi = /* @__PURE__ */ S(g2, [["render", y2]]), b2 = {
  name: "LuxIconDerivativesHealthy",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function _2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M14.39,14.83a.44.44,0,0,0,.25.08.46.46,0,0,0,.25-.08c.23-.17,5.73-4.17,5.73-7.31a3.29,3.29,0,0,0-3.18-3.46,3.16,3.16,0,0,0-2.8,1.87,3.16,3.16,0,0,0-2.8-1.87A3.28,3.28,0,0,0,8.66,7.52C8.66,10.66,14.15,14.66,14.39,14.83ZM11.84,4.91c1.13,0,2,.89,2.38,2.37a.44.44,0,0,0,.83,0c.36-1.48,1.26-2.37,2.39-2.37a2.45,2.45,0,0,1,2.32,2.61c0,2.13-3.49,5.2-5.12,6.43C13,12.72,9.51,9.65,9.51,7.52A2.45,2.45,0,0,1,11.84,4.91Z",
      transform: "translate(-0.46 -0.47)"
    }, null, -1),
    o("path", {
      d: "M23.21.47H6.12A.42.42,0,0,0,5.7.9v3H3.56a.43.43,0,0,0-.43.42V20.54a.43.43,0,0,0,.43.43H19.79a.43.43,0,0,0,.43-.43V18.41h3a.42.42,0,0,0,.42-.43V.9A.42.42,0,0,0,23.21.47ZM19.36,20.12H4V4.74H5.7V18a.42.42,0,0,0,.42.43H19.36Zm3.42-2.57H6.55V1.32H22.78Z",
      transform: "translate(-0.46 -0.47)"
    }, null, -1),
    o("polygon", { points: "3.05 7.05 0.5 7.05 0.5 22.38 15.68 22.38 15.68 20.5 3.1 20.5 3.05 7.05" }, null, -1)
  ]));
}
const w2 = /* @__PURE__ */ S(b2, [["render", _2]]), $2 = {
  name: "LuxIconDerivativesUnhealthy",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function C2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M23.21.47H6.12A.42.42,0,0,0,5.7.9v3H3.56a.43.43,0,0,0-.43.42V20.54a.43.43,0,0,0,.43.43H19.79a.43.43,0,0,0,.43-.43V18.41h3a.42.42,0,0,0,.42-.43V.9A.42.42,0,0,0,23.21.47ZM19.36,20.12H4V4.74H5.7V18a.42.42,0,0,0,.42.43H19.36Zm3.42-2.57H6.55V1.32H22.78Z",
      transform: "translate(-0.46 -0.47)"
    }, null, -1),
    o("polygon", {
      class: "cls-1",
      points: "3.05 7.05 0.5 7.05 0.5 22.38 15.68 22.38 15.68 20.5 3.1 20.5 3.05 7.05"
    }, null, -1),
    o("path", {
      class: "cls-2",
      d: "M14.38,7.56v4.26a.28.28,0,0,0,.56,0V7.56a.28.28,0,0,0-.56,0Z",
      transform: "translate(-0.46 -0.47)"
    }, null, -1),
    o("path", {
      class: "cls-2",
      d: "M21,15.35,14.91,3.18a.3.3,0,0,0-.5,0L8.29,15.42a.29.29,0,0,0,0,.27.28.28,0,0,0,.23.13H20.79a.28.28,0,0,0,.27-.28A.26.26,0,0,0,21,15.35ZM9,15.26,14.66,3.93l5.67,11.33Z",
      transform: "translate(-0.46 -0.47)"
    }, null, -1),
    o("circle", {
      cx: "14.2",
      cy: "13.12",
      r: "0.56"
    }, null, -1)
  ]));
}
const x2 = /* @__PURE__ */ S($2, [["render", C2]]), S2 = {
  name: "LuxIconDescending",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function M2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("circle", {
      class: "st0",
      cx: "12",
      cy: "12",
      r: "2"
    }, null, -1),
    o("polygon", {
      class: "st1",
      points: "17.5,6.5 12,0.5 6.5,6.5 	"
    }, null, -1),
    o("polygon", {
      class: "st2",
      points: "6.5,17.5 12,23.5 17.5,17.5 	"
    }, null, -1)
  ]));
}
const D2 = /* @__PURE__ */ S(S2, [["render", M2], ["__scopeId", "data-v-4f713d51"]]), k2 = {
  name: "LuxIconEdit",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function L2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: `M19.9,7L17,4.1C16.9,4.1,16.8,4,16.7,4s-0.3,0.1-0.4,0.1L7.5,13c0,0-0.1,0.1-0.1,0.2l0,0c0,0,0,0,0,0l-2.1,4.9
            c-0.1,0.2,0,0.4,0.1,0.6c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0l4.9-2.1h0l0,0c0.1,0,0.1-0.1,0.2-0.1l8.8-8.8
            C20,7.5,20,7.2,19.9,7z M10.7,15.5l-2.1-2.1L14.8,7L17,9.2L10.7,15.5z M8,14.2L9.8,16l-3.1,1.3L8,14.2z M17.7,8.5l-2.1-2.1l1.1-1.1
            l2.1,2.1L17.7,8.5z` }, null, -1),
    o("path", { d: `M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M12,23C5.9,23,1,18.1,1,12C1,5.9,5.9,1,12,1s11,4.9,11,11
            C23,18.1,18.1,23,12,23z` }, null, -1)
  ]));
}
const O2 = /* @__PURE__ */ S(k2, [["render", L2]]), I2 = {
  name: "LuxIconExclamation",
  status: "ready",
  release: "3.1.1",
  type: "Element"
};
function E2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: `M23.5,1h-23C0.2,1,0,1.2,0,1.5v16C0,17.8,0.2,18,0.5,18H7v3.5c0,0.2,0.1,0.4,0.3,0.5c0.1,0,0.1,0,0.2,0
  		c0.1,0,0.3-0.1,0.4-0.1l3.9-3.9h11.8c0.3,0,0.5-0.2,0.5-0.5v-16C24,1.2,23.8,1,23.5,1z M23,17H11.5c-0.1,0-0.3,0.1-0.4,0.1L8,20.3
  		v-2.8C8,17.2,7.8,17,7.5,17H1V2h22V17z` }, null, -1),
    o("path", { d: "M11.5,11c0.3,0,0.5-0.2,0.5-0.5v-6C12,4.2,11.8,4,11.5,4S11,4.2,11,4.5v6C11,10.8,11.2,11,11.5,11z" }, null, -1),
    o("circle", {
      cx: "11.5",
      cy: "13",
      r: "1"
    }, null, -1)
  ]));
}
const T2 = /* @__PURE__ */ S(I2, [["render", E2]]), A2 = {
  name: "LuxIconFile",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function P2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M20.5,24h-17C3.2,24,3,23.8,3,23.5v-23C3,0.2,3.2,0,3.5,0h11c0.1,0,0.3,0.1,0.4,0.1l6,6C20.9,6.2,21,6.4,21,6.5v17
        C21,23.8,20.8,24,20.5,24z M4,23h16V6.7L14.3,1H4V23z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M20.5,7h-6C14.2,7,14,6.8,14,6.5v-6C14,0.2,14.2,0,14.5,0S15,0.2,15,0.5V6h5.5C20.8,6,21,6.2,21,6.5S20.8,7,20.5,7z" })
    ], -1)
  ]));
}
const z2 = /* @__PURE__ */ S(A2, [["render", P2]]), Y2 = {
  name: "LuxIconFileHealthy",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function V2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: "M3.5,9C3.776,9,4,8.776,4,8.5v-2C4,6.224,3.776,6,3.5,6S3,6.224,3,6.5v2C3,8.776,3.224,9,3.5,9z" }, null, -1),
    o("path", { d: "M10,6.5C10,6.224,9.776,6,9.5,6S9,6.224,9,6.5v2C9,8.776,9.224,9,9.5,9S10,8.776,10,8.5V6.5z" }, null, -1),
    o("path", { d: "M7.5,11C7.224,11,7,11.224,7,11.5v2C7,13.776,7.224,14,7.5,14S8,13.776,8,13.5v-2C8,11.224,7.776,11,7.5,11z" }, null, -1),
    o("path", { d: "M10,11.5c0-0.276-0.224-0.5-0.5-0.5S9,11.224,9,11.5v2C9,13.776,9.224,14,9.5,14s0.5-0.224,0.5-0.5V11.5z" }, null, -1),
    o("path", { d: "M8,8.5v-2C8,6.224,7.776,6,7.5,6h-2C5.224,6,5,6.224,5,6.5v2C5,8.776,5.224,9,5.5,9h2C7.776,9,8,8.776,8,8.5z M7,8H6V7h1V8   z" }, null, -1),
    o("path", { d: "M6,11.5C6,11.224,5.776,11,5.5,11h-2C3.224,11,3,11.224,3,11.5v2C3,13.776,3.224,14,3.5,14h2C5.776,14,6,13.776,6,13.5   V11.5z M5,13H4v-1h1V13z" }, null, -1),
    o("path", { d: "M7.5,19h2c0.276,0,0.5-0.224,0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5h-2C7.224,16,7,16.224,7,16.5v2   C7,18.776,7.224,19,7.5,19z M8,17h1v1H8V17z" }, null, -1),
    o("path", { d: "M3,16.5v2C3,18.776,3.224,19,3.5,19S4,18.776,4,18.5v-2C4,16.224,3.776,16,3.5,16S3,16.224,3,16.5z" }, null, -1),
    o("path", { d: "M5.5,16C5.224,16,5,16.224,5,16.5v2C5,18.776,5.224,19,5.5,19S6,18.776,6,18.5v-2C6,16.224,5.776,16,5.5,16z" }, null, -1),
    o("path", { d: "M20.276,12.5c-0.95,0-2.07,0.491-2.776,1.784c-0.706-1.293-1.826-1.784-2.776-1.784c-1.585,0-3.224,1.323-3.224,3.537   c0,3.181,5.473,7.198,5.706,7.367c0.088,0.063,0.19,0.096,0.294,0.096s0.206-0.032,0.294-0.096   c0.233-0.169,5.706-4.187,5.706-7.367C23.5,13.823,21.861,12.5,20.276,12.5z M17.5,22.376c-1.63-1.246-5-4.253-5-6.339   c0-1.588,1.131-2.537,2.224-2.537c1.086,0,1.942,0.864,2.29,2.313c0.109,0.449,0.863,0.449,0.973,0   c0.348-1.448,1.204-2.313,2.29-2.313c1.093,0,2.224,0.949,2.224,2.537C22.5,18.121,19.13,21.13,17.5,22.376z" }, null, -1),
    o("path", { d: "M1,1h10v4.5C11,5.776,11.224,6,11.5,6H16v5h1V5.5c0-0.066-0.014-0.132-0.039-0.192c-0.025-0.062-0.063-0.115-0.108-0.162   l-4.998-4.999c-0.046-0.045-0.101-0.082-0.162-0.107C11.632,0.014,11.566,0,11.5,0h-11C0.224,0,0,0.224,0,0.5v21   C0,21.776,0.224,22,0.5,22h11.979v-1H1V1z M12,1.707L15.293,5H12V1.707z" }, null, -1)
  ]));
}
const H2 = /* @__PURE__ */ S(Y2, [["render", V2]]), N2 = {
  name: "LuxIconFileUnhealthy",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function R2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: "M3.5,9C3.776,9,4,8.776,4,8.5v-2C4,6.224,3.776,6,3.5,6S3,6.224,3,6.5v2C3,8.776,3.224,9,3.5,9z" }, null, -1),
    o("path", { d: "M10,6.5C10,6.224,9.776,6,9.5,6S9,6.224,9,6.5v2C9,8.776,9.224,9,9.5,9S10,8.776,10,8.5V6.5z" }, null, -1),
    o("path", { d: "M7.5,11C7.224,11,7,11.224,7,11.5v2C7,13.776,7.224,14,7.5,14S8,13.776,8,13.5v-2C8,11.224,7.776,11,7.5,11z" }, null, -1),
    o("path", { d: "M10,11.5c0-0.276-0.224-0.5-0.5-0.5S9,11.224,9,11.5v2C9,13.776,9.224,14,9.5,14s0.5-0.224,0.5-0.5V11.5z" }, null, -1),
    o("path", { d: "M8,8.5v-2C8,6.224,7.776,6,7.5,6h-2C5.224,6,5,6.224,5,6.5v2C5,8.776,5.224,9,5.5,9h2C7.776,9,8,8.776,8,8.5z M7,8H6V7h1V8   z" }, null, -1),
    o("path", { d: "M6,11.5C6,11.224,5.776,11,5.5,11h-2C3.224,11,3,11.224,3,11.5v2C3,13.776,3.224,14,3.5,14h2C5.776,14,6,13.776,6,13.5   V11.5z M5,13H4v-1h1V13z" }, null, -1),
    o("path", { d: "M7.5,19h2c0.276,0,0.5-0.224,0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5h-2C7.224,16,7,16.224,7,16.5v2   C7,18.776,7.224,19,7.5,19z M8,17h1v1H8V17z" }, null, -1),
    o("path", { d: "M3,16.5v2C3,18.776,3.224,19,3.5,19S4,18.776,4,18.5v-2C4,16.224,3.776,16,3.5,16S3,16.224,3,16.5z" }, null, -1),
    o("path", { d: "M5.5,16C5.224,16,5,16.224,5,16.5v2C5,18.776,5.224,19,5.5,19S6,18.776,6,18.5v-2C6,16.224,5.776,16,5.5,16z" }, null, -1),
    o("path", { d: "M23.892,23.166l-5.944-11.89c-0.17-0.338-0.725-0.338-0.895,0l-6,12c-0.077,0.155-0.069,0.339,0.021,0.486   C11.166,23.91,11.327,24,11.5,24h12c0.007,0,0.015,0,0.02,0c0.276,0,0.5-0.224,0.5-0.5C24.02,23.371,23.972,23.254,23.892,23.166z    M12.309,23L17.5,12.618L22.691,23H12.309z" }, null, -1),
    o("path", { d: "M17,16.409v3.272c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-3.272c0-0.276-0.224-0.5-0.5-0.5S17,16.133,17,16.409z" }, null, -1),
    o("circle", {
      cx: "17.5",
      cy: "21.5",
      r: "0.5"
    }, null, -1),
    o("path", { d: "M11.5,6H16v4h1V5.5c0-0.066-0.014-0.132-0.039-0.192c-0.025-0.062-0.063-0.115-0.108-0.162l-4.998-4.999   c-0.046-0.045-0.101-0.082-0.162-0.107C11.632,0.014,11.566,0,11.5,0h-11C0.224,0,0,0.224,0,0.5v21C0,21.776,0.224,22,0.5,22H11v-1   H1V1h10v4.5C11,5.776,11.224,6,11.5,6z M12,1.707L15.293,5H12V1.707z" }, null, -1)
  ]));
}
const B2 = /* @__PURE__ */ S(N2, [["render", R2]]), F2 = {
  name: "LuxIconFilter",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function j2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", {
      class: "st0",
      d: "M23.5,0.5h-23l10,12.1v10.9l3-3v-7.9L23.5,0.5z"
    }, null, -1)
  ]));
}
const W2 = /* @__PURE__ */ S(F2, [["render", j2]]), U2 = {
  name: "LuxIconFlower",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function q2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M10,13.5c-3.9,0-7-2.7-7-6c0-1.7,0.8-3.2,2.2-4.4C5.4,3,5.7,3,5.9,3.2C6.1,3.4,6,3.7,5.8,3.9C4.6,4.9,4,6.1,4,7.5
          c0,2.8,2.7,5,6,5s6-2.2,6-5c0-1.4-0.6-2.6-1.8-3.6c-0.2-0.2-0.2-0.5-0.1-0.7C14.3,3,14.6,3,14.8,3.1C16.2,4.3,17,5.8,17,7.5
          C17,10.8,13.9,13.5,10,13.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M10,7.5C7.3,7.5,5.2,5.9,5.2,4c0-1,0.6-1.9,1.6-2.6C7,1.3,7.3,1.3,7.4,1.6c0.2,0.2,0.1,0.5-0.1,0.7
          C6.6,2.7,6.2,3.3,6.2,4c0,1.4,1.8,2.5,3.8,2.5s3.8-1.1,3.8-2.5c0-0.7-0.4-1.3-1.1-1.7c-0.2-0.2-0.3-0.5-0.1-0.7
          c0.2-0.2,0.5-0.3,0.7-0.1c1,0.7,1.6,1.6,1.6,2.6C14.8,5.9,12.7,7.5,10,7.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M13.5,12.5c-0.3,0-0.5-0.2-0.5-0.5v-2c0-2-2.5-2.5-2.6-2.5c-0.3,0-0.5-0.3-0.4-0.6c0-0.3,0.3-0.5,0.6-0.4
          C11.7,6.7,14,7.7,14,10v2C14,12.3,13.8,12.5,13.5,12.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M8,7C7.9,7,7.9,7,7.8,7C7.6,6.9,7.4,6.6,7.5,6.3c0-0.1,0.4-1.2,1.4-2.2C9.1,4,9.4,4,9.6,4.1c0.2,0.2,0.2,0.5,0,0.7
          C8.8,5.6,8.5,6.6,8.5,6.7C8.4,6.9,8.2,7,8,7z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M10,5C8,5,6.5,3.9,6.5,2.5S8,0,10,0s3.5,1.1,3.5,2.5S12,5,10,5z M10,1C8.6,1,7.5,1.7,7.5,2.5S8.6,4,10,4
          s2.5-0.7,2.5-1.5S11.4,1,10,1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M10,5C9.7,5,9.5,4.8,9.5,4.5S9.7,4,10,4c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.5-0.7-0.8-1.8-0.8
          C8.7,2.5,8.5,2.3,8.5,2S8.7,1.5,9,1.5c0.9,0,1.5,0.2,2,0.5c0.5,0.3,0.7,0.8,0.7,1.3C11.8,4.2,11,5,10,5z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M10.5,24c-0.3,0-0.5-0.2-0.5-0.5V13c0-0.3,0.2-0.5,0.5-0.5S11,12.7,11,13v10.5C11,23.8,10.8,24,10.5,24z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M12.5,22c-0.8,0-1.6-0.3-2.1-1.1c-0.5-0.7-0.5-1.6,0-2.2c0.5-0.7,1.4-1,2.3-0.7c1,0.3,2.7-0.7,3.2-1.2
          c0.2-0.1,0.4-0.2,0.6,0c0.2,0.1,0.3,0.3,0.2,0.5c-0.1,0.3-0.8,3.1-2.1,4C14,21.7,13.2,22,12.5,22z M12,18.9
          c-0.3,0-0.6,0.2-0.8,0.4c-0.2,0.2-0.3,0.6,0,1c0.7,0.9,1.9,0.8,2.8,0.2c0.5-0.3,0.9-1.2,1.2-2.1c-0.8,0.5-2,0.9-2.9,0.5
          C12.2,18.9,12.1,18.9,12,18.9z` })
    ], -1)
  ]));
}
const G2 = /* @__PURE__ */ S(U2, [["render", q2]]), K2 = {
  name: "LuxIconGlobe",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Z2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M12,24c-3.1,0-6.1-1.2-8.5-3.5c-4.7-4.7-4.7-12.3,0-17c4.7-4.7,12.3-4.7,17,0s4.7,12.3,0,17C18.1,22.8,15.1,24,12,24z
        M12,1C9.2,1,6.4,2.1,4.2,4.2c-4.3,4.3-4.3,11.3,0,15.6c4.3,4.3,11.3,4.3,15.6,0c4.3-4.3,4.3-11.3,0-15.6C17.6,2.1,14.8,1,12,1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M11,20.5c-1,0-2-2.5-2-3c0-0.4,0.2-0.7,0.3-1c0.1-0.2,0.2-0.4,0.2-0.5c0-0.2-0.4-0.7-0.9-1.1c-0.1-0.1-0.1-0.2-0.1-0.4
        c0-0.4-0.1-0.7-0.2-0.9c-0.3-0.2-0.8-0.2-1.5-0.2c-0.3,0-0.5,0-0.8,0c-1.6,0-2-1.6-2-2.5c0-0.2,0-3.9,2.9-4.5
        c1.3-0.3,2.2-0.2,2.7,0.2C9.8,6.9,9.9,7.1,10,7.2c0.5,0.4,1.5,0.2,2.3,0c0.3-0.1,0.5-0.1,0.8-0.2c0.1-0.8,0.1-1.7,0-2
        c-0.6,0.3-1.2,0.3-1.7,0c-0.5-0.3-0.8-0.8-0.9-1.5c-0.2-1.9,3.9-2.9,4.8-3c0.3-0.1,0.5,0.1,0.6,0.4c0.1,0.3-0.1,0.5-0.4,0.6
        c-1.9,0.4-4,1.3-4,2c0,0.2,0.1,0.5,0.4,0.7c0.2,0.1,0.6,0.1,0.9-0.1c0.3-0.1,0.6-0.1,0.8,0c0.7,0.5,0.6,2.1,0.4,3.5
        C14,7.8,13.7,8,13.5,8c-0.2,0-0.6,0.1-1,0.2C11.4,8.4,10,8.7,9.1,7.9C9.1,7.8,9,7.6,9,7.5c0,0-0.5-0.3-1.9,0C5,7.9,5,11,5,11
        c0,0.1,0,1.5,1,1.5c0.2,0,0.5,0,0.7,0c0.8,0,1.7-0.1,2.2,0.4c0.3,0.3,0.5,0.8,0.5,1.4c0.4,0.4,1,1.1,1,1.7c0,0.4-0.2,0.7-0.3,1
        c-0.1,0.2-0.2,0.4-0.2,0.5c0,0.4,0.7,1.8,1.1,2c1.6,0,2.4-0.7,2.4-2c0-0.2,0.1-0.4,0.3-0.5c0,0,0.7-0.2,1.3-0.9
        c0.1-0.1,0.1-0.1,0.1-0.1c0,0-0.1-0.1-0.2-0.2c-0.2-0.2-0.5-0.5-0.5-0.9c0-0.4,0.3-0.6,0.8-1.2c0.7-0.8,1.5-1.6,1.4-2.2
        c-0.5,0.1-1.1,0.2-1.6-0.3c-0.1-0.1-0.1-0.1-0.1-0.2c-0.2-0.7-0.5-1.4-0.6-1.6c-0.2,0-0.3-0.2-0.4-0.3c0-0.1-0.1-0.4,0.1-0.6
        c0.4-0.4,2.1-1.4,3.8-1.1C19.6,6.5,20,4.2,20,4.2c0-0.3,0.3-0.5,0.6-0.4c0.3,0,0.5,0.3,0.4,0.6c0,0.1-0.6,3-2.8,4.1
        c-0.1,0.1-0.2,0.1-0.3,0c-1.1-0.3-2.1,0.1-2.7,0.4c0.2,0.3,0.5,0.8,0.7,1.8c0.2,0.1,0.6,0,0.8-0.1c0.2-0.1,0.4-0.1,0.6,0.1
        c1.2,1.2-0.4,2.8-1.3,3.8c-0.2,0.2-0.4,0.4-0.5,0.5c0,0,0.1,0.1,0.1,0.1c0.2,0.2,0.5,0.5,0.6,0.9c0,0.3-0.1,0.6-0.4,0.8
        c-0.5,0.5-1,0.8-1.4,1C14.3,19.5,13.1,20.5,11,20.5z` })
    ], -1)
  ]));
}
const X2 = /* @__PURE__ */ S(K2, [["render", Z2]]), J2 = {
  name: "LuxIconHospital",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Q2(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: "M17.5,24c-0.3,0-0.5-0.2-0.5-0.5v-13c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v13C18,23.8,17.8,24,17.5,24z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M6.5,24C6.2,24,6,23.8,6,23.5V10.4c0-0.3,0.2-0.5,0.5-0.5S7,10.2,7,10.4v13.1C7,23.8,6.8,24,6.5,24z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M23.5,24c-0.3,0-0.5-0.2-0.5-0.5V13h-5v10.5c0,0.3-0.2,0.5-0.5,0.5S17,23.8,17,23.5v-11c0-0.3,0.2-0.5,0.5-0.5h6
                      c0.3,0,0.5,0.2,0.5,0.5v11C24,23.8,23.8,24,23.5,24z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M6.5,24C6.2,24,6,23.8,6,23.5V13H1v10.5C1,23.8,0.8,24,0.5,24S0,23.8,0,23.5v-11C0,12.2,0.2,12,0.5,12h6
                      C6.8,12,7,12.2,7,12.5v11C7,23.8,6.8,24,6.5,24z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M23.5,24h-23C0.2,24,0,23.8,0,23.5S0.2,23,0.5,23h23c0.3,0,0.5,0.2,0.5,0.5S23.8,24,23.5,24z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,14c-3.9,0-7-3.1-7-7s3.1-7,7-7c3.9,0,7,3.1,7,7S15.9,14,12,14z M12,1C8.7,1,6,3.7,6,7s2.7,6,6,6s6-2.7,6-6
                      S15.3,1,12,1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M13.5,11h-3c-0.3,0-0.5-0.2-0.5-0.5V9H8.5C8.2,9,8,8.8,8,8.5v-3C8,5.2,8.2,5,8.5,5H10l0-1.5C10,3.2,10.2,3,10.5,3h3
                      c0.1,0,0.3,0.1,0.4,0.1S14,3.4,14,3.5L14,5h1.5C15.8,5,16,5.2,16,5.5v3C16,8.8,15.8,9,15.5,9H14v1.5C14,10.8,13.8,11,13.5,11z
                       M11,10h2V8.5C13,8.2,13.2,8,13.5,8H15V6h-1.5c-0.1,0-0.3-0.1-0.4-0.1S13,5.6,13,5.5L13,4h-2l0,1.5C11,5.8,10.8,6,10.5,6H9v2
                      h1.5C10.8,8,11,8.2,11,8.5V10z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M4.5,15h-2C2.2,15,2,14.8,2,14.5S2.2,14,2.5,14h2C4.8,14,5,14.2,5,14.5S4.8,15,4.5,15z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M4.5,17h-2C2.2,17,2,16.8,2,16.5S2.2,16,2.5,16h2C4.8,16,5,16.2,5,16.5S4.8,17,4.5,17z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M4.5,19h-2C2.2,19,2,18.8,2,18.5S2.2,18,2.5,18h2C4.8,18,5,18.2,5,18.5S4.8,19,4.5,19z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M4.5,21h-2C2.2,21,2,20.8,2,20.5S2.2,20,2.5,20h2C4.8,20,5,20.2,5,20.5S4.8,21,4.5,21z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M21.5,15h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S21.8,15,21.5,15z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M21.5,17h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S21.8,17,21.5,17z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M21.5,19h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S21.8,19,21.5,19z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M21.5,21h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S21.8,21,21.5,21z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M9.5,16h-1C8.2,16,8,15.8,8,15.5S8.2,15,8.5,15h1c0.3,0,0.5,0.2,0.5,0.5S9.8,16,9.5,16z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M9.5,18h-1C8.2,18,8,17.8,8,17.5S8.2,17,8.5,17h1c0.3,0,0.5,0.2,0.5,0.5S9.8,18,9.5,18z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M9.5,20h-1C8.2,20,8,19.8,8,19.5S8.2,19,8.5,19h1c0.3,0,0.5,0.2,0.5,0.5S9.8,20,9.5,20z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M12.5,16h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S12.8,16,12.5,16z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M12.5,18h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S12.8,18,12.5,18z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M12.5,20h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S12.8,20,12.5,20z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M15.5,16h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S15.8,16,15.5,16z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M15.5,18h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S15.8,18,15.5,18z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M15.5,20h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1c0.3,0,0.5,0.2,0.5,0.5S15.8,20,15.5,20z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M13.5,24h-3c-0.3,0-0.5-0.2-0.5-0.5v-2c0-0.3,0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5v2C14,23.8,13.8,24,13.5,24z
                       M11,23h2v-1h-2V23z` })
    ], -1)
  ]));
}
const eu = /* @__PURE__ */ S(J2, [["render", Q2]]), tu = {
  name: "LuxIconInfo",
  status: "ready",
  release: "1.0.0",
  type: "Element"
}, nu = { d: `M11.5,1C5.2,1,0,6.2,0,12.5S5.2,24,11.5,24C17.8,24,23,18.8,23,12.5S17.8,1,11.5,1z M11,6c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1
  	c-0.6,0-1-0.4-1-1C10,6.4,10.4,6,11,6z M14.5,20h-6C8.2,20,8,19.8,8,19.5S8.2,19,8.5,19H11v-8H9.5C9.2,11,9,10.8,9,10.5
  	S9.2,10,9.5,10h2c0.3,0,0.5,0.2,0.5,0.5V19h2.5c0.3,0,0.5,0.2,0.5,0.5S14.8,20,14.5,20z` };
function au(e, t, n, a, r, s) {
  return h(), g("path", nu);
}
const ru = /* @__PURE__ */ S(tu, [["render", au]]), su = {
  name: "LuxIconLockClose",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function iu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: "M12,14c-0.552,0-1,0.449-1,1c0,0.365,0.207,0.672,0.5,0.847V18.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-2.653   C12.793,15.672,13,15.365,13,15C13,14.449,12.552,14,12,14z" }, null, -1),
    o("path", { d: "M20.5,9H18V6c0-3.309-2.691-6-6-6S6,2.691,6,6v3H3.5C3.224,9,3,9.224,3,9.5v14C3,23.776,3.224,24,3.5,24h17   c0.276,0,0.5-0.224,0.5-0.5v-14C21,9.224,20.776,9,20.5,9z M7,6c0-2.757,2.243-5,5-5s5,2.243,5,5v3H7V6z M20,23H4V10h2.5h11H20V23z   " }, null, -1)
  ]));
}
const ou = /* @__PURE__ */ S(su, [["render", iu]]), lu = {
  name: "LuxIconLockOpen",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function uu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: "M11.5,15.847V18.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-2.653C12.793,15.672,13,15.365,13,15c0-0.551-0.448-1-1-1   s-1,0.449-1,1C11,15.365,11.207,15.672,11.5,15.847z" }, null, -1),
    o("path", { d: "M20.5,9H18V6c0-3.309-2.691-6-6-6S6,2.691,6,6h1c0-2.757,2.243-5,5-5s5,2.243,5,5v3H3.5C3.224,9,3,9.224,3,9.5v14   C3,23.776,3.224,24,3.5,24h17c0.276,0,0.5-0.224,0.5-0.5v-14C21,9.224,20.776,9,20.5,9z M20,23H4V10h16V23z" }, null, -1)
  ]));
}
const cu = /* @__PURE__ */ S(lu, [["render", uu]]), du = {
  name: "LuxIconNewTab",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function fu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", {
      class: "cls-2",
      d: "M12.5,13c.3,0,.5-.1.7-.3l5.8-6.2v2.5c0,.6.4,1,1,1s1-.4,1-1V4s0,0,0,0c0-.6-.5-1-1-1h-4.5c-.6,0-1,.4-1,1s.4,1,1,1h2.2l-5.9,6.3c-.4.4-.4,1,0,1.4.2.2.4.3.7.3h0Z"
    }, null, -1),
    o("rect", {
      class: "cls-2",
      x: "1.4",
      y: "5.9",
      width: "11.2",
      height: "2"
    }, null, -1),
    o("rect", {
      class: "cls-2",
      x: "1.4",
      y: "20.2",
      width: "17.9",
      height: "2"
    }, null, -1),
    o("rect", {
      class: "cls-2",
      x: "17.3",
      y: "12.1",
      width: "2",
      height: "8.1"
    }, null, -1),
    o("rect", {
      class: "cls-2",
      x: "1.4",
      y: "7.9",
      width: "2",
      height: "12.3"
    }, null, -1)
  ]));
}
const vi = /* @__PURE__ */ S(du, [["render", fu]]), hu = {
  name: "LuxIconNote",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function pu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M7.5,22c-0.1,0-0.1,0-0.2,0C7.1,21.9,7,21.7,7,21.5V18H0.5C0.2,18,0,17.8,0,17.5v-16C0,1.2,0.2,1,0.5,1h23
              C23.8,1,24,1.2,24,1.5v16c0,0.3-0.2,0.5-0.5,0.5H11.7l-3.9,3.9C7.8,21.9,7.6,22,7.5,22z M1,17h6.5C7.8,17,8,17.2,8,17.5v2.8
              l3.1-3.1c0.1-0.1,0.2-0.1,0.4-0.1H23V2H1V17z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M14.5,7h-9C5.2,7,5,6.8,5,6.5S5.2,6,5.5,6h9C14.8,6,15,6.2,15,6.5S14.8,7,14.5,7z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M18.5,10h-13C5.2,10,5,9.8,5,9.5S5.2,9,5.5,9h13C18.8,9,19,9.2,19,9.5S18.8,10,18.5,10z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M18.5,13h-13C5.2,13,5,12.8,5,12.5S5.2,12,5.5,12h13c0.3,0,0.5,0.2,0.5,0.5S18.8,13,18.5,13z" })
    ], -1)
  ]));
}
const vu = /* @__PURE__ */ S(hu, [["render", pu]]), mu = {
  name: "LuxIconPerson",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function gu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M21.5,23h-19C2.2,23,2,22.8,2,22.5v-1.9c0-1.5,0.9-2.8,2.3-3.3L9,15.6v-2.5h1V16c0,0.2-0.1,0.4-0.3,0.5l-5,1.8
              c-1,0.4-1.7,1.3-1.7,2.4V22h18v-1.4c0-1.1-0.7-2-1.7-2.4l-5-1.8C14.1,16.4,14,16.2,14,16v-2.8h1v2.5l4.7,1.7
              c1.4,0.5,2.3,1.8,2.3,3.3v1.9C22,22.8,21.8,23,21.5,23z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,14.5c-1.5,0-2.9-0.7-3.9-1.9C6,10,6,6,8.1,3.4c1-1.2,2.4-1.9,3.9-1.9l0,0c1.5,0,2.9,0.7,3.9,1.9v0
              C18,6,18,10,15.9,12.6C14.9,13.8,13.5,14.5,12,14.5z M12,2.5c-1.2,0-2.3,0.6-3.2,1.6C7,6.2,7,9.8,8.8,11.9c0.8,1,2,1.6,3.2,1.6
              s2.3-0.6,3.2-1.6c1.8-2.2,1.8-5.7,0-7.8v0C14.3,3.1,13.2,2.5,12,2.5L12,2.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M15.7,8.1c-1.2,0-2.1-0.5-2.9-1.6C11.9,7.3,10.4,8,9,8C8.2,8,7.5,7.8,6.8,7.5l0.5-0.9C7.8,6.9,8.4,7,9,7
              c1.3,0,2.9-0.8,3.3-1.7c0.1-0.2,0.3-0.3,0.4-0.3c0.2,0,0.4,0.1,0.4,0.3c0.9,1.5,1.8,2,3.2,1.7c0.1,0,0.2,0,0.3,0l0.2,0l0.1,1
              c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0C16.3,8.1,16,8.1,15.7,8.1z` })
    ], -1)
  ]));
}
const yu = /* @__PURE__ */ S(mu, [["render", gu]]), bu = {
  name: "LuxIconPicture",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function _u(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M23.5,24h-23C0.2,24,0,23.8,0,23.5v-23C0,0.2,0.2,0,0.5,0h23C23.8,0,24,0.2,24,0.5v23C24,23.8,23.8,24,23.5,24z M1,23
					h22V1H1V23z` })
    ], -1),
    o("g", null, [
      o("rect", {
        x: "0.5",
        y: "17",
        width: "23",
        height: "1"
      })
    ], -1),
    o("g", null, [
      o("path", { d: `M9.5,9h-3c-1.1,0-2-0.9-2-2c0-0.7,0.3-1.3,0.9-1.6C5.8,5.1,6.2,5,6.7,5c0.4-1.2,1.5-2,2.8-2c1.7,0,3,1.3,3,3
					S11.2,9,9.5,9z M6.5,6C6.3,6,6.1,6.1,5.9,6.2C5.7,6.4,5.5,6.7,5.5,7c0,0.6,0.4,1,1,1h3c1.1,0,2-0.9,2-2s-0.9-2-2-2
					c-1,0-1.8,0.7-2,1.7C7.5,5.8,7.4,6,7.3,6C7.2,6.1,7,6.1,6.9,6.1C6.7,6,6.6,6,6.5,6z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M21.6,17.7L18,10.7c-0.2-0.4-0.6-0.6-1-0.6c-0.4,0-0.8,0.2-1.1,0.6l-3,5.2c-0.1,0.1-0.2,0.2-0.4,0.2
					c-0.2,0-0.3-0.1-0.4-0.2c0,0-1.9-2.8-4.1-2.8c-1.8,0-3.5,3.4-4,4.7L3,17.3C3.3,16.8,5.2,12,8,12c2,0,3.7,1.7,4.4,2.6l2.6-4.5
					C15.5,9.4,16.2,9,17,9c0.8,0,1.5,0.5,1.9,1.2l3.5,7.1L21.6,17.7z` })
    ], -1)
  ]));
}
const wu = /* @__PURE__ */ S(bu, [["render", _u]]), $u = {
  name: "LuxIconQuestion",
  status: "ready",
  release: "3.1.1",
  type: "Element"
};
function Cu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: `M23.5,1h-23C0.2,1,0,1.2,0,1.5v16C0,17.8,0.2,18,0.5,18H7v3.5c0,0.2,0.1,0.4,0.3,0.5c0.1,0,0.1,0,0.2,0
  		c0.1,0,0.3-0.1,0.4-0.1l3.9-3.9h11.8c0.3,0,0.5-0.2,0.5-0.5v-16C24,1.2,23.8,1,23.5,1z M23,17H11.5c-0.1,0-0.3,0.1-0.4,0.1L8,20.3
  		v-2.8C8,17.2,7.8,17,7.5,17H1V2h22V17z` }, null, -1),
    o("path", { d: `M9.5,8C9.8,8,10,7.8,10,7.5C10,6.1,11.1,5,12.5,5S15,6.1,15,7.5S13.9,10,12.5,10c-0.3,0-0.5,0.2-0.5,0.5v1
  		c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V11c1.7-0.2,3-1.7,3-3.5C16,5.6,14.4,4,12.5,4S9,5.6,9,7.5C9,7.8,9.2,8,9.5,8z` }, null, -1),
    o("circle", {
      cx: "12.5",
      cy: "14",
      r: "1"
    }, null, -1)
  ]));
}
const xu = /* @__PURE__ */ S($u, [["render", Cu]]), Su = {
  name: "LuxIconQuestionFilled",
  status: "ready",
  release: "3.1.1",
  type: "Element"
};
function Mu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: `M23.5,1h-23C0.2,1,0,1.2,0,1.5v16C0,17.8,0.2,18,0.5,18H7v3.5c0,0.2,0.1,0.4,0.3,0.5c0.1,0,0.1,0,0.2,0
	c0.1,0,0.3-0.1,0.4-0.1l3.9-3.9h11.8c0.3,0,0.5-0.2,0.5-0.5v-16C24,1.2,23.8,1,23.5,1z M12.5,15c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1
	s1,0.4,1,1C13.5,14.6,13.1,15,12.5,15z M13,11v0.5c0,0.3-0.2,0.5-0.5,0.5S12,11.8,12,11.5v-1c0-0.3,0.2-0.5,0.5-0.5
	c1.4,0,2.5-1.1,2.5-2.5S13.9,5,12.5,5S10,6.1,10,7.5C10,7.8,9.8,8,9.5,8S9,7.8,9,7.5C9,5.6,10.6,4,12.5,4S16,5.6,16,7.5
	C16,9.3,14.7,10.7,13,11z` }, null, -1)
  ]));
}
const Du = /* @__PURE__ */ S(Su, [["render", Mu]]), ku = {
  name: "LuxIconRefresh",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Lu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M4.5,14C4.5,14,4.5,14,4.5,14c-0.2,0-0.3-0.1-0.4-0.2l-3-4.5C0.9,9,1,8.7,1.2,8.6c0.2-0.2,0.5-0.1,0.7,0.1l2.6,4
        l3.1-3.5c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-3.5,4C4.8,13.9,4.6,14,4.5,14z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M14,22c-0.3,0-0.5-0.2-0.5-0.5S13.7,21,14,21c5,0,9-4,9-9c0-5-4-9-9-9c-5,0-9,4-9,9v1.5C5,13.8,4.8,14,4.5,14
        S4,13.8,4,13.5V12C4,6.5,8.5,2,14,2c5.5,0,10,4.5,10,10C24,17.5,19.5,22,14,22z` })
    ], -1)
  ]));
}
const Ou = /* @__PURE__ */ S(ku, [["render", Lu]]), Iu = {
  name: "LuxIconRelax",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Eu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M12,24C5.4,24,0,18.6,0,12C0,5.4,5.4,0,12,0c6.6,0,12,5.4,12,12C24,18.6,18.6,24,12,24z M12,1C5.9,1,1,5.9,1,12
          s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,21c-4.4,0-8-3.6-8-8c0-0.3,0.2-0.5,0.5-0.5S5,12.7,5,13c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7c0-0.3,0.2-0.5,0.5-0.5
          S20,12.7,20,13C20,17.4,16.4,21,12,21z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M16.5,10.5C15.3,10.5,14,9.6,14,8c0-0.3,0.2-0.5,0.5-0.5S15,7.7,15,8c0,1.6,1.8,1.8,2.5,1.1C17.8,8.8,18,8.5,18,8
          c0-0.3,0.2-0.5,0.5-0.5S19,7.7,19,8c0,1-0.4,1.5-0.8,1.9C17.8,10.3,17.1,10.5,16.5,10.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M7.5,10.5c-0.6,0-1.3-0.2-1.7-0.6C5.4,9.5,5,9,5,8c0-0.3,0.2-0.5,0.5-0.5S6,7.7,6,8c0,0.5,0.2,0.8,0.5,1.1
          C7.2,9.8,9,9.6,9,8c0-0.3,0.2-0.5,0.5-0.5S10,7.7,10,8C10,9.6,8.7,10.5,7.5,10.5z` })
    ], -1)
  ]));
}
const Tu = /* @__PURE__ */ S(Iu, [["render", Eu]]), Au = {
  name: "LuxIconReportHealthy",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function Pu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: "M12,21H2.5C1.673,21,1,20.327,1,19.5V4h3v1H2.5C2.224,5,2,5.224,2,5.5v14C2,19.776,2.224,20,2.5,20h8   c0.276,0,0.5-0.224,0.5-0.5S10.776,19,10.5,19H3V6h1v0.5C4,6.776,4.224,7,4.5,7h8C12.776,7,13,6.776,13,6.5V6h1v5   c0,0.276,0.224,0.5,0.5,0.5S15,11.276,15,11V5.5C15,5.224,14.776,5,14.5,5H13V4h3v7.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5   v-8C17,3.224,16.776,3,16.5,3H13V2.5C13,2.224,12.776,2,12.5,2h-1.545C10.766,0.963,9.98,0,8.5,0S6.234,0.963,6.045,2H4.5   C4.224,2,4,2.224,4,2.5V3H0.5C0.224,3,0,3.224,0,3.5v16C0,20.879,1.122,22,2.5,22H12c0.276,0,0.5-0.224,0.5-0.5S12.276,21,12,21z    M5,3h1.5C6.776,3,7,2.776,7,2.5C7,2.347,7.042,1,8.5,1S10,2.347,10,2.5C10,2.776,10.224,3,10.5,3H12v3H5V3z" }, null, -1),
    o("path", { d: "M10.5,9h-5C5.224,9,5,9.224,5,9.5S5.224,10,5.5,10h5c0.276,0,0.5-0.224,0.5-0.5S10.776,9,10.5,9z" }, null, -1),
    o("path", { d: "M10.5,11h-5C5.224,11,5,11.224,5,11.5S5.224,12,5.5,12h5c0.276,0,0.5-0.224,0.5-0.5S10.776,11,10.5,11z" }, null, -1),
    o("path", { d: "M11,13.5c0-0.276-0.224-0.5-0.5-0.5h-5C5.224,13,5,13.224,5,13.5S5.224,14,5.5,14h5C10.776,14,11,13.776,11,13.5z" }, null, -1),
    o("path", { d: "M5.5,15C5.224,15,5,15.224,5,15.5S5.224,16,5.5,16h3C8.776,16,9,15.776,9,15.5S8.776,15,8.5,15H5.5z" }, null, -1),
    o("path", { d: "M20.414,13.001c-0.951,0-2.071,0.491-2.777,1.784c-0.706-1.293-1.826-1.784-2.777-1.784c-1.584,0-3.223,1.322-3.223,3.536   c0,3.181,5.473,7.198,5.706,7.367C17.43,23.969,17.534,24,17.637,24s0.207-0.031,0.294-0.096c0.233-0.169,5.706-4.187,5.706-7.367   C23.637,14.323,21.998,13.001,20.414,13.001z M17.637,22.876c-1.63-1.246-5-4.253-5-6.339c0-1.588,1.13-2.536,2.223-2.536   c1.086,0,1.942,0.864,2.291,2.313c0.108,0.449,0.864,0.449,0.973,0c0.348-1.448,1.204-2.313,2.291-2.313   c1.093,0,2.223,0.948,2.223,2.536C22.637,18.621,19.267,21.63,17.637,22.876z" }, null, -1)
  ]));
}
const zu = /* @__PURE__ */ S(Au, [["render", Pu]]), Yu = {
  name: "LuxIconReportRemove",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Vu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("g", null, [
        o("path", { d: `M17.5,24c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5S21.1,24,17.5,24z M17.5,12c-3,0-5.5,2.5-5.5,5.5
          s2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5S20.5,12,17.5,12z` })
      ]),
      o("g", null, [
        o("path", { d: `M15,20.5c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7l5-5c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7l-5,5
          C15.3,20.5,15.1,20.5,15,20.5z` })
      ]),
      o("g", null, [
        o("path", { d: `M20,20.5c-0.1,0-0.3,0-0.4-0.1l-5-5c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l5,5c0.2,0.2,0.2,0.5,0,0.7
          C20.3,20.5,20.1,20.5,20,20.5z` })
      ])
    ], -1),
    o("g", null, [
      o("g", null, [
        o("path", { d: "M8,7H3.5C3.2,7,3,6.8,3,6.5S3.2,6,3.5,6H8c0.3,0,0.5,0.2,0.5,0.5S8.3,7,8,7z" })
      ]),
      o("g", null, [
        o("path", { d: "M11.5,10h-8C3.2,10,3,9.8,3,9.5S3.2,9,3.5,9h8C11.8,9,12,9.2,12,9.5S11.8,10,11.5,10z" })
      ]),
      o("g", null, [
        o("path", { d: "M9.5,13h-6C3.2,13,3,12.8,3,12.5S3.2,12,3.5,12h6c0.3,0,0.5,0.2,0.5,0.5S9.8,13,9.5,13z" })
      ]),
      o("g", null, [
        o("path", { d: "M8.5,16h-5C3.2,16,3,15.8,3,15.5S3.2,15,3.5,15h5C8.8,15,9,15.2,9,15.5S8.8,16,8.5,16z" })
      ]),
      o("g", null, [
        o("g", null, [
          o("path", { d: `M10.5,22h-10C0.2,22,0,21.8,0,21.5v-21C0,0.2,0.2,0,0.5,0h11c0.1,0,0.3,0.1,0.4,0.1l5,5C16.9,5.2,17,5.4,17,5.5v4
            c0,0.3-0.2,0.5-0.5,0.5S16,9.8,16,9.5V5.7L11.3,1H1v20h9.5c0.3,0,0.5,0.2,0.5,0.5S10.8,22,10.5,22z` })
        ]),
        o("g", null, [
          o("path", { d: "M16.5,6h-5C11.2,6,11,5.8,11,5.5v-5C11,0.2,11.2,0,11.5,0S12,0.2,12,0.5V5h4.5C16.8,5,17,5.2,17,5.5S16.8,6,16.5,6z" })
        ])
      ])
    ], -1)
  ]));
}
const Hu = /* @__PURE__ */ S(Yu, [["render", Vu]]), Nu = {
  name: "LuxIconReportUnhealthy",
  status: "ready",
  release: "4.1.0",
  type: "Element"
};
function Ru(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: "M2.5,5C2.224,5,2,5.224,2,5.5v14C2,19.776,2.224,20,2.5,20H11c0.276,0,0.5-0.224,0.5-0.5S11.276,19,11,19H3V6h1v0.5   C4,6.776,4.224,7,4.5,7h8C12.776,7,13,6.776,13,6.5V6h1v7c0,0.276,0.224,0.5,0.5,0.5S15,13.276,15,13V5.5C15,5.224,14.776,5,14.5,5   H13V4h3v6c0,0.276,0.224,0.5,0.5,0.5S17,10.276,17,10V3.5C17,3.224,16.776,3,16.5,3H13V2.5C13,2.224,12.776,2,12.5,2h-1.545   C10.766,0.963,9.98,0,8.5,0S6.234,0.963,6.045,2H4.5C4.224,2,4,2.224,4,2.5V3H0.5C0.224,3,0,3.224,0,3.5v16   C0,20.879,1.122,22,2.5,22H10c0.276,0,0.5-0.224,0.5-0.5S10.276,21,10,21H2.5C1.673,21,1,20.327,1,19.5V4h3v1H2.5z M5,3h1.5   C6.776,3,7,2.776,7,2.5C7,2.347,7.042,1,8.5,1S10,2.347,10,2.5C10,2.776,10.224,3,10.5,3H12v3H5V3z" }, null, -1),
    o("path", { d: "M10.5,9h-5C5.224,9,5,9.224,5,9.5S5.224,10,5.5,10h5c0.276,0,0.5-0.224,0.5-0.5S10.776,9,10.5,9z" }, null, -1),
    o("path", { d: "M10.5,11h-5C5.224,11,5,11.224,5,11.5S5.224,12,5.5,12h5c0.276,0,0.5-0.224,0.5-0.5S10.776,11,10.5,11z" }, null, -1),
    o("path", { d: "M11,13.5c0-0.276-0.224-0.5-0.5-0.5h-5C5.224,13,5,13.224,5,13.5S5.224,14,5.5,14h5C10.776,14,11,13.776,11,13.5z" }, null, -1),
    o("path", { d: "M5.5,15C5.224,15,5,15.224,5,15.5S5.224,16,5.5,16h3C8.776,16,9,15.776,9,15.5S8.776,15,8.5,15H5.5z" }, null, -1),
    o("path", { d: "M23.892,23.166l-5.945-11.89c-0.17-0.338-0.725-0.338-0.895,0l-6,12c-0.078,0.155-0.069,0.339,0.022,0.486   S11.327,24,11.5,24h12c0.007,0,0.013,0,0.02,0c0.276,0,0.5-0.224,0.5-0.5C24.02,23.371,23.972,23.254,23.892,23.166z M12.309,23   L17.5,12.619L22.691,23H12.309z" }, null, -1),
    o("path", { d: "M17,16.409v3.272c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-3.272c0-0.276-0.224-0.5-0.5-0.5S17,16.133,17,16.409z" }, null, -1),
    o("circle", {
      cx: "17.5",
      cy: "21.318",
      r: "0.545"
    }, null, -1)
  ]));
}
const Bu = /* @__PURE__ */ S(Nu, [["render", Ru]]), Fu = {
  name: "LuxIconUserHome",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function ju(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M20.5,23h-17C3.2,23,3,22.8,3,22.5v-11C3,11.2,3.2,11,3.5,11S4,11.2,4,11.5V22h16V11c0-0.3,0.2-0.5,0.5-0.5
        S21,10.7,21,11v11.5C21,22.8,20.8,23,20.5,23z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M23.5,11.5c-0.1,0-0.2,0-0.3-0.1L12,1.2L0.8,11.4c-0.2,0.2-0.5,0.2-0.7,0c-0.2-0.2-0.2-0.5,0-0.7L11.7,0.1
        c0.2-0.2,0.5-0.2,0.7,0l11.5,10.5c0.2,0.2,0.2,0.5,0,0.7C23.8,11.4,23.6,11.5,23.5,11.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M19.5,5.5C19.2,5.5,19,5.3,19,5V2h-3c-0.3,0-0.5-0.2-0.5-0.5S15.7,1,16,1h3.5C19.8,1,20,1.2,20,1.5V5
        C20,5.3,19.8,5.5,19.5,5.5z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,15c-1.9,0-3.5-1.6-3.5-3.5S10.1,8,12,8s3.5,1.6,3.5,3.5S13.9,15,12,15z M12,9c-1.4,0-2.5,1.1-2.5,2.5
        S10.6,14,12,14c1.4,0,2.5-1.1,2.5-2.5S13.4,9,12,9z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M17.3,20H6.7c-0.3,0-0.5-0.2-0.5-0.5c0-3.1,2.5-5.5,5.8-5.5s5.8,2.4,5.8,5.5C17.8,19.8,17.6,20,17.3,20z M7.2,19h9.6
        c-0.3-2.3-2.2-4-4.8-4C9.4,15,7.4,16.7,7.2,19z` })
    ], -1)
  ]));
}
const Wu = /* @__PURE__ */ S(Fu, [["render", ju]]), Uu = {
  name: "LuxIconReported",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function qu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("g", null, [
        o("path", { d: `M17.5,24c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5S21.1,24,17.5,24z M17.5,12c-3,0-5.5,2.5-5.5,5.5
          s2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5S20.5,12,17.5,12z` })
      ]),
      o("g", null, [
        o("path", { d: `M16.5,20c-0.1,0-0.3,0-0.4-0.1l-2-2c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l1.6,1.6l3.6-3.6c0.2-0.2,0.5-0.2,0.7,0
          s0.2,0.5,0,0.7l-4,4C16.8,20,16.6,20,16.5,20z` })
      ])
    ], -1),
    o("g", null, [
      o("g", null, [
        o("path", { d: "M8,7H3.5C3.2,7,3,6.8,3,6.5S3.2,6,3.5,6H8c0.3,0,0.5,0.2,0.5,0.5S8.3,7,8,7z" })
      ]),
      o("g", null, [
        o("path", { d: "M11.5,10h-8C3.2,10,3,9.8,3,9.5S3.2,9,3.5,9h8C11.8,9,12,9.2,12,9.5S11.8,10,11.5,10z" })
      ]),
      o("g", null, [
        o("path", { d: "M9.5,13h-6C3.2,13,3,12.8,3,12.5S3.2,12,3.5,12h6c0.3,0,0.5,0.2,0.5,0.5S9.8,13,9.5,13z" })
      ]),
      o("g", null, [
        o("path", { d: "M8.5,16h-5C3.2,16,3,15.8,3,15.5S3.2,15,3.5,15h5C8.8,15,9,15.2,9,15.5S8.8,16,8.5,16z" })
      ]),
      o("g", null, [
        o("g", null, [
          o("path", { d: `M10.5,22h-10C0.2,22,0,21.8,0,21.5v-21C0,0.2,0.2,0,0.5,0h11c0.1,0,0.3,0.1,0.4,0.1l5,5C16.9,5.2,17,5.4,17,5.5v4
            c0,0.3-0.2,0.5-0.5,0.5S16,9.8,16,9.5V5.7L11.3,1H1v20h9.5c0.3,0,0.5,0.2,0.5,0.5S10.8,22,10.5,22z` })
        ]),
        o("g", null, [
          o("path", { d: "M16.5,6h-5C11.2,6,11,5.8,11,5.5v-5C11,0.2,11.2,0,11.5,0S12,0.2,12,0.5V5h4.5C16.8,5,17,5.2,17,5.5S16.8,6,16.5,6z" })
        ])
      ])
    ], -1)
  ]));
}
const Gu = /* @__PURE__ */ S(Uu, [["render", qu]]), Ku = {
  name: "LuxIconResearch",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Zu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M8.5,18.9c-0.1,0-0.1,0-0.2,0c-2.1-0.9-5-1.4-7.8-1.4C0.2,17.5,0,17.3,0,17V0.5C0,0.2,0.2,0,0.5,0c4.7,0,9.5,1,11,2.8
          C13,1,17.8,0,22.5,0C22.8,0,23,0.2,23,0.5V17c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-1,0-1,0l0-1c0,0,0.2,0,0.5,0V1c-5.7,0.1-10,1.6-10,3
          c0,0.3-0.2,0.5-0.5,0.5S11,4.3,11,4c0-1.3-4.3-2.9-10-3v15.5c2.8,0.1,5.6,0.6,7.7,1.4C8.9,18,9.1,18.3,9,18.6
          C8.9,18.8,8.7,18.9,8.5,18.9z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M11.5,5C11.2,5,11,4.8,11,4.5V4c0-0.3,0.2-0.5,0.5-0.5S12,3.7,12,4v0.5C12,4.8,11.8,5,11.5,5z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M9,6.7c-0.1,0-0.1,0-0.2,0C7.2,6.1,5,5.7,2.5,5.5C2.2,5.5,2,5.2,2,5s0.3-0.5,0.5-0.5c2.6,0.2,5,0.6,6.6,1.3
          c0.3,0.1,0.4,0.4,0.3,0.6C9.4,6.6,9.2,6.7,9,6.7z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M7,9.1c0,0-0.1,0-0.1,0C5.6,8.8,4.1,8.6,2.5,8.5C2.2,8.5,2,8.2,2,8s0.3-0.5,0.5-0.5c1.7,0.1,3.2,0.3,4.6,0.7
          c0.3,0.1,0.4,0.3,0.4,0.6C7.5,9,7.2,9.1,7,9.1z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M5.9,11.9C5.9,11.9,5.9,11.9,5.9,11.9c-1.1-0.2-2.3-0.3-3.5-0.4C2.2,11.5,2,11.2,2,11s0.3-0.5,0.5-0.5
          c1.2,0.1,2.4,0.2,3.5,0.4c0.3,0,0.5,0.3,0.4,0.6C6.4,11.8,6.2,11.9,5.9,11.9z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M6.1,14.9C6.1,14.9,6,14.9,6.1,14.9c-1.2-0.2-2.4-0.4-3.6-0.4C2.2,14.5,2,14.2,2,14s0.3-0.5,0.5-0.5
          c1.3,0.1,2.5,0.2,3.6,0.5c0.3,0.1,0.4,0.3,0.4,0.6C6.5,14.8,6.3,14.9,6.1,14.9z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M16.5,6c-0.2,0-0.4-0.2-0.5-0.4C16,5.4,16.2,5.1,16.4,5c1.2-0.3,2.6-0.4,4-0.5C20.7,4.5,21,4.7,21,5
          c0,0.3-0.2,0.5-0.5,0.5c-1.4,0.1-2.7,0.3-3.9,0.5C16.6,6,16.6,6,16.5,6z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M19.4,8.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.4-0.5c0.4,0,0.7-0.1,1.1-0.1C20.7,7.5,21,7.7,21,8s-0.2,0.5-0.5,0.5
          C20.2,8.5,19.8,8.6,19.4,8.6C19.5,8.6,19.4,8.6,19.4,8.6z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M13.5,19C9.9,19,7,16.1,7,12.5S9.9,6,13.5,6S20,8.9,20,12.5S17.1,19,13.5,19z M13.5,7C10.5,7,8,9.5,8,12.5
          c0,3,2.5,5.5,5.5,5.5c3,0,5.5-2.5,5.5-5.5C19,9.5,16.5,7,13.5,7z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M23.5,23c-0.1,0-0.3,0-0.4-0.1l-5.7-5.7c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l5.7,5.7c0.2,0.2,0.2,0.5,0,0.7
          C23.8,23,23.6,23,23.5,23z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M15.5,13c-0.3,0-0.5-0.2-0.5-0.5V11h-3v1.5c0,0.3-0.2,0.5-0.5,0.5S11,12.8,11,12.5v-2c0-0.3,0.2-0.5,0.5-0.5h4
          c0.3,0,0.5,0.2,0.5,0.5v2C16,12.8,15.8,13,15.5,13z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M13.5,16c-0.3,0-0.5-0.2-0.5-0.5v-5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v5C14,15.8,13.8,16,13.5,16z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M15,16h-3c-0.3,0-0.5-0.2-0.5-0.5S11.7,15,12,15h3c0.3,0,0.5,0.2,0.5,0.5S15.3,16,15,16z" })
    ], -1)
  ]));
}
const Xu = /* @__PURE__ */ S(Ku, [["render", Zu]]), Ju = {
  name: "LuxIconScales",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function Qu(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: "M11.5,22c-0.3,0-0.5-0.2-0.5-0.5V6.4c0-0.3,0.2-0.5,0.5-0.5S12,6.2,12,6.4v15.1C12,21.8,11.8,22,11.5,22z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M14.4,22H8.6c-0.3,0-0.5-0.2-0.5-0.5S8.3,21,8.6,21h5.8c0.3,0,0.5,0.2,0.5,0.5S14.7,22,14.4,22z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M11.5,6.9c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S12.6,6.9,11.5,6.9z M11.5,4c-0.5,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1
          S12,4,11.5,4z` })
    ], -1),
    o("g", null, [
      o("g", null, [
        o("path", { d: `M7.5,13c-0.2,0-0.4-0.1-0.5-0.3L4,5.7l-3,6.9C0.8,13,0.6,13.1,0.3,13C0,12.8-0.1,12.6,0,12.3l3.5-8C3.6,4.1,3.8,4,4,4
            c0,0,0,0,0,0c0.2,0,0.4,0.1,0.5,0.3l3.5,8c0.1,0.3,0,0.5-0.3,0.7C7.6,13,7.6,13,7.5,13z` })
      ]),
      o("g", null, [
        o("path", { d: "M10.1,5H2.5C2.2,5,2,4.8,2,4.5S2.2,4,2.5,4h7.6c0.3,0,0.5,0.2,0.5,0.5S10.4,5,10.1,5z" })
      ]),
      o("g", null, [
        o("path", { d: `M4,16.5c-2.2,0-4-1.8-4-4C0,12.2,0.2,12,0.5,12h7C7.8,12,8,12.2,8,12.5C8,14.7,6.2,16.5,4,16.5z M1,13
            c0.2,1.4,1.5,2.5,3,2.5s2.7-1.1,3-2.5H1z` })
      ])
    ], -1),
    o("g", null, [
      o("g", null, [
        o("path", { d: `M15.5,13c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.7l3.5-8C18.6,4.1,18.8,4,19,4l0,0c0.2,0,0.4,0.1,0.5,0.3l3.5,8
            c0.1,0.3,0,0.5-0.3,0.7c-0.3,0.1-0.5,0-0.7-0.3l-3-6.9l-3,6.9C15.9,12.9,15.7,13,15.5,13z` })
      ]),
      o("g", null, [
        o("path", { d: "M20.5,5h-7.6c-0.3,0-0.5-0.2-0.5-0.5S12.6,4,12.9,4h7.6C20.8,4,21,4.2,21,4.5S20.8,5,20.5,5z" })
      ]),
      o("g", null, [
        o("path", { d: `M19,16.5c-2.2,0-4-1.8-4-4c0-0.3,0.2-0.5,0.5-0.5h7c0.3,0,0.5,0.2,0.5,0.5C23,14.7,21.2,16.5,19,16.5z M16,13
            c0.2,1.4,1.5,2.5,3,2.5s2.7-1.1,3-2.5H16z` })
      ])
    ], -1)
  ]));
}
const ec = /* @__PURE__ */ S(Ju, [["render", Qu]]), tc = {
  name: "LuxIconSearch",
  status: "ready",
  release: "1.0.0",
  type: "Element"
}, nc = {
  class: "lux-search-icon",
  d: "M9.58,16.8c1.65,0,3.25-.57,4.5-1.59l6.14,6.14c.3.32.83.33,1.13.02.32-.31.32-.83.02-1.14,0,0-6.16-6.16-6.16-6.16C19.84,8.26,13.64.15,6.79,2.98-.39,6.12,1.74,16.7,9.58,16.8ZM9.58,4.01c3.92-.07,6.78,4.2,5.16,7.77-1.86,4.54-8.47,4.54-10.32,0-1.62-3.57,1.24-7.84,5.16-7.77Z"
};
function ac(e, t, n, a, r, s) {
  return h(), g("path", nc);
}
const rc = /* @__PURE__ */ S(tc, [["render", ac]]), sc = {
  name: "LuxIconUnsorted",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function ic(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("circle", {
      class: "st0",
      cx: "12",
      cy: "12",
      r: "2"
    }, null, -1),
    o("polygon", {
      class: "st1",
      points: "17.5,6.5 12,0.5 6.5,6.5 	"
    }, null, -1),
    o("polygon", {
      class: "st1",
      points: "6.5,17.5 12,23.5 17.5,17.5 	"
    }, null, -1)
  ]));
}
const oc = /* @__PURE__ */ S(sc, [["render", ic], ["__scopeId", "data-v-c811dfb3"]]), lc = {
  name: "LuxIconVacation",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function uc(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("g", null, [
      o("path", { d: `M18.4,24H0.5C0.2,24,0,23.8,0,23.5c0-3.7,4.9-5,9.5-5c4.6,0,9.5,1.3,9.5,5C18.9,23.8,18.7,24,18.4,24z M1,23h16.8
          c-0.5-2.6-4.7-3.5-8.4-3.5C5.8,19.5,1.5,20.4,1,23z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M6.5,19.5L5.6,19l5.9-10.8C11.7,8.1,11.9,8,12.1,8s0.4,0.3,0.4,0.5L12,19.1l-1,0l0.4-8.5L6.5,19.5z" })
    ], -1),
    o("g", null, [
      o("path", { d: `M3.7,11.4c-0.9,0-1.8,0-2.7-0.1c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.3,0-0.5c2.1-5,8.7-4.8,11.7-3.6
          c0.2,0.1,0.3,0.3,0.3,0.5v1c0,0.2-0.1,0.3-0.2,0.4C9.5,10.9,6.7,11.4,3.7,11.4z M1.7,10.3c3.6,0.2,6.7,0,9.8-2.1V7.9
          C9.3,7.1,3.9,6.6,1.7,10.3z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,8c-0.1,0-0.1,0-0.2,0L4.3,5C4.1,4.9,4,4.7,4,4.6c0-0.2,0.1-0.4,0.2-0.5C6,2.9,8.1,2.8,9.9,3.8
          c1.6,0.8,2.6,2.3,2.6,3.7c0,0.2-0.1,0.3-0.2,0.4C12.2,8,12.1,8,12,8z M5.7,4.4l5.7,2.3c-0.3-0.8-1-1.6-1.9-2.1
          C8.2,4,6.9,3.9,5.7,4.4z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M19.1,11.5c-2.9,0-5.6-0.5-7.5-2.6c-0.1-0.1-0.1-0.2-0.1-0.3v-1c0-0.2,0.1-0.4,0.3-0.5c3-1.2,9.6-1.4,11.7,3.6
          c0.1,0.1,0.1,0.3,0,0.5c-0.1,0.1-0.2,0.2-0.4,0.2l-0.9,0C21.2,11.4,20.1,11.5,19.1,11.5z M12.5,8.3c2.2,2.5,6,2.2,9.7,2l0.1,0
          c-2.2-3.7-7.6-3.2-9.8-2.5V8.3z` })
    ], -1),
    o("g", null, [
      o("path", { d: `M12,8c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.4c0-1.4,1-2.9,2.6-3.7c1.8-1,3.9-0.9,5.7,0.3
          C19.9,4.2,20,4.4,20,4.6c0,0.2-0.1,0.3-0.3,0.4l-7.5,3C12.1,8,12.1,8,12,8z M16.7,4.1c-0.7,0-1.4,0.2-2.1,0.5
          c-0.9,0.5-1.6,1.3-1.9,2.1l5.7-2.3C17.8,4.2,17.2,4.1,16.7,4.1z` })
    ], -1),
    o("g", null, [
      o("path", { d: "M11.6,17.5H10c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.6c0.3,0,0.5,0.2,0.5,0.5S11.9,17.5,11.6,17.5z" })
    ], -1),
    o("g", null, [
      o("path", { d: "M11.7,15.5h-1.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.2c0.3,0,0.5,0.2,0.5,0.5S12,15.5,11.7,15.5z" })
    ], -1)
  ]));
}
const cc = /* @__PURE__ */ S(lc, [["render", uc]]), dc = {
  name: "LuxIconView",
  status: "ready",
  release: "1.0.0",
  type: "Element"
};
function fc(e, t, n, a, r, s) {
  return h(), g("g", null, t[0] || (t[0] = [
    o("path", { d: `M1.4,7.5c0.1,0,0.1,0.1,0.2,0.1c0.2,0,0.4-0.1,0.5-0.3c1-2.2,2.8-4,4.9-5.1c0.2-0.1,0.3-0.4,0.2-0.7
  		C7.1,1.3,6.8,1.2,6.5,1.3C4.2,2.5,2.3,4.5,1.2,6.8C1.1,7.1,1.2,7.4,1.4,7.5z` }, null, -1),
    o("path", { d: `M9.5,1.3c2.3-0.5,4.8-0.3,7,0.7c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.5-0.3c0.1-0.3,0-0.5-0.2-0.7C14.6,0,11.8-0.3,9.3,0.3
  		C9,0.4,8.9,0.6,8.9,0.9S9.2,1.3,9.5,1.3z` }, null, -1),
    o("path", { d: `M22.7,9.3c0.1,0.2,0.3,0.4,0.5,0.4c0,0,0.1,0,0.1,0c0.3-0.1,0.4-0.3,0.4-0.6c-0.6-2.5-2.1-4.8-4.2-6.5
  		c-0.2-0.2-0.5-0.1-0.7,0.1s-0.1,0.5,0.1,0.7C20.7,4.9,22.1,7,22.7,9.3z` }, null, -1),
    o("path", { d: `M1,12c0-0.7,0.1-1.5,0.2-2.2c0.1-0.3-0.1-0.5-0.4-0.6C0.6,9.2,0.3,9.3,0.2,9.6C0.1,10.4,0,11.2,0,12c0,1.8,0.4,3.6,1.2,5.2
  		c0.1,0.2,0.3,0.3,0.4,0.3c0.1,0,0.1,0,0.2,0c0.2-0.1,0.4-0.4,0.2-0.7C1.4,15.3,1,13.7,1,12z` }, null, -1),
    o("path", { d: `M18.9,20.6c-1.9,1.5-4.2,2.4-6.6,2.4c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0,0,0,0,0,0c2.7-0.1,5.2-1,7.2-2.6
  		c0.2-0.2,0.2-0.5,0.1-0.7C19.4,20.5,19.1,20.4,18.9,20.6z` }, null, -1),
    o("path", { d: `M23.5,11.5c-0.3,0-0.5,0.2-0.5,0.5c0,2.4-0.8,4.7-2.3,6.7c-0.2,0.2-0.1,0.5,0.1,0.7c0.1,0.1,0.2,0.1,0.3,0.1
  		c0.1,0,0.3-0.1,0.4-0.2c1.6-2.1,2.5-4.6,2.5-7.3v0C24,11.7,23.8,11.5,23.5,11.5z` }, null, -1),
    o("path", { d: `M9.6,22.7c-2.3-0.5-4.5-1.8-6-3.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.2,0.2-0.2,0.5-0.1,0.7c1.7,2,4,3.4,6.6,4c0,0,0.1,0,0.1,0
  		c0.2,0,0.4-0.2,0.5-0.4C10,23.1,9.8,22.8,9.6,22.7z` }, null, -1),
    o("path", { d: `M12,7c-4.6,0-8.2,4.5-8.4,4.7c-0.1,0.2-0.1,0.4,0,0.6C3.8,12.5,7.4,17,12,17c4.6,0,8.2-4.5,8.4-4.7c0.1-0.2,0.1-0.4,0-0.6
  		C20.2,11.5,16.5,7,12,7z M12,16c-3.4,0-6.4-3-7.3-4c0.9-1,3.9-4,7.3-4c3.4,0,6.4,3,7.3,4C18.4,13,15.4,16,12,16z` }, null, -1),
    o("path", { d: "M12,9c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S13.6,9,12,9z M12,14c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S13.1,14,12,14z" }, null, -1)
  ]));
}
const hc = /* @__PURE__ */ S(dc, [["render", fc]]), pc = {
  name: "LuxInputButton",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  data: function() {
    return {
      label: "Submit"
    };
  },
  props: {
    /**
     * The button's variations `solid, outline, text, dropdown, icon`
     */
    variation: {
      type: String,
      default: "solid",
      validator: (e) => e.match(/(solid|outline|text|dropdown|icon|icon-prepend)/)
    },
    /**
     * The button's type attribute `button, submit`
     */
    type: {
      type: String,
      default: "button",
      validator: (e) => e.match(/(|button|submit)/)
    },
    /**
     * Sets the size of the button `small, medium, large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    },
    /**
     * Whether the button extends the full available width or not
     */
    block: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the button is disabled or not
     * `true, false`
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the button is focused or not
     * `true, false`
     */
    focused: {
      type: Boolean,
      default: !1
    },
    /**
     * Clicking this button can emit a custom event that should trigger an alert.
     * You must supply an alertStatus and alertMessage, like so:
     * { 'alertStatus': 'success', 'alertMessage': 'This is my message.'}
     */
    customAlertEvent: {
      type: Object,
      default: null
    },
    /**
     * Visually hides the button text.
     */
    hideLabel: {
      type: Boolean,
      default: !1
    },
    /**
     * Indicates what icon to use. Values should be hyphenated and do not use the "lux-icon-" prefix.
     * For example, instead of `lux-icon-search`, simply use `search`.
     */
    icon: {
      type: String,
      default: ""
    }
  },
  computed: {
    iconComponent() {
      return "lux-icon-" + this.icon;
    }
  },
  emits: ["button-clicked", "system-alert"],
  methods: {
    buttonClicked(e) {
      this.customAlertEvent && this.$emit("system-alert", {
        event: e,
        alertStatus: this.customAlertEvent.alertStatus,
        alertMessage: this.customAlertEvent.alertMessage
      }), this.$emit("button-clicked", e);
    }
  },
  mounted() {
    let e = this;
    e.$nextTick(function() {
      e.focused && this.$refs.inputButton.focus();
    });
  },
  components: {
    LuxIconBase: In
  }
}, vc = ["type", "disabled"], mc = {
  key: 0,
  class: "prepend-icon"
}, gc = {
  key: 1,
  class: "append-icon"
};
function yc(e, t, n, a, r, s) {
  const i = Y("lux-icon-base");
  return h(), g("button", {
    ref: "inputButton",
    type: n.type ? n.type : !1,
    class: z(["lux-button", n.variation, n.size, { "lux-expanded": n.block == !0 }]),
    disabled: n.disabled,
    onClick: t[0] || (t[0] = (l) => s.buttonClicked(l))
  }, [
    n.variation === "icon-prepend" ? (h(), g("div", mc, [
      k(i, {
        width: "18",
        height: "18",
        "icon-name": n.icon
      }, {
        default: P(() => [
          (h(), H(ie(s.iconComponent)))
        ]),
        _: 1
      }, 8, ["icon-name"])
    ])) : B("", !0),
    ae(e.$slots, "default", {}, void 0, !0),
    n.variation === "icon" ? (h(), g("div", gc, [
      k(i, {
        width: "18",
        height: "18",
        "icon-name": n.icon
      }, {
        default: P(() => [
          (h(), H(ie(s.iconComponent)))
        ]),
        _: 1
      }, 8, ["icon-name"])
    ])) : B("", !0)
  ], 10, vc);
}
const Pr = /* @__PURE__ */ S(pc, [["render", yc], ["__scopeId", "data-v-3b077077"]]), bc = {
  name: "LuxInputCheckbox",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  model: {
    prop: "checked",
    event: "change"
  },
  emits: ["change", "inputblur"],
  data: function() {
    return {
      wrapper: this.groupLabel.length ? "fieldset" : "div"
    };
  },
  props: {
    /**
     * If true, the checkboxes will be stacked vertically. Otherwise they will be horizontal (inline).
     */
    vertical: {
      type: Boolean,
      default: !1
    },
    /**
     * The available options to check. Option properties are: id, value, disabled, required, checked
     */
    options: {
      required: !0,
      type: Array
    },
    /**
     * The label of the form input field.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * The validation message a user should get.
     */
    errormessage: {
      type: String,
      default: ""
    },
    /**
     * The html element name used for the wrapper.
     * `div, section`
     */
    groupLabel: {
      type: String,
      default: ""
    },
    /**
     * Whether the form input field is disabled or not.
     * `true, false`
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the form input field is required or not.
     * `true, false`
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s hover state.
     * `true, false`
     */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s focus state.
     * `true, false`
     */
    focus: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    change(e) {
      this.$emit("change", e.target.checked);
    },
    inputblur(e) {
      this.$emit("inputblur", e);
    }
  }
}, _c = { key: 0 }, wc = ["id", "name", "value", "checked", "disabled", "required"], $c = ["for"], Cc = ["for"], xc = {
  key: 1,
  role: "alert",
  class: "lux-error"
};
function Sc(e, t, n, a, r, s) {
  return h(), H(ie(e.wrapper), { class: "lux-input" }, {
    default: P(() => [
      n.groupLabel ? (h(), g("legend", _c, j(n.groupLabel), 1)) : B("", !0),
      (h(!0), g(se, null, fe(n.options, (i) => (h(), g("div", {
        class: z(["lux-checkbox", { "lux-inline": !n.vertical }]),
        key: i.id
      }, [
        o("input", {
          type: "checkbox",
          id: i.id,
          name: n.label,
          value: i.value,
          checked: i.checked,
          disabled: i.disabled,
          required: i.required,
          onChange: t[0] || (t[0] = (l) => s.change(l)),
          onBlur: t[1] || (t[1] = (l) => s.inputblur(l.target))
        }, null, 40, wc),
        i.label ? (h(), g("label", {
          key: 0,
          for: i.id
        }, j(i.label), 9, $c)) : (h(), g("label", {
          key: 1,
          for: i.id
        }, j(i.value), 9, Cc))
      ], 2))), 128)),
      n.errormessage ? (h(), g("div", xc, j(n.errormessage), 1)) : B("", !0)
    ]),
    _: 1
  });
}
const Mc = /* @__PURE__ */ S(bc, [["render", Sc], ["__scopeId", "data-v-42b6a3db"]]);
function Fa(e) {
  return e === 0 ? !1 : Array.isArray(e) && e.length === 0 ? !0 : !e;
}
function Dc(e) {
  return (...t) => !e(...t);
}
function kc(e, t) {
  return e === void 0 && (e = "undefined"), e === null && (e = "null"), e === !1 && (e = "false"), e.toString().toLowerCase().indexOf(t.trim()) !== -1;
}
function Lc(e) {
  return e.filter((t) => !t.$isLabel);
}
function ja(e, t) {
  return (n) => n.reduce((a, r) => r[e] && r[e].length ? (a.push({
    $groupLabel: r[t],
    $isLabel: !0
  }), a.concat(r[e])) : a, []);
}
const S1 = (...e) => (t) => e.reduce((n, a) => a(n), t);
var Oc = {
  data() {
    return {
      search: "",
      isOpen: !1,
      preferredOpenDirection: "below",
      optimizedHeight: this.maxHeight
    };
  },
  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: !0
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: !0
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: !1
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: "Select option"
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: !1
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default(e, t) {
        return Fa(e) ? "" : t ? e[t] : e;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: !1
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: "Press enter to create a tag"
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: "top"
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: !1
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1e3
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
    */
    preserveSearch: {
      type: Boolean,
      default: !1
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
    */
    preselectFirst: {
      type: Boolean,
      default: !1
    },
    /**
     * Prevent autofocus
     * @default false
     * @type {Boolean}
     */
    preventAutofocus: {
      type: Boolean,
      default: !1
    },
    /**
     * Allows a custom function for sorting search/filtered results.
     * @default null
     * @type {Function}
     */
    filteringSortFunc: {
      type: Function,
      default: null
    }
  },
  mounted() {
    !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
  },
  computed: {
    internalValue() {
      return this.modelValue || this.modelValue === 0 ? Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue] : [];
    },
    filteredOptions() {
      const e = this.search || "", t = e.toLowerCase().trim();
      let n = this.options.concat();
      return this.internalSearch ? n = this.groupValues ? this.filterAndFlat(n, t, this.label) : this.filterOptions(n, t, this.label, this.customLabel) : n = this.groupValues ? ja(this.groupValues, this.groupLabel)(n) : n, n = this.hideSelected ? n.filter(Dc(this.isSelected)) : n, this.taggable && t.length && !this.isExistingOption(t) && (this.tagPosition === "bottom" ? n.push({ isTag: !0, label: e }) : n.unshift({ isTag: !0, label: e })), n.slice(0, this.optionsLimit);
    },
    valueKeys() {
      return this.trackBy ? this.internalValue.map((e) => e[this.trackBy]) : this.internalValue;
    },
    optionKeys() {
      return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map((t) => this.customLabel(t, this.label).toString().toLowerCase());
    },
    currentOptionLabel() {
      return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
    }
  },
  watch: {
    internalValue: {
      handler() {
        this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("update:modelValue", this.multiple ? [] : null));
      },
      deep: !0
    },
    search() {
      this.$emit("search-change", this.search);
    }
  },
  emits: ["open", "search-change", "close", "select", "update:modelValue", "remove", "tag"],
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },
    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @return {Array} returns a filtered and flat options list
     */
    filterAndFlat(e, t, n) {
      return S1(
        this.filterGroups(t, n, this.groupValues, this.groupLabel, this.customLabel),
        ja(this.groupValues, this.groupLabel)
      )(e);
    },
    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @return {Array} returns a flat options list without group labels
     */
    flatAndStrip(e) {
      return S1(
        ja(this.groupValues, this.groupLabel),
        Lc
      )(e);
    },
    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch(e) {
      this.search = e;
    },
    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @return {Boolean} returns true if element is available
     */
    isExistingOption(e) {
      return this.options ? this.optionKeys.indexOf(e) > -1 : !1;
    },
    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected(e) {
      const t = this.trackBy ? e[this.trackBy] : e;
      return this.valueKeys.indexOf(t) > -1;
    },
    /**
     * Finds out if the given option is disabled
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is disabled
     */
    isOptionDisabled(e) {
      return !!e.$isDisabled;
    },
    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel(e) {
      if (Fa(e)) return "";
      if (e.isTag) return e.label;
      if (e.$isLabel) return e.$groupLabel;
      const t = this.customLabel(e, this.label);
      return Fa(t) ? "" : t;
    },
    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select(e, t) {
      if (e.$isLabel && this.groupSelect) {
        this.selectGroup(e);
        return;
      }
      if (!(this.blockKeys.indexOf(t) !== -1 || this.disabled || e.$isDisabled || e.$isLabel) && !(this.max && this.multiple && this.internalValue.length === this.max) && !(t === "Tab" && !this.pointerDirty)) {
        if (e.isTag)
          this.$emit("tag", e.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();
        else {
          if (this.isSelected(e)) {
            t !== "Tab" && this.removeElement(e);
            return;
          }
          this.multiple ? this.$emit("update:modelValue", this.internalValue.concat([e])) : this.$emit("update:modelValue", e), this.$emit("select", e, this.id), this.clearOnSelect && (this.search = "");
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup(e) {
      const t = this.options.find((n) => n[this.groupLabel] === e.$groupLabel);
      if (t) {
        if (this.wholeGroupSelected(t)) {
          this.$emit("remove", t[this.groupValues], this.id);
          const n = this.trackBy ? t[this.groupValues].map((r) => r[this.trackBy]) : t[this.groupValues], a = this.internalValue.filter(
            (r) => n.indexOf(this.trackBy ? r[this.trackBy] : r) === -1
          );
          this.$emit("update:modelValue", a);
        } else {
          const n = t[this.groupValues].filter(
            (a) => !(this.isOptionDisabled(a) || this.isSelected(a))
          );
          this.max && n.splice(this.max - this.internalValue.length), this.$emit("select", n, this.id), this.$emit(
            "update:modelValue",
            this.internalValue.concat(n)
          );
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected(e) {
      return e[this.groupValues].every(
        (t) => this.isSelected(t) || this.isOptionDisabled(t)
      );
    },
    /**
     * Helper to identify if all values in a group are disabled
     *
     * @param {Object} group to check for disabled values
     */
    wholeGroupDisabled(e) {
      return e[this.groupValues].every(this.isOptionDisabled);
    },
    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @return {type}        description
     */
    removeElement(e, t = !0) {
      if (this.disabled || e.$isDisabled) return;
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }
      const n = typeof e == "object" ? this.valueKeys.indexOf(e[this.trackBy]) : this.valueKeys.indexOf(e);
      if (this.multiple) {
        const a = this.internalValue.slice(0, n).concat(this.internalValue.slice(n + 1));
        this.$emit("update:modelValue", a);
      } else
        this.$emit("update:modelValue", null);
      this.$emit("remove", e, this.id), this.closeOnSelect && t && this.deactivate();
    },
    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement() {
      this.blockKeys.indexOf("Delete") === -1 && this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
    },
    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate() {
      this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && this.pointer === 0 && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.preventAutofocus || this.$nextTick(() => this.$refs.search && this.$refs.search.focus())) : this.preventAutofocus || typeof this.$el < "u" && this.$el.focus(), this.$emit("open", this.id));
    },
    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate() {
      this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search !== null && typeof this.$refs.search < "u" && this.$refs.search.blur() : typeof this.$el < "u" && this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
    },
    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },
    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition() {
      if (typeof window > "u") return;
      const e = this.$el.getBoundingClientRect().top, t = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      t > this.maxHeight || t > e || this.openDirection === "below" || this.openDirection === "bottom" ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(t - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(e - 40, this.maxHeight));
    },
    /**
     * Filters and sorts the options ready for selection
     * @param {Array} options
     * @param {String} search
     * @param {String} label
     * @param {Function} customLabel
     * @returns {Array}
     */
    filterOptions(e, t, n, a) {
      return t ? e.filter((r) => kc(a(r, n), t)).sort((r, s) => typeof this.filteringSortFunc == "function" ? this.filteringSortFunc(r, s) : a(r, n).length - a(s, n).length) : e;
    },
    /**
     *
     * @param {String} search
     * @param {String} label
     * @param {String} values
     * @param {String} groupLabel
     * @param {function} customLabel
     * @returns {function(*): *}
     */
    filterGroups(e, t, n, a, r) {
      return (s) => s.map((i) => {
        if (!i[n])
          return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
        const l = this.filterOptions(i[n], e, t, r);
        return l.length ? {
          [a]: i[a],
          [n]: l
        } : [];
      });
    }
  }
}, Ic = {
  data() {
    return {
      pointer: 0,
      pointerDirty: !1
    };
  },
  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: !0
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions() {
      this.pointerAdjust();
    },
    isOpen() {
      this.pointerDirty = !1;
    },
    pointer() {
      this.$refs.search && this.$refs.search.setAttribute("aria-activedescendant", this.id + "-" + this.pointer.toString());
    }
  },
  methods: {
    optionHighlight(e, t) {
      return {
        "multiselect__option--highlight": e === this.pointer && this.showPointer,
        "multiselect__option--selected": this.isSelected(t)
      };
    },
    groupHighlight(e, t) {
      if (!this.groupSelect)
        return [
          "multiselect__option--disabled",
          { "multiselect__option--group": t.$isLabel }
        ];
      const n = this.options.find((a) => a[this.groupLabel] === t.$groupLabel);
      return n && !this.wholeGroupDisabled(n) ? [
        "multiselect__option--group",
        { "multiselect__option--highlight": e === this.pointer && this.showPointer },
        { "multiselect__option--group-selected": this.wholeGroupSelected(n) }
      ] : "multiselect__option--disabled";
    },
    addPointerElement({ key: e } = "Enter") {
      this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], e), this.pointerReset();
    },
    pointerForward() {
      this.pointer < this.filteredOptions.length - 1 && (this.pointer++, this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
    },
    pointerBackward() {
      this.pointer > 0 ? (this.pointer--, this.$refs.list.scrollTop >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
    },
    pointerReset() {
      this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
    },
    pointerAdjust() {
      this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
    },
    pointerSet(e) {
      this.pointer = e, this.pointerDirty = !0;
    }
  }
}, mi = {
  name: "vue-multiselect",
  mixins: [Oc, Ic],
  compatConfig: {
    MODE: 3,
    ATTR_ENUMERATED_COERCION: !1
  },
  props: {
    /**
       * name attribute to match optional label element
       * @default ''
       * @type {String}
       */
    name: {
      type: String,
      default: ""
    },
    /**
       * Presets the selected options value.
       * @type {Object||Array||String||Integer}
       */
    modelValue: {
      type: null,
      default() {
        return [];
      }
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    /**
       * String to show next to selected option
       * @default 'Selected'
       * @type {String}
       */
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    /**
       * Decide whether to show pointer labels
       * @default true
       * @type {Boolean}
       */
    showLabels: {
      type: Boolean,
      default: !0
    },
    /**
       * Limit the display of selected options. The rest will be hidden within the limitText string.
       * @default 99999
       * @type {Integer}
       */
    limit: {
      type: Number,
      default: 99999
    },
    /**
       * Sets maxHeight style value of the dropdown
       * @default 300
       * @type {Integer}
       */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
       * Function that process the message shown when selected
       * elements pass the defined limit.
       * @default 'and * more'
       * @param {Int} count Number of elements more than limit
       * @type {Function}
       */
    limitText: {
      type: Function,
      default: (e) => `and ${e} more`
    },
    /**
       * Set true to trigger the loading spinner.
       * @default False
       * @type {Boolean}
       */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
       * Disables the multiselect if true.
       * @default false
       * @type {Boolean}
       */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Enables search input's spellcheck if true.
     * @default false
     * @type {Boolean}
     */
    spellcheck: {
      type: Boolean,
      default: !1
    },
    /**
       * Fixed opening direction
       * @default ''
       * @type {String}
       */
    openDirection: {
      type: String,
      default: ""
    },
    /**
       * Shows slot with message about empty options
       * @default true
       * @type {Boolean}
       */
    showNoOptions: {
      type: Boolean,
      default: !0
    },
    showNoResults: {
      type: Boolean,
      default: !0
    },
    tabindex: {
      type: Number,
      default: 0
    },
    /**
     * Adds Required attribute to the input element when there is no value selected
     * @default false
     * @type {Boolean}
     */
    required: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasOptionGroup() {
      return this.groupValues && this.groupLabel && this.groupSelect;
    },
    isSingleLabelVisible() {
      return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText() {
      return this.showLabels ? this.deselectLabel : "";
    },
    deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : "";
    },
    selectLabelText() {
      return this.showLabels ? this.selectLabel : "";
    },
    selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : "";
    },
    selectedLabelText() {
      return this.showLabels ? this.selectedLabel : "";
    },
    inputStyle() {
      return this.searchable || this.multiple && this.modelValue && this.modelValue.length ? this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" } : "";
    },
    contentStyle() {
      return this.options.length ? { display: "inline-block" } : { display: "block" };
    },
    isAbove() {
      return this.openDirection === "above" || this.openDirection === "top" ? !0 : this.openDirection === "below" || this.openDirection === "bottom" ? !1 : this.preferredOpenDirection === "above";
    },
    showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : !0);
    },
    isRequired() {
      return this.required === !1 ? !1 : this.internalValue.length <= 0;
    }
  }
};
const Ec = ["tabindex", "aria-expanded", "aria-owns", "aria-activedescendant"], Tc = {
  ref: "tags",
  class: "multiselect__tags"
}, Ac = { class: "multiselect__tags-wrap" }, Pc = ["textContent"], zc = ["onKeypress", "onMousedown"], Yc = ["textContent"], Vc = { class: "multiselect__spinner" }, Hc = ["name", "id", "spellcheck", "placeholder", "required", "value", "disabled", "tabindex", "aria-label", "aria-controls"], Nc = ["id", "aria-multiselectable"], Rc = { key: 0 }, Bc = { class: "multiselect__option" }, Fc = ["aria-selected", "id", "role"], jc = ["onClick", "onMouseenter", "data-select", "data-selected", "data-deselect"], Wc = ["data-select", "data-deselect", "onMouseenter", "onMousedown"], Uc = { class: "multiselect__option" }, qc = { class: "multiselect__option" };
function Gc(e, t, n, a, r, s) {
  return h(), g("div", {
    tabindex: e.searchable ? -1 : n.tabindex,
    class: z([{ "multiselect--active": e.isOpen, "multiselect--disabled": n.disabled, "multiselect--above": s.isAbove, "multiselect--has-options-group": s.hasOptionGroup }, "multiselect"]),
    onFocus: t[14] || (t[14] = (i) => e.activate()),
    onBlur: t[15] || (t[15] = (i) => e.searchable ? !1 : e.deactivate()),
    onKeydown: [
      t[16] || (t[16] = Oe(xe((i) => e.pointerForward(), ["self", "prevent"]), ["down"])),
      t[17] || (t[17] = Oe(xe((i) => e.pointerBackward(), ["self", "prevent"]), ["up"]))
    ],
    onKeypress: t[18] || (t[18] = Oe(xe((i) => e.addPointerElement(i), ["stop", "self"]), ["enter", "tab"])),
    onKeyup: t[19] || (t[19] = Oe((i) => e.deactivate(), ["esc"])),
    role: "combobox",
    "aria-expanded": e.isOpen,
    "aria-owns": "listbox-" + e.id,
    "aria-activedescendant": e.isOpen && e.pointer !== null ? e.id + "-" + e.pointer : null
  }, [
    ae(e.$slots, "caret", { toggle: e.toggle }, () => [
      o(
        "div",
        {
          onMousedown: t[0] || (t[0] = xe((i) => e.toggle(), ["prevent", "stop"])),
          class: "multiselect__select"
        },
        null,
        32
        /* NEED_HYDRATION */
      )
    ]),
    ae(e.$slots, "clear", { search: e.search }),
    o(
      "div",
      Tc,
      [
        ae(e.$slots, "selection", {
          search: e.search,
          remove: e.removeElement,
          values: s.visibleValues,
          isOpen: e.isOpen
        }, () => [
          ht(o(
            "div",
            Ac,
            [
              (h(!0), g(
                se,
                null,
                fe(s.visibleValues, (i, l) => ae(e.$slots, "tag", {
                  option: i,
                  search: e.search,
                  remove: e.removeElement
                }, () => [
                  (h(), g(
                    "span",
                    {
                      class: "multiselect__tag",
                      key: l,
                      onMousedown: t[1] || (t[1] = xe(() => {
                      }, ["prevent"]))
                    },
                    [
                      o("span", {
                        textContent: j(e.getOptionLabel(i))
                      }, null, 8, Pc),
                      o("i", {
                        tabindex: "1",
                        onKeypress: Oe(xe((u) => e.removeElement(i), ["prevent"]), ["enter"]),
                        onMousedown: xe((u) => e.removeElement(i), ["prevent"]),
                        class: "multiselect__tag-icon"
                      }, null, 40, zc)
                    ],
                    32
                    /* NEED_HYDRATION */
                  ))
                ])),
                256
                /* UNKEYED_FRAGMENT */
              ))
            ],
            512
            /* NEED_PATCH */
          ), [
            [S0, s.visibleValues.length > 0]
          ]),
          e.internalValue && e.internalValue.length > n.limit ? ae(e.$slots, "limit", { key: 0 }, () => [
            o("strong", {
              class: "multiselect__strong",
              textContent: j(n.limitText(e.internalValue.length - n.limit))
            }, null, 8, Yc)
          ]) : B("v-if", !0)
        ]),
        k($n, { name: "multiselect__loading" }, {
          default: P(() => [
            ae(e.$slots, "loading", {}, () => [
              ht(o(
                "div",
                Vc,
                null,
                512
                /* NEED_PATCH */
              ), [
                [S0, n.loading]
              ])
            ])
          ]),
          _: 3
          /* FORWARDED */
        }),
        e.searchable ? (h(), g("input", {
          key: 0,
          ref: "search",
          name: n.name,
          id: e.id,
          type: "text",
          autocomplete: "off",
          spellcheck: n.spellcheck,
          placeholder: e.placeholder,
          required: s.isRequired,
          style: Fe(s.inputStyle),
          value: e.search,
          disabled: n.disabled,
          tabindex: n.tabindex,
          "aria-label": n.name + "-searchbox",
          onInput: t[2] || (t[2] = (i) => e.updateSearch(i.target.value)),
          onFocus: t[3] || (t[3] = xe((i) => e.activate(), ["prevent"])),
          onBlur: t[4] || (t[4] = xe((i) => e.deactivate(), ["prevent"])),
          onKeyup: t[5] || (t[5] = Oe((i) => e.deactivate(), ["esc"])),
          onKeydown: [
            t[6] || (t[6] = Oe(xe((i) => e.pointerForward(), ["prevent"]), ["down"])),
            t[7] || (t[7] = Oe(xe((i) => e.pointerBackward(), ["prevent"]), ["up"])),
            t[9] || (t[9] = Oe(xe((i) => e.removeLastElement(), ["stop"]), ["delete"]))
          ],
          onKeypress: t[8] || (t[8] = Oe(xe((i) => e.addPointerElement(i), ["prevent", "stop", "self"]), ["enter"])),
          class: "multiselect__input",
          "aria-controls": "listbox-" + e.id
        }, null, 44, Hc)) : B("v-if", !0),
        s.isSingleLabelVisible ? (h(), g(
          "span",
          {
            key: 1,
            class: "multiselect__single",
            onMousedown: t[10] || (t[10] = xe((...i) => e.toggle && e.toggle(...i), ["prevent"]))
          },
          [
            ae(e.$slots, "singleLabel", { option: s.singleValue }, () => [
              me(
                j(e.currentOptionLabel),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : B("v-if", !0),
        s.isPlaceholderVisible ? (h(), g(
          "span",
          {
            key: 2,
            class: "multiselect__placeholder",
            onMousedown: t[11] || (t[11] = xe((...i) => e.toggle && e.toggle(...i), ["prevent"]))
          },
          [
            ae(e.$slots, "placeholder", {}, () => [
              me(
                j(e.placeholder),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : B("v-if", !0)
      ],
      512
      /* NEED_PATCH */
    ),
    k($n, {
      name: "multiselect",
      persisted: ""
    }, {
      default: P(() => [
        ht(o(
          "div",
          {
            class: "multiselect__content-wrapper",
            onFocus: t[12] || (t[12] = (...i) => e.activate && e.activate(...i)),
            tabindex: "-1",
            onMousedown: t[13] || (t[13] = xe(() => {
            }, ["prevent"])),
            style: Fe({ maxHeight: e.optimizedHeight + "px" }),
            ref: "list"
          },
          [
            o("ul", {
              class: "multiselect__content",
              style: Fe(s.contentStyle),
              role: "listbox",
              id: "listbox-" + e.id,
              "aria-multiselectable": e.multiple
            }, [
              ae(e.$slots, "beforeList"),
              e.multiple && e.max === e.internalValue.length ? (h(), g("li", Rc, [
                o("span", Bc, [
                  ae(e.$slots, "maxElements", {}, () => [
                    me(
                      "Maximum of " + j(e.max) + " options selected. First remove a selected option to select another.",
                      1
                      /* TEXT */
                    )
                  ])
                ])
              ])) : B("v-if", !0),
              !e.max || e.internalValue.length < e.max ? (h(!0), g(
                se,
                { key: 1 },
                fe(e.filteredOptions, (i, l) => (h(), g("li", {
                  class: "multiselect__element",
                  key: l,
                  "aria-selected": e.isSelected(i),
                  id: e.id + "-" + l,
                  role: i && (i.$isLabel || i.$isDisabled) ? null : "option"
                }, [
                  i && (i.$isLabel || i.$isDisabled) ? B("v-if", !0) : (h(), g("span", {
                    key: 0,
                    class: z([e.optionHighlight(l, i), "multiselect__option"]),
                    onClick: xe((u) => e.select(i), ["stop"]),
                    onMouseenter: xe((u) => e.pointerSet(l), ["self"]),
                    "data-select": i && i.isTag ? e.tagPlaceholder : s.selectLabelText,
                    "data-selected": s.selectedLabelText,
                    "data-deselect": s.deselectLabelText
                  }, [
                    ae(e.$slots, "option", {
                      option: i,
                      search: e.search,
                      index: l
                    }, () => [
                      o(
                        "span",
                        null,
                        j(e.getOptionLabel(i)),
                        1
                        /* TEXT */
                      )
                    ])
                  ], 42, jc)),
                  i && (i.$isLabel || i.$isDisabled) ? (h(), g("span", {
                    key: 1,
                    "data-select": e.groupSelect && s.selectGroupLabelText,
                    "data-deselect": e.groupSelect && s.deselectGroupLabelText,
                    class: z([e.groupHighlight(l, i), "multiselect__option"]),
                    onMouseenter: xe((u) => e.groupSelect && e.pointerSet(l), ["self"]),
                    onMousedown: xe((u) => e.selectGroup(i), ["prevent"])
                  }, [
                    ae(e.$slots, "option", {
                      option: i,
                      search: e.search,
                      index: l
                    }, () => [
                      o(
                        "span",
                        null,
                        j(e.getOptionLabel(i)),
                        1
                        /* TEXT */
                      )
                    ])
                  ], 42, Wc)) : B("v-if", !0)
                ], 8, Fc))),
                128
                /* KEYED_FRAGMENT */
              )) : B("v-if", !0),
              ht(o(
                "li",
                null,
                [
                  o("span", Uc, [
                    ae(e.$slots, "noResult", { search: e.search }, () => [
                      t[20] || (t[20] = me("No elements found. Consider changing the search query."))
                    ])
                  ])
                ],
                512
                /* NEED_PATCH */
              ), [
                [S0, n.showNoResults && e.filteredOptions.length === 0 && e.search && !n.loading]
              ]),
              ht(o(
                "li",
                null,
                [
                  o("span", qc, [
                    ae(e.$slots, "noOptions", {}, () => [
                      t[21] || (t[21] = me("List is empty."))
                    ])
                  ])
                ],
                512
                /* NEED_PATCH */
              ), [
                [S0, n.showNoOptions && (e.options.length === 0 || s.hasOptionGroup === !0 && e.filteredOptions.length === 0) && !e.search && !n.loading]
              ]),
              ae(e.$slots, "afterList")
            ], 12, Nc)
          ],
          36
          /* STYLE, NEED_HYDRATION */
        ), [
          [S0, e.isOpen]
        ])
      ]),
      _: 3
      /* FORWARDED */
    })
  ], 42, Ec);
}
mi.render = Gc;
const Kc = {
  name: "LuxInputMultiselect",
  status: "prototype",
  release: "4.1.0",
  type: "Element",
  components: {
    Multiselect: mi
  },
  data() {
    return {
      vals: this.value,
      opts: this.options
    };
  },
  props: {
    /**
     * Optionally set the placeholder using a string
     */
    placeholder: {
      type: String,
      default: "Search or add a tag",
      required: !1
    },
    /**
     * Optionally set the tag placeholder using a string
     */
    tagPlaceholder: {
      type: String,
      default: "Add this as new tag",
      required: !1
    },
    /**
     * Set the selected options using an array of label/value pairs
     */
    value: {
      type: Array,
      default: null,
      required: !1
    },
    /**
     * Customize the selectable options using an array of label/value pairs
     */
    options: {
      type: Array,
      default: null,
      required: !1
    },
    /**
     * The label of the LuxSelect2 field.
     */
    inputLabel: {
      type: String,
      default: ""
    },
    /**
     * Unique identifier of the LuxSelect2 field.
     */
    id: {
      type: String,
      default: null,
      required: !0
    }
  },
  methods: {
    addTag(e) {
      const t = {
        name: e,
        code: e.substring(0, 2) + Math.floor(Math.random() * 1e7)
      };
      this.opts.push(t), this.vals.push(t);
    }
  },
  beforeMount: function() {
  }
}, Zc = ["for"], Xc = { class: "language-json" };
function Jc(e, t, n, a, r, s) {
  const i = Y("multiselect");
  return h(), g("div", null, [
    n.inputLabel ? (h(), g("label", {
      key: 0,
      for: n.id
    }, j(n.inputLabel), 9, Zc)) : B("", !0),
    k(i, {
      modelValue: r.vals,
      "onUpdate:modelValue": t[0] || (t[0] = (l) => r.vals = l),
      id: n.id,
      "tag-placeholder": n.tagPlaceholder,
      placeholder: n.placeholder,
      label: "name",
      "track-by": "code",
      options: r.opts,
      multiple: !0,
      taggable: !0,
      onTag: s.addTag
    }, null, 8, ["modelValue", "id", "tag-placeholder", "placeholder", "options", "onTag"]),
    o("pre", Xc, [
      o("code", null, j(r.vals), 1)
    ])
  ]);
}
const Qc = /* @__PURE__ */ S(Kc, [["render", Jc]]), e5 = {
  name: "LuxInputRadio",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  model: {
    prop: "checked",
    event: "change"
  },
  emits: ["change", "inputblur"],
  data: function() {
    return {
      wrapper: this.groupLabel.length ? "fieldset" : "div"
    };
  },
  props: {
    /**
     * If true, the radio buttons will be stacked vertically. Otherwise they will be horizontal (inline).
     */
    vertical: {
      type: Boolean,
      default: !1
    },
    /**
     * The available options to check. Option properties are: id, value, disabled, required, checked
     */
    options: {
      required: !0,
      type: Array
    },
    /**
     * The label of the form input field.
     */
    groupLabel: {
      type: String,
      default: ""
    },
    /**
     * The validation message a user should get.
     */
    errormessage: {
      type: String,
      default: ""
    },
    /**
     * Unique identifier of the form input field.
     */
    id: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * Whether the form input field is disabled or not.
     * `true, false`
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the form input field is required or not.
     * `true, false`
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s hover state.
     * `true, false`
     */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s focus state.
     * `true, false`
     */
    focus: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    change(e) {
      this.$emit("change", e);
    },
    inputblur(e) {
      this.$emit("inputblur", e);
    }
  }
}, t5 = { key: 0 }, n5 = ["id", "name", "value", "checked", "disabled", "required"], a5 = ["for"], r5 = ["for"], s5 = {
  key: 1,
  role: "alert",
  class: "lux-error"
};
function i5(e, t, n, a, r, s) {
  return h(), H(ie(e.wrapper), { class: "lux-input" }, {
    default: P(() => [
      n.groupLabel ? (h(), g("legend", t5, j(n.groupLabel), 1)) : B("", !0),
      (h(!0), g(se, null, fe(n.options, (i) => (h(), g("div", {
        class: z(["lux-radio", { "lux-inline": !n.vertical }]),
        key: i.id
      }, [
        o("input", {
          type: "radio",
          id: i.id,
          name: i.name,
          value: i.value,
          checked: i.checked,
          disabled: i.disabled,
          required: i.required,
          onChange: t[0] || (t[0] = (l) => s.change(l.target.value)),
          onBlur: t[1] || (t[1] = (l) => s.inputblur(l.target))
        }, null, 40, n5),
        i.label ? (h(), g("label", {
          key: 0,
          for: i.id
        }, j(i.label), 9, a5)) : (h(), g("label", {
          key: 1,
          for: i.id
        }, j(i.value), 9, r5))
      ], 2))), 128)),
      n.errormessage ? (h(), g("div", s5, j(n.errormessage), 1)) : B("", !0)
    ]),
    _: 1
  });
}
const o5 = /* @__PURE__ */ S(e5, [["render", i5], ["__scopeId", "data-v-39d16c92"]]), l5 = {
  name: "LuxInputSelect",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  model: {
    event: "change"
  },
  computed: {
    hasError() {
      return this.errormessage.length;
    }
  },
  emits: ["change", "inputblur"],
  props: {
    /**
     * Sets the value of the selected option.
     */
    value: {
      type: String
    },
    /**
     * Determines whether the user can select multiple options.
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * The available options to check.
     */
    options: {
      required: !0,
      type: Array
    },
    /**
     * The label of the input select field.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Visually hides the label of the form input field.
     */
    hideLabel: {
      type: Boolean,
      default: !1
    },
    /**
     * The validation message a user should get.
     */
    errormessage: {
      type: String,
      default: ""
    },
    /**
     * The html element name used for the wrapper.
     * `div, section`
     */
    wrapper: {
      type: String,
      default: "div",
      validator: (e) => e.match(/(div|section)/)
    },
    /**
     * Unique identifier of the input select field.
     */
    id: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * The name attribute for the form input field.
     */
    name: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * The width of the input select field.
     * `auto, expand`
     */
    width: {
      type: String,
      default: "auto",
      validator: (e) => e.match(/(auto|expand)/)
    },
    /**
     * Sets the size of the input area `small, medium, large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    },
    /**
     * Whether the form input field is disabled or not.
     * `true, false`
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the form input field is required or not.
     * `true, false`
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s hover state.
     * `true, false`
     */
    hover: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    change(e) {
      this.$emit("change", e.target.value);
    },
    inputblur(e) {
      this.$emit("inputblur", e);
    },
    focusSelect() {
      this.$nextTick(() => {
        this.$refs.select.focus();
      });
    }
  }
}, u5 = ["for"], c5 = ["id", "disabled", "required", "multiple", "errormessage", "value", "name"], d5 = ["value", "disabled"], f5 = {
  key: 1,
  role: "alert",
  class: "lux-error"
};
function h5(e, t, n, a, r, s) {
  return h(), H(ie(n.wrapper), { class: "lux-select" }, {
    default: P(() => [
      n.label ? (h(), g("label", {
        key: 0,
        for: n.id,
        class: z({ "lux-hidden": n.hideLabel })
      }, j(n.label), 11, u5)) : B("", !0),
      o("select", {
        id: n.id,
        class: z([
          "lux-select",
          { "lux-select-error": s.hasError },
          { "lux-select-expand": n.width === "expand" },
          n.size
        ]),
        disabled: n.disabled,
        required: n.required,
        multiple: n.multiple,
        errormessage: n.errormessage,
        value: n.value,
        ref: "select",
        name: n.name,
        onChange: t[0] || (t[0] = (i) => s.change(i)),
        onBlur: t[1] || (t[1] = (i) => s.inputblur(i.target))
      }, [
        (h(!0), g(se, null, fe(n.options, (i, l) => (h(), g("option", {
          key: l,
          value: i.value,
          disabled: i.disabled
        }, j(i.label), 9, d5))), 128))
      ], 42, c5),
      n.errormessage ? (h(), g("div", f5, j(n.errormessage), 1)) : B("", !0)
    ]),
    _: 1
  });
}
const p5 = /* @__PURE__ */ S(l5, [["render", h5], ["__scopeId", "data-v-1cc1b664"]]), v5 = {
  name: "LuxInputText",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  emits: [
    "inputvaluechange",
    "inputblur",
    "inputfocus",
    "update:value",
    "input",
    "keyup",
    "change",
    "blur",
    "focus"
  ],
  computed: {
    hasError() {
      return this.errormessage.length;
    }
  },
  props: {
    /**
     * The type of the form input field.
     * `text, number, email`
     */
    type: {
      type: String,
      default: "text",
      validator: (e) => e.match(/(text|number|email|textarea)/)
    },
    /**
     * Text value of the form input field.
     */
    value: {
      type: [String, Number],
      default: ""
    },
    /**
     * The placeholder value for the form input field.
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * The label of the form input field.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Visually hides the label of the form input field.
     */
    hideLabel: {
      type: Boolean,
      default: !1
    },
    /**
     * The validation message a user should get.
     */
    errormessage: {
      type: String,
      default: ""
    },
    /**
     * The helper text a user should get.
     */
    helper: {
      type: String,
      default: ""
    },
    /**
     * The html element name used for the wrapper.
     * `div, section`
     */
    wrapper: {
      type: String,
      default: "div",
      validator: (e) => e.match(/(div|section)/)
    },
    /**
     * Unique identifier of the form input field.
     */
    id: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * The name attribute for the form input field.
     */
    name: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * The width of the form input field.
     * `auto, expand`
     */
    width: {
      type: String,
      default: "auto",
      validator: (e) => e.match(/(auto|expand)/)
    },
    /**
     * Sets the size of the input area `small, medium, large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    },
    /**
     * The number of visible text lines for textarea.
     */
    rows: {
      type: String,
      default: "5"
    },
    /**
     * The maximum number of characters that the user can enter in textarea.
     */
    maxlength: {
      type: Number,
      default: 256
    },
    /**
     * Whether the form input field is disabled or not.
     * `true, false`
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the form input field is readonly or not.
     * `true, false`
     */
    readonly: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the form input field is required or not.
     * `true, false`
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s hover state.
     * `true, false`
     */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually trigger input field’s focus state.
     * `true, false`
     */
    focused: {
      type: Boolean,
      default: !1
    },
    /**
     * Appends icon inside container. Option:
     * `alert`, `approved`, `denied`
     */
    icon: {
      type: String,
      default: ""
    }
  },
  methods: {
    inputFired(e) {
      this.$emit("input", e), this.inputvaluechange(e.target.value);
    },
    inputvaluechange(e) {
      this.$emit("update:value", e);
    },
    inputblur(e) {
      this.$emit("inputblur", e);
    },
    focusFired(e) {
      this.$emit("focus", e), this.inputfocus(e.target.value);
    },
    inputfocus(e) {
      this.$emit("inputfocus", e);
    }
  },
  mounted: function() {
    let e = this;
    e.$nextTick(function() {
      e.focused && (e.type == "text" && this.$refs.textInput.focus(), e.type == "textarea" && this.$refs.textArea.focus());
    });
  },
  components: {
    LuxIconAlert: ci,
    LuxIconApproved: di,
    LuxIconDenied: pi,
    LuxIconBase: In
  }
}, m5 = ["for"], g5 = ["name", "value", "id", "readonly", "disabled", "required", "type", "maxlength", "hover", "placeholder", "errormessage"], y5 = ["name", "id", "disabled", "readonly", "required", "rows", "maxlength", "hover", "value", "placeholder", "errormessage"], b5 = {
  key: 2,
  class: "append-icon"
}, _5 = {
  key: 1,
  role: "alert",
  class: "lux-error"
}, w5 = {
  key: 2,
  class: "lux-helper"
};
function $5(e, t, n, a, r, s) {
  const i = Y("lux-icon-alert"), l = Y("lux-icon-approved"), u = Y("lux-icon-denied"), c = Y("lux-icon-base");
  return h(), H(ie(n.wrapper), {
    class: z(["lux-input", { "lux-has-icon": n.icon }])
  }, {
    default: P(() => [
      n.label ? (h(), g("label", {
        key: 0,
        for: n.id,
        class: z({ "lux-hidden": n.hideLabel })
      }, j(n.label), 11, m5)) : B("", !0),
      o("div", {
        class: z(["lux-input-field", [{ "lux-input-expand": n.width === "expand" }, { disabled: n.disabled }, n.size]])
      }, [
        n.type !== "textarea" ? (h(), g("input", {
          key: 0,
          autocomplete: "off",
          ref: "textInput",
          name: n.name,
          value: n.value,
          id: n.id,
          readonly: n.readonly,
          disabled: n.disabled,
          required: n.required,
          type: n.type,
          maxlength: n.maxlength,
          hover: n.hover,
          placeholder: n.placeholder,
          errormessage: n.errormessage,
          class: z(["lux-input", { "lux-input-error": s.hasError }]),
          onInput: t[0] || (t[0] = (d) => s.inputFired(d)),
          onChange: t[1] || (t[1] = (...d) => e.$emit("change", ...d)),
          onKeyup: t[2] || (t[2] = (...d) => e.$emit("keyup", ...d)),
          onBlur: t[3] || (t[3] = (...d) => e.$emit("blur", ...d)),
          onFocus: t[4] || (t[4] = (d) => s.focusFired(d))
        }, null, 42, g5)) : (h(), g("textarea", {
          key: 1,
          autocomplete: "off",
          ref: "textArea",
          name: n.name,
          id: n.id,
          disabled: n.disabled,
          readonly: n.readonly,
          required: n.required,
          rows: n.rows,
          maxlength: n.maxlength,
          hover: n.hover,
          value: n.value,
          placeholder: n.placeholder,
          errormessage: n.errormessage,
          class: z([
            "lux-input",
            { "lux-input-error": s.hasError },
            { "lux-input-expand": n.width === "expand" }
          ]),
          onInput: t[5] || (t[5] = (d) => s.inputvaluechange(d.target.value)),
          onBlur: t[6] || (t[6] = (d) => s.inputblur(d)),
          onFocus: t[7] || (t[7] = (d) => s.inputfocus(d))
        }, null, 42, y5)),
        n.icon ? (h(), g("div", b5, [
          k(c, {
            width: "24",
            height: "24"
          }, {
            default: P(() => [
              n.icon === "alert" ? (h(), H(i, { key: 0 })) : B("", !0),
              n.icon === "approved" ? (h(), H(l, { key: 1 })) : B("", !0),
              n.icon === "denied" ? (h(), H(u, { key: 2 })) : B("", !0)
            ]),
            _: 1
          })
        ])) : B("", !0)
      ], 2),
      n.errormessage ? (h(), g("div", _5, j(n.errormessage), 1)) : B("", !0),
      n.helper ? (h(), g("div", w5, j(n.helper), 1)) : B("", !0)
    ]),
    _: 1
  }, 8, ["class"]);
}
const zr = /* @__PURE__ */ S(v5, [["render", $5], ["__scopeId", "data-v-bc042a76"]]), C5 = {
  name: "LuxCardContent",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    }
  }
};
function x5(e, t, n, a, r, s) {
  return h(), H(ie(n.type), { class: "lux-card-content" }, {
    default: P(() => [
      ae(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  });
}
const S5 = /* @__PURE__ */ S(C5, [["render", x5], ["__scopeId", "data-v-1ac57255"]]), M5 = {
  name: "LuxCardHeader",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    }
  }
};
function D5(e, t, n, a, r, s) {
  return h(), H(ie(n.type), { class: "lux-card-header" }, {
    default: P(() => [
      ae(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  });
}
const k5 = /* @__PURE__ */ S(M5, [["render", D5], ["__scopeId", "data-v-0185aee7"]]), L5 = {
  name: "LuxCardMedia",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    }
  }
};
function O5(e, t, n, a, r, s) {
  return h(), H(ie(n.type), { class: "lux-card-media" }, {
    default: P(() => [
      ae(e.$slots, "default")
    ]),
    _: 3
  });
}
const I5 = /* @__PURE__ */ S(L5, [["render", O5], ["__scopeId", "data-v-aef1f826"]]), E5 = {
  name: "LuxHamburger",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    }
  }
}, T5 = { class: "hamburger-box" };
function A5(e, t, n, a, r, s) {
  return h(), g("span", T5, t[0] || (t[0] = [
    o("span", { class: "hamburger-inner" }, null, -1)
  ]));
}
const gi = /* @__PURE__ */ S(E5, [["render", A5], ["__scopeId", "data-v-d93a1c53"]]), P5 = ["innerHTML"], yi = {
  __name: "_LuxMenuBarLabel",
  props: {
    item: Object
  },
  setup(e) {
    return (t, n) => e.item.unsafe_name ? (h(), g("span", {
      key: 0,
      innerHTML: e.item.unsafe_name
    }, null, 8, P5)) : (h(), g(se, { key: 1 }, [
      me(j(e.item.name), 1)
    ], 64));
  }
}, z5 = {
  name: "LuxSubscribeNewsletter",
  status: "ready",
  release: "5.2.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    },
    buttonLabel: {
      type: String,
      default: "Subscribe"
    }
  },
  components: {
    LuxInputButton: Pr,
    LuxInputText: zr
  }
}, Y5 = {
  id: "mc-embedded-subscribe-form",
  action: "https://princeton.us4.list-manage.com/subscribe/post?u=f1159e2c2a8bc35d62147f282&id=6c19fe9a37",
  method: "post",
  name: "mc-embedded-subscribe-form",
  class: "validate",
  target: "_blank",
  novalidate: ""
}, V5 = {
  id: "mc_embed_signup_scroll",
  class: "newsletter-signup"
};
function H5(e, t, n, a, r, s) {
  const i = Y("lux-input-text"), l = Y("lux-input-button");
  return h(), H(ie(n.type), { class: "lux-subscribe-newsletter" }, {
    default: P(() => [
      o("form", Y5, [
        o("div", V5, [
          k(i, {
            id: "mce-EMAIL",
            type: "email",
            name: "EMAIL",
            label: "Email address",
            hideLabel: !0
          }),
          k(l, {
            id: "mc-embedded-subscribe",
            type: "submit",
            name: "subscribe",
            class: "lux-subscribe-newsletter",
            variation: "outline",
            "aria-describedby": "describe-mailchimp-form"
          }, {
            default: P(() => [
              me(j(n.buttonLabel), 1)
            ]),
            _: 1
          }),
          t[0] || (t[0] = o("div", { id: "describe-mailchimp-form" }, "Opens the form in a new tab", -1)),
          t[1] || (t[1] = o("div", {
            style: { position: "absolute", left: "-5000px" },
            "aria-hidden": "true"
          }, [
            o("input", {
              type: "text",
              name: "b_f1159e2c2a8bc35d62147f282_6c19fe9a37",
              tabindex: "-1",
              value: ""
            })
          ], -1))
        ])
      ])
    ]),
    _: 1
  });
}
const bi = /* @__PURE__ */ S(z5, [["render", H5], ["__scopeId", "data-v-102d5e24"]]), N5 = {
  name: "LuxHyperlink",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The href value of the link.
     */
    href: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * Whether the link appears as text or as a button. Options include `button solid`
     * and `button outline`.
     */
    variation: {
      type: String,
      default: "link",
      validator: (e) => e.match(/(link|button)/)
    },
    /**
     * Sets the size of the button `small`, `medium`, `large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    },
    /**
     * Should the link open in a new tab?  This can be
     * disconcerting, so don't use it unless necessary.
     */
    newTab: {
      type: Boolean,
      default: !1
    },
    /**
     * Should the link have an underline?
     */
    underline: {
      type: Boolean,
      default: !1
    }
  },
  components: {
    LuxIconBase: In,
    LuxIconNewTab: vi
  }
}, R5 = ["href", "target"];
function B5(e, t, n, a, r, s) {
  const i = Y("lux-icon-new-tab"), l = Y("lux-icon-base");
  return h(), g("a", {
    href: n.href,
    class: z(["lux-link", n.variation, n.size, n.underline ? "lux-link-underline" : ""]),
    target: n.newTab ? "_blank" : null
  }, [
    ae(e.$slots, "default", {}, void 0, !0),
    n.newTab ? (h(), H(l, {
      key: 0,
      width: "14",
      height: "14",
      "icon-name": "(opens in new tab)"
    }, {
      default: P(() => [
        k(i)
      ]),
      _: 1
    })) : B("", !0)
  ], 10, R5);
}
const Yr = /* @__PURE__ */ S(N5, [["render", B5], ["__scopeId", "data-v-d02cc921"]]), F5 = {
  name: "LuxUniversityAccessibility",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "span"
    },
    theme: {
      type: String,
      default: "dark"
    }
  },
  components: {
    LuxHyperlink: Yr
  }
};
function j5(e, t, n, a, r, s) {
  const i = Y("LuxHyperlink");
  return h(), H(ie(n.type), {
    class: z(["lux-accessibility", n.theme])
  }, {
    default: P(() => [
      k(i, {
        href: "https://accessibility.princeton.edu/help",
        newTab: !0
      }, {
        default: P(() => t[0] || (t[0] = [
          me("Accessibility Help")
        ])),
        _: 1,
        __: [0]
      })
    ]),
    _: 1
  }, 8, ["class"]);
}
const W5 = /* @__PURE__ */ S(F5, [["render", j5], ["__scopeId", "data-v-88f7846b"]]), U5 = {
  name: "LuxUniversityAccessibilityOld",
  status: "ready",
  release: "5.2.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "span"
    }
  }
};
function q5(e, t, n, a, r, s) {
  return h(), H(ie(n.type), { class: "lux-accessibility" }, {
    default: P(() => t[0] || (t[0] = [
      o("a", { href: "https://accessibility.princeton.edu/help" }, "Accessibility", -1)
    ])),
    _: 1,
    __: [0]
  });
}
const _i = /* @__PURE__ */ S(U5, [["render", q5], ["__scopeId", "data-v-18a88cf9"]]), G5 = {
  name: "LuxLibraryContactInfo",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    },
    theme: {
      type: String,
      default: "dark"
    }
  }
};
function K5(e, t, n, a, r, s) {
  return h(), H(ie(n.type), {
    class: z(["lux-library-contact", n.theme])
  }, {
    default: P(() => t[0] || (t[0] = [
      o("div", {
        itemscope: "",
        itemtype: "http://schema.org/Organization"
      }, [
        o("div", {
          itemscope: "",
          itemtype: "http://schema.org/PostalAddress"
        }, [
          o("span", { itemprop: "streetAddress" }, "One Washington Road"),
          me(),
          o("br"),
          o("span", { itemprop: "addressLocality" }, "Princeton"),
          me(", "),
          o("span", { itemprop: "addressRegion" }, "NJ"),
          o("span", { itemprop: "postalCode" }, " 08544-2098"),
          me(),
          o("span", { itemprop: "addressCountry" }, "USA")
        ]),
        o("div", { class: "phone" }, [
          o("span", { itemprop: "telephone" }, [
            o("a", { href: "tel:1-609-258-1470" }, "(609) 258-1470")
          ])
        ])
      ], -1)
    ])),
    _: 1,
    __: [0]
  }, 8, ["class"]);
}
const wi = /* @__PURE__ */ S(G5, [["render", K5], ["__scopeId", "data-v-953883de"]]), Z5 = {
  name: "LuxLogoFacebook",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 24
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 24
    }
  }
}, X5 = ["width", "height"];
function J5(e, t, n, a, r, s) {
  return h(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: n.width,
    height: n.height,
    viewBox: "0 0 25 25",
    preserveAspectRatio: "xMinYMid",
    "aria-labelledby": "logo-facebook",
    role: "img",
    fill: "currentColor",
    class: "lux-logo-facebook"
  }, t[0] || (t[0] = [
    o("title", {
      id: "logo-facebook",
      lang: "en"
    }, "PUL Facebook", -1),
    o("g", null, [
      o("path", { d: "M18.768 7.465H14.5V5.56c0-.896.594-1.105 1.012-1.105H18.5V.513L14.171.5C10.244.5 9.5 3.438 9.5 5.32v2.144h-3v4h3v12h5v-12h3.851l.417-3.999z" }),
      o("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
      })
    ], -1)
  ]), 8, X5);
}
const Vr = /* @__PURE__ */ S(Z5, [["render", J5]]), Q5 = {
  name: "LuxLogoX",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 24
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 24
    }
  }
}, ed = ["width", "height"];
function td(e, t, n, a, r, s) {
  return h(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: n.width,
    height: n.height,
    viewBox: "0 0 18 18",
    preserveAspectRatio: "xMinYMid",
    "aria-labelledby": "logo-x",
    role: "img",
    fill: "currentColor"
  }, t[0] || (t[0] = [
    o("title", {
      id: "logo-x",
      lang: "en"
    }, "PUL X", -1),
    o("g", null, [
      o("path", { d: "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" })
    ], -1)
  ]), 8, ed);
}
const Hr = /* @__PURE__ */ S(Q5, [["render", td]]), nd = {
  name: "LuxLogoGovDocs",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 32
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 32
    }
  }
}, ad = ["width", "height"];
function rd(e, t, n, a, r, s) {
  return h(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: n.width,
    height: n.height,
    viewBox: "0 0 32 32",
    preserveAspectRatio: "xMinYMid",
    "aria-labelledby": "logo-gov-docs",
    role: "img",
    class: "lux-logo-gov-docs"
  }, t[0] || (t[0] = [
    Dn('<title id="logo-gov-docs" lang="en">Government Docs</title><g><path fill="#002C64" d="M15.1 30.2c-1.2-.1-1.9-.2-2.7-.4-2.8-.7-5.1-2.1-7.2-4.1-3-3-4.8-6.9-5.1-11.5-.1-.6-.1-3.4-.1-6.7V1.8h32v.4c.1.7.1 11 0 11.9-.3 3.1-.9 5.4-2.3 7.8-2.6 4.8-7.2 7.8-12.3 8.3-.8 0-1.7.1-2.3 0z"></path><path fill="#FFF" d="M17.2 29.5c1.8-.1 4.4-1 6-1.9 2.7-1.6 4.9-3.9 6.3-6.9.8-1.6 1.2-4 1.2-7 0-1.4 0-1.7-.2-2.6-.5-2.7-1.8-5.2-3.7-7-.4-.4-.5-.5-.5-.8 0-.5 0-.5-3.5-.5-2.7 0-3.2 0-3.4.1-.4.2-.5.7-.1.7s.7.1 1 .3c.4.3.7.3 1.2.1.5-.2.7-.2.9 0 .1.1.2.2.2.5 0 .4-.1.5-.7.5-.5 0-.9-.2-1.7-.7-.6-.4-.8-.4-2.2 0-1.1.3-1.2.4-1.3.6-.3.4-.3.8 0 1.6.2.4.3.8.3.9 0 .1.1.2.2.2.2 0 .2 0 .4-.2.2-.4.6-.4 1.1-.3.8.2 1.4.5 2.3 1.4.5.5 1.1 1.9 1.2 3.2.1.9.1 2.3-.1 3.1-.5 2-1.7 3.9-3.2 4.9-.3.2-1.2.7-1.6.8-.5.2-1.8.2-2.4.1-1.2-.3-2.7-1.3-3.6-2.5-.3-.4-.7-1.4-.8-2.2-.1-.7 0-1.9.1-2.4.4-1.4 1.6-2.7 3.2-3.5.9-.4 1.1-.7 1-1.3-.1-.4-.3-.7-.6-1l-.3-.2H.7v2.6l.3.2.3.2h8s-.2.2-.4.5c-1 1.8-1.3 3.8-.8 6 .2.8.9 2.2 1.6 3.2 1.1 1.4 2.8 2.5 4.4 2.8.8.2 2.1.2 3 .1l.5-.1-.3.4c-.5.7-1 2-1.2 3.5-.1.8-.5 1.8-.8 2.2-.1.2-.2.3-.2.4 0 0 .2.1.5.1h.7s.5 0 .9-.1z"></path><path fill="#FFF" d="M14 29.2c.3-.1.7-.5.9-.8.1-.2.2-.7.3-1.2.2-.9.5-1.7.9-2.6.1-.3.2-.5.2-.5h-.4c-.2 0-.7-.1-1-.1-.3-.1-.7-.1-.8-.1-.4.1-1.5 1.3-2.3 2.5-.4.6-1 1.1-1.8 1.4-.3 0-.5.2-.4.2.1.2 1.8.8 3.3 1.1.8.2.8.2 1.1.1zm-4.6-2.1c.8-.4 1.2-.8 1.6-1.5.5-.7.7-1 1.5-1.6.3-.2.5-.4.5-.4s-.2-.1-.3-.2c-.4-.2-1.1-.6-1.7-1-.4-.3-.8-.3-1.5-.1-.4.1-1.6.7-2.2 1.1-.9.6-1.5.8-2.1.8h-.5c0 .3.9 1.2 2.1 2 1.1.8 1.6 1.1 1.9 1.1.1.1.4 0 .7-.2zm-4-3.6c.1-.1.5-.3.8-.5 1.2-.8 2.4-1.3 3.2-1.4.3 0 .5-.1.5-.1s-1.8-2.3-2-2.6c-.4-.5-1.6-.5-2.6 0-.7.3-1.5.5-2.3.5-.5 0-.8 0-.9-.1-.2-.1-.2-.1-.2 0 0 .2 1.5 3.2 1.8 3.5.5.7 1.1 1 1.7.7zm-2.5-4.8c1.4-.3 3.1-.6 3.5-.7.3 0 .5 0 .7.1.1.1.2.1.3.1 0 0 0-.2-.1-.4s-.2-.8-.3-1.3c-.1-.5-.1-.9-.2-1 0-.1-.2-.2-.4-.3-.3-.2-.4-.2-2.6-.2-2.1 0-2.4-.1-2.6-.2-.2-.1-.3-.1-.4-.1l.4 3c.1.7.2.8.4 1 .3.1.6.2 1.3 0zm12.7-.4c.3-.3.8-.3 1.1 0 .1.1.2.1 1.6.1h1.5v-6.6h-1v-.6c0-.7 0-.7-.8-.5-.6.2-1.1.4-1.5.8l-.3.3-.3-.3c-.4-.4-.9-.7-1.5-.8-.8-.2-.7-.2-.8.5v.6h-1v6.5h3z"></path><path fill="#C30035" d="M13.2 15.3c0-2.5 0-2.6.1-2.6s.1 0 .1 2.2v2.2h.4c.2 0 .5.1.7.1.3.1 1.2.6 1.2.6h-2.6v-2.5zm3.4 2.4c.7-.4 1.1-.6 1.6-.6h.5v-4.4h.4v5.2h-2.8l.3-.2z"></path><path fill="#C30035" d="M15.6 16.8c-.3-.2-1-.5-1.2-.5h-.2v-4.6l.3.1c.4.1.9.4 1.1.6l.2.2v2.1c-.1 2.2-.1 2.2-.2 2.1zm1-2c0-1.9 0-2.2.1-2.3.2-.3.7-.6 1.1-.7l.3-.1v4.6h-.2c-.2 0-.8.3-1.1.5l-.2.1v-2.1z"></path><path fill="#FFF" d="M6.9 14.3c0-.3.2-1.4.3-1.8.1-.3.1-.4 0-.7-.2-.6-.1-.6-3.1-.6H1.5L1 11l-.5-.2v.6c.1 1.2.3 2.2.4 2.4.1.1.2.3.3.3.1.1.9.1 2.4.1 2.3 0 2.9.1 3.1.3.1.1.2 0 .2-.2z"></path></g>', 2)
  ]), 8, ad);
}
const Nr = /* @__PURE__ */ S(nd, [["render", rd]]), sd = {
  name: "LuxLogoFriends",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 115
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 31
    }
  }
}, id = ["width", "height"];
function od(e, t, n, a, r, s) {
  return h(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: n.width,
    height: n.height,
    viewBox: "0 0 115.7 31.1",
    preserveAspectRatio: "xMinYMid",
    "aria-labelledby": "logo-friends",
    role: "img",
    class: "lux-logo-friends"
  }, t[0] || (t[0] = [
    Dn('<title id="logo-friends" lang="en" data-v-a2d5b1e6>Friends of Princeton University Library</title><g data-v-a2d5b1e6><path d="M.5 27.1A3.54 3.54 0 0 0 4 30.6h107.7a3.54 3.54 0 0 0 3.5-3.5V4a3.54 3.54 0 0 0-3.5-3.5H4.1A3.54 3.54 0 0 0 .6 4v23.1z" data-v-a2d5b1e6></path><path d="M.5 27.1A3.54 3.54 0 0 0 4 30.6h107.7a3.54 3.54 0 0 0 3.5-3.5V4a3.54 3.54 0 0 0-3.5-3.5H4.1A3.54 3.54 0 0 0 .6 4v23.1z" stroke-miterlimit="10" stroke="#000" data-v-a2d5b1e6></path><path class="friends-b" d="M24.3 9.3a1.39 1.39 0 0 0-1.4-1.1v15.3a37 37 0 0 1-3.8-1.4 4.24 4.24 0 0 0-3.9.2 4.32 4.32 0 0 0-3.9-.2 37 37 0 0 1-3.8 1.4V8.1a1.38 1.38 0 0 0-1.3 1.1v15.5h18.1V9.3z" data-v-a2d5b1e6></path><path class="friends-b" d="M10.7 17.3a11 11 0 0 0 1.4 2.1l3.1-3 3.1 3c.5-.7 1-1.4 1.4-2.1L15.2 13zm11.1-9.2a4.68 4.68 0 0 1-1.7.2 5.46 5.46 0 0 1-4.8-2.7 5.72 5.72 0 0 1-4.8 2.7 9.85 9.85 0 0 1-1.7-.2 17.53 17.53 0 0 0 .3 4.6h12.5a23.63 23.63 0 0 0 .2-4.6" data-v-a2d5b1e6></path><path d="M40.82 12.85a.24.24 0 0 1-.15 0h-.28a9.76 9.76 0 0 0-.66-1.19 8.14 8.14 0 0 0-.62-.83 4.1 4.1 0 0 0-.56-.55 6.93 6.93 0 0 0-.49-.39 1.15 1.15 0 0 0-.71-.19h-3.59c-.2 0-.32 0-.35.06s0 .14 0 .3v6h1.52a3.19 3.19 0 0 0 .6-.12 2.21 2.21 0 0 0 .55-.23 1.19 1.19 0 0 0 .43-.37 1.82 1.82 0 0 0 .25-.46 3.3 3.3 0 0 0 .13-.52c0-.18.06-.34.08-.51s0-.29 0-.38h.45l.14.07v6.05a.49.49 0 0 1-.32.08h-.27c0-.07 0-.2-.06-.38s-.06-.39-.09-.63a1.9 1.9 0 0 0-.28-.77 2.77 2.77 0 0 0-.66-.72 1.54 1.54 0 0 0-.62-.25 5.14 5.14 0 0 0-1.15-.11 3.36 3.36 0 0 0-.63.06v.56a5.55 5.55 0 0 0 0 .65v4.13a2.45 2.45 0 0 0 .41.93 1.59 1.59 0 0 0 .52.45 2 2 0 0 0 .31.05h.5l.5.05a2.85 2.85 0 0 0 .37 0 .8.8 0 0 1 .06.3.49.49 0 0 1 0 .12.65.65 0 0 1 0 .15h-7.71a.48.48 0 0 1-.1-.27.5.5 0 0 1 .08-.27c.32 0 .68-.08 1.07-.15l.91-.15a2.55 2.55 0 0 0 .36-.76 7 7 0 0 0 .24-1.34v-9.43a5 5 0 0 0-.06-.73 1.73 1.73 0 0 0-.24-.66 3.86 3.86 0 0 0-.47-.58 1.43 1.43 0 0 0-.68-.17l-1-.1a.51.51 0 0 1-.07-.3v-.14l.07-.13H40.6l.07.14v.24l.19 3.28a.31.31 0 0 0-.04.11zm12.49 11.08a1.12 1.12 0 0 1-.05.27h-3a.41.41 0 0 1-.38-.18 1.14 1.14 0 0 1-.14-.45l-.16-.81c-.06-.29-.14-.57-.22-.85a8.11 8.11 0 0 0-.36-.81 3.26 3.26 0 0 0-.34-.62l-.57-.66a1.8 1.8 0 0 0-.76-.51 2.17 2.17 0 0 0-.69-.11h-1v2.86a1.7 1.7 0 0 0 .28 1.11 1 1 0 0 0 .5.36 3.31 3.31 0 0 0 .84.14.7.7 0 0 1 .13.3.12.12 0 0 1 0 .11.58.58 0 0 0-.07.14h-5.48a1 1 0 0 1-.05-.17.49.49 0 0 1 0-.12.34.34 0 0 1 0-.11 1.26 1.26 0 0 1 .05-.15h.38l.43-.06a2.11 2.11 0 0 0 .4-.11.65.65 0 0 0 .24-.12 1 1 0 0 0 .22-.38 3.9 3.9 0 0 0 .12-.46v-6.33a8 8 0 0 0-.09-.81 1 1 0 0 0-.47-.73 3.06 3.06 0 0 0-1.33-.3.76.76 0 0 1 0-.29v-.11l.06-.12h6.97a4 4 0 0 1 .88.14 2.54 2.54 0 0 1 1.48 1 2.7 2.7 0 0 1 .48 1.57 2.24 2.24 0 0 1-.67 1.62 3.56 3.56 0 0 1-2.25.86v.11a3 3 0 0 1 1 .31 2.74 2.74 0 0 1 .6.44 4.32 4.32 0 0 1 .51.65 8.53 8.53 0 0 1 .46.95l.32.81.33.89a1.45 1.45 0 0 0 .12.19.53.53 0 0 0 .19.15h.19l.33.05h.32a1 1 0 0 0 .21 0 .51.51 0 0 1 .04.34zm-3.89-7.5a2.82 2.82 0 0 0-.08-.68 1.45 1.45 0 0 0-.32-.58 1.49 1.49 0 0 0-.42-.41 1.51 1.51 0 0 0-.53-.24 3.53 3.53 0 0 0-.71-.11h-.94a1.53 1.53 0 0 0-.64.08.33.33 0 0 0-.12.3v3.78h1.57a4.85 4.85 0 0 0 .8-.08 1.67 1.67 0 0 0 .58-.29 1.62 1.62 0 0 0 .42-.48 2.48 2.48 0 0 0 .27-.62 2.57 2.57 0 0 0 .12-.67zm10.86 7.5a.54.54 0 0 1-.09.27h-5.52a.6.6 0 0 1-.05-.14.28.28 0 0 1 0-.09.8.8 0 0 1 .06-.3 7.23 7.23 0 0 0 1.13-.22.82.82 0 0 0 .53-.47 2.09 2.09 0 0 0 .07-.54c0-.31 0-.65.05-1s0-.72 0-1.05v-4.22c0-.26 0-.55-.06-.85a.74.74 0 0 0-.46-.71 5.86 5.86 0 0 0-1.24-.2.88.88 0 0 1-.06-.29.23.23 0 0 1 0-.13.81.81 0 0 0 .08-.12h5.29a.43.43 0 0 1 .12.25 1 1 0 0 1-.06.29l-.93.14a.71.71 0 0 0-.6.43 1.1 1.1 0 0 0-.07.31v6.33a7.46 7.46 0 0 0 .09 1.21.81.81 0 0 0 .56.72 2.06 2.06 0 0 0 .5.06h.6l.05.13.01.19zm12.39.28a1.4 1.4 0 0 1-.42.05h-9.97a.53.53 0 0 1-.06-.23v-.15a.28.28 0 0 1 0-.15 6.51 6.51 0 0 0 1-.13 1.22 1.22 0 0 0 .53-.2 1.14 1.14 0 0 0 .22-.53 6.77 6.77 0 0 0 .11-1.07v-6.12a1.66 1.66 0 0 0-.11-.67 1 1 0 0 0-.33-.36 1.32 1.32 0 0 0-.53-.16l-.77-.09a.83.83 0 0 1-.06-.27.5.5 0 0 1 0-.14.26.26 0 0 1 .07-.13h8.97a.82.82 0 0 1 .27 0c.06 0 .09.09.09.2l.32 2.43-.14.07h-.38a7.4 7.4 0 0 0-.46-.73 4.22 4.22 0 0 0-.39-.47 3.46 3.46 0 0 0-.35-.33l-.37-.28a1.85 1.85 0 0 0-.91-.27h-2.28a1.14 1.14 0 0 0-.35 0h-.11v.36a2.2 2.2 0 0 1 0 .23v3.21h1.03a1.82 1.82 0 0 0 .5-.1 1.87 1.87 0 0 0 .61-.28 1.52 1.52 0 0 0 .46-.45 1.21 1.21 0 0 0 .13-.42c0-.21.08-.36.1-.46a.82.82 0 0 1 .34-.07.34.34 0 0 1 .27.09c0 .21 0 .51-.06.89s0 .83 0 1.33v2.08l-.14.07h-.15a1.92 1.92 0 0 1-.3 0 4.89 4.89 0 0 0-.25-1.13 1.21 1.21 0 0 0-.73-.68 3.16 3.16 0 0 0-.59-.17 3.48 3.48 0 0 0-.57 0h-.69v2.73a4 4 0 0 0 .12 1.22 1.69 1.69 0 0 0 .24.35.68.68 0 0 0 .39.24h3.11a1 1 0 0 0 .49-.14 2 2 0 0 0 .37-.31c.16-.16.32-.34.49-.54a7 7 0 0 0 .47-.66 3.89 3.89 0 0 0 .35-.71l.16-.06h.15a.52.52 0 0 1 .29.09V24c-.06.09-.1.18-.18.21zM87.24 14.1a.45.45 0 0 1 0 .11.34.34 0 0 1 0 .14 2.39 2.39 0 0 0-.76.15 1.74 1.74 0 0 0-.63.39 1.85 1.85 0 0 0-.43.7 3.32 3.32 0 0 0-.15 1.07v7.67a1 1 0 0 1-.23.12.63.63 0 0 1-.19 0 .68.68 0 0 1-.27-.16l-7.35-7.92.08 1.63v3.44c0 .24 0 .46.06.65a1.77 1.77 0 0 0 .18.71 1.35 1.35 0 0 0 .35.4 1.7 1.7 0 0 0 .69.33c.27.06.51.11.72.14a.53.53 0 0 1 .06.23.89.89 0 0 1 0 .11l-.06.16h-4.58a.68.68 0 0 1 0-.23v-.11a1.16 1.16 0 0 1 .06-.16c.12 0 .27 0 .43-.08a2.54 2.54 0 0 0 .47-.14 4.32 4.32 0 0 0 .43-.22 1.87 1.87 0 0 0 .33-.28 1.53 1.53 0 0 0 .13-.54v-5.9a1.85 1.85 0 0 0-.35-1.13 2.71 2.71 0 0 1-.19-.21l-.34-.34a1.35 1.35 0 0 0-.54-.29l-.64-.23a.58.58 0 0 1 0-.14.44.44 0 0 1 0-.09.6.6 0 0 1 .06-.27h2.99a.78.78 0 0 1 .33.21L83.23 20l.66.76c.23.26.43.49.58.69v-5.46a2.65 2.65 0 0 0-.32-1.11.5.5 0 0 0-.26-.19 2.37 2.37 0 0 0-.45-.15 4.51 4.51 0 0 0-.53-.1l-.46-.09a.94.94 0 0 1-.06-.31.53.53 0 0 1 0-.23h4.81a.57.57 0 0 1 .04.29zm13.29 5.12a5.36 5.36 0 0 1-.22 1.51 4.55 4.55 0 0 1-.66 1.43 6 6 0 0 1-.91 1 3.62 3.62 0 0 1-1.07.64 6.47 6.47 0 0 1-1.33.34 12.2 12.2 0 0 1-1.69.1H88.8a.47.47 0 0 1-.07-.25v-.11a1.16 1.16 0 0 1 .06-.16 4.22 4.22 0 0 0 1.21-.18 1 1 0 0 0 .53-.43 2.84 2.84 0 0 0 .13-.41 4.08 4.08 0 0 0 .1-1.08v-4.86c0-.51 0-.85-.07-1a3.78 3.78 0 0 0-.06-.47.9.9 0 0 0-.21-.44 1.21 1.21 0 0 0-.52-.31 3 3 0 0 0-1-.13.83.83 0 0 1 0-.15.39.39 0 0 1 0-.14.51.51 0 0 1 .09-.25h3.61l1.09-.05h1a8 8 0 0 1 1.92.22 6.64 6.64 0 0 1 1.46.56 4 4 0 0 1 1.16.86 5.43 5.43 0 0 1 .81 1.15 5.86 5.86 0 0 1 .48 1.31 6.37 6.37 0 0 1 .01 1.3zm-2.26-.1a5.58 5.58 0 0 0-.39-2.2 3.72 3.72 0 0 0-1.27-1.56 4.76 4.76 0 0 0-1.36-.71 5.6 5.6 0 0 0-1.73-.24 2.36 2.36 0 0 0-.44 0l-.36.06v7.41a1.8 1.8 0 0 0 .28 1.25 1.79 1.79 0 0 0 .47.38 1.34 1.34 0 0 0 .6.12 4.8 4.8 0 0 0 1.74-.29 3.15 3.15 0 0 0 1.28-1 4.36 4.36 0 0 0 .91-1.42 5.07 5.07 0 0 0 .27-1.8zm12.53 2.22a2.87 2.87 0 0 1-.3 1.31 3 3 0 0 1-.81 1 3.34 3.34 0 0 1-1.16.63 4.36 4.36 0 0 1-1.4.22 4.25 4.25 0 0 1-1.31-.2 6 6 0 0 1-1.11-.43.53.53 0 0 0-.19-.06h-.18a.79.79 0 0 0-.32.1 3 3 0 0 0-.46.3.81.81 0 0 1-.37-.09.42.42 0 0 1-.24-.23 2.9 2.9 0 0 1 .09-.56 2.88 2.88 0 0 0 .1-.72v-1.33a2.66 2.66 0 0 1 0-.35.54.54 0 0 1 .46-.23h.17c0 .1.12.24.19.42l.25.57.26.58a2.84 2.84 0 0 0 .26.45 2.94 2.94 0 0 0 1.13.83 3.33 3.33 0 0 0 1.18.26 2.29 2.29 0 0 0 1.68-.5 2.13 2.13 0 0 0 .47-.62 1.56 1.56 0 0 0 .12-.64 1.48 1.48 0 0 0-.29-.95 1.92 1.92 0 0 0-.41-.4l-.69-.38a4.5 4.5 0 0 0-.51-.18l-.75-.24-.77-.25a2.82 2.82 0 0 1-.61-.25 4.17 4.17 0 0 1-.85-.49 5 5 0 0 1-.6-.54 2.26 2.26 0 0 1-.46-.93 3.8 3.8 0 0 1-.13-1 2.93 2.93 0 0 1 .23-1.16 2.68 2.68 0 0 1 .66-.93 3.26 3.26 0 0 1 1-.61 3.78 3.78 0 0 1 1.28-.22 6.78 6.78 0 0 1 1.21.12 2.79 2.79 0 0 1 1.27.6 3.84 3.84 0 0 1 .28-.3l.33-.29a.74.74 0 0 1 .38.09c.09.07.15.13.16.18s0 .33-.09.61a4.62 4.62 0 0 0-.07.82 3.1 3.1 0 0 0 0 .34l.06.47v.45a1.8 1.8 0 0 1 0 .27l-.17.1a.54.54 0 0 1-.22 0 .54.54 0 0 1-.19 0 4.66 4.66 0 0 1-.43-.92 4.9 4.9 0 0 0-.45-.89 2 2 0 0 0-.88-.69 3.1 3.1 0 0 0-1.18-.21 2.12 2.12 0 0 0-1.34.44 1.35 1.35 0 0 0-.55 1.11 1.22 1.22 0 0 0 .42 1 3.62 3.62 0 0 0 .86.54l.72.27c.26.1.54.19.85.29a13.82 13.82 0 0 1 1.66.63 3.17 3.17 0 0 1 1.31 1.14 3 3 0 0 1 .45 1.65z" stroke="#fff" stroke-width=".5" fill="#fff" stroke-miterlimit="10" data-v-a2d5b1e6></path></g>', 2)
  ]), 8, id);
}
const Rr = /* @__PURE__ */ S(sd, [["render", od], ["__scopeId", "data-v-a2d5b1e6"]]), ld = {
  name: "LibraryContactInfoOld",
  status: "ready",
  release: "5.2.0",
  type: "Element",
  components: {
    LuxLogoFacebook: Vr,
    LuxLogoX: Hr,
    LuxLogoGovDocs: Nr,
    LuxLogoFriends: Rr
  },
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    }
  }
}, ud = { class: "icons" }, cd = { href: "http://www.facebook.com/PULibrary" }, dd = { href: "https://x.com/PULibrary" }, fd = { href: "https://libguides.princeton.edu/usgovdocs" }, hd = { href: "https://fpul.princeton.edu/" };
function pd(e, t, n, a, r, s) {
  const i = Y("lux-logo-facebook"), l = Y("lux-logo-x"), u = Y("lux-logo-gov-docs"), c = Y("lux-logo-friends");
  return h(), H(ie(n.type), { class: "lux-library-contact" }, {
    default: P(() => [
      t[0] || (t[0] = o("div", {
        itemscope: "",
        itemtype: "http://schema.org/Organization"
      }, [
        o("h2", { itemprop: "name" }, "Princeton University Library"),
        o("div", {
          itemscope: "",
          itemtype: "http://schema.org/PostalAddress"
        }, [
          o("span", { itemprop: "streetAddress" }, "One Washington Road"),
          me(),
          o("br"),
          o("span", { itemprop: "addressLocality" }, "Princeton"),
          me(", "),
          o("span", { itemprop: "addressRegion" }, "NJ"),
          o("span", { itemprop: "postalCode" }, "08544"),
          me(),
          o("span", { itemprop: "addressCountry" }, "USA")
        ]),
        o("span", { itemprop: "telephone" }, [
          o("a", { href: "tel:1-609-258-1470" }, "(609) 258-1470")
        ])
      ], -1)),
      o("ul", ud, [
        o("li", null, [
          o("a", cd, [
            k(i, {
              width: "24",
              height: "24"
            })
          ])
        ]),
        o("li", null, [
          o("a", dd, [
            k(l, {
              width: "24",
              height: "24"
            })
          ])
        ]),
        o("li", null, [
          o("a", fd, [
            k(u, {
              width: "24",
              height: "24"
            })
          ])
        ]),
        o("li", null, [
          o("a", hd, [
            k(c, {
              width: "87",
              height: "24"
            })
          ])
        ])
      ])
    ]),
    _: 1,
    __: [0]
  });
}
const $i = /* @__PURE__ */ S(ld, [["render", pd], ["__scopeId", "data-v-2e74db5d"]]), vd = {
  name: "LuxUniversityCopyright",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "span"
    },
    theme: {
      type: String,
      default: "dark"
    }
  }
};
function md(e, t, n, a, r, s) {
  return h(), H(ie(n.type), {
    class: z(["lux-copyright", n.theme])
  }, {
    default: P(() => [
      me(" © " + j((/* @__PURE__ */ new Date()).getFullYear()) + " The Trustees of Princeton University ", 1)
    ]),
    _: 1
  }, 8, ["class"]);
}
const Br = /* @__PURE__ */ S(vd, [["render", md], ["__scopeId", "data-v-69740eed"]]), gd = {
  name: "LuxUniversityCopyrightOld",
  status: "ready",
  release: "5.2.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "span"
    }
  }
};
function yd(e, t, n, a, r, s) {
  return h(), H(ie(n.type), { class: "lux-copyright" }, {
    default: P(() => [
      me(" © " + j((/* @__PURE__ */ new Date()).getFullYear()) + " The Trustees of Princeton University ", 1)
    ]),
    _: 1
  });
}
const bd = /* @__PURE__ */ S(gd, [["render", yd], ["__scopeId", "data-v-59c3fc85"]]), _d = {
  name: "LuxUniversityPrivacyNotice",
  status: "ready",
  release: "5.5.1",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "span"
    },
    theme: {
      type: String,
      default: "dark"
    }
  },
  components: {
    LuxHyperlink: Yr
  }
};
function wd(e, t, n, a, r, s) {
  const i = Y("LuxHyperlink");
  return h(), H(ie(n.type), {
    class: z(["lux-privacy-notice", n.theme])
  }, {
    default: P(() => [
      k(i, {
        href: "https://www.princeton.edu/privacy-notice",
        newTab: !0
      }, {
        default: P(() => t[0] || (t[0] = [
          me("Princeton University Privacy Notice")
        ])),
        _: 1,
        __: [0]
      })
    ]),
    _: 1
  }, 8, ["class"]);
}
const Ci = /* @__PURE__ */ S(_d, [["render", wd], ["__scopeId", "data-v-4d74b6cf"]]);
var M1 = {
  expireTimes: "1d",
  path: "; path=/",
  domain: "",
  secure: !1,
  sameSite: "; SameSite=Lax"
}, $d = (
  /** @class */
  function() {
    function e() {
      this.current_default_config = M1;
    }
    return e.prototype.config = function(t) {
      for (var n in this.current_default_config)
        this.current_default_config[n] = t[n] ? t[n] : M1[n];
    }, e.prototype.get = function(t) {
      var n = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(t).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
      if (n && n.substring(0, 1) === "{" && n.substring(n.length - 1, n.length) === "}")
        try {
          n = JSON.parse(n);
        } catch {
          return n;
        }
      return n;
    }, e.prototype.set = function(t, n, a, r, s, i, l) {
      if (t) {
        if (/^(?:expires|max-age|path|domain|secure|SameSite)$/i.test(t))
          throw new Error('Cookie name illegality. Cannot be set to ["expires","max-age","path","domain","secure","SameSite"]	 current key name: ' + t);
      } else throw new Error("Cookie name is not found in the first argument.");
      n && n.constructor === Object && (n = JSON.stringify(n));
      var u = "";
      if (a == null && (a = this.current_default_config.expireTimes ? this.current_default_config.expireTimes : ""), a && a != 0)
        switch (a.constructor) {
          case Number:
            a === 1 / 0 || a === -1 ? u = "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : u = "; max-age=" + a;
            break;
          case String:
            if (/^(?:\d+(y|m|d|h|min|s))$/i.test(a)) {
              var c = a.replace(/^(\d+)(?:y|m|d|h|min|s)$/i, "$1");
              switch (a.replace(/^(?:\d+)(y|m|d|h|min|s)$/i, "$1").toLowerCase()) {
                // Frequency sorting
                case "m":
                  u = "; max-age=" + +c * 2592e3;
                  break;
                // 60 * 60 * 24 * 30
                case "d":
                  u = "; max-age=" + +c * 86400;
                  break;
                // 60 * 60 * 24
                case "h":
                  u = "; max-age=" + +c * 3600;
                  break;
                // 60 * 60
                case "min":
                  u = "; max-age=" + +c * 60;
                  break;
                // 60
                case "s":
                  u = "; max-age=" + c;
                  break;
                case "y":
                  u = "; max-age=" + +c * 31104e3;
                  break;
              }
            } else
              u = "; expires=" + a;
            break;
          case Date:
            u = "; expires=" + a.toUTCString();
            break;
        }
      return document.cookie = encodeURIComponent(t) + "=" + encodeURIComponent(n) + u + (s ? "; domain=" + s : this.current_default_config.domain ? this.current_default_config.domain : "") + (r ? "; path=" + r : this.current_default_config.path ? this.current_default_config.path : "; path=/") + (i == null ? this.current_default_config.secure ? "; Secure" : "" : i ? "; Secure" : "") + (l == null ? this.current_default_config.sameSite ? "; SameSute=" + this.current_default_config.sameSite : "" : l ? "; SameSite=" + l : ""), this;
    }, e.prototype.remove = function(t, n, a) {
      return !t || !this.isKey(t) ? !1 : (document.cookie = encodeURIComponent(t) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (a ? "; domain=" + a : this.current_default_config.domain ? this.current_default_config.domain : "") + (n ? "; path=" + n : this.current_default_config.path ? this.current_default_config.path : "; path=/") + "; SameSite=Lax", !0);
    }, e.prototype.isKey = function(t) {
      return new RegExp("(?:^|;\\s*)" + encodeURIComponent(t).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
    }, e.prototype.keys = function() {
      if (!document.cookie)
        return [];
      for (var t = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/), n = 0; n < t.length; n++)
        t[n] = decodeURIComponent(t[n]);
      return t;
    }, e;
  }()
), Wa = null;
function Cd() {
  Wa == null && (Wa = new $d());
  var e = W0(Wa);
  return { cookies: e };
}
const xd = {
  name: "LuxBanner",
  status: "prototype",
  release: "2.16.3",
  type: "Element",
  metaInfo: {
    title: "Global alert message to user.",
    htmlAttrs: {
      lang: "en"
    }
  },
  setup() {
    const { cookies: e } = Cd();
    return { cookies: e };
  },
  data: function() {
    return {
      bannerMessage: "This is the announcement description.",
      show: !0
    };
  },
  computed: {
    isFullScreen() {
      return this.fullscreen === "true";
    }
  },
  props: {
    /**
     * Allows the banner to act as an overlay, near the top of the screen.
     */
    fullscreen: {
      type: Boolean,
      default: !1
    },
    /**
     * User can manually hide the notification.
     */
    dismissible: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    hideBanner() {
      this.show = !1, this.cookies.set("showBanner", !1);
    }
  },
  created: function() {
    this.cookies.isKey("showBanner") && (this.show = this.cookies.get("showBanner") === "true");
  }
}, Sd = {
  class: "lux-announcement open",
  role: "alert"
};
function Md(e, t, n, a, r, s) {
  const i = Y("lux-wrapper");
  return e.show ? (h(), g("div", {
    key: 0,
    class: z(["lux-banner", { "lux-banner-fullscreen": s.isFullScreen }])
  }, [
    o("div", Sd, [
      k(i, { maxWidth: "1125" }, {
        default: P(() => [
          n.dismissible ? (h(), g("button", {
            key: 0,
            type: "button",
            class: "lux-announcement__close",
            "data-dismiss": "alert",
            "aria-label": "Close",
            onClick: t[0] || (t[0] = (l) => s.hideBanner())
          }, t[1] || (t[1] = [
            o("span", { "aria-hidden": "true" }, "×", -1)
          ]))) : B("", !0),
          ae(e.$slots, "default", {}, () => [
            me(j(e.bannerMessage), 1)
          ])
        ]),
        _: 3
      })
    ])
  ], 2)) : B("", !0);
}
const Dd = /* @__PURE__ */ S(xd, [["render", Md]]), kd = {
  name: "LuxCard",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * Sets the id to reference this card with.
     */
    id: {
      type: String,
      default: ""
    },
    /**
     * Sets the URL linking to the card content
     */
    cardUrl: {
      type: String,
      default: ""
    },
    /**
     * Sets arbitrary card width. It's recommended to use size over this setting.
     */
    cardPixelWidth: {
      default: ""
    },
    /**
     * Sets the size of the card `small, medium, large, full-width`
     */
    size: {
      type: String,
      default: "medium"
      // validator: (value) => {
      //   return value.match(/(small|medium|large|full-width)/);
      // },
    },
    /**
     * Indicates whether the card is selected.
     */
    selected: {
      type: Boolean,
      default: !1
    },
    /**
     * Indicates whether the object a card represents has been altered from its persisted form.
     */
    edited: {
      type: Boolean,
      default: !1
    },
    /**
     * Indicates the user cannot interact with the card.
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Indicates the user cannot interact with the card.
     */
    cardTitle: {
      type: String,
      default: ""
    }
  },
  methods: {
    select: function(e) {
      this.$emit("card-click", e);
    }
  }
}, Ld = ["id"];
function Od(e, t, n, a, r, s) {
  return h(), g("article", {
    id: n.id,
    onClickCapture: t[0] || (t[0] = (i) => s.select(i)),
    class: z(["lux-card", [
      n.size,
      { "lux-card-selected": n.selected },
      { "lux-card-edited": n.edited },
      { "lux-card-disabled": n.disabled }
    ]]),
    style: Fe({ "max-width": n.cardPixelWidth + "px" })
  }, [
    ae(e.$slots, "default")
  ], 46, Ld);
}
const Id = /* @__PURE__ */ S(kd, [["render", Od]]);
function Ed() {
  return xi().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function xi() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const Td = typeof Proxy == "function", Ad = "devtools-plugin:setup", Pd = "plugin:settings:set";
let w0, pr;
function zd() {
  var e;
  return w0 !== void 0 || (typeof window < "u" && window.performance ? (w0 = !0, pr = window.performance) : typeof globalThis < "u" && (!((e = globalThis.perf_hooks) === null || e === void 0) && e.performance) ? (w0 = !0, pr = globalThis.perf_hooks.performance) : w0 = !1), w0;
}
function Yd() {
  return zd() ? pr.now() : Date.now();
}
class Vd {
  constructor(t, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = n;
    const a = {};
    if (t.settings)
      for (const i in t.settings) {
        const l = t.settings[i];
        a[i] = l.defaultValue;
      }
    const r = `__vue-devtools-plugin-settings__${t.id}`;
    let s = Object.assign({}, a);
    try {
      const i = localStorage.getItem(r), l = JSON.parse(i);
      Object.assign(s, l);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return s;
      },
      setSettings(i) {
        try {
          localStorage.setItem(r, JSON.stringify(i));
        } catch {
        }
        s = i;
      },
      now() {
        return Yd();
      }
    }, n && n.on(Pd, (i, l) => {
      i === this.plugin.id && this.fallbacks.setSettings(l);
    }), this.proxiedOn = new Proxy({}, {
      get: (i, l) => this.target ? this.target.on[l] : (...u) => {
        this.onQueue.push({
          method: l,
          args: u
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (i, l) => this.target ? this.target[l] : l === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(l) ? (...u) => (this.targetQueue.push({
        method: l,
        args: u,
        resolve: () => {
        }
      }), this.fallbacks[l](...u)) : (...u) => new Promise((c) => {
        this.targetQueue.push({
          method: l,
          args: u,
          resolve: c
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function Hd(e, t) {
  const n = e, a = xi(), r = Ed(), s = Td && n.enableEarlyProxy;
  if (r && (a.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !s))
    r.emit(Ad, e, t);
  else {
    const i = s ? new Vd(n, r) : null;
    (a.__VUE_DEVTOOLS_PLUGINS__ = a.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: t,
      proxy: i
    }), i && t(i.proxiedTarget);
  }
}
/*!
 * vuex v4.1.0
 * (c) 2022 Evan You
 * @license MIT
 */
var Nd = "store";
function U0(e, t) {
  Object.keys(e).forEach(function(n) {
    return t(e[n], n);
  });
}
function Rd(e) {
  return e !== null && typeof e == "object";
}
function Bd(e) {
  return e && typeof e.then == "function";
}
function Fd(e, t) {
  return function() {
    return e(t);
  };
}
function Si(e, t, n) {
  return t.indexOf(e) < 0 && (n && n.prepend ? t.unshift(e) : t.push(e)), function() {
    var a = t.indexOf(e);
    a > -1 && t.splice(a, 1);
  };
}
function Mi(e, t) {
  e._actions = /* @__PURE__ */ Object.create(null), e._mutations = /* @__PURE__ */ Object.create(null), e._wrappedGetters = /* @__PURE__ */ Object.create(null), e._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
  var n = e.state;
  Ma(e, n, [], e._modules.root, !0), Fr(e, n, t);
}
function Fr(e, t, n) {
  var a = e._state, r = e._scope;
  e.getters = {}, e._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  var s = e._wrappedGetters, i = {}, l = {}, u = zl(!0);
  u.run(function() {
    U0(s, function(c, d) {
      i[d] = Fd(c, e), l[d] = $(function() {
        return i[d]();
      }), Object.defineProperty(e.getters, d, {
        get: function() {
          return l[d].value;
        },
        enumerable: !0
        // for local getters
      });
    });
  }), e._state = W0({
    data: t
  }), e._scope = u, e.strict && Gd(e), a && n && e._withCommit(function() {
    a.data = null;
  }), r && r.stop();
}
function Ma(e, t, n, a, r) {
  var s = !n.length, i = e._modules.getNamespace(n);
  if (a.namespaced && (e._modulesNamespaceMap[i], e._modulesNamespaceMap[i] = a), !s && !r) {
    var l = jr(t, n.slice(0, -1)), u = n[n.length - 1];
    e._withCommit(function() {
      l[u] = a.state;
    });
  }
  var c = a.context = jd(e, i, n);
  a.forEachMutation(function(d, f) {
    var v = i + f;
    Wd(e, v, d, c);
  }), a.forEachAction(function(d, f) {
    var v = d.root ? f : i + f, p = d.handler || d;
    Ud(e, v, p, c);
  }), a.forEachGetter(function(d, f) {
    var v = i + f;
    qd(e, v, d, c);
  }), a.forEachChild(function(d, f) {
    Ma(e, t, n.concat(f), d, r);
  });
}
function jd(e, t, n) {
  var a = t === "", r = {
    dispatch: a ? e.dispatch : function(s, i, l) {
      var u = oa(s, i, l), c = u.payload, d = u.options, f = u.type;
      return (!d || !d.root) && (f = t + f), e.dispatch(f, c);
    },
    commit: a ? e.commit : function(s, i, l) {
      var u = oa(s, i, l), c = u.payload, d = u.options, f = u.type;
      (!d || !d.root) && (f = t + f), e.commit(f, c, d);
    }
  };
  return Object.defineProperties(r, {
    getters: {
      get: a ? function() {
        return e.getters;
      } : function() {
        return Di(e, t);
      }
    },
    state: {
      get: function() {
        return jr(e.state, n);
      }
    }
  }), r;
}
function Di(e, t) {
  if (!e._makeLocalGettersCache[t]) {
    var n = {}, a = t.length;
    Object.keys(e.getters).forEach(function(r) {
      if (r.slice(0, a) === t) {
        var s = r.slice(a);
        Object.defineProperty(n, s, {
          get: function() {
            return e.getters[r];
          },
          enumerable: !0
        });
      }
    }), e._makeLocalGettersCache[t] = n;
  }
  return e._makeLocalGettersCache[t];
}
function Wd(e, t, n, a) {
  var r = e._mutations[t] || (e._mutations[t] = []);
  r.push(function(i) {
    n.call(e, a.state, i);
  });
}
function Ud(e, t, n, a) {
  var r = e._actions[t] || (e._actions[t] = []);
  r.push(function(i) {
    var l = n.call(e, {
      dispatch: a.dispatch,
      commit: a.commit,
      getters: a.getters,
      state: a.state,
      rootGetters: e.getters,
      rootState: e.state
    }, i);
    return Bd(l) || (l = Promise.resolve(l)), e._devtoolHook ? l.catch(function(u) {
      throw e._devtoolHook.emit("vuex:error", u), u;
    }) : l;
  });
}
function qd(e, t, n, a) {
  e._wrappedGetters[t] || (e._wrappedGetters[t] = function(s) {
    return n(
      a.state,
      // local state
      a.getters,
      // local getters
      s.state,
      // root state
      s.getters
      // root getters
    );
  });
}
function Gd(e) {
  Ie(function() {
    return e._state.data;
  }, function() {
  }, { deep: !0, flush: "sync" });
}
function jr(e, t) {
  return t.reduce(function(n, a) {
    return n[a];
  }, e);
}
function oa(e, t, n) {
  return Rd(e) && e.type && (n = t, t = e, e = e.type), { type: e, payload: t, options: n };
}
var Kd = "vuex bindings", D1 = "vuex:mutations", Ua = "vuex:actions", $0 = "vuex", Zd = 0;
function Xd(e, t) {
  Hd(
    {
      id: "org.vuejs.vuex",
      app: e,
      label: "Vuex",
      homepage: "https://next.vuex.vuejs.org/",
      logo: "https://vuejs.org/images/icons/favicon-96x96.png",
      packageName: "vuex",
      componentStateTypes: [Kd]
    },
    function(n) {
      n.addTimelineLayer({
        id: D1,
        label: "Vuex Mutations",
        color: k1
      }), n.addTimelineLayer({
        id: Ua,
        label: "Vuex Actions",
        color: k1
      }), n.addInspector({
        id: $0,
        label: "Vuex",
        icon: "storage",
        treeFilterPlaceholder: "Filter stores..."
      }), n.on.getInspectorTree(function(a) {
        if (a.app === e && a.inspectorId === $0)
          if (a.filter) {
            var r = [];
            Ii(r, t._modules.root, a.filter, ""), a.rootNodes = r;
          } else
            a.rootNodes = [
              Oi(t._modules.root, "")
            ];
      }), n.on.getInspectorState(function(a) {
        if (a.app === e && a.inspectorId === $0) {
          var r = a.nodeId;
          Di(t, r), a.state = e3(
            n3(t._modules, r),
            r === "root" ? t.getters : t._makeLocalGettersCache,
            r
          );
        }
      }), n.on.editInspectorState(function(a) {
        if (a.app === e && a.inspectorId === $0) {
          var r = a.nodeId, s = a.path;
          r !== "root" && (s = r.split("/").filter(Boolean).concat(s)), t._withCommit(function() {
            a.set(t._state.data, s, a.state.value);
          });
        }
      }), t.subscribe(function(a, r) {
        var s = {};
        a.payload && (s.payload = a.payload), s.state = r, n.notifyComponentUpdate(), n.sendInspectorTree($0), n.sendInspectorState($0), n.addTimelineEvent({
          layerId: D1,
          event: {
            time: Date.now(),
            title: a.type,
            data: s
          }
        });
      }), t.subscribeAction({
        before: function(a, r) {
          var s = {};
          a.payload && (s.payload = a.payload), a._id = Zd++, a._time = Date.now(), s.state = r, n.addTimelineEvent({
            layerId: Ua,
            event: {
              time: a._time,
              title: a.type,
              groupId: a._id,
              subtitle: "start",
              data: s
            }
          });
        },
        after: function(a, r) {
          var s = {}, i = Date.now() - a._time;
          s.duration = {
            _custom: {
              type: "duration",
              display: i + "ms",
              tooltip: "Action duration",
              value: i
            }
          }, a.payload && (s.payload = a.payload), s.state = r, n.addTimelineEvent({
            layerId: Ua,
            event: {
              time: Date.now(),
              title: a.type,
              groupId: a._id,
              subtitle: "end",
              data: s
            }
          });
        }
      });
    }
  );
}
var k1 = 8702998, Jd = 6710886, Qd = 16777215, ki = {
  label: "namespaced",
  textColor: Qd,
  backgroundColor: Jd
};
function Li(e) {
  return e && e !== "root" ? e.split("/").slice(-2, -1)[0] : "Root";
}
function Oi(e, t) {
  return {
    id: t || "root",
    // all modules end with a `/`, we want the last segment only
    // cart/ -> cart
    // nested/cart/ -> cart
    label: Li(t),
    tags: e.namespaced ? [ki] : [],
    children: Object.keys(e._children).map(
      function(n) {
        return Oi(
          e._children[n],
          t + n + "/"
        );
      }
    )
  };
}
function Ii(e, t, n, a) {
  a.includes(n) && e.push({
    id: a || "root",
    label: a.endsWith("/") ? a.slice(0, a.length - 1) : a || "Root",
    tags: t.namespaced ? [ki] : []
  }), Object.keys(t._children).forEach(function(r) {
    Ii(e, t._children[r], n, a + r + "/");
  });
}
function e3(e, t, n) {
  t = n === "root" ? t : t[n];
  var a = Object.keys(t), r = {
    state: Object.keys(e.state).map(function(i) {
      return {
        key: i,
        editable: !0,
        value: e.state[i]
      };
    })
  };
  if (a.length) {
    var s = t3(t);
    r.getters = Object.keys(s).map(function(i) {
      return {
        key: i.endsWith("/") ? Li(i) : i,
        editable: !1,
        value: vr(function() {
          return s[i];
        })
      };
    });
  }
  return r;
}
function t3(e) {
  var t = {};
  return Object.keys(e).forEach(function(n) {
    var a = n.split("/");
    if (a.length > 1) {
      var r = t, s = a.pop();
      a.forEach(function(i) {
        r[i] || (r[i] = {
          _custom: {
            value: {},
            display: i,
            tooltip: "Module",
            abstract: !0
          }
        }), r = r[i]._custom.value;
      }), r[s] = vr(function() {
        return e[n];
      });
    } else
      t[n] = vr(function() {
        return e[n];
      });
  }), t;
}
function n3(e, t) {
  var n = t.split("/").filter(function(a) {
    return a;
  });
  return n.reduce(
    function(a, r, s) {
      var i = a[r];
      if (!i)
        throw new Error('Missing module "' + r + '" for path "' + t + '".');
      return s === n.length - 1 ? i : i._children;
    },
    t === "root" ? e : e.root._children
  );
}
function vr(e) {
  try {
    return e();
  } catch (t) {
    return t;
  }
}
var vt = function(t, n) {
  this.runtime = n, this._children = /* @__PURE__ */ Object.create(null), this._rawModule = t;
  var a = t.state;
  this.state = (typeof a == "function" ? a() : a) || {};
}, Ei = { namespaced: { configurable: !0 } };
Ei.namespaced.get = function() {
  return !!this._rawModule.namespaced;
};
vt.prototype.addChild = function(t, n) {
  this._children[t] = n;
};
vt.prototype.removeChild = function(t) {
  delete this._children[t];
};
vt.prototype.getChild = function(t) {
  return this._children[t];
};
vt.prototype.hasChild = function(t) {
  return t in this._children;
};
vt.prototype.update = function(t) {
  this._rawModule.namespaced = t.namespaced, t.actions && (this._rawModule.actions = t.actions), t.mutations && (this._rawModule.mutations = t.mutations), t.getters && (this._rawModule.getters = t.getters);
};
vt.prototype.forEachChild = function(t) {
  U0(this._children, t);
};
vt.prototype.forEachGetter = function(t) {
  this._rawModule.getters && U0(this._rawModule.getters, t);
};
vt.prototype.forEachAction = function(t) {
  this._rawModule.actions && U0(this._rawModule.actions, t);
};
vt.prototype.forEachMutation = function(t) {
  this._rawModule.mutations && U0(this._rawModule.mutations, t);
};
Object.defineProperties(vt.prototype, Ei);
var h0 = function(t) {
  this.register([], t, !1);
};
h0.prototype.get = function(t) {
  return t.reduce(function(n, a) {
    return n.getChild(a);
  }, this.root);
};
h0.prototype.getNamespace = function(t) {
  var n = this.root;
  return t.reduce(function(a, r) {
    return n = n.getChild(r), a + (n.namespaced ? r + "/" : "");
  }, "");
};
h0.prototype.update = function(t) {
  Ti([], this.root, t);
};
h0.prototype.register = function(t, n, a) {
  var r = this;
  a === void 0 && (a = !0);
  var s = new vt(n, a);
  if (t.length === 0)
    this.root = s;
  else {
    var i = this.get(t.slice(0, -1));
    i.addChild(t[t.length - 1], s);
  }
  n.modules && U0(n.modules, function(l, u) {
    r.register(t.concat(u), l, a);
  });
};
h0.prototype.unregister = function(t) {
  var n = this.get(t.slice(0, -1)), a = t[t.length - 1], r = n.getChild(a);
  r && r.runtime && n.removeChild(a);
};
h0.prototype.isRegistered = function(t) {
  var n = this.get(t.slice(0, -1)), a = t[t.length - 1];
  return n ? n.hasChild(a) : !1;
};
function Ti(e, t, n) {
  if (t.update(n), n.modules)
    for (var a in n.modules) {
      if (!t.getChild(a))
        return;
      Ti(
        e.concat(a),
        t.getChild(a),
        n.modules[a]
      );
    }
}
function a3(e) {
  return new Ge(e);
}
var Ge = function(t) {
  var n = this;
  t === void 0 && (t = {});
  var a = t.plugins;
  a === void 0 && (a = []);
  var r = t.strict;
  r === void 0 && (r = !1);
  var s = t.devtools;
  this._committing = !1, this._actions = /* @__PURE__ */ Object.create(null), this._actionSubscribers = [], this._mutations = /* @__PURE__ */ Object.create(null), this._wrappedGetters = /* @__PURE__ */ Object.create(null), this._modules = new h0(t), this._modulesNamespaceMap = /* @__PURE__ */ Object.create(null), this._subscribers = [], this._makeLocalGettersCache = /* @__PURE__ */ Object.create(null), this._scope = null, this._devtools = s;
  var i = this, l = this, u = l.dispatch, c = l.commit;
  this.dispatch = function(v, p) {
    return u.call(i, v, p);
  }, this.commit = function(v, p, y) {
    return c.call(i, v, p, y);
  }, this.strict = r;
  var d = this._modules.root.state;
  Ma(this, d, [], this._modules.root), Fr(this, d), a.forEach(function(f) {
    return f(n);
  });
}, Wr = { state: { configurable: !0 } };
Ge.prototype.install = function(t, n) {
  t.provide(n || Nd, this), t.config.globalProperties.$store = this;
  var a = this._devtools !== void 0 ? this._devtools : !1;
  a && Xd(t, this);
};
Wr.state.get = function() {
  return this._state.data;
};
Wr.state.set = function(e) {
};
Ge.prototype.commit = function(t, n, a) {
  var r = this, s = oa(t, n, a), i = s.type, l = s.payload, u = { type: i, payload: l }, c = this._mutations[i];
  c && (this._withCommit(function() {
    c.forEach(function(f) {
      f(l);
    });
  }), this._subscribers.slice().forEach(function(d) {
    return d(u, r.state);
  }));
};
Ge.prototype.dispatch = function(t, n) {
  var a = this, r = oa(t, n), s = r.type, i = r.payload, l = { type: s, payload: i }, u = this._actions[s];
  if (u) {
    try {
      this._actionSubscribers.slice().filter(function(d) {
        return d.before;
      }).forEach(function(d) {
        return d.before(l, a.state);
      });
    } catch {
    }
    var c = u.length > 1 ? Promise.all(u.map(function(d) {
      return d(i);
    })) : u[0](i);
    return new Promise(function(d, f) {
      c.then(function(v) {
        try {
          a._actionSubscribers.filter(function(p) {
            return p.after;
          }).forEach(function(p) {
            return p.after(l, a.state);
          });
        } catch {
        }
        d(v);
      }, function(v) {
        try {
          a._actionSubscribers.filter(function(p) {
            return p.error;
          }).forEach(function(p) {
            return p.error(l, a.state, v);
          });
        } catch {
        }
        f(v);
      });
    });
  }
};
Ge.prototype.subscribe = function(t, n) {
  return Si(t, this._subscribers, n);
};
Ge.prototype.subscribeAction = function(t, n) {
  var a = typeof t == "function" ? { before: t } : t;
  return Si(a, this._actionSubscribers, n);
};
Ge.prototype.watch = function(t, n, a) {
  var r = this;
  return Ie(function() {
    return t(r.state, r.getters);
  }, n, Object.assign({}, a));
};
Ge.prototype.replaceState = function(t) {
  var n = this;
  this._withCommit(function() {
    n._state.data = t;
  });
};
Ge.prototype.registerModule = function(t, n, a) {
  a === void 0 && (a = {}), typeof t == "string" && (t = [t]), this._modules.register(t, n), Ma(this, this.state, t, this._modules.get(t), a.preserveState), Fr(this, this.state);
};
Ge.prototype.unregisterModule = function(t) {
  var n = this;
  typeof t == "string" && (t = [t]), this._modules.unregister(t), this._withCommit(function() {
    var a = jr(n.state, t.slice(0, -1));
    delete a[t[t.length - 1]];
  }), Mi(this);
};
Ge.prototype.hasModule = function(t) {
  return typeof t == "string" && (t = [t]), this._modules.isRegistered(t);
};
Ge.prototype.hotUpdate = function(t) {
  this._modules.update(t), Mi(this, !0);
};
Ge.prototype._withCommit = function(t) {
  var n = this._committing;
  this._committing = !0, t(), this._committing = n;
};
Object.defineProperties(Ge.prototype, Wr);
const r3 = {
  items: [],
  selected: [],
  cut: [],
  changeList: [],
  ogItems: []
}, s3 = {
  CUT(e, t) {
    e.cut = [...t];
  },
  PASTE(e, t) {
    e.items = [...t];
  },
  SELECT(e, t) {
    e.selected = [...t];
  },
  SET_GALLERY(e, t) {
    e.items = t, e.ogItems = t;
  },
  SORT_ITEMS(e, t) {
    e.items = [...t];
  },
  UPDATE_CHANGES(e, t) {
    e.changeList = [...t];
  },
  UPDATE_ITEMS(e, t) {
    e.items = [...t];
  }
}, i3 = {
  count: 10
}, o3 = {
  increment(e) {
    e.count++;
  }
}, l3 = {
  count: (e) => e.count
}, u3 = {
  state: r3,
  mutations: s3
}, c3 = {
  state: i3,
  mutations: o3,
  getters: l3
}, Je = a3({
  // state: { count: 10 },
  //
  // mutations: {
  //   increment(state) {
  //     // `state` is the local module state
  //     state.count++
  //   },
  // },
  //
  // getters: {
  //   count: state => {
  //     return state.count
  //   },
  // },
  modules: {
    counter: c3,
    gallery: u3
  }
}), d3 = {
  name: "LuxCounter",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  methods: {
    increment() {
      Je.commit("increment");
    }
  },
  computed: {
    // mapState does not seem to work
    // ...mapState({
    //   counter: state => store.counter.state,
    // }),
    count() {
      return Je.state.counter.count;
    }
  }
};
function f3(e, t, n, a, r, s) {
  return h(), g("div", null, [
    o("button", {
      onClick: t[0] || (t[0] = (i) => s.increment())
    }, "increment"),
    o("p", null, j(s.count), 1)
  ]);
}
const h3 = /* @__PURE__ */ S(d3, [["render", f3]]), p3 = {
  name: "LuxDataTable",
  status: "ready",
  release: "3.1.4",
  type: "Element",
  data() {
    return {
      rows: this.jsonData,
      parsedColumns: []
    };
  },
  props: {
    /**
     * caption provides context for the data that is helpful to users, particularly those who use screenreaders.
     * `e.g. [name, title, age]`
     */
    caption: {
      required: !0,
      type: String
    },
    /**
     * summaryLabel provides context to the data values in tfoot element cells.
     */
    summaryLabel: {
      required: !1,
      type: String
    },
    /**
     * columns define the columns and order for which the data should be displayed.
     * Columns entries can be simple strings, or they may be more complicated objects
     * that can define `name`, `display_name`,`align`, `sortable`, and `checkbox` properties.
     * Sorting on `numeric` or `currency` values requires a column to have
     * a `datatype='number'` or `datatype='currency'` property.
     * Sorting on `date` values requires a column to have
     * a `datatype='date'` property.
     * Use `checkbox=true` to create a checkbox whose value is the value for that
     * column value for the row in the table.
     * `e.g. ['name', 'email', 'age']`
     */
    columns: {
      required: !0,
      type: Array
    },
    /**
     * jsonData is supplied via Array with an object representing each row.
     * Applying links to data cell content can be achieved by supplying an object
     * that contains a `value` and `link` property. Date sorting uses the JavaScript
     * `datestring` parameter. Shorthand dates are supported in most browsers, but can be implementation-specific.
     * (e.g., `{ value: 'content', link: 'https://url.com'}`)
     * See above example for exact structure.
     */
    jsonData: {
      required: !0,
      type: Array
    }
  },
  created: function() {
    let e = this.columns.map((n) => this.isObject(n) ? (n.name = n.name.toLowerCase(), n.sortable && typeof n.ascending > "u" && (n.ascending = null), n) : { name: n.toLowerCase(), ascending: null });
    this.parsedColumns = e;
    let t = this.jsonData.length;
    for (let n = 0; n < t; n++)
      for (let a in this.jsonData[n])
        this.jsonData[n].hasOwnProperty(a) && (this.isObject(this.jsonData[n][a]) || (this.jsonData[n][a] = { value: this.jsonData[n][a], link: null }));
    this.rows = this.jsonData;
  },
  computed: {
    footerColumns() {
      let e = this.columns;
      return e.shift(), e;
    }
  },
  methods: {
    getAriaLabel(e) {
      let t = [];
      for (const [n, a] of Object.entries(e))
        t.push(`${n}: ${a.value}`);
      return t.join(", ");
    },
    iconLabel(e) {
      if (e === !0)
        return "ascending";
      if (e === !1)
        return "descending";
      if (e === null)
        return "unsorted";
    },
    displayName(e) {
      return e.hasOwnProperty("display_name") ? e.display_name : e.name;
    },
    sortTable(e) {
      e.ascending ? e.datatype === "number" || e.datatype === "currency" ? this.rows.sort((t, n) => n[e.name].value - t[e.name].value) : e.datatype === "date" ? this.rows.sort((t, n) => new Date(n[e.name].value) - new Date(t[e.name].value)) : this.rows.sort(function(t, n) {
        let a = t[e.name.toLowerCase()].value.toString().toLowerCase(), r = n[e.name.toLowerCase()].value.toString().toLowerCase();
        return a < r ? 1 : a > r ? -1 : 0;
      }) : e.datatype === "number" || e.datatype === "currency" ? this.rows.sort((t, n) => t[e.name].value - n[e.name].value) : e.datatype === "date" ? this.rows.sort((t, n) => new Date(t[e.name].value) - new Date(n[e.name].value)) : this.rows.sort(function(t, n) {
        let a = t[e.name.toLowerCase()].value.toString().toLowerCase(), r = n[e.name.toLowerCase()].value.toString().toLowerCase();
        return a < r ? -1 : a > r ? 1 : 0;
      }), e.ascending = !e.ascending, this.parsedColumns = this.parsedColumns.map(function(t) {
        return e.name != t.name && (t.ascending = null), t;
      });
    },
    isObject(e) {
      return e && typeof e == "object" && e.constructor === Object;
    },
    isCurrency(e) {
      return e === "currency";
    },
    isNum(e) {
      return e === "number";
    },
    isLeft(e) {
      return e === "left";
    },
    isCenter(e) {
      return e === "center";
    },
    isRight(e) {
      return e === "right";
    }
  }
}, v3 = {
  border: "1px",
  class: /* @__PURE__ */ z(["lux-data-table"])
}, m3 = { key: 1 }, g3 = ["id", "aria-label", "name", "value"], y3 = { key: 2 }, b3 = { key: 0 }, _3 = { scope: "row" };
function w3(e, t, n, a, r, s) {
  const i = Y("lux-icon-ascending"), l = Y("lux-icon-descending"), u = Y("lux-icon-unsorted"), c = Y("lux-icon-base"), d = Y("lux-input-button"), f = Y("lux-hyperlink");
  return h(), g("table", v3, [
    o("caption", null, j(n.caption), 1),
    o("thead", null, [
      o("tr", null, [
        (h(!0), g(se, null, fe(r.parsedColumns, (v, p) => (h(), g("th", {
          scope: "col",
          key: p,
          nowrap: ""
        }, [
          v.sortable ? (h(), H(d, {
            key: 0,
            type: "button",
            onButtonClicked: (y) => s.sortTable(v),
            variation: "text"
          }, {
            default: P(() => [
              v.sortable ? (h(), H(c, {
                key: 0,
                width: "16",
                height: "16",
                "icon-name": s.iconLabel(v.ascending)
              }, {
                default: P(() => [
                  v.ascending ? (h(), H(i, { key: 0 })) : B("", !0),
                  v.ascending === !1 ? (h(), H(l, { key: 1 })) : B("", !0),
                  v.ascending === null ? (h(), H(u, { key: 2 })) : B("", !0)
                ]),
                _: 2
              }, 1032, ["icon-name"])) : B("", !0),
              me(" " + j(s.displayName(v)), 1)
            ]),
            _: 2
          }, 1032, ["onButtonClicked"])) : (h(), g("span", m3, j(s.displayName(v)), 1))
        ]))), 128))
      ])
    ]),
    o("tbody", null, [
      (h(!0), g(se, null, fe(r.rows, (v, p) => (h(), g("tr", {
        class: "row",
        key: p
      }, [
        (h(!0), g(se, null, fe(r.parsedColumns, (y, w) => (h(), g("td", {
          key: w,
          class: z([
            { "lux-data-table-left": s.isLeft(y.align) },
            { "lux-data-table-center": s.isCenter(y.align) },
            { "lux-data-table-right": s.isRight(y.align) },
            { "lux-data-table-number": s.isNum(y.datatype) },
            { "lux-data-table-currency": s.isCurrency(y.datatype) }
          ])
        }, [
          y.checkbox ? (h(), g("input", {
            key: 0,
            id: v[y.name].value,
            type: "checkbox",
            "aria-label": s.getAriaLabel(v),
            name: y.name,
            value: v[y.name].value
          }, null, 8, g3)) : v[y.name].link ? (h(), H(f, {
            key: 1,
            href: v[y.name].link
          }, {
            default: P(() => [
              me(j(v[y.name].value), 1)
            ]),
            _: 2
          }, 1032, ["href"])) : (h(), g("span", y3, j(v[y.name].value), 1))
        ], 2))), 128))
      ]))), 128))
    ]),
    n.summaryLabel ? (h(), g("tfoot", b3, [
      o("tr", null, [
        o("th", _3, j(n.summaryLabel), 1),
        (h(!0), g(se, null, fe(s.footerColumns, (v, p) => (h(), g("td", {
          key: p,
          class: z([
            { "lux-data-table-left": s.isLeft(v.align) },
            { "lux-data-table-center": s.isCenter(v.align) },
            { "lux-data-table-right": s.isRight(v.align) },
            { "lux-data-table-number": s.isNum(v.datatype) },
            { "lux-data-table-currency": s.isCurrency(v.datatype) }
          ])
        }, [
          o("span", null, j(v.summary_value), 1)
        ], 2))), 128))
      ])
    ])) : B("", !0)
  ]);
}
const $3 = /* @__PURE__ */ S(p3, [["render", w3], ["__scopeId", "data-v-c372dd16"]]);
var Ue = "top", lt = "bottom", ut = "right", qe = "left", Ur = "auto", En = [Ue, lt, ut, qe], Y0 = "start", Cn = "end", C3 = "clippingParents", Ai = "viewport", rn = "popper", x3 = "reference", L1 = /* @__PURE__ */ En.reduce(function(e, t) {
  return e.concat([t + "-" + Y0, t + "-" + Cn]);
}, []), Pi = /* @__PURE__ */ [].concat(En, [Ur]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Y0, t + "-" + Cn]);
}, []), S3 = "beforeRead", M3 = "read", D3 = "afterRead", k3 = "beforeMain", L3 = "main", O3 = "afterMain", I3 = "beforeWrite", E3 = "write", T3 = "afterWrite", A3 = [S3, M3, D3, k3, L3, O3, I3, E3, T3];
function xt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function tt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function d0(e) {
  var t = tt(e).Element;
  return e instanceof t || e instanceof Element;
}
function it(e) {
  var t = tt(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function qr(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = tt(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function P3(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var a = t.styles[n] || {}, r = t.attributes[n] || {}, s = t.elements[n];
    !it(s) || !xt(s) || (Object.assign(s.style, a), Object.keys(r).forEach(function(i) {
      var l = r[i];
      l === !1 ? s.removeAttribute(i) : s.setAttribute(i, l === !0 ? "" : l);
    }));
  });
}
function z3(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(a) {
      var r = t.elements[a], s = t.attributes[a] || {}, i = Object.keys(t.styles.hasOwnProperty(a) ? t.styles[a] : n[a]), l = i.reduce(function(u, c) {
        return u[c] = "", u;
      }, {});
      !it(r) || !xt(r) || (Object.assign(r.style, l), Object.keys(s).forEach(function(u) {
        r.removeAttribute(u);
      }));
    });
  };
}
const Y3 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: P3,
  effect: z3,
  requires: ["computeStyles"]
};
function $t(e) {
  return e.split("-")[0];
}
var c0 = Math.max, la = Math.min, V0 = Math.round;
function mr() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function zi() {
  return !/^((?!chrome|android).)*safari/i.test(mr());
}
function H0(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var a = e.getBoundingClientRect(), r = 1, s = 1;
  t && it(e) && (r = e.offsetWidth > 0 && V0(a.width) / e.offsetWidth || 1, s = e.offsetHeight > 0 && V0(a.height) / e.offsetHeight || 1);
  var i = d0(e) ? tt(e) : window, l = i.visualViewport, u = !zi() && n, c = (a.left + (u && l ? l.offsetLeft : 0)) / r, d = (a.top + (u && l ? l.offsetTop : 0)) / s, f = a.width / r, v = a.height / s;
  return {
    width: f,
    height: v,
    top: d,
    right: c + f,
    bottom: d + v,
    left: c,
    x: c,
    y: d
  };
}
function Gr(e) {
  var t = H0(e), n = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - a) <= 1 && (a = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: a
  };
}
function Yi(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && qr(n)) {
    var a = t;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function It(e) {
  return tt(e).getComputedStyle(e);
}
function V3(e) {
  return ["table", "td", "th"].indexOf(xt(e)) >= 0;
}
function Qt(e) {
  return ((d0(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Da(e) {
  return xt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (qr(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Qt(e)
  );
}
function O1(e) {
  return !it(e) || // https://github.com/popperjs/popper-core/issues/837
  It(e).position === "fixed" ? null : e.offsetParent;
}
function H3(e) {
  var t = /firefox/i.test(mr()), n = /Trident/i.test(mr());
  if (n && it(e)) {
    var a = It(e);
    if (a.position === "fixed")
      return null;
  }
  var r = Da(e);
  for (qr(r) && (r = r.host); it(r) && ["html", "body"].indexOf(xt(r)) < 0; ) {
    var s = It(r);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || t && s.willChange === "filter" || t && s.filter && s.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function Tn(e) {
  for (var t = tt(e), n = O1(e); n && V3(n) && It(n).position === "static"; )
    n = O1(n);
  return n && (xt(n) === "html" || xt(n) === "body" && It(n).position === "static") ? t : n || H3(e) || t;
}
function Kr(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function vn(e, t, n) {
  return c0(e, la(t, n));
}
function N3(e, t, n) {
  var a = vn(e, t, n);
  return a > n ? n : a;
}
function Vi() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Hi(e) {
  return Object.assign({}, Vi(), e);
}
function Ni(e, t) {
  return t.reduce(function(n, a) {
    return n[a] = e, n;
  }, {});
}
var R3 = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Hi(typeof t != "number" ? t : Ni(t, En));
};
function B3(e) {
  var t, n = e.state, a = e.name, r = e.options, s = n.elements.arrow, i = n.modifiersData.popperOffsets, l = $t(n.placement), u = Kr(l), c = [qe, ut].indexOf(l) >= 0, d = c ? "height" : "width";
  if (!(!s || !i)) {
    var f = R3(r.padding, n), v = Gr(s), p = u === "y" ? Ue : qe, y = u === "y" ? lt : ut, w = n.rects.reference[d] + n.rects.reference[u] - i[u] - n.rects.popper[d], _ = i[u] - n.rects.reference[u], b = Tn(s), N = b ? u === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, E = w / 2 - _ / 2, L = f[p], A = N - v[d] - f[y], D = N / 2 - v[d] / 2 + E, I = vn(L, D, A), F = u;
    n.modifiersData[a] = (t = {}, t[F] = I, t.centerOffset = I - D, t);
  }
}
function F3(e) {
  var t = e.state, n = e.options, a = n.element, r = a === void 0 ? "[data-popper-arrow]" : a;
  r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || Yi(t.elements.popper, r) && (t.elements.arrow = r));
}
const j3 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: B3,
  effect: F3,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function N0(e) {
  return e.split("-")[1];
}
var W3 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function U3(e, t) {
  var n = e.x, a = e.y, r = t.devicePixelRatio || 1;
  return {
    x: V0(n * r) / r || 0,
    y: V0(a * r) / r || 0
  };
}
function I1(e) {
  var t, n = e.popper, a = e.popperRect, r = e.placement, s = e.variation, i = e.offsets, l = e.position, u = e.gpuAcceleration, c = e.adaptive, d = e.roundOffsets, f = e.isFixed, v = i.x, p = v === void 0 ? 0 : v, y = i.y, w = y === void 0 ? 0 : y, _ = typeof d == "function" ? d({
    x: p,
    y: w
  }) : {
    x: p,
    y: w
  };
  p = _.x, w = _.y;
  var b = i.hasOwnProperty("x"), N = i.hasOwnProperty("y"), E = qe, L = Ue, A = window;
  if (c) {
    var D = Tn(n), I = "clientHeight", F = "clientWidth";
    if (D === tt(n) && (D = Qt(n), It(D).position !== "static" && l === "absolute" && (I = "scrollHeight", F = "scrollWidth")), D = D, r === Ue || (r === qe || r === ut) && s === Cn) {
      L = lt;
      var U = f && D === A && A.visualViewport ? A.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        D[I]
      );
      w -= U - a.height, w *= u ? 1 : -1;
    }
    if (r === qe || (r === Ue || r === lt) && s === Cn) {
      E = ut;
      var X = f && D === A && A.visualViewport ? A.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        D[F]
      );
      p -= X - a.width, p *= u ? 1 : -1;
    }
  }
  var Q = Object.assign({
    position: l
  }, c && W3), R = d === !0 ? U3({
    x: p,
    y: w
  }, tt(n)) : {
    x: p,
    y: w
  };
  if (p = R.x, w = R.y, u) {
    var G;
    return Object.assign({}, Q, (G = {}, G[L] = N ? "0" : "", G[E] = b ? "0" : "", G.transform = (A.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + w + "px)" : "translate3d(" + p + "px, " + w + "px, 0)", G));
  }
  return Object.assign({}, Q, (t = {}, t[L] = N ? w + "px" : "", t[E] = b ? p + "px" : "", t.transform = "", t));
}
function q3(e) {
  var t = e.state, n = e.options, a = n.gpuAcceleration, r = a === void 0 ? !0 : a, s = n.adaptive, i = s === void 0 ? !0 : s, l = n.roundOffsets, u = l === void 0 ? !0 : l, c = {
    placement: $t(t.placement),
    variation: N0(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: r,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, I1(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: u
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, I1(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const G3 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: q3,
  data: {}
};
var Bn = {
  passive: !0
};
function K3(e) {
  var t = e.state, n = e.instance, a = e.options, r = a.scroll, s = r === void 0 ? !0 : r, i = a.resize, l = i === void 0 ? !0 : i, u = tt(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return s && c.forEach(function(d) {
    d.addEventListener("scroll", n.update, Bn);
  }), l && u.addEventListener("resize", n.update, Bn), function() {
    s && c.forEach(function(d) {
      d.removeEventListener("scroll", n.update, Bn);
    }), l && u.removeEventListener("resize", n.update, Bn);
  };
}
const Z3 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: K3,
  data: {}
};
var X3 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Xn(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return X3[t];
  });
}
var J3 = {
  start: "end",
  end: "start"
};
function E1(e) {
  return e.replace(/start|end/g, function(t) {
    return J3[t];
  });
}
function Zr(e) {
  var t = tt(e), n = t.pageXOffset, a = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: a
  };
}
function Xr(e) {
  return H0(Qt(e)).left + Zr(e).scrollLeft;
}
function Q3(e, t) {
  var n = tt(e), a = Qt(e), r = n.visualViewport, s = a.clientWidth, i = a.clientHeight, l = 0, u = 0;
  if (r) {
    s = r.width, i = r.height;
    var c = zi();
    (c || !c && t === "fixed") && (l = r.offsetLeft, u = r.offsetTop);
  }
  return {
    width: s,
    height: i,
    x: l + Xr(e),
    y: u
  };
}
function e4(e) {
  var t, n = Qt(e), a = Zr(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, s = c0(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), i = c0(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), l = -a.scrollLeft + Xr(e), u = -a.scrollTop;
  return It(r || n).direction === "rtl" && (l += c0(n.clientWidth, r ? r.clientWidth : 0) - s), {
    width: s,
    height: i,
    x: l,
    y: u
  };
}
function Jr(e) {
  var t = It(e), n = t.overflow, a = t.overflowX, r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + a);
}
function Ri(e) {
  return ["html", "body", "#document"].indexOf(xt(e)) >= 0 ? e.ownerDocument.body : it(e) && Jr(e) ? e : Ri(Da(e));
}
function mn(e, t) {
  var n;
  t === void 0 && (t = []);
  var a = Ri(e), r = a === ((n = e.ownerDocument) == null ? void 0 : n.body), s = tt(a), i = r ? [s].concat(s.visualViewport || [], Jr(a) ? a : []) : a, l = t.concat(i);
  return r ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(mn(Da(i)))
  );
}
function gr(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function t4(e, t) {
  var n = H0(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function T1(e, t, n) {
  return t === Ai ? gr(Q3(e, n)) : d0(t) ? t4(t, n) : gr(e4(Qt(e)));
}
function n4(e) {
  var t = mn(Da(e)), n = ["absolute", "fixed"].indexOf(It(e).position) >= 0, a = n && it(e) ? Tn(e) : e;
  return d0(a) ? t.filter(function(r) {
    return d0(r) && Yi(r, a) && xt(r) !== "body";
  }) : [];
}
function a4(e, t, n, a) {
  var r = t === "clippingParents" ? n4(e) : [].concat(t), s = [].concat(r, [n]), i = s[0], l = s.reduce(function(u, c) {
    var d = T1(e, c, a);
    return u.top = c0(d.top, u.top), u.right = la(d.right, u.right), u.bottom = la(d.bottom, u.bottom), u.left = c0(d.left, u.left), u;
  }, T1(e, i, a));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function Bi(e) {
  var t = e.reference, n = e.element, a = e.placement, r = a ? $t(a) : null, s = a ? N0(a) : null, i = t.x + t.width / 2 - n.width / 2, l = t.y + t.height / 2 - n.height / 2, u;
  switch (r) {
    case Ue:
      u = {
        x: i,
        y: t.y - n.height
      };
      break;
    case lt:
      u = {
        x: i,
        y: t.y + t.height
      };
      break;
    case ut:
      u = {
        x: t.x + t.width,
        y: l
      };
      break;
    case qe:
      u = {
        x: t.x - n.width,
        y: l
      };
      break;
    default:
      u = {
        x: t.x,
        y: t.y
      };
  }
  var c = r ? Kr(r) : null;
  if (c != null) {
    var d = c === "y" ? "height" : "width";
    switch (s) {
      case Y0:
        u[c] = u[c] - (t[d] / 2 - n[d] / 2);
        break;
      case Cn:
        u[c] = u[c] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return u;
}
function xn(e, t) {
  t === void 0 && (t = {});
  var n = t, a = n.placement, r = a === void 0 ? e.placement : a, s = n.strategy, i = s === void 0 ? e.strategy : s, l = n.boundary, u = l === void 0 ? C3 : l, c = n.rootBoundary, d = c === void 0 ? Ai : c, f = n.elementContext, v = f === void 0 ? rn : f, p = n.altBoundary, y = p === void 0 ? !1 : p, w = n.padding, _ = w === void 0 ? 0 : w, b = Hi(typeof _ != "number" ? _ : Ni(_, En)), N = v === rn ? x3 : rn, E = e.rects.popper, L = e.elements[y ? N : v], A = a4(d0(L) ? L : L.contextElement || Qt(e.elements.popper), u, d, i), D = H0(e.elements.reference), I = Bi({
    reference: D,
    element: E,
    placement: r
  }), F = gr(Object.assign({}, E, I)), U = v === rn ? F : D, X = {
    top: A.top - U.top + b.top,
    bottom: U.bottom - A.bottom + b.bottom,
    left: A.left - U.left + b.left,
    right: U.right - A.right + b.right
  }, Q = e.modifiersData.offset;
  if (v === rn && Q) {
    var R = Q[r];
    Object.keys(X).forEach(function(G) {
      var re = [ut, lt].indexOf(G) >= 0 ? 1 : -1, W = [Ue, lt].indexOf(G) >= 0 ? "y" : "x";
      X[G] += R[W] * re;
    });
  }
  return X;
}
function r4(e, t) {
  t === void 0 && (t = {});
  var n = t, a = n.placement, r = n.boundary, s = n.rootBoundary, i = n.padding, l = n.flipVariations, u = n.allowedAutoPlacements, c = u === void 0 ? Pi : u, d = N0(a), f = d ? l ? L1 : L1.filter(function(y) {
    return N0(y) === d;
  }) : En, v = f.filter(function(y) {
    return c.indexOf(y) >= 0;
  });
  v.length === 0 && (v = f);
  var p = v.reduce(function(y, w) {
    return y[w] = xn(e, {
      placement: w,
      boundary: r,
      rootBoundary: s,
      padding: i
    })[$t(w)], y;
  }, {});
  return Object.keys(p).sort(function(y, w) {
    return p[y] - p[w];
  });
}
function s4(e) {
  if ($t(e) === Ur)
    return [];
  var t = Xn(e);
  return [E1(e), t, E1(t)];
}
function i4(e) {
  var t = e.state, n = e.options, a = e.name;
  if (!t.modifiersData[a]._skip) {
    for (var r = n.mainAxis, s = r === void 0 ? !0 : r, i = n.altAxis, l = i === void 0 ? !0 : i, u = n.fallbackPlacements, c = n.padding, d = n.boundary, f = n.rootBoundary, v = n.altBoundary, p = n.flipVariations, y = p === void 0 ? !0 : p, w = n.allowedAutoPlacements, _ = t.options.placement, b = $t(_), N = b === _, E = u || (N || !y ? [Xn(_)] : s4(_)), L = [_].concat(E).reduce(function(de, Me) {
      return de.concat($t(Me) === Ur ? r4(t, {
        placement: Me,
        boundary: d,
        rootBoundary: f,
        padding: c,
        flipVariations: y,
        allowedAutoPlacements: w
      }) : Me);
    }, []), A = t.rects.reference, D = t.rects.popper, I = /* @__PURE__ */ new Map(), F = !0, U = L[0], X = 0; X < L.length; X++) {
      var Q = L[X], R = $t(Q), G = N0(Q) === Y0, re = [Ue, lt].indexOf(R) >= 0, W = re ? "width" : "height", ne = xn(t, {
        placement: Q,
        boundary: d,
        rootBoundary: f,
        altBoundary: v,
        padding: c
      }), oe = re ? G ? ut : qe : G ? lt : Ue;
      A[W] > D[W] && (oe = Xn(oe));
      var Ce = Xn(oe), ve = [];
      if (s && ve.push(ne[R] <= 0), l && ve.push(ne[oe] <= 0, ne[Ce] <= 0), ve.every(function(de) {
        return de;
      })) {
        U = Q, F = !1;
        break;
      }
      I.set(Q, ve);
    }
    if (F)
      for (var O = y ? 3 : 1, le = function(Me) {
        var Te = L.find(function(De) {
          var Ae = I.get(De);
          if (Ae)
            return Ae.slice(0, Me).every(function(Ke) {
              return Ke;
            });
        });
        if (Te)
          return U = Te, "break";
      }, K = O; K > 0; K--) {
        var Se = le(K);
        if (Se === "break") break;
      }
    t.placement !== U && (t.modifiersData[a]._skip = !0, t.placement = U, t.reset = !0);
  }
}
const o4 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: i4,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function A1(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function P1(e) {
  return [Ue, ut, lt, qe].some(function(t) {
    return e[t] >= 0;
  });
}
function l4(e) {
  var t = e.state, n = e.name, a = t.rects.reference, r = t.rects.popper, s = t.modifiersData.preventOverflow, i = xn(t, {
    elementContext: "reference"
  }), l = xn(t, {
    altBoundary: !0
  }), u = A1(i, a), c = A1(l, r, s), d = P1(u), f = P1(c);
  t.modifiersData[n] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: c,
    isReferenceHidden: d,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": f
  });
}
const u4 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: l4
};
function c4(e, t, n) {
  var a = $t(e), r = [qe, Ue].indexOf(a) >= 0 ? -1 : 1, s = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, i = s[0], l = s[1];
  return i = i || 0, l = (l || 0) * r, [qe, ut].indexOf(a) >= 0 ? {
    x: l,
    y: i
  } : {
    x: i,
    y: l
  };
}
function d4(e) {
  var t = e.state, n = e.options, a = e.name, r = n.offset, s = r === void 0 ? [0, 0] : r, i = Pi.reduce(function(d, f) {
    return d[f] = c4(f, t.rects, s), d;
  }, {}), l = i[t.placement], u = l.x, c = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += u, t.modifiersData.popperOffsets.y += c), t.modifiersData[a] = i;
}
const f4 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: d4
};
function h4(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Bi({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const p4 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: h4,
  data: {}
};
function v4(e) {
  return e === "x" ? "y" : "x";
}
function m4(e) {
  var t = e.state, n = e.options, a = e.name, r = n.mainAxis, s = r === void 0 ? !0 : r, i = n.altAxis, l = i === void 0 ? !1 : i, u = n.boundary, c = n.rootBoundary, d = n.altBoundary, f = n.padding, v = n.tether, p = v === void 0 ? !0 : v, y = n.tetherOffset, w = y === void 0 ? 0 : y, _ = xn(t, {
    boundary: u,
    rootBoundary: c,
    padding: f,
    altBoundary: d
  }), b = $t(t.placement), N = N0(t.placement), E = !N, L = Kr(b), A = v4(L), D = t.modifiersData.popperOffsets, I = t.rects.reference, F = t.rects.popper, U = typeof w == "function" ? w(Object.assign({}, t.rects, {
    placement: t.placement
  })) : w, X = typeof U == "number" ? {
    mainAxis: U,
    altAxis: U
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, U), Q = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, R = {
    x: 0,
    y: 0
  };
  if (D) {
    if (s) {
      var G, re = L === "y" ? Ue : qe, W = L === "y" ? lt : ut, ne = L === "y" ? "height" : "width", oe = D[L], Ce = oe + _[re], ve = oe - _[W], O = p ? -F[ne] / 2 : 0, le = N === Y0 ? I[ne] : F[ne], K = N === Y0 ? -F[ne] : -I[ne], Se = t.elements.arrow, de = p && Se ? Gr(Se) : {
        width: 0,
        height: 0
      }, Me = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Vi(), Te = Me[re], De = Me[W], Ae = vn(0, I[ne], de[ne]), Ke = E ? I[ne] / 2 - O - Ae - Te - X.mainAxis : le - Ae - Te - X.mainAxis, kt = E ? -I[ne] / 2 + O + Ae + De + X.mainAxis : K + Ae + De + X.mainAxis, ct = t.elements.arrow && Tn(t.elements.arrow), nt = ct ? L === "y" ? ct.clientTop || 0 : ct.clientLeft || 0 : 0, at = (G = Q == null ? void 0 : Q[L]) != null ? G : 0, Vt = oe + Ke - at - nt, g0 = oe + kt - at, yt = vn(p ? la(Ce, Vt) : Ce, oe, p ? c0(ve, g0) : ve);
      D[L] = yt, R[L] = yt - oe;
    }
    if (l) {
      var t0, n0 = L === "x" ? Ue : qe, a0 = L === "x" ? lt : ut, dt = D[A], Ht = A === "y" ? "height" : "width", Nt = dt + _[n0], Rt = dt - _[a0], Bt = [Ue, qe].indexOf(b) !== -1, Ft = (t0 = Q == null ? void 0 : Q[A]) != null ? t0 : 0, jt = Bt ? Nt : dt - I[Ht] - F[Ht] - Ft + X.altAxis, r0 = Bt ? dt + I[Ht] + F[Ht] - Ft - X.altAxis : Rt, y0 = p && Bt ? N3(jt, dt, r0) : vn(p ? jt : Nt, dt, p ? r0 : Rt);
      D[A] = y0, R[A] = y0 - dt;
    }
    t.modifiersData[a] = R;
  }
}
const g4 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: m4,
  requiresIfExists: ["offset"]
};
function y4(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function b4(e) {
  return e === tt(e) || !it(e) ? Zr(e) : y4(e);
}
function _4(e) {
  var t = e.getBoundingClientRect(), n = V0(t.width) / e.offsetWidth || 1, a = V0(t.height) / e.offsetHeight || 1;
  return n !== 1 || a !== 1;
}
function w4(e, t, n) {
  n === void 0 && (n = !1);
  var a = it(t), r = it(t) && _4(t), s = Qt(t), i = H0(e, r, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (a || !a && !n) && ((xt(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Jr(s)) && (l = b4(t)), it(t) ? (u = H0(t, !0), u.x += t.clientLeft, u.y += t.clientTop) : s && (u.x = Xr(s))), {
    x: i.left + l.scrollLeft - u.x,
    y: i.top + l.scrollTop - u.y,
    width: i.width,
    height: i.height
  };
}
function $4(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(s) {
    t.set(s.name, s);
  });
  function r(s) {
    n.add(s.name);
    var i = [].concat(s.requires || [], s.requiresIfExists || []);
    i.forEach(function(l) {
      if (!n.has(l)) {
        var u = t.get(l);
        u && r(u);
      }
    }), a.push(s);
  }
  return e.forEach(function(s) {
    n.has(s.name) || r(s);
  }), a;
}
function C4(e) {
  var t = $4(e);
  return A3.reduce(function(n, a) {
    return n.concat(t.filter(function(r) {
      return r.phase === a;
    }));
  }, []);
}
function x4(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function S4(e) {
  var t = e.reduce(function(n, a) {
    var r = n[a.name];
    return n[a.name] = r ? Object.assign({}, r, a, {
      options: Object.assign({}, r.options, a.options),
      data: Object.assign({}, r.data, a.data)
    }) : a, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var z1 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Y1() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function M4(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, a = n === void 0 ? [] : n, r = t.defaultOptions, s = r === void 0 ? z1 : r;
  return function(l, u, c) {
    c === void 0 && (c = s);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, z1, s),
      modifiersData: {},
      elements: {
        reference: l,
        popper: u
      },
      attributes: {},
      styles: {}
    }, f = [], v = !1, p = {
      state: d,
      setOptions: function(b) {
        var N = typeof b == "function" ? b(d.options) : b;
        w(), d.options = Object.assign({}, s, d.options, N), d.scrollParents = {
          reference: d0(l) ? mn(l) : l.contextElement ? mn(l.contextElement) : [],
          popper: mn(u)
        };
        var E = C4(S4([].concat(a, d.options.modifiers)));
        return d.orderedModifiers = E.filter(function(L) {
          return L.enabled;
        }), y(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!v) {
          var b = d.elements, N = b.reference, E = b.popper;
          if (Y1(N, E)) {
            d.rects = {
              reference: w4(N, Tn(E), d.options.strategy === "fixed"),
              popper: Gr(E)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(X) {
              return d.modifiersData[X.name] = Object.assign({}, X.data);
            });
            for (var L = 0; L < d.orderedModifiers.length; L++) {
              if (d.reset === !0) {
                d.reset = !1, L = -1;
                continue;
              }
              var A = d.orderedModifiers[L], D = A.fn, I = A.options, F = I === void 0 ? {} : I, U = A.name;
              typeof D == "function" && (d = D({
                state: d,
                options: F,
                name: U,
                instance: p
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: x4(function() {
        return new Promise(function(_) {
          p.forceUpdate(), _(d);
        });
      }),
      destroy: function() {
        w(), v = !0;
      }
    };
    if (!Y1(l, u))
      return p;
    p.setOptions(c).then(function(_) {
      !v && c.onFirstUpdate && c.onFirstUpdate(_);
    });
    function y() {
      d.orderedModifiers.forEach(function(_) {
        var b = _.name, N = _.options, E = N === void 0 ? {} : N, L = _.effect;
        if (typeof L == "function") {
          var A = L({
            state: d,
            name: b,
            instance: p,
            options: E
          }), D = function() {
          };
          f.push(A || D);
        }
      });
    }
    function w() {
      f.forEach(function(_) {
        return _();
      }), f = [];
    }
    return p;
  };
}
var D4 = [Z3, p4, G3, Y3, f4, o4, g4, j3, u4], k4 = /* @__PURE__ */ M4({
  defaultModifiers: D4
}), L4 = Object.defineProperty, O4 = (e, t, n) => t in e ? L4(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, q = (e, t, n) => (O4(e, typeof t != "symbol" ? t + "" : t, n), n), Fn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Fi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var I4 = Object.prototype, E4 = I4.hasOwnProperty;
function T4(e, t) {
  return e != null && E4.call(e, t);
}
var A4 = T4, P4 = Array.isArray, mt = P4, z4 = typeof Fn == "object" && Fn && Fn.Object === Object && Fn, ji = z4, Y4 = ji, V4 = typeof self == "object" && self && self.Object === Object && self, H4 = Y4 || V4 || Function("return this")(), Mt = H4, N4 = Mt, R4 = N4.Symbol, ka = R4, V1 = ka, Wi = Object.prototype, B4 = Wi.hasOwnProperty, F4 = Wi.toString, sn = V1 ? V1.toStringTag : void 0;
function j4(e) {
  var t = B4.call(e, sn), n = e[sn];
  try {
    e[sn] = void 0;
    var a = !0;
  } catch {
  }
  var r = F4.call(e);
  return a && (t ? e[sn] = n : delete e[sn]), r;
}
var W4 = j4, U4 = Object.prototype, q4 = U4.toString;
function G4(e) {
  return q4.call(e);
}
var K4 = G4, H1 = ka, Z4 = W4, X4 = K4, J4 = "[object Null]", Q4 = "[object Undefined]", N1 = H1 ? H1.toStringTag : void 0;
function ef(e) {
  return e == null ? e === void 0 ? Q4 : J4 : N1 && N1 in Object(e) ? Z4(e) : X4(e);
}
var Dt = ef;
function tf(e) {
  return e != null && typeof e == "object";
}
var gt = tf, nf = Dt, af = gt, rf = "[object Symbol]";
function sf(e) {
  return typeof e == "symbol" || af(e) && nf(e) == rf;
}
var Qr = sf, of = mt, lf = Qr, uf = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, cf = /^\w*$/;
function df(e, t) {
  if (of(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || lf(e) ? !0 : cf.test(e) || !uf.test(e) || t != null && e in Object(t);
}
var e1 = df;
function ff(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Pt = ff, hf = Dt, pf = Pt, vf = "[object AsyncFunction]", mf = "[object Function]", gf = "[object GeneratorFunction]", yf = "[object Proxy]";
function bf(e) {
  if (!pf(e))
    return !1;
  var t = hf(e);
  return t == mf || t == gf || t == vf || t == yf;
}
var p0 = bf, _f = Mt, wf = _f["__core-js_shared__"], $f = wf, qa = $f, R1 = function() {
  var e = /[^.]+$/.exec(qa && qa.keys && qa.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Cf(e) {
  return !!R1 && R1 in e;
}
var xf = Cf, Sf = Function.prototype, Mf = Sf.toString;
function Df(e) {
  if (e != null) {
    try {
      return Mf.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Ui = Df, kf = p0, Lf = xf, Of = Pt, If = Ui, Ef = /[\\^$.*+?()[\]{}|]/g, Tf = /^\[object .+?Constructor\]$/, Af = Function.prototype, Pf = Object.prototype, zf = Af.toString, Yf = Pf.hasOwnProperty, Vf = RegExp(
  "^" + zf.call(Yf).replace(Ef, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Hf(e) {
  if (!Of(e) || Lf(e))
    return !1;
  var t = kf(e) ? Vf : Tf;
  return t.test(If(e));
}
var Nf = Hf;
function Rf(e, t) {
  return e == null ? void 0 : e[t];
}
var Bf = Rf, Ff = Nf, jf = Bf;
function Wf(e, t) {
  var n = jf(e, t);
  return Ff(n) ? n : void 0;
}
var v0 = Wf, Uf = v0, qf = Uf(Object, "create"), La = qf, B1 = La;
function Gf() {
  this.__data__ = B1 ? B1(null) : {}, this.size = 0;
}
var Kf = Gf;
function Zf(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Xf = Zf, Jf = La, Qf = "__lodash_hash_undefined__", eh = Object.prototype, th = eh.hasOwnProperty;
function nh(e) {
  var t = this.__data__;
  if (Jf) {
    var n = t[e];
    return n === Qf ? void 0 : n;
  }
  return th.call(t, e) ? t[e] : void 0;
}
var ah = nh, rh = La, sh = Object.prototype, ih = sh.hasOwnProperty;
function oh(e) {
  var t = this.__data__;
  return rh ? t[e] !== void 0 : ih.call(t, e);
}
var lh = oh, uh = La, ch = "__lodash_hash_undefined__";
function dh(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = uh && t === void 0 ? ch : t, this;
}
var fh = dh, hh = Kf, ph = Xf, vh = ah, mh = lh, gh = fh;
function q0(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
q0.prototype.clear = hh;
q0.prototype.delete = ph;
q0.prototype.get = vh;
q0.prototype.has = mh;
q0.prototype.set = gh;
var yh = q0;
function bh() {
  this.__data__ = [], this.size = 0;
}
var _h = bh;
function wh(e, t) {
  return e === t || e !== e && t !== t;
}
var G0 = wh, $h = G0;
function Ch(e, t) {
  for (var n = e.length; n--; )
    if ($h(e[n][0], t))
      return n;
  return -1;
}
var Oa = Ch, xh = Oa, Sh = Array.prototype, Mh = Sh.splice;
function Dh(e) {
  var t = this.__data__, n = xh(t, e);
  if (n < 0)
    return !1;
  var a = t.length - 1;
  return n == a ? t.pop() : Mh.call(t, n, 1), --this.size, !0;
}
var kh = Dh, Lh = Oa;
function Oh(e) {
  var t = this.__data__, n = Lh(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var Ih = Oh, Eh = Oa;
function Th(e) {
  return Eh(this.__data__, e) > -1;
}
var Ah = Th, Ph = Oa;
function zh(e, t) {
  var n = this.__data__, a = Ph(n, e);
  return a < 0 ? (++this.size, n.push([e, t])) : n[a][1] = t, this;
}
var Yh = zh, Vh = _h, Hh = kh, Nh = Ih, Rh = Ah, Bh = Yh;
function K0(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
K0.prototype.clear = Vh;
K0.prototype.delete = Hh;
K0.prototype.get = Nh;
K0.prototype.has = Rh;
K0.prototype.set = Bh;
var Ia = K0, Fh = v0, jh = Mt, Wh = Fh(jh, "Map"), t1 = Wh, F1 = yh, Uh = Ia, qh = t1;
function Gh() {
  this.size = 0, this.__data__ = {
    hash: new F1(),
    map: new (qh || Uh)(),
    string: new F1()
  };
}
var Kh = Gh;
function Zh(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Xh = Zh, Jh = Xh;
function Qh(e, t) {
  var n = e.__data__;
  return Jh(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Ea = Qh, e7 = Ea;
function t7(e) {
  var t = e7(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var n7 = t7, a7 = Ea;
function r7(e) {
  return a7(this, e).get(e);
}
var s7 = r7, i7 = Ea;
function o7(e) {
  return i7(this, e).has(e);
}
var l7 = o7, u7 = Ea;
function c7(e, t) {
  var n = u7(this, e), a = n.size;
  return n.set(e, t), this.size += n.size == a ? 0 : 1, this;
}
var d7 = c7, f7 = Kh, h7 = n7, p7 = s7, v7 = l7, m7 = d7;
function Z0(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
Z0.prototype.clear = f7;
Z0.prototype.delete = h7;
Z0.prototype.get = p7;
Z0.prototype.has = v7;
Z0.prototype.set = m7;
var n1 = Z0, qi = n1, g7 = "Expected a function";
function a1(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(g7);
  var n = function() {
    var a = arguments, r = t ? t.apply(this, a) : a[0], s = n.cache;
    if (s.has(r))
      return s.get(r);
    var i = e.apply(this, a);
    return n.cache = s.set(r, i) || s, i;
  };
  return n.cache = new (a1.Cache || qi)(), n;
}
a1.Cache = qi;
var y7 = a1, b7 = y7, _7 = 500;
function w7(e) {
  var t = b7(e, function(a) {
    return n.size === _7 && n.clear(), a;
  }), n = t.cache;
  return t;
}
var $7 = w7, C7 = $7, x7 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, S7 = /\\(\\)?/g, M7 = C7(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(x7, function(n, a, r, s) {
    t.push(r ? s.replace(S7, "$1") : a || n);
  }), t;
}), D7 = M7;
function k7(e, t) {
  for (var n = -1, a = e == null ? 0 : e.length, r = Array(a); ++n < a; )
    r[n] = t(e[n], n, e);
  return r;
}
var L7 = k7, j1 = ka, O7 = L7, I7 = mt, E7 = Qr, W1 = j1 ? j1.prototype : void 0, U1 = W1 ? W1.toString : void 0;
function Gi(e) {
  if (typeof e == "string")
    return e;
  if (I7(e))
    return O7(e, Gi) + "";
  if (E7(e))
    return U1 ? U1.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var T7 = Gi, A7 = T7;
function P7(e) {
  return e == null ? "" : A7(e);
}
var z7 = P7, Y7 = mt, V7 = e1, H7 = D7, N7 = z7;
function R7(e, t) {
  return Y7(e) ? e : V7(e, t) ? [e] : H7(N7(e));
}
var Ki = R7, B7 = Dt, F7 = gt, j7 = "[object Arguments]";
function W7(e) {
  return F7(e) && B7(e) == j7;
}
var U7 = W7, q1 = U7, q7 = gt, Zi = Object.prototype, G7 = Zi.hasOwnProperty, K7 = Zi.propertyIsEnumerable, Z7 = q1(/* @__PURE__ */ function() {
  return arguments;
}()) ? q1 : function(e) {
  return q7(e) && G7.call(e, "callee") && !K7.call(e, "callee");
}, r1 = Z7, X7 = 9007199254740991, J7 = /^(?:0|[1-9]\d*)$/;
function Q7(e, t) {
  var n = typeof e;
  return t = t ?? X7, !!t && (n == "number" || n != "symbol" && J7.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var s1 = Q7, ep = 9007199254740991;
function tp(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= ep;
}
var i1 = tp, np = Qr;
function ap(e) {
  if (typeof e == "string" || np(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Ta = ap, rp = Ki, sp = r1, ip = mt, op = s1, lp = i1, up = Ta;
function cp(e, t, n) {
  t = rp(t, e);
  for (var a = -1, r = t.length, s = !1; ++a < r; ) {
    var i = up(t[a]);
    if (!(s = e != null && n(e, i)))
      break;
    e = e[i];
  }
  return s || ++a != r ? s : (r = e == null ? 0 : e.length, !!r && lp(r) && op(i, r) && (ip(e) || sp(e)));
}
var Xi = cp, dp = A4, fp = Xi;
function hp(e, t) {
  return e != null && fp(e, t, dp);
}
var Ji = hp, pp = Dt, vp = gt, mp = "[object Date]";
function gp(e) {
  return vp(e) && pp(e) == mp;
}
var yp = gp;
function bp(e) {
  return function(t) {
    return e(t);
  };
}
var Qi = bp, Sn = {}, _p = {
  get exports() {
    return Sn;
  },
  set exports(e) {
    Sn = e;
  }
};
(function(e, t) {
  var n = ji, a = t && !t.nodeType && t, r = a && !0 && e && !e.nodeType && e, s = r && r.exports === a, i = s && n.process, l = function() {
    try {
      var u = r && r.require && r.require("util").types;
      return u || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  e.exports = l;
})(_p, Sn);
var wp = yp, $p = Qi, G1 = Sn, K1 = G1 && G1.isDate, Cp = K1 ? $p(K1) : wp, xp = Cp, Sp = Dt, Mp = mt, Dp = gt, kp = "[object String]";
function Lp(e) {
  return typeof e == "string" || !Mp(e) && Dp(e) && Sp(e) == kp;
}
var _t = Lp;
function Op(e, t) {
  for (var n = -1, a = e == null ? 0 : e.length; ++n < a; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var eo = Op, Ip = Ia;
function Ep() {
  this.__data__ = new Ip(), this.size = 0;
}
var Tp = Ep;
function Ap(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var Pp = Ap;
function zp(e) {
  return this.__data__.get(e);
}
var Yp = zp;
function Vp(e) {
  return this.__data__.has(e);
}
var Hp = Vp, Np = Ia, Rp = t1, Bp = n1, Fp = 200;
function jp(e, t) {
  var n = this.__data__;
  if (n instanceof Np) {
    var a = n.__data__;
    if (!Rp || a.length < Fp - 1)
      return a.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new Bp(a);
  }
  return n.set(e, t), this.size = n.size, this;
}
var Wp = jp, Up = Ia, qp = Tp, Gp = Pp, Kp = Yp, Zp = Hp, Xp = Wp;
function X0(e) {
  var t = this.__data__ = new Up(e);
  this.size = t.size;
}
X0.prototype.clear = qp;
X0.prototype.delete = Gp;
X0.prototype.get = Kp;
X0.prototype.has = Zp;
X0.prototype.set = Xp;
var o1 = X0, Jp = "__lodash_hash_undefined__";
function Qp(e) {
  return this.__data__.set(e, Jp), this;
}
var e6 = Qp;
function t6(e) {
  return this.__data__.has(e);
}
var n6 = t6, a6 = n1, r6 = e6, s6 = n6;
function ua(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new a6(); ++t < n; )
    this.add(e[t]);
}
ua.prototype.add = ua.prototype.push = r6;
ua.prototype.has = s6;
var i6 = ua;
function o6(e, t) {
  return e.has(t);
}
var l6 = o6, u6 = i6, c6 = eo, d6 = l6, f6 = 1, h6 = 2;
function p6(e, t, n, a, r, s) {
  var i = n & f6, l = e.length, u = t.length;
  if (l != u && !(i && u > l))
    return !1;
  var c = s.get(e), d = s.get(t);
  if (c && d)
    return c == t && d == e;
  var f = -1, v = !0, p = n & h6 ? new u6() : void 0;
  for (s.set(e, t), s.set(t, e); ++f < l; ) {
    var y = e[f], w = t[f];
    if (a)
      var _ = i ? a(w, y, f, t, e, s) : a(y, w, f, e, t, s);
    if (_ !== void 0) {
      if (_)
        continue;
      v = !1;
      break;
    }
    if (p) {
      if (!c6(t, function(b, N) {
        if (!d6(p, N) && (y === b || r(y, b, n, a, s)))
          return p.push(N);
      })) {
        v = !1;
        break;
      }
    } else if (!(y === w || r(y, w, n, a, s))) {
      v = !1;
      break;
    }
  }
  return s.delete(e), s.delete(t), v;
}
var to = p6, v6 = Mt, m6 = v6.Uint8Array, no = m6;
function g6(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(a, r) {
    n[++t] = [r, a];
  }), n;
}
var y6 = g6;
function b6(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(a) {
    n[++t] = a;
  }), n;
}
var _6 = b6, Z1 = ka, X1 = no, w6 = G0, $6 = to, C6 = y6, x6 = _6, S6 = 1, M6 = 2, D6 = "[object Boolean]", k6 = "[object Date]", L6 = "[object Error]", O6 = "[object Map]", I6 = "[object Number]", E6 = "[object RegExp]", T6 = "[object Set]", A6 = "[object String]", P6 = "[object Symbol]", z6 = "[object ArrayBuffer]", Y6 = "[object DataView]", J1 = Z1 ? Z1.prototype : void 0, Ga = J1 ? J1.valueOf : void 0;
function V6(e, t, n, a, r, s, i) {
  switch (n) {
    case Y6:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case z6:
      return !(e.byteLength != t.byteLength || !s(new X1(e), new X1(t)));
    case D6:
    case k6:
    case I6:
      return w6(+e, +t);
    case L6:
      return e.name == t.name && e.message == t.message;
    case E6:
    case A6:
      return e == t + "";
    case O6:
      var l = C6;
    case T6:
      var u = a & S6;
      if (l || (l = x6), e.size != t.size && !u)
        return !1;
      var c = i.get(e);
      if (c)
        return c == t;
      a |= M6, i.set(e, t);
      var d = $6(l(e), l(t), a, r, s, i);
      return i.delete(e), d;
    case P6:
      if (Ga)
        return Ga.call(e) == Ga.call(t);
  }
  return !1;
}
var H6 = V6;
function N6(e, t) {
  for (var n = -1, a = t.length, r = e.length; ++n < a; )
    e[r + n] = t[n];
  return e;
}
var R6 = N6, B6 = R6, F6 = mt;
function j6(e, t, n) {
  var a = t(e);
  return F6(e) ? a : B6(a, n(e));
}
var W6 = j6;
function U6(e, t) {
  for (var n = -1, a = e == null ? 0 : e.length, r = 0, s = []; ++n < a; ) {
    var i = e[n];
    t(i, n, e) && (s[r++] = i);
  }
  return s;
}
var q6 = U6;
function G6() {
  return [];
}
var K6 = G6, Z6 = q6, X6 = K6, J6 = Object.prototype, Q6 = J6.propertyIsEnumerable, Q1 = Object.getOwnPropertySymbols, ev = Q1 ? function(e) {
  return e == null ? [] : (e = Object(e), Z6(Q1(e), function(t) {
    return Q6.call(e, t);
  }));
} : X6, tv = ev;
function nv(e, t) {
  for (var n = -1, a = Array(e); ++n < e; )
    a[n] = t(n);
  return a;
}
var av = nv, R0 = {}, rv = {
  get exports() {
    return R0;
  },
  set exports(e) {
    R0 = e;
  }
};
function sv() {
  return !1;
}
var iv = sv;
(function(e, t) {
  var n = Mt, a = iv, r = t && !t.nodeType && t, s = r && !0 && e && !e.nodeType && e, i = s && s.exports === r, l = i ? n.Buffer : void 0, u = l ? l.isBuffer : void 0, c = u || a;
  e.exports = c;
})(rv, R0);
var ov = Dt, lv = i1, uv = gt, cv = "[object Arguments]", dv = "[object Array]", fv = "[object Boolean]", hv = "[object Date]", pv = "[object Error]", vv = "[object Function]", mv = "[object Map]", gv = "[object Number]", yv = "[object Object]", bv = "[object RegExp]", _v = "[object Set]", wv = "[object String]", $v = "[object WeakMap]", Cv = "[object ArrayBuffer]", xv = "[object DataView]", Sv = "[object Float32Array]", Mv = "[object Float64Array]", Dv = "[object Int8Array]", kv = "[object Int16Array]", Lv = "[object Int32Array]", Ov = "[object Uint8Array]", Iv = "[object Uint8ClampedArray]", Ev = "[object Uint16Array]", Tv = "[object Uint32Array]", ye = {};
ye[Sv] = ye[Mv] = ye[Dv] = ye[kv] = ye[Lv] = ye[Ov] = ye[Iv] = ye[Ev] = ye[Tv] = !0;
ye[cv] = ye[dv] = ye[Cv] = ye[fv] = ye[xv] = ye[hv] = ye[pv] = ye[vv] = ye[mv] = ye[gv] = ye[yv] = ye[bv] = ye[_v] = ye[wv] = ye[$v] = !1;
function Av(e) {
  return uv(e) && lv(e.length) && !!ye[ov(e)];
}
var Pv = Av, zv = Pv, Yv = Qi, es = Sn, ts = es && es.isTypedArray, Vv = ts ? Yv(ts) : zv, l1 = Vv, Hv = av, Nv = r1, Rv = mt, Bv = R0, Fv = s1, jv = l1, Wv = Object.prototype, Uv = Wv.hasOwnProperty;
function qv(e, t) {
  var n = Rv(e), a = !n && Nv(e), r = !n && !a && Bv(e), s = !n && !a && !r && jv(e), i = n || a || r || s, l = i ? Hv(e.length, String) : [], u = l.length;
  for (var c in e)
    (t || Uv.call(e, c)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Fv(c, u))) && l.push(c);
  return l;
}
var ao = qv, Gv = Object.prototype;
function Kv(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Gv;
  return e === n;
}
var u1 = Kv;
function Zv(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var ro = Zv, Xv = ro, Jv = Xv(Object.keys, Object), Qv = Jv, e8 = u1, t8 = Qv, n8 = Object.prototype, a8 = n8.hasOwnProperty;
function r8(e) {
  if (!e8(e))
    return t8(e);
  var t = [];
  for (var n in Object(e))
    a8.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var s8 = r8, i8 = p0, o8 = i1;
function l8(e) {
  return e != null && o8(e.length) && !i8(e);
}
var An = l8, u8 = ao, c8 = s8, d8 = An;
function f8(e) {
  return d8(e) ? u8(e) : c8(e);
}
var c1 = f8, h8 = W6, p8 = tv, v8 = c1;
function m8(e) {
  return h8(e, v8, p8);
}
var g8 = m8, ns = g8, y8 = 1, b8 = Object.prototype, _8 = b8.hasOwnProperty;
function w8(e, t, n, a, r, s) {
  var i = n & y8, l = ns(e), u = l.length, c = ns(t), d = c.length;
  if (u != d && !i)
    return !1;
  for (var f = u; f--; ) {
    var v = l[f];
    if (!(i ? v in t : _8.call(t, v)))
      return !1;
  }
  var p = s.get(e), y = s.get(t);
  if (p && y)
    return p == t && y == e;
  var w = !0;
  s.set(e, t), s.set(t, e);
  for (var _ = i; ++f < u; ) {
    v = l[f];
    var b = e[v], N = t[v];
    if (a)
      var E = i ? a(N, b, v, t, e, s) : a(b, N, v, e, t, s);
    if (!(E === void 0 ? b === N || r(b, N, n, a, s) : E)) {
      w = !1;
      break;
    }
    _ || (_ = v == "constructor");
  }
  if (w && !_) {
    var L = e.constructor, A = t.constructor;
    L != A && "constructor" in e && "constructor" in t && !(typeof L == "function" && L instanceof L && typeof A == "function" && A instanceof A) && (w = !1);
  }
  return s.delete(e), s.delete(t), w;
}
var $8 = w8, C8 = v0, x8 = Mt, S8 = C8(x8, "DataView"), M8 = S8, D8 = v0, k8 = Mt, L8 = D8(k8, "Promise"), O8 = L8, I8 = v0, E8 = Mt, T8 = I8(E8, "Set"), A8 = T8, P8 = v0, z8 = Mt, Y8 = P8(z8, "WeakMap"), V8 = Y8, yr = M8, br = t1, _r = O8, wr = A8, $r = V8, so = Dt, J0 = Ui, as = "[object Map]", H8 = "[object Object]", rs = "[object Promise]", ss = "[object Set]", is = "[object WeakMap]", os = "[object DataView]", N8 = J0(yr), R8 = J0(br), B8 = J0(_r), F8 = J0(wr), j8 = J0($r), o0 = so;
(yr && o0(new yr(new ArrayBuffer(1))) != os || br && o0(new br()) != as || _r && o0(_r.resolve()) != rs || wr && o0(new wr()) != ss || $r && o0(new $r()) != is) && (o0 = function(e) {
  var t = so(e), n = t == H8 ? e.constructor : void 0, a = n ? J0(n) : "";
  if (a)
    switch (a) {
      case N8:
        return os;
      case R8:
        return as;
      case B8:
        return rs;
      case F8:
        return ss;
      case j8:
        return is;
    }
  return t;
});
var W8 = o0, Ka = o1, U8 = to, q8 = H6, G8 = $8, ls = W8, us = mt, cs = R0, K8 = l1, Z8 = 1, ds = "[object Arguments]", fs = "[object Array]", jn = "[object Object]", X8 = Object.prototype, hs = X8.hasOwnProperty;
function J8(e, t, n, a, r, s) {
  var i = us(e), l = us(t), u = i ? fs : ls(e), c = l ? fs : ls(t);
  u = u == ds ? jn : u, c = c == ds ? jn : c;
  var d = u == jn, f = c == jn, v = u == c;
  if (v && cs(e)) {
    if (!cs(t))
      return !1;
    i = !0, d = !1;
  }
  if (v && !d)
    return s || (s = new Ka()), i || K8(e) ? U8(e, t, n, a, r, s) : q8(e, t, u, n, a, r, s);
  if (!(n & Z8)) {
    var p = d && hs.call(e, "__wrapped__"), y = f && hs.call(t, "__wrapped__");
    if (p || y) {
      var w = p ? e.value() : e, _ = y ? t.value() : t;
      return s || (s = new Ka()), r(w, _, n, a, s);
    }
  }
  return v ? (s || (s = new Ka()), G8(e, t, n, a, r, s)) : !1;
}
var Q8 = J8, em = Q8, ps = gt;
function io(e, t, n, a, r) {
  return e === t ? !0 : e == null || t == null || !ps(e) && !ps(t) ? e !== e && t !== t : em(e, t, n, a, io, r);
}
var oo = io, tm = o1, nm = oo, am = 1, rm = 2;
function sm(e, t, n, a) {
  var r = n.length, s = r, i = !a;
  if (e == null)
    return !s;
  for (e = Object(e); r--; ) {
    var l = n[r];
    if (i && l[2] ? l[1] !== e[l[0]] : !(l[0] in e))
      return !1;
  }
  for (; ++r < s; ) {
    l = n[r];
    var u = l[0], c = e[u], d = l[1];
    if (i && l[2]) {
      if (c === void 0 && !(u in e))
        return !1;
    } else {
      var f = new tm();
      if (a)
        var v = a(c, d, u, e, t, f);
      if (!(v === void 0 ? nm(d, c, am | rm, a, f) : v))
        return !1;
    }
  }
  return !0;
}
var im = sm, om = Pt;
function lm(e) {
  return e === e && !om(e);
}
var lo = lm, um = lo, cm = c1;
function dm(e) {
  for (var t = cm(e), n = t.length; n--; ) {
    var a = t[n], r = e[a];
    t[n] = [a, r, um(r)];
  }
  return t;
}
var fm = dm;
function hm(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var uo = hm, pm = im, vm = fm, mm = uo;
function gm(e) {
  var t = vm(e);
  return t.length == 1 && t[0][2] ? mm(t[0][0], t[0][1]) : function(n) {
    return n === e || pm(n, e, t);
  };
}
var ym = gm, bm = Ki, _m = Ta;
function wm(e, t) {
  t = bm(t, e);
  for (var n = 0, a = t.length; e != null && n < a; )
    e = e[_m(t[n++])];
  return n && n == a ? e : void 0;
}
var co = wm, $m = co;
function Cm(e, t, n) {
  var a = e == null ? void 0 : $m(e, t);
  return a === void 0 ? n : a;
}
var u0 = Cm;
function xm(e, t) {
  return e != null && t in Object(e);
}
var Sm = xm, Mm = Sm, Dm = Xi;
function km(e, t) {
  return e != null && Dm(e, t, Mm);
}
var Lm = km, Om = oo, Im = u0, Em = Lm, Tm = e1, Am = lo, Pm = uo, zm = Ta, Ym = 1, Vm = 2;
function Hm(e, t) {
  return Tm(e) && Am(t) ? Pm(zm(e), t) : function(n) {
    var a = Im(n, e);
    return a === void 0 && a === t ? Em(n, e) : Om(t, a, Ym | Vm);
  };
}
var Nm = Hm;
function Rm(e) {
  return e;
}
var d1 = Rm;
function Bm(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var Fm = Bm, jm = co;
function Wm(e) {
  return function(t) {
    return jm(t, e);
  };
}
var Um = Wm, qm = Fm, Gm = Um, Km = e1, Zm = Ta;
function Xm(e) {
  return Km(e) ? qm(Zm(e)) : Gm(e);
}
var Jm = Xm, Qm = ym, e9 = Nm, t9 = d1, n9 = mt, a9 = Jm;
function r9(e) {
  return typeof e == "function" ? e : e == null ? t9 : typeof e == "object" ? n9(e) ? e9(e[0], e[1]) : Qm(e) : a9(e);
}
var fo = r9;
function s9(e) {
  return function(t, n, a) {
    for (var r = -1, s = Object(t), i = a(t), l = i.length; l--; ) {
      var u = i[e ? l : ++r];
      if (n(s[u], u, s) === !1)
        break;
    }
    return t;
  };
}
var i9 = s9, o9 = i9, l9 = o9(), ho = l9, u9 = ho, c9 = c1;
function d9(e, t) {
  return e && u9(e, t, c9);
}
var po = d9, f9 = An;
function h9(e, t) {
  return function(n, a) {
    if (n == null)
      return n;
    if (!f9(n))
      return e(n, a);
    for (var r = n.length, s = t ? r : -1, i = Object(n); (t ? s-- : ++s < r) && a(i[s], s, i) !== !1; )
      ;
    return n;
  };
}
var p9 = h9, v9 = po, m9 = p9, g9 = m9(v9), y9 = g9, b9 = y9;
function _9(e, t) {
  var n;
  return b9(e, function(a, r, s) {
    return n = t(a, r, s), !n;
  }), !!n;
}
var w9 = _9, $9 = G0, C9 = An, x9 = s1, S9 = Pt;
function M9(e, t, n) {
  if (!S9(n))
    return !1;
  var a = typeof t;
  return (a == "number" ? C9(n) && x9(t, n.length) : a == "string" && t in n) ? $9(n[t], e) : !1;
}
var f1 = M9, D9 = eo, k9 = fo, L9 = w9, O9 = mt, I9 = f1;
function E9(e, t, n) {
  var a = O9(e) ? D9 : L9;
  return n && I9(e, t, n) && (t = void 0), a(e, k9(t));
}
var T9 = E9, A9 = Dt, P9 = gt, z9 = "[object Boolean]";
function Y9(e) {
  return e === !0 || e === !1 || P9(e) && A9(e) == z9;
}
var V9 = Y9, H9 = Dt, N9 = gt, R9 = "[object Number]";
function B9(e) {
  return typeof e == "number" || N9(e) && H9(e) == R9;
}
var pt = B9, F9 = v0, j9 = function() {
  try {
    var e = F9(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), vo = j9, vs = vo;
function W9(e, t, n) {
  t == "__proto__" && vs ? vs(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var Aa = W9, U9 = Aa, q9 = G0, G9 = Object.prototype, K9 = G9.hasOwnProperty;
function Z9(e, t, n) {
  var a = e[t];
  (!(K9.call(e, t) && q9(a, n)) || n === void 0 && !(t in e)) && U9(e, t, n);
}
var X9 = Z9, J9 = Aa, Q9 = po, eg = fo;
function tg(e, t) {
  var n = {};
  return t = eg(t), Q9(e, function(a, r, s) {
    J9(n, r, t(a, r, s));
  }), n;
}
var ng = tg;
function ag(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var mo = ag, rg = mo, ms = Math.max;
function sg(e, t, n) {
  return t = ms(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var a = arguments, r = -1, s = ms(a.length - t, 0), i = Array(s); ++r < s; )
      i[r] = a[t + r];
    r = -1;
    for (var l = Array(t + 1); ++r < t; )
      l[r] = a[r];
    return l[t] = n(i), rg(e, this, l);
  };
}
var ig = sg;
function og(e) {
  return function() {
    return e;
  };
}
var lg = og, ug = lg, gs = vo, cg = d1, dg = gs ? function(e, t) {
  return gs(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: ug(t),
    writable: !0
  });
} : cg, fg = dg, hg = 800, pg = 16, vg = Date.now;
function mg(e) {
  var t = 0, n = 0;
  return function() {
    var a = vg(), r = pg - (a - n);
    if (n = a, r > 0) {
      if (++t >= hg)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var gg = mg, yg = fg, bg = gg, _g = bg(yg), wg = _g, $g = d1, Cg = ig, xg = wg;
function Sg(e, t) {
  return xg(Cg(e, t, $g), e + "");
}
var h1 = Sg;
function Mg(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var Dg = Mg, kg = Pt, Lg = u1, Og = Dg, Ig = Object.prototype, Eg = Ig.hasOwnProperty;
function Tg(e) {
  if (!kg(e))
    return Og(e);
  var t = Lg(e), n = [];
  for (var a in e)
    a == "constructor" && (t || !Eg.call(e, a)) || n.push(a);
  return n;
}
var Ag = Tg, Pg = ao, zg = Ag, Yg = An;
function Vg(e) {
  return Yg(e) ? Pg(e, !0) : zg(e);
}
var p1 = Vg, Hg = h1, Ng = G0, Rg = f1, Bg = p1, go = Object.prototype, Fg = go.hasOwnProperty, jg = Hg(function(e, t) {
  e = Object(e);
  var n = -1, a = t.length, r = a > 2 ? t[2] : void 0;
  for (r && Rg(t[0], t[1], r) && (a = 1); ++n < a; )
    for (var s = t[n], i = Bg(s), l = -1, u = i.length; ++l < u; ) {
      var c = i[l], d = e[c];
      (d === void 0 || Ng(d, go[c]) && !Fg.call(e, c)) && (e[c] = s[c]);
    }
  return e;
}), ys = jg, Wg = Aa, Ug = G0;
function qg(e, t, n) {
  (n !== void 0 && !Ug(e[t], n) || n === void 0 && !(t in e)) && Wg(e, t, n);
}
var yo = qg, ca = {}, Gg = {
  get exports() {
    return ca;
  },
  set exports(e) {
    ca = e;
  }
};
(function(e, t) {
  var n = Mt, a = t && !t.nodeType && t, r = a && !0 && e && !e.nodeType && e, s = r && r.exports === a, i = s ? n.Buffer : void 0, l = i ? i.allocUnsafe : void 0;
  function u(c, d) {
    if (d)
      return c.slice();
    var f = c.length, v = l ? l(f) : new c.constructor(f);
    return c.copy(v), v;
  }
  e.exports = u;
})(Gg, ca);
var bs = no;
function Kg(e) {
  var t = new e.constructor(e.byteLength);
  return new bs(t).set(new bs(e)), t;
}
var Zg = Kg, Xg = Zg;
function Jg(e, t) {
  var n = t ? Xg(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Qg = Jg;
function ey(e, t) {
  var n = -1, a = e.length;
  for (t || (t = Array(a)); ++n < a; )
    t[n] = e[n];
  return t;
}
var ty = ey, ny = Pt, _s = Object.create, ay = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!ny(t))
      return {};
    if (_s)
      return _s(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), ry = ay, sy = ro, iy = sy(Object.getPrototypeOf, Object), bo = iy, oy = ry, ly = bo, uy = u1;
function cy(e) {
  return typeof e.constructor == "function" && !uy(e) ? oy(ly(e)) : {};
}
var dy = cy, fy = An, hy = gt;
function py(e) {
  return hy(e) && fy(e);
}
var vy = py, my = Dt, gy = bo, yy = gt, by = "[object Object]", _y = Function.prototype, wy = Object.prototype, _o = _y.toString, $y = wy.hasOwnProperty, Cy = _o.call(Object);
function xy(e) {
  if (!yy(e) || my(e) != by)
    return !1;
  var t = gy(e);
  if (t === null)
    return !0;
  var n = $y.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && _o.call(n) == Cy;
}
var Sy = xy;
function My(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var wo = My, Dy = X9, ky = Aa;
function Ly(e, t, n, a) {
  var r = !n;
  n || (n = {});
  for (var s = -1, i = t.length; ++s < i; ) {
    var l = t[s], u = a ? a(n[l], e[l], l, n, e) : void 0;
    u === void 0 && (u = e[l]), r ? ky(n, l, u) : Dy(n, l, u);
  }
  return n;
}
var Oy = Ly, Iy = Oy, Ey = p1;
function Ty(e) {
  return Iy(e, Ey(e));
}
var Ay = Ty, ws = yo, Py = ca, zy = Qg, Yy = ty, Vy = dy, $s = r1, Cs = mt, Hy = vy, Ny = R0, Ry = p0, By = Pt, Fy = Sy, jy = l1, xs = wo, Wy = Ay;
function Uy(e, t, n, a, r, s, i) {
  var l = xs(e, n), u = xs(t, n), c = i.get(u);
  if (c) {
    ws(e, n, c);
    return;
  }
  var d = s ? s(l, u, n + "", e, t, i) : void 0, f = d === void 0;
  if (f) {
    var v = Cs(u), p = !v && Ny(u), y = !v && !p && jy(u);
    d = u, v || p || y ? Cs(l) ? d = l : Hy(l) ? d = Yy(l) : p ? (f = !1, d = Py(u, !0)) : y ? (f = !1, d = zy(u, !0)) : d = [] : Fy(u) || $s(u) ? (d = l, $s(l) ? d = Wy(l) : (!By(l) || Ry(l)) && (d = Vy(u))) : f = !1;
  }
  f && (i.set(u, d), r(d, u, a, s, i), i.delete(u)), ws(e, n, d);
}
var qy = Uy, Gy = o1, Ky = yo, Zy = ho, Xy = qy, Jy = Pt, Qy = p1, eb = wo;
function $o(e, t, n, a, r) {
  e !== t && Zy(t, function(s, i) {
    if (r || (r = new Gy()), Jy(s))
      Xy(e, t, i, n, $o, a, r);
    else {
      var l = a ? a(eb(e, i), s, i + "", e, t, r) : void 0;
      l === void 0 && (l = s), Ky(e, i, l);
    }
  }, Qy);
}
var Co = $o, tb = Co, Ss = Pt;
function xo(e, t, n, a, r, s) {
  return Ss(e) && Ss(t) && (s.set(t, e), tb(e, t, void 0, xo, s), s.delete(t)), e;
}
var nb = xo, ab = h1, rb = f1;
function sb(e) {
  return ab(function(t, n) {
    var a = -1, r = n.length, s = r > 1 ? n[r - 1] : void 0, i = r > 2 ? n[2] : void 0;
    for (s = e.length > 3 && typeof s == "function" ? (r--, s) : void 0, i && rb(n[0], n[1], i) && (s = r < 3 ? void 0 : s, r = 1), t = Object(t); ++a < r; ) {
      var l = n[a];
      l && e(t, l, a, s);
    }
    return t;
  });
}
var ib = sb, ob = Co, lb = ib, ub = lb(function(e, t, n, a) {
  ob(e, t, n, a);
}), cb = ub, db = mo, fb = h1, hb = nb, pb = cb, vb = fb(function(e) {
  return e.push(void 0, hb), db(pb, void 0, e);
}), B0 = vb;
function mb(e) {
  return e && e.length ? e[0] : void 0;
}
var So = mb;
function gb(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var O0 = gb;
const yb = (e) => Object.prototype.toString.call(e).slice(8, -1), T0 = (e) => xp(e) && !isNaN(e.getTime()), Et = (e) => yb(e) === "Object", Mo = Ji, Ms = (e, t) => T9(t, (n) => Ji(e, n)), he = (e, t, n = "0") => {
  for (e = e != null ? String(e) : "", t = t || 2; e.length < t; )
    e = `${n}${e}`;
  return e;
}, ot = (e) => Array.isArray(e), Lt = (e) => ot(e) && e.length > 0, da = (e) => e == null ? null : document && _t(e) ? document.querySelector(e) : e.$el ?? e, qt = (e, t, n, a = void 0) => {
  e.removeEventListener(t, n, a);
}, Gt = (e, t, n, a = void 0) => (e.addEventListener(t, n, a), () => qt(e, t, n, a)), Jn = (e, t) => !!e && !!t && (e === t || e.contains(t)), Wn = (e, t) => {
  (e.key === " " || e.key === "Enter") && (t(e), e.preventDefault());
}, Do = (e, ...t) => {
  const n = {};
  let a;
  for (a in e)
    t.includes(a) || (n[a] = e[a]);
  return n;
}, ko = (e, t) => {
  const n = {};
  return t.forEach((a) => {
    a in e && (n[a] = e[a]);
  }), n;
};
function bb(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
var fa = {}, _b = {
  get exports() {
    return fa;
  },
  set exports(e) {
    fa = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(a) {
    if (a === null || a === !0 || a === !1)
      return NaN;
    var r = Number(a);
    return isNaN(r) ? r : r < 0 ? Math.ceil(r) : Math.floor(r);
  }
  e.exports = t.default;
})(_b, fa);
const wb = /* @__PURE__ */ Fi(fa);
var ha = {}, $b = {
  get exports() {
    return ha;
  },
  set exports(e) {
    ha = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(a) {
    var r = new Date(Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), a.getSeconds(), a.getMilliseconds()));
    return r.setUTCFullYear(a.getFullYear()), a.getTime() - r.getTime();
  }
  e.exports = t.default;
})($b, ha);
const Ds = /* @__PURE__ */ Fi(ha);
function Cb(e, t) {
  var n = Db(t);
  return n.formatToParts ? Sb(n, e) : Mb(n, e);
}
var xb = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function Sb(e, t) {
  try {
    for (var n = e.formatToParts(t), a = [], r = 0; r < n.length; r++) {
      var s = xb[n[r].type];
      s >= 0 && (a[s] = parseInt(n[r].value, 10));
    }
    return a;
  } catch (i) {
    if (i instanceof RangeError)
      return [NaN];
    throw i;
  }
}
function Mb(e, t) {
  var n = e.format(t).replace(/\u200E/g, ""), a = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [a[3], a[1], a[2], a[4], a[5], a[6]];
}
var Za = {};
function Db(e) {
  if (!Za[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Za[e] = n ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Za[e];
}
function Lo(e, t, n, a, r, s, i) {
  var l = /* @__PURE__ */ new Date(0);
  return l.setUTCFullYear(e, t, n), l.setUTCHours(a, r, s, i), l;
}
var ks = 36e5, kb = 6e4, Xa = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function Lb(e, t, n) {
  var a, r;
  if (!e || (a = Xa.timezoneZ.exec(e), a))
    return 0;
  var s;
  if (a = Xa.timezoneHH.exec(e), a)
    return s = parseInt(a[1], 10), Ls(s) ? -(s * ks) : NaN;
  if (a = Xa.timezoneHHMM.exec(e), a) {
    s = parseInt(a[1], 10);
    var i = parseInt(a[2], 10);
    return Ls(s, i) ? (r = Math.abs(s) * ks + i * kb, s > 0 ? -r : r) : NaN;
  }
  if (Eb(e)) {
    t = new Date(t || Date.now());
    var l = Ob(t), u = Cr(l, e), c = Ib(t, u, e);
    return -c;
  }
  return NaN;
}
function Ob(e) {
  return Lo(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function Cr(e, t) {
  var n = Cb(e, t), a = Lo(
    n[0],
    n[1] - 1,
    n[2],
    n[3] % 24,
    n[4],
    n[5],
    0
  ).getTime(), r = e.getTime(), s = r % 1e3;
  return r -= s >= 0 ? s : 1e3 + s, a - r;
}
function Ib(e, t, n) {
  var a = e.getTime(), r = a - t, s = Cr(new Date(r), n);
  if (t === s)
    return t;
  r -= s - t;
  var i = Cr(new Date(r), n);
  return s === i ? s : Math.max(s, i);
}
function Ls(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var Os = {};
function Eb(e) {
  if (Os[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), Os[e] = !0, !0;
  } catch {
    return !1;
  }
}
var Tb = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const Ab = Tb;
var Ja = 36e5, Is = 6e4, Pb = 2, Be = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: Ab
};
function zb(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = t || {}, a = n.additionalDigits == null ? Pb : wb(n.additionalDigits);
  if (a !== 2 && a !== 1 && a !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var r = Yb(e), s = Vb(r.date, a), i = s.year, l = s.restDateString, u = Hb(l, i);
  if (isNaN(u))
    return /* @__PURE__ */ new Date(NaN);
  if (u) {
    var c = u.getTime(), d = 0, f;
    if (r.time && (d = Nb(r.time), isNaN(d)))
      return /* @__PURE__ */ new Date(NaN);
    if (r.timeZone || n.timeZone) {
      if (f = Lb(r.timeZone || n.timeZone, new Date(c + d)), isNaN(f))
        return /* @__PURE__ */ new Date(NaN);
    } else
      f = Ds(new Date(c + d)), f = Ds(new Date(c + d + f));
    return new Date(c + d + f);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function Yb(e) {
  var t = {}, n = Be.dateTimePattern.exec(e), a;
  if (n ? (t.date = n[1], a = n[3]) : (n = Be.datePattern.exec(e), n ? (t.date = n[1], a = n[2]) : (t.date = null, a = e)), a) {
    var r = Be.timeZone.exec(a);
    r ? (t.time = a.replace(r[1], ""), t.timeZone = r[1].trim()) : t.time = a;
  }
  return t;
}
function Vb(e, t) {
  var n = Be.YYY[t], a = Be.YYYYY[t], r;
  if (r = Be.YYYY.exec(e) || a.exec(e), r) {
    var s = r[1];
    return {
      year: parseInt(s, 10),
      restDateString: e.slice(s.length)
    };
  }
  if (r = Be.YY.exec(e) || n.exec(e), r) {
    var i = r[1];
    return {
      year: parseInt(i, 10) * 100,
      restDateString: e.slice(i.length)
    };
  }
  return {
    year: null
  };
}
function Hb(e, t) {
  if (t === null)
    return null;
  var n, a, r, s;
  if (e.length === 0)
    return a = /* @__PURE__ */ new Date(0), a.setUTCFullYear(t), a;
  if (n = Be.MM.exec(e), n)
    return a = /* @__PURE__ */ new Date(0), r = parseInt(n[1], 10) - 1, Ts(t, r) ? (a.setUTCFullYear(t, r), a) : /* @__PURE__ */ new Date(NaN);
  if (n = Be.DDD.exec(e), n) {
    a = /* @__PURE__ */ new Date(0);
    var i = parseInt(n[1], 10);
    return Fb(t, i) ? (a.setUTCFullYear(t, 0, i), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = Be.MMDD.exec(e), n) {
    a = /* @__PURE__ */ new Date(0), r = parseInt(n[1], 10) - 1;
    var l = parseInt(n[2], 10);
    return Ts(t, r, l) ? (a.setUTCFullYear(t, r, l), a) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = Be.Www.exec(e), n)
    return s = parseInt(n[1], 10) - 1, As(t, s) ? Es(t, s) : /* @__PURE__ */ new Date(NaN);
  if (n = Be.WwwD.exec(e), n) {
    s = parseInt(n[1], 10) - 1;
    var u = parseInt(n[2], 10) - 1;
    return As(t, s, u) ? Es(t, s, u) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Nb(e) {
  var t, n, a;
  if (t = Be.HH.exec(e), t)
    return n = parseFloat(t[1].replace(",", ".")), Qa(n) ? n % 24 * Ja : NaN;
  if (t = Be.HHMM.exec(e), t)
    return n = parseInt(t[1], 10), a = parseFloat(t[2].replace(",", ".")), Qa(n, a) ? n % 24 * Ja + a * Is : NaN;
  if (t = Be.HHMMSS.exec(e), t) {
    n = parseInt(t[1], 10), a = parseInt(t[2], 10);
    var r = parseFloat(t[3].replace(",", "."));
    return Qa(n, a, r) ? n % 24 * Ja + a * Is + r * 1e3 : NaN;
  }
  return null;
}
function Es(e, t, n) {
  t = t || 0, n = n || 0;
  var a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(e, 0, 4);
  var r = a.getUTCDay() || 7, s = t * 7 + n + 1 - r;
  return a.setUTCDate(a.getUTCDate() + s), a;
}
var Rb = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Bb = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Oo(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Ts(e, t, n) {
  if (t < 0 || t > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    var a = Oo(e);
    if (a && n > Bb[t] || !a && n > Rb[t])
      return !1;
  }
  return !0;
}
function Fb(e, t) {
  if (t < 1)
    return !1;
  var n = Oo(e);
  return !(n && t > 366 || !n && t > 365);
}
function As(e, t, n) {
  return !(t < 0 || t > 52 || n != null && (n < 0 || n > 6));
}
function Qa(e, t, n) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || n != null && (n < 0 || n >= 60));
}
function Ve(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Qn(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Qn = function(n) {
    return typeof n;
  } : Qn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Qn(e);
}
function zt(e) {
  Ve(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Qn(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Q0(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
var jb = {};
function v1() {
  return jb;
}
function f0(e, t) {
  var n, a, r, s, i, l, u, c;
  Ve(1, arguments);
  var d = v1(), f = Q0((n = (a = (r = (s = t == null ? void 0 : t.weekStartsOn) !== null && s !== void 0 ? s : t == null || (i = t.locale) === null || i === void 0 || (l = i.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && r !== void 0 ? r : d.weekStartsOn) !== null && a !== void 0 ? a : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var v = zt(e), p = v.getDay(), y = (p < f ? 7 : 0) + p - f;
  return v.setDate(v.getDate() - y), v.setHours(0, 0, 0, 0), v;
}
function Ps(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var Wb = 6048e5;
function Ub(e, t, n) {
  Ve(2, arguments);
  var a = f0(e, n), r = f0(t, n), s = a.getTime() - Ps(a), i = r.getTime() - Ps(r);
  return Math.round((s - i) / Wb);
}
function qb(e) {
  Ve(1, arguments);
  var t = zt(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function Gb(e) {
  Ve(1, arguments);
  var t = zt(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Kb(e, t) {
  return Ve(1, arguments), Ub(qb(e), Gb(e), t) + 1;
}
function Zb(e, t) {
  var n, a, r, s, i, l, u, c;
  Ve(1, arguments);
  var d = zt(e), f = d.getFullYear(), v = v1(), p = Q0((n = (a = (r = (s = t == null ? void 0 : t.firstWeekContainsDate) !== null && s !== void 0 ? s : t == null || (i = t.locale) === null || i === void 0 || (l = i.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && r !== void 0 ? r : v.firstWeekContainsDate) !== null && a !== void 0 ? a : (u = v.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(p >= 1 && p <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var y = /* @__PURE__ */ new Date(0);
  y.setFullYear(f + 1, 0, p), y.setHours(0, 0, 0, 0);
  var w = f0(y, t), _ = /* @__PURE__ */ new Date(0);
  _.setFullYear(f, 0, p), _.setHours(0, 0, 0, 0);
  var b = f0(_, t);
  return d.getTime() >= w.getTime() ? f + 1 : d.getTime() >= b.getTime() ? f : f - 1;
}
function Xb(e, t) {
  var n, a, r, s, i, l, u, c;
  Ve(1, arguments);
  var d = v1(), f = Q0((n = (a = (r = (s = t == null ? void 0 : t.firstWeekContainsDate) !== null && s !== void 0 ? s : t == null || (i = t.locale) === null || i === void 0 || (l = i.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && r !== void 0 ? r : d.firstWeekContainsDate) !== null && a !== void 0 ? a : (u = d.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), v = Zb(e, t), p = /* @__PURE__ */ new Date(0);
  p.setFullYear(v, 0, f), p.setHours(0, 0, 0, 0);
  var y = f0(p, t);
  return y;
}
var Jb = 6048e5;
function Qb(e, t) {
  Ve(1, arguments);
  var n = zt(e), a = f0(n, t).getTime() - Xb(n, t).getTime();
  return Math.round(a / Jb) + 1;
}
function pa(e) {
  return Ve(1, arguments), f0(e, {
    weekStartsOn: 1
  });
}
function e_(e) {
  Ve(1, arguments);
  var t = zt(e), n = t.getFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  var r = pa(a), s = /* @__PURE__ */ new Date(0);
  s.setFullYear(n, 0, 4), s.setHours(0, 0, 0, 0);
  var i = pa(s);
  return t.getTime() >= r.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function t_(e) {
  Ve(1, arguments);
  var t = e_(e), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0);
  var a = pa(n);
  return a;
}
var n_ = 6048e5;
function a_(e) {
  Ve(1, arguments);
  var t = zt(e), n = pa(t).getTime() - t_(t).getTime();
  return Math.round(n / n_) + 1;
}
function Re(e, t) {
  Ve(2, arguments);
  var n = zt(e), a = Q0(t);
  return isNaN(a) ? /* @__PURE__ */ new Date(NaN) : (a && n.setDate(n.getDate() + a), n);
}
function va(e, t) {
  Ve(2, arguments);
  var n = zt(e), a = Q0(t);
  if (isNaN(a))
    return /* @__PURE__ */ new Date(NaN);
  if (!a)
    return n;
  var r = n.getDate(), s = new Date(n.getTime());
  s.setMonth(n.getMonth() + a + 1, 0);
  var i = s.getDate();
  return r >= i ? s : (n.setFullYear(s.getFullYear(), s.getMonth(), r), n);
}
function zs(e, t) {
  Ve(2, arguments);
  var n = Q0(t);
  return va(e, n * 12);
}
const r_ = {
  daily: ["year", "month", "day"],
  weekly: ["year", "month", "week"],
  monthly: ["year", "month"]
};
function s_({
  monthComps: e,
  prevMonthComps: t,
  nextMonthComps: n
}, a) {
  const r = [], {
    firstDayOfWeek: s,
    firstWeekday: i,
    isoWeeknumbers: l,
    weeknumbers: u,
    numDays: c,
    numWeeks: d
  } = e, f = i + (i < s ? Ye : 0) - s;
  let v = !0, p = !1, y = !1, w = 0;
  const _ = new Intl.DateTimeFormat(a.id, {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  let b = t.numDays - f + 1, N = t.numDays - b + 1, E = Math.floor((b - 1) / Ye + 1), L = 1, A = t.numWeeks, D = 1, I = t.month, F = t.year;
  const U = /* @__PURE__ */ new Date(), X = U.getDate(), Q = U.getMonth() + 1, R = U.getFullYear();
  for (let G = 1; G <= J_; G++) {
    for (let re = 1, W = s; re <= Ye; re++, W += W === Ye ? 1 - Ye : 1) {
      v && W === i && (b = 1, N = e.numDays, E = Math.floor((b - 1) / Ye + 1), L = Math.floor((c - b) / Ye + 1), A = 1, D = d, I = e.month, F = e.year, v = !1, p = !0);
      const ne = a.getDateFromParams(F, I, b, 0, 0, 0, 0), oe = a.getDateFromParams(F, I, b, 12, 0, 0, 0), Ce = a.getDateFromParams(
        F,
        I,
        b,
        23,
        59,
        59,
        999
      ), ve = ne, O = `${he(F, 4)}-${he(I, 2)}-${he(b, 2)}`, le = re, K = Ye - re, Se = u[G - 1], de = l[G - 1], Me = b === X && I === Q && F === R, Te = p && b === 1, De = p && b === c, Ae = G === 1, Ke = G === d, kt = re === 1, ct = re === Ye, nt = Bo(F, I, b);
      r.push({
        locale: a,
        id: O,
        position: ++w,
        label: b.toString(),
        ariaLabel: _.format(new Date(F, I - 1, b)),
        day: b,
        dayFromEnd: N,
        weekday: W,
        weekdayPosition: le,
        weekdayPositionFromEnd: K,
        weekdayOrdinal: E,
        weekdayOrdinalFromEnd: L,
        week: A,
        weekFromEnd: D,
        weekPosition: G,
        weeknumber: Se,
        isoWeeknumber: de,
        month: I,
        year: F,
        date: ve,
        startDate: ne,
        endDate: Ce,
        noonDate: oe,
        dayIndex: nt,
        isToday: Me,
        isFirstDay: Te,
        isLastDay: De,
        isDisabled: !p,
        isFocusable: !p,
        isFocused: !1,
        inMonth: p,
        inPrevMonth: v,
        inNextMonth: y,
        onTop: Ae,
        onBottom: Ke,
        onLeft: kt,
        onRight: ct,
        classes: [
          `id-${O}`,
          `day-${b}`,
          `day-from-end-${N}`,
          `weekday-${W}`,
          `weekday-position-${le}`,
          `weekday-ordinal-${E}`,
          `weekday-ordinal-from-end-${L}`,
          `week-${A}`,
          `week-from-end-${D}`,
          {
            "is-today": Me,
            "is-first-day": Te,
            "is-last-day": De,
            "in-month": p,
            "in-prev-month": v,
            "in-next-month": y,
            "on-top": Ae,
            "on-bottom": Ke,
            "on-left": kt,
            "on-right": ct
          }
        ]
      }), p && De ? (p = !1, y = !0, b = 1, N = c, E = 1, L = Math.floor((c - b) / Ye + 1), A = 1, D = n.numWeeks, I = n.month, F = n.year) : (b++, N--, E = Math.floor((b - 1) / Ye + 1), L = Math.floor((c - b) / Ye + 1));
    }
    A++, D--;
  }
  return r;
}
function i_(e, t, n, a) {
  const r = e.reduce((s, i, l) => {
    const u = Math.floor(l / 7);
    let c = s[u];
    return c || (c = {
      id: `week-${u + 1}`,
      title: "",
      week: i.week,
      weekPosition: i.weekPosition,
      weeknumber: i.weeknumber,
      isoWeeknumber: i.isoWeeknumber,
      weeknumberDisplay: t ? i.weeknumber : n ? i.isoWeeknumber : void 0,
      days: []
    }, s[u] = c), c.days.push(i), s;
  }, Array(e.length / Ye));
  return r.forEach((s) => {
    const i = s.days[0], l = s.days[s.days.length - 1];
    i.month === l.month ? s.title = `${a.formatDate(i.date, "MMMM YYYY")}` : i.year === l.year ? s.title = `${a.formatDate(
      i.date,
      "MMM"
    )} - ${a.formatDate(l.date, "MMM YYYY")}` : s.title = `${a.formatDate(
      i.date,
      "MMM YYYY"
    )} - ${a.formatDate(l.date, "MMM YYYY")}`;
  }), r;
}
function o_(e, t) {
  return e.days.map((n) => ({
    label: t.formatDate(n.date, t.masks.weekdays),
    weekday: n.weekday
  }));
}
function l_(e, t) {
  return `${t}.${he(e, 2)}`;
}
function Io(e, t, n) {
  return ko(
    n.getDateParts(n.toDate(e)),
    r_[t]
  );
}
function Eo({ day: e, week: t, month: n, year: a }, r, s, i) {
  if (s === "daily" && e) {
    const l = new Date(a, n - 1, e), u = Re(l, r);
    return {
      day: u.getDate(),
      month: u.getMonth() + 1,
      year: u.getFullYear()
    };
  } else if (s === "weekly" && t) {
    const u = i.getMonthParts(n, a).firstDayOfMonth, c = Re(u, (t - 1 + r) * 7), d = i.getDateParts(c);
    return {
      week: d.week,
      month: d.month,
      year: d.year
    };
  } else {
    const l = new Date(a, n - 1, 1), u = va(l, r);
    return {
      month: u.getMonth() + 1,
      year: u.getFullYear()
    };
  }
}
function wt(e) {
  return e != null && e.month != null && e.year != null;
}
function xr(e, t) {
  return !wt(e) || !wt(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year < t.year : e.month && t.month && e.month !== t.month ? e.month < t.month : e.week && t.week && e.week !== t.week ? e.week < t.week : e.day && t.day && e.day !== t.day ? e.day < t.day : !1);
}
function ma(e, t) {
  return !wt(e) || !wt(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year > t.year : e.month && t.month && e.month !== t.month ? e.month > t.month : e.week && t.week && e.week !== t.week ? e.week > t.week : e.day && t.day && e.day !== t.day ? e.day > t.day : !1);
}
function u_(e, t, n) {
  return (e || !1) && !xr(e, t) && !ma(e, n);
}
function c_(e, t) {
  return !e && t || e && !t ? !1 : !e && !t ? !0 : (e = e, t = t, e.year === t.year && e.month === t.month && e.week === t.week && e.day === t.day);
}
function d_(e, t, n, a) {
  if (!wt(e) || !wt(t))
    return [];
  const r = [];
  for (; !ma(e, t); )
    r.push(e), e = Eo(e, 1, n, a);
  return r;
}
function To(e) {
  const { day: t, week: n, month: a, year: r } = e;
  let s = `${r}-${he(a, 2)}`;
  return n && (s = `${s}-w${n}`), t && (s = `${s}-${he(t, 2)}`), s;
}
function f_(e, t) {
  const { month: n, year: a, showWeeknumbers: r, showIsoWeeknumbers: s } = e, i = new Date(a, n - 1, 15), l = t.getMonthParts(n, a), u = t.getPrevMonthParts(n, a), c = t.getNextMonthParts(n, a), d = s_({ monthComps: l, prevMonthComps: u, nextMonthComps: c }, t), f = i_(d, r, s, t), v = o_(f[0], t);
  return {
    id: To(e),
    month: n,
    year: a,
    monthTitle: t.formatDate(i, t.masks.title),
    shortMonthLabel: t.formatDate(i, "MMM"),
    monthLabel: t.formatDate(i, "MMMM"),
    shortYearLabel: a.toString().substring(2),
    yearLabel: a.toString(),
    monthComps: l,
    prevMonthComps: u,
    nextMonthComps: c,
    days: d,
    weeks: f,
    weekdays: v
  };
}
function h_(e, t) {
  const { day: n, week: a, view: r, trimWeeks: s } = e, i = {
    ...t,
    ...e,
    title: "",
    viewDays: [],
    viewWeeks: []
  };
  switch (r) {
    case "daily": {
      let l = i.days.find((c) => c.inMonth);
      n ? l = i.days.find((c) => c.day === n && c.inMonth) || l : a && (l = i.days.find((c) => c.week === a && c.inMonth));
      const u = i.weeks[l.week - 1];
      i.viewWeeks = [u], i.viewDays = [l], i.week = l.week, i.weekTitle = u.title, i.day = l.day, i.dayTitle = l.ariaLabel, i.title = i.dayTitle;
      break;
    }
    case "weekly": {
      i.week = a || 1;
      const l = i.weeks[i.week - 1];
      i.viewWeeks = [l], i.viewDays = l.days, i.weekTitle = l.title, i.title = i.weekTitle;
      break;
    }
    default: {
      i.title = i.monthTitle, i.viewWeeks = i.weeks.slice(
        0,
        s ? i.monthComps.numWeeks : void 0
      ), i.viewDays = i.days;
      break;
    }
  }
  return i;
}
class Ys {
  constructor(t, n, a) {
    q(this, "keys", []), q(this, "store", {}), this.size = t, this.createKey = n, this.createItem = a;
  }
  get(...t) {
    const n = this.createKey(...t);
    return this.store[n];
  }
  getOrSet(...t) {
    const n = this.createKey(...t);
    if (this.store[n])
      return this.store[n];
    const a = this.createItem(...t);
    if (this.keys.length >= this.size) {
      const r = this.keys.shift();
      r != null && delete this.store[r];
    }
    return this.keys.push(n), this.store[n] = a, a;
  }
}
class A0 {
  constructor(t, n = new ga()) {
    q(this, "order"), q(this, "locale"), q(this, "start", null), q(this, "end", null), q(this, "repeat", null);
    var a;
    this.locale = n;
    const { start: r, end: s, span: i, order: l, repeat: u } = t;
    T0(r) && (this.start = n.getDateParts(r)), T0(s) ? this.end = n.getDateParts(s) : this.start != null && i && (this.end = n.getDateParts(Re(this.start.date, i - 1))), this.order = l ?? 0, u && (this.repeat = new ya(
      {
        from: (a = this.start) == null ? void 0 : a.date,
        ...u
      },
      {
        locale: this.locale
      }
    ));
  }
  static fromMany(t, n) {
    return (ot(t) ? t : [t]).filter((a) => a).map((a) => A0.from(a, n));
  }
  static from(t, n) {
    if (t instanceof A0)
      return t;
    const a = {
      start: null,
      end: null
    };
    return t != null && (ot(t) ? (a.start = t[0] ?? null, a.end = t[1] ?? null) : Et(t) ? Object.assign(a, t) : (a.start = t, a.end = t)), a.start != null && (a.start = new Date(a.start)), a.end != null && (a.end = new Date(a.end)), new A0(a, n);
  }
  get opts() {
    const { order: t, locale: n } = this;
    return { order: t, locale: n };
  }
  get hasRepeat() {
    return !!this.repeat;
  }
  get isSingleDay() {
    const { start: t, end: n } = this;
    return t && n && t.year === n.year && t.month === n.month && t.day === n.day;
  }
  get isMultiDay() {
    return !this.isSingleDay;
  }
  get daySpan() {
    return this.start == null || this.end == null ? this.hasRepeat ? 1 : 1 / 0 : this.end.dayIndex - this.start.dayIndex;
  }
  startsOnDay(t) {
    var n, a;
    return ((n = this.start) == null ? void 0 : n.dayIndex) === t.dayIndex || !!((a = this.repeat) != null && a.passes(t));
  }
  intersectsDay(t) {
    return this.intersectsDayRange(t, t);
  }
  intersectsRange(t) {
    var n, a;
    return this.intersectsDayRange(
      ((n = t.start) == null ? void 0 : n.dayIndex) ?? -1 / 0,
      ((a = t.end) == null ? void 0 : a.dayIndex) ?? 1 / 0
    );
  }
  intersectsDayRange(t, n) {
    return !(this.start && this.start.dayIndex > n || this.end && this.end.dayIndex < t);
  }
}
class p_ {
  constructor() {
    q(this, "records", {});
  }
  render(t, n, a) {
    var r, s, i, l;
    let u = null;
    const c = a[0].dayIndex, d = a[a.length - 1].dayIndex;
    return n.hasRepeat ? a.forEach((f) => {
      var v, p;
      if (n.startsOnDay(f)) {
        const y = n.daySpan < 1 / 0 ? n.daySpan : 1;
        u = {
          startDay: f.dayIndex,
          startTime: ((v = n.start) == null ? void 0 : v.time) ?? 0,
          endDay: f.dayIndex + y - 1,
          endTime: ((p = n.end) == null ? void 0 : p.time) ?? ea
        }, this.getRangeRecords(t).push(u);
      }
    }) : n.intersectsDayRange(c, d) && (u = {
      startDay: ((r = n.start) == null ? void 0 : r.dayIndex) ?? -1 / 0,
      startTime: ((s = n.start) == null ? void 0 : s.time) ?? -1 / 0,
      endDay: ((i = n.end) == null ? void 0 : i.dayIndex) ?? 1 / 0,
      endTime: ((l = n.end) == null ? void 0 : l.time) ?? 1 / 0
    }, this.getRangeRecords(t).push(u)), u;
  }
  getRangeRecords(t) {
    let n = this.records[t.key];
    return n || (n = {
      ranges: [],
      data: t
    }, this.records[t.key] = n), n.ranges;
  }
  getCell(t, n) {
    return this.getCells(n).find((s) => s.data.key === t);
  }
  cellExists(t, n) {
    const a = this.records[t];
    return a == null ? !1 : a.ranges.some(
      (r) => r.startDay <= n && r.endDay >= n
    );
  }
  getCells(t) {
    const n = Object.values(this.records), a = [], { dayIndex: r } = t;
    return n.forEach(({ data: s, ranges: i }) => {
      i.filter((l) => l.startDay <= r && l.endDay >= r).forEach((l) => {
        const u = r === l.startDay, c = r === l.endDay, d = u ? l.startTime : 0, f = new Date(t.startDate.getTime() + d), v = c ? l.endTime : ea, p = new Date(t.endDate.getTime() + v), y = d === 0 && v === ea, w = s.order || 0;
        a.push({
          ...l,
          data: s,
          onStart: u,
          onEnd: c,
          startTime: d,
          startDate: f,
          endTime: v,
          endDate: p,
          allDay: y,
          order: w
        });
      });
    }), a.sort((s, i) => s.order - i.order), a;
  }
}
const Tt = {
  // Arabic
  ar: { dow: 7, L: "D/‏M/‏YYYY" },
  // Bulgarian
  bg: { dow: 2, L: "D.MM.YYYY" },
  // Catalan
  ca: { dow: 2, L: "DD/MM/YYYY" },
  // Chinese (China)
  "zh-CN": { dow: 2, L: "YYYY/MM/DD" },
  // Chinese (Taiwan)
  "zh-TW": { dow: 1, L: "YYYY/MM/DD" },
  // Croatian
  hr: { dow: 2, L: "DD.MM.YYYY" },
  // Czech
  cs: { dow: 2, L: "DD.MM.YYYY" },
  // Danish
  da: { dow: 2, L: "DD.MM.YYYY" },
  // Dutch
  nl: { dow: 2, L: "DD-MM-YYYY" },
  // English (US)
  "en-US": { dow: 1, L: "MM/DD/YYYY" },
  // English (Australia)
  "en-AU": { dow: 2, L: "DD/MM/YYYY" },
  // English (Canada)
  "en-CA": { dow: 1, L: "YYYY-MM-DD" },
  // English (Great Britain)
  "en-GB": { dow: 2, L: "DD/MM/YYYY" },
  // English (Ireland)
  "en-IE": { dow: 2, L: "DD-MM-YYYY" },
  // English (New Zealand)
  "en-NZ": { dow: 2, L: "DD/MM/YYYY" },
  // English (South Africa)
  "en-ZA": { dow: 1, L: "YYYY/MM/DD" },
  // Esperanto
  eo: { dow: 2, L: "YYYY-MM-DD" },
  // Estonian
  et: { dow: 2, L: "DD.MM.YYYY" },
  // Finnish
  fi: { dow: 2, L: "DD.MM.YYYY" },
  // French
  fr: { dow: 2, L: "DD/MM/YYYY" },
  // French (Canada)
  "fr-CA": { dow: 1, L: "YYYY-MM-DD" },
  // French (Switzerland)
  "fr-CH": { dow: 2, L: "DD.MM.YYYY" },
  // German
  de: { dow: 2, L: "DD.MM.YYYY" },
  // Hebrew
  he: { dow: 1, L: "DD.MM.YYYY" },
  // Indonesian
  id: { dow: 2, L: "DD/MM/YYYY" },
  // Italian
  it: { dow: 2, L: "DD/MM/YYYY" },
  // Japanese
  ja: { dow: 1, L: "YYYY年M月D日" },
  // Korean
  ko: { dow: 1, L: "YYYY.MM.DD" },
  // Latvian
  lv: { dow: 2, L: "DD.MM.YYYY" },
  // Lithuanian
  lt: { dow: 2, L: "DD.MM.YYYY" },
  // Macedonian
  mk: { dow: 2, L: "D.MM.YYYY" },
  // Norwegian
  nb: { dow: 2, L: "D. MMMM YYYY" },
  nn: { dow: 2, L: "D. MMMM YYYY" },
  // Polish
  pl: { dow: 2, L: "DD.MM.YYYY" },
  // Portuguese
  pt: { dow: 2, L: "DD/MM/YYYY" },
  // Romanian
  ro: { dow: 2, L: "DD.MM.YYYY" },
  // Russian
  ru: { dow: 2, L: "DD.MM.YYYY" },
  // Slovak
  sk: { dow: 2, L: "DD.MM.YYYY" },
  // Spanish (Spain)
  "es-ES": { dow: 2, L: "DD/MM/YYYY" },
  // Spanish (Mexico)
  "es-MX": { dow: 2, L: "DD/MM/YYYY" },
  // Swedish
  sv: { dow: 2, L: "YYYY-MM-DD" },
  // Thai
  th: { dow: 1, L: "DD/MM/YYYY" },
  // Turkish
  tr: { dow: 2, L: "DD.MM.YYYY" },
  // Ukrainian
  uk: { dow: 2, L: "DD.MM.YYYY" },
  // Vietnam
  vi: { dow: 2, L: "DD/MM/YYYY" }
};
Tt.en = Tt["en-US"];
Tt.es = Tt["es-ES"];
Tt.no = Tt.nb;
Tt.zh = Tt["zh-CN"];
const v_ = Object.entries(Tt).reduce(
  (e, [t, { dow: n, L: a }]) => (e[t] = {
    id: t,
    firstDayOfWeek: n,
    masks: { L: a }
  }, e),
  {}
), m_ = "MMMM YYYY", g_ = "W", y_ = "MMM", b_ = "h A", __ = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], w_ = [
  "L h:mm A",
  "YYYY-MM-DD h:mm A",
  "YYYY/MM/DD h:mm A"
], $_ = [
  "L HH:mm",
  "YYYY-MM-DD HH:mm",
  "YYYY/MM/DD HH:mm"
], C_ = [
  "h:mm A"
], x_ = [
  "HH:mm"
], S_ = "WWW, MMM D, YYYY", M_ = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], D_ = "iso", k_ = "YYYY-MM-DDTHH:mm:ss.SSSZ", L_ = {
  title: m_,
  weekdays: g_,
  navMonths: y_,
  hours: b_,
  input: __,
  inputDateTime: w_,
  inputDateTime24hr: $_,
  inputTime: C_,
  inputTime24hr: x_,
  dayPopover: S_,
  data: M_,
  model: D_,
  iso: k_
}, O_ = 300, I_ = 60, E_ = 80, T_ = {
  maxSwipeTime: O_,
  minHorizontalSwipeDistance: I_,
  maxVerticalSwipeDistance: E_
}, A_ = {
  componentPrefix: "V",
  color: "blue",
  isDark: !1,
  navVisibility: "click",
  titlePosition: "center",
  transition: "slide-h",
  touch: T_,
  masks: L_,
  locales: v_,
  datePicker: {
    updateOnInput: !0,
    inputDebounce: 1e3,
    popover: {
      visibility: "hover-focus",
      placement: "bottom-start",
      isInteractive: !0
    }
  }
}, P0 = W0(A_), P_ = $(() => ng(P0.locales, (e) => (e.masks = B0(e.masks, P0.masks), e))), Jt = (e) => typeof window < "u" && Mo(window.__vcalendar__, e) ? u0(window.__vcalendar__, e) : u0(P0, e), z_ = (e, t) => (e.config.globalProperties.$VCalendar = P0, Object.assign(P0, B0(t, P0))), Y_ = 12, V_ = 5;
function H_(e, t) {
  const n = new Intl.DateTimeFormat().resolvedOptions().locale;
  let a;
  _t(e) ? a = e : Mo(e, "id") && (a = e.id), a = (a || n).toLowerCase();
  const r = Object.keys(t), s = (u) => r.find((c) => c.toLowerCase() === u);
  a = s(a) || s(a.substring(0, 2)) || n;
  const i = {
    ...t["en-IE"],
    ...t[a],
    id: a,
    monthCacheSize: Y_,
    pageCacheSize: V_
  };
  return Et(e) ? B0(e, i) : i;
}
class ga {
  constructor(t = void 0, n) {
    q(this, "id"), q(this, "daysInWeek"), q(this, "firstDayOfWeek"), q(this, "masks"), q(this, "timezone"), q(this, "hourLabels"), q(this, "dayNames"), q(this, "dayNamesShort"), q(this, "dayNamesShorter"), q(this, "dayNamesNarrow"), q(this, "monthNames"), q(this, "monthNamesShort"), q(this, "relativeTimeNames"), q(this, "amPm", ["am", "pm"]), q(this, "monthCache"), q(this, "pageCache");
    const { id: a, firstDayOfWeek: r, masks: s, monthCacheSize: i, pageCacheSize: l } = H_(t, P_.value);
    this.monthCache = new Ys(
      i,
      ow,
      lw
    ), this.pageCache = new Ys(l, To, f_), this.id = a, this.daysInWeek = Ye, this.firstDayOfWeek = bb(r, 1, Ye), this.masks = s, this.timezone = n || void 0, this.hourLabels = this.getHourLabels(), this.dayNames = er("long", this.id), this.dayNamesShort = er("short", this.id), this.dayNamesShorter = this.dayNamesShort.map((u) => u.substring(0, 2)), this.dayNamesNarrow = er("narrow", this.id), this.monthNames = Fs("long", this.id), this.monthNamesShort = Fs("short", this.id), this.relativeTimeNames = dw(this.id);
  }
  formatDate(t, n) {
    return mw(t, n, this);
  }
  parseDate(t, n) {
    return js(t, n, this);
  }
  toDate(t, n = {}) {
    const a = /* @__PURE__ */ new Date(NaN);
    let r = a;
    const { fillDate: s, mask: i, patch: l, rules: u } = n;
    if (pt(t) ? (n.type = "number", r = /* @__PURE__ */ new Date(+t)) : _t(t) ? (n.type = "string", r = t ? js(t, i || "iso", this) : a) : T0(t) ? (n.type = "date", r = new Date(t.getTime())) : m1(t) && (n.type = "object", r = this.getDateFromParts(t)), r && (l || u)) {
      let c = this.getDateParts(r);
      if (l && s != null) {
        const d = this.getDateParts(this.toDate(s));
        c = this.getDateParts(
          this.toDate({ ...d, ...ko(c, X_[l]) })
        );
      }
      u && (c = vw(c, u)), r = this.getDateFromParts(c);
    }
    return r || a;
  }
  toDateOrNull(t, n = {}) {
    const a = this.toDate(t, n);
    return isNaN(a.getTime()) ? null : a;
  }
  fromDate(t, { type: n, mask: a } = {}) {
    switch (n) {
      case "number":
        return t ? t.getTime() : NaN;
      case "string":
        return t ? this.formatDate(t, a || "iso") : "";
      case "object":
        return t ? this.getDateParts(t) : null;
      default:
        return t ? new Date(t) : null;
    }
  }
  range(t) {
    return A0.from(t, this);
  }
  ranges(t) {
    return A0.fromMany(t, this);
  }
  getDateParts(t) {
    return iw(t, this);
  }
  getDateFromParts(t) {
    return jo(t, this.timezone);
  }
  getDateFromParams(t, n, a, r, s, i, l) {
    return this.getDateFromParts({
      year: t,
      month: n,
      day: a,
      hours: r,
      minutes: s,
      seconds: i,
      milliseconds: l
    });
  }
  getPage(t) {
    const n = this.pageCache.getOrSet(t, this);
    return h_(t, n);
  }
  getMonthParts(t, n) {
    const { firstDayOfWeek: a } = this;
    return this.monthCache.getOrSet(t, n, a);
  }
  getThisMonthParts() {
    const t = /* @__PURE__ */ new Date();
    return this.getMonthParts(
      t.getMonth() + 1,
      t.getFullYear()
    );
  }
  getPrevMonthParts(t, n) {
    return t === 1 ? this.getMonthParts(12, n - 1) : this.getMonthParts(t - 1, n);
  }
  getNextMonthParts(t, n) {
    return t === 12 ? this.getMonthParts(1, n + 1) : this.getMonthParts(t + 1, n);
  }
  getHourLabels() {
    return cw().map((t) => this.formatDate(t, this.masks.hours));
  }
  getDayId(t) {
    return this.formatDate(t, "YYYY-MM-DD");
  }
}
var D0 = /* @__PURE__ */ ((e) => (e.Any = "any", e.All = "all", e))(D0 || {}), Ao = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(Ao || {}), Po = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weekdays = "weekdays", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(Po || {}), zo = /* @__PURE__ */ ((e) => (e.OrdinalWeekdays = "ordinalWeekdays", e))(zo || {});
class N_ {
  constructor(t, n, a) {
    q(this, "validated", !0), this.type = t, this.interval = n, this.from = a, this.from || (console.error(
      'A valid "from" date is required for date interval rule. This rule will be skipped.'
    ), this.validated = !1);
  }
  passes(t) {
    if (!this.validated)
      return !0;
    const { date: n } = t;
    switch (this.type) {
      case "days":
        return g1(this.from.date, n) % this.interval === 0;
      case "weeks":
        return rw(this.from.date, n) % this.interval === 0;
      case "months":
        return sw(this.from.date, n) % this.interval === 0;
      case "years":
        return Fo(this.from.date, n) % this.interval === 0;
      default:
        return !1;
    }
  }
}
class en {
  constructor(t, n, a, r) {
    q(this, "components", []), this.type = t, this.validator = a, this.getter = r, this.components = this.normalizeComponents(n);
  }
  static create(t, n) {
    switch (t) {
      case "days":
        return new R_(n);
      case "weekdays":
        return new B_(n);
      case "weeks":
        return new F_(n);
      case "months":
        return new j_(n);
      case "years":
        return new W_(n);
    }
  }
  normalizeComponents(t) {
    if (this.validator(t))
      return [t];
    if (!ot(t))
      return [];
    const n = [];
    return t.forEach((a) => {
      if (!this.validator(a)) {
        console.error(
          `Component value ${a} in invalid for "${this.type}" rule. This rule will be skipped.`
        );
        return;
      }
      n.push(a);
    }), n;
  }
  passes(t) {
    return this.getter(t).some((r) => this.components.includes(r));
  }
}
class R_ extends en {
  constructor(t) {
    super(
      "days",
      t,
      G_,
      ({ day: n, dayFromEnd: a }) => [n, -a]
    );
  }
}
class B_ extends en {
  constructor(t) {
    super(
      "weekdays",
      t,
      Sr,
      ({ weekday: n }) => [n]
    );
  }
}
class F_ extends en {
  constructor(t) {
    super(
      "weeks",
      t,
      K_,
      ({ week: n, weekFromEnd: a }) => [n, -a]
    );
  }
}
class j_ extends en {
  constructor(t) {
    super("months", t, Z_, ({ month: n }) => [
      n
    ]);
  }
}
class W_ extends en {
  constructor(t) {
    super("years", t, pt, ({ year: n }) => [n]);
  }
}
class U_ {
  constructor(t, n) {
    q(this, "components"), this.type = t, this.components = this.normalizeComponents(n);
  }
  normalizeArrayConfig(t) {
    const n = [];
    return t.forEach((a, r) => {
      if (pt(a)) {
        if (r === 0)
          return;
        if (!Vs(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!Sr(a)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        n.push([t[0], a]);
      } else ot(a) && n.push(...this.normalizeArrayConfig(a));
    }), n;
  }
  normalizeComponents(t) {
    const n = [];
    return t.forEach((a, r) => {
      if (pt(a)) {
        if (r === 0)
          return;
        if (!Vs(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!Sr(a)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        n.push([t[0], a]);
      } else ot(a) && n.push(...this.normalizeArrayConfig(a));
    }), n;
  }
  passes(t) {
    const { weekday: n, weekdayOrdinal: a, weekdayOrdinalFromEnd: r } = t;
    return this.components.some(
      ([s, i]) => (s === a || s === -r) && n === i
    );
  }
}
class q_ {
  constructor(t) {
    q(this, "type", "function"), q(this, "validated", !0), this.fn = t, p0(t) || (console.error(
      "The function rule requires a valid function. This rule will be skipped."
    ), this.validated = !1);
  }
  passes(t) {
    return this.validated ? this.fn(t) : !0;
  }
}
class ya {
  constructor(t, n = {}, a) {
    q(this, "validated", !0), q(this, "config"), q(this, "type", D0.Any), q(this, "from"), q(this, "until"), q(this, "rules", []), q(this, "locale", new ga()), this.parent = a, n.locale && (this.locale = n.locale), this.config = t, p0(t) ? (this.type = D0.All, this.rules = [new q_(t)]) : ot(t) ? (this.type = D0.Any, this.rules = t.map((r) => new ya(r, n, this))) : Et(t) ? (this.type = D0.All, this.from = t.from ? this.locale.getDateParts(t.from) : a == null ? void 0 : a.from, this.until = t.until ? this.locale.getDateParts(t.until) : a == null ? void 0 : a.until, this.rules = this.getObjectRules(t)) : (console.error("Rule group configuration must be an object or an array."), this.validated = !1);
  }
  getObjectRules(t) {
    const n = [];
    if (t.every && (_t(t.every) && (t.every = [1, `${t.every}s`]), ot(t.every))) {
      const [a = 1, r = Ao.Days] = t.every;
      n.push(new N_(r, a, this.from));
    }
    return Object.values(Po).forEach((a) => {
      a in t && n.push(en.create(a, t[a]));
    }), Object.values(zo).forEach((a) => {
      a in t && n.push(new U_(a, t[a]));
    }), t.on != null && (ot(t.on) || (t.on = [t.on]), n.push(
      new ya(t.on, { locale: this.locale }, this.parent)
    )), n;
  }
  passes(t) {
    return this.validated ? this.from && t.dayIndex <= this.from.dayIndex || this.until && t.dayIndex >= this.until.dayIndex ? !1 : this.type === D0.Any ? this.rules.some((n) => n.passes(t)) : this.rules.every((n) => n.passes(t)) : !0;
  }
}
function G_(e) {
  return pt(e) ? e >= 1 && e <= 31 : !1;
}
function Sr(e) {
  return pt(e) ? e >= 1 && e <= 7 : !1;
}
function K_(e) {
  return pt(e) ? e >= -6 && e <= -1 || e >= 1 && e <= 6 : !1;
}
function Z_(e) {
  return pt(e) ? e >= 1 && e <= 12 : !1;
}
function Vs(e) {
  return !(!pt(e) || e < -5 || e > 5 || e === 0);
}
const X_ = {
  dateTime: [
    "year",
    "month",
    "day",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ],
  date: ["year", "month", "day"],
  time: ["hours", "minutes", "seconds", "milliseconds"]
}, Ye = 7, J_ = 6, Yo = 1e3, Vo = Yo * 60, Ho = Vo * 60, ea = Ho * 24, Q_ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ew = ["L", "iso"], un = {
  milliseconds: [0, 999, 3],
  seconds: [0, 59, 2],
  minutes: [0, 59, 2],
  hours: [0, 23, 2]
}, No = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, tw = /\[([^]*?)\]/gm, Hs = {
  D(e) {
    return e.day;
  },
  DD(e) {
    return he(e.day, 2);
  },
  // Do(d: DateParts, l: Locale) {
  //   return l.DoFn(d.day);
  // },
  d(e) {
    return e.weekday - 1;
  },
  dd(e) {
    return he(e.weekday - 1, 2);
  },
  W(e, t) {
    return t.dayNamesNarrow[e.weekday - 1];
  },
  WW(e, t) {
    return t.dayNamesShorter[e.weekday - 1];
  },
  WWW(e, t) {
    return t.dayNamesShort[e.weekday - 1];
  },
  WWWW(e, t) {
    return t.dayNames[e.weekday - 1];
  },
  M(e) {
    return e.month;
  },
  MM(e) {
    return he(e.month, 2);
  },
  MMM(e, t) {
    return t.monthNamesShort[e.month - 1];
  },
  MMMM(e, t) {
    return t.monthNames[e.month - 1];
  },
  YY(e) {
    return String(e.year).substr(2);
  },
  YYYY(e) {
    return he(e.year, 4);
  },
  h(e) {
    return e.hours % 12 || 12;
  },
  hh(e) {
    return he(e.hours % 12 || 12, 2);
  },
  H(e) {
    return e.hours;
  },
  HH(e) {
    return he(e.hours, 2);
  },
  m(e) {
    return e.minutes;
  },
  mm(e) {
    return he(e.minutes, 2);
  },
  s(e) {
    return e.seconds;
  },
  ss(e) {
    return he(e.seconds, 2);
  },
  S(e) {
    return Math.round(e.milliseconds / 100);
  },
  SS(e) {
    return he(Math.round(e.milliseconds / 10), 2);
  },
  SSS(e) {
    return he(e.milliseconds, 3);
  },
  a(e, t) {
    return e.hours < 12 ? t.amPm[0] : t.amPm[1];
  },
  A(e, t) {
    return e.hours < 12 ? t.amPm[0].toUpperCase() : t.amPm[1].toUpperCase();
  },
  Z() {
    return "Z";
  },
  ZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${he(Math.floor(Math.abs(t) / 60), 2)}`;
  },
  ZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${he(
      Math.floor(Math.abs(t) / 60) * 100 + Math.abs(t) % 60,
      4
    )}`;
  },
  ZZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${he(Math.floor(Math.abs(t) / 60), 2)}:${he(
      Math.abs(t) % 60,
      2
    )}`;
  }
}, Wt = /\d\d?/, nw = /\d{3}/, aw = /\d{4}/, on = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, Ns = () => {
}, Rs = (e) => (t, n, a) => {
  const r = a[e].indexOf(
    n.charAt(0).toUpperCase() + n.substr(1).toLowerCase()
  );
  ~r && (t.month = r);
}, ge = {
  D: [
    Wt,
    (e, t) => {
      e.day = t;
    }
  ],
  Do: [
    new RegExp(Wt.source + on.source),
    (e, t) => {
      e.day = parseInt(t, 10);
    }
  ],
  d: [Wt, Ns],
  W: [on, Ns],
  M: [
    Wt,
    (e, t) => {
      e.month = t - 1;
    }
  ],
  MMM: [on, Rs("monthNamesShort")],
  MMMM: [on, Rs("monthNames")],
  YY: [
    Wt,
    (e, t) => {
      const a = +(/* @__PURE__ */ new Date()).getFullYear().toString().substr(0, 2);
      e.year = +`${t > 68 ? a - 1 : a}${t}`;
    }
  ],
  YYYY: [
    aw,
    (e, t) => {
      e.year = t;
    }
  ],
  S: [
    /\d/,
    (e, t) => {
      e.milliseconds = t * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (e, t) => {
      e.milliseconds = t * 10;
    }
  ],
  SSS: [
    nw,
    (e, t) => {
      e.milliseconds = t;
    }
  ],
  h: [
    Wt,
    (e, t) => {
      e.hours = t;
    }
  ],
  m: [
    Wt,
    (e, t) => {
      e.minutes = t;
    }
  ],
  s: [
    Wt,
    (e, t) => {
      e.seconds = t;
    }
  ],
  a: [
    on,
    (e, t, n) => {
      const a = t.toLowerCase();
      a === n.amPm[0] ? e.isPm = !1 : a === n.amPm[1] && (e.isPm = !0);
    }
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (e, t) => {
      t === "Z" && (t = "+00:00");
      const n = `${t}`.match(/([+-]|\d\d)/gi);
      if (n) {
        const a = +n[1] * 60 + parseInt(n[2], 10);
        e.timezoneOffset = n[0] === "+" ? a : -a;
      }
    }
  ]
};
ge.DD = ge.D;
ge.dd = ge.d;
ge.WWWW = ge.WWW = ge.WW = ge.W;
ge.MM = ge.M;
ge.mm = ge.m;
ge.hh = ge.H = ge.HH = ge.h;
ge.ss = ge.s;
ge.A = ge.a;
ge.ZZZZ = ge.ZZZ = ge.ZZ = ge.Z;
function Ro(e, t) {
  return (Lt(e) && e || [
    _t(e) && e || "YYYY-MM-DD"
  ]).map(
    (n) => ew.reduce(
      (a, r) => a.replace(r, t.masks[r] || ""),
      n
    )
  );
}
function m1(e) {
  return Et(e) && "year" in e && "month" in e && "day" in e;
}
function Bs(e, t = 1) {
  const n = e.getDay() + 1, a = n >= t ? t - n : -(7 - (t - n));
  return Re(e, a);
}
function Bo(e, t, n) {
  const a = Date.UTC(e, t - 1, n);
  return g1(/* @__PURE__ */ new Date(0), new Date(a));
}
function g1(e, t) {
  return Math.round((t.getTime() - e.getTime()) / ea);
}
function rw(e, t) {
  return Math.ceil(g1(Bs(e), Bs(t)) / 7);
}
function Fo(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}
function sw(e, t) {
  return Fo(e, t) * 12 + (t.getMonth() - e.getMonth());
}
function jo(e, t = "") {
  const n = /* @__PURE__ */ new Date(), {
    year: a = n.getFullYear(),
    month: r = n.getMonth() + 1,
    day: s = n.getDate(),
    hours: i = 0,
    minutes: l = 0,
    seconds: u = 0,
    milliseconds: c = 0
  } = e;
  if (t) {
    const d = `${he(a, 4)}-${he(r, 2)}-${he(s, 2)}T${he(
      i,
      2
    )}:${he(l, 2)}:${he(u, 2)}.${he(c, 3)}`;
    return zb(d, { timeZone: t });
  }
  return new Date(a, r - 1, s, i, l, u, c);
}
function iw(e, t) {
  let n = new Date(e.getTime());
  t.timezone && (n = new Date(
    e.toLocaleString("en-US", { timeZone: t.timezone })
  ), n.setMilliseconds(e.getMilliseconds()));
  const a = n.getMilliseconds(), r = n.getSeconds(), s = n.getMinutes(), i = n.getHours(), l = a + r * Yo + s * Vo + i * Ho, u = n.getMonth() + 1, c = n.getFullYear(), d = t.getMonthParts(u, c), f = n.getDate(), v = d.numDays - f + 1, p = n.getDay() + 1, y = Math.floor((f - 1) / 7 + 1), w = Math.floor((d.numDays - f) / 7 + 1), _ = Math.ceil(
    (f + Math.abs(d.firstWeekday - d.firstDayOfWeek)) / 7
  ), b = d.numWeeks - _ + 1, N = d.weeknumbers[_], E = Bo(c, u, f);
  return {
    milliseconds: a,
    seconds: r,
    minutes: s,
    hours: i,
    time: l,
    day: f,
    dayFromEnd: v,
    weekday: p,
    weekdayOrdinal: y,
    weekdayOrdinalFromEnd: w,
    week: _,
    weekFromEnd: b,
    weeknumber: N,
    month: u,
    year: c,
    date: n,
    dateTime: n.getTime(),
    dayIndex: E,
    timezoneOffset: 0,
    isValid: !0
  };
}
function ow(e, t, n) {
  return `${t}-${e}-${n}`;
}
function lw(e, t, n) {
  const a = t % 4 === 0 && t % 100 !== 0 || t % 400 === 0, r = new Date(t, e - 1, 1), s = r.getDay() + 1, i = e === 2 && a ? 29 : Q_[e - 1], l = n - 1, u = Kb(r, {
    weekStartsOn: l
  }), c = [], d = [];
  for (let f = 0; f < u; f++) {
    const v = Re(r, f * 7);
    c.push(Qb(v, { weekStartsOn: l })), d.push(a_(v));
  }
  return {
    firstDayOfWeek: n,
    firstDayOfMonth: r,
    inLeapYear: a,
    firstWeekday: s,
    numDays: i,
    numWeeks: u,
    month: e,
    year: t,
    weeknumbers: c,
    isoWeeknumbers: d
  };
}
function uw() {
  const e = [];
  for (let r = 0; r < Ye; r++)
    e.push(
      jo({
        year: 2020,
        month: 1,
        day: 5 + r,
        hours: 12
      })
    );
  return e;
}
function er(e, t = void 0) {
  const n = new Intl.DateTimeFormat(t, {
    weekday: e
  });
  return uw().map((a) => n.format(a));
}
function cw() {
  const e = [];
  for (let t = 0; t <= 24; t++)
    e.push(new Date(2e3, 0, 1, t));
  return e;
}
function dw(e = void 0) {
  const t = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "quarter",
    "year"
  ], n = new Intl.RelativeTimeFormat(e);
  return t.reduce((a, r) => {
    const s = n.formatToParts(100, r);
    return a[r] = s[1].unit, a;
  }, {});
}
function Wo() {
  const e = [];
  for (let t = 0; t < 12; t++)
    e.push(new Date(2e3, t, 15));
  return e;
}
function Fs(e, t = void 0) {
  const n = new Intl.DateTimeFormat(t, {
    month: e,
    timeZone: "UTC"
  });
  return Wo().map((a) => n.format(a));
}
function fw(e, t, n) {
  return pt(t) ? t === e : ot(t) ? t.includes(e) : p0(t) ? t(e, n) : !(t.min != null && t.min > e || t.max != null && t.max < e || t.interval != null && e % t.interval !== 0);
}
function cn(e, t, n) {
  const a = [], [r, s, i] = t;
  for (let l = r; l <= s; l++)
    (n == null || fw(l, n, e)) && a.push({
      value: l,
      label: he(l, i)
    });
  return a;
}
function hw(e, t) {
  return {
    milliseconds: cn(
      e,
      un.milliseconds,
      t.milliseconds
    ),
    seconds: cn(e, un.seconds, t.seconds),
    minutes: cn(e, un.minutes, t.minutes),
    hours: cn(e, un.hours, t.hours)
  };
}
function pw(e, t, n, a) {
  const s = cn(e, t, a).reduce((i, l) => {
    if (l.disabled)
      return i;
    if (isNaN(i))
      return l.value;
    const u = Math.abs(i - n);
    return Math.abs(l.value - n) < u ? l.value : i;
  }, NaN);
  return isNaN(s) ? n : s;
}
function vw(e, t) {
  const n = { ...e };
  return Object.entries(t).forEach(([a, r]) => {
    const s = un[a], i = e[a];
    n[a] = pw(
      e,
      s,
      i,
      r
    );
  }), n;
}
function js(e, t, n) {
  return Ro(t, n).map((r) => {
    if (typeof r != "string")
      throw new Error("Invalid mask");
    let s = e;
    if (s.length > 1e3)
      return !1;
    let i = !0;
    const l = {};
    if (r.replace(No, (d) => {
      if (ge[d]) {
        const f = ge[d], v = s.search(f[0]);
        ~v ? s.replace(f[0], (p) => (f[1](l, p, n), s = s.substr(v + p.length), p)) : i = !1;
      }
      return ge[d] ? "" : d.slice(1, d.length - 1);
    }), !i)
      return !1;
    const u = /* @__PURE__ */ new Date();
    l.hours != null && (l.isPm === !0 && +l.hours != 12 ? l.hours = +l.hours + 12 : l.isPm === !1 && +l.hours == 12 && (l.hours = 0));
    let c;
    return l.timezoneOffset != null ? (l.minutes = +(l.minutes || 0) - +l.timezoneOffset, c = new Date(
      Date.UTC(
        l.year || u.getFullYear(),
        l.month || 0,
        l.day || 1,
        l.hours || 0,
        l.minutes || 0,
        l.seconds || 0,
        l.milliseconds || 0
      )
    )) : c = n.getDateFromParts({
      year: l.year || u.getFullYear(),
      month: (l.month || 0) + 1,
      day: l.day || 1,
      hours: l.hours || 0,
      minutes: l.minutes || 0,
      seconds: l.seconds || 0,
      milliseconds: l.milliseconds || 0
    }), c;
  }).find((r) => r) || new Date(e);
}
function mw(e, t, n) {
  if (e == null)
    return "";
  let a = Ro(t, n)[0];
  /Z$/.test(a) && (n.timezone = "utc");
  const r = [];
  a = a.replace(tw, (i, l) => (r.push(l), "??"));
  const s = n.getDateParts(e);
  return a = a.replace(
    No,
    (i) => i in Hs ? Hs[i](s, n) : i.slice(1, i.length - 1)
  ), a.replace(/\?\?/g, () => r.shift());
}
let gw = 0;
class Uo {
  constructor(t, n, a) {
    q(this, "key", ""), q(this, "hashcode", ""), q(this, "highlight", null), q(this, "content", null), q(this, "dot", null), q(this, "bar", null), q(this, "event", null), q(this, "popover", null), q(this, "customData", null), q(this, "ranges"), q(this, "hasRanges", !1), q(this, "order", 0), q(this, "pinPage", !1), q(this, "maxRepeatSpan", 0), q(this, "locale");
    const { dates: r } = Object.assign(
      this,
      { hashcode: "", order: 0, pinPage: !1 },
      t
    );
    this.key || (this.key = ++gw), this.locale = a, n.normalizeGlyphs(this), this.ranges = a.ranges(r ?? []), this.hasRanges = !!Lt(this.ranges), this.maxRepeatSpan = this.ranges.filter((s) => s.hasRepeat).map((s) => s.daySpan).reduce((s, i) => Math.max(s, i), 0);
  }
  intersectsRange({ start: t, end: n }) {
    if (t == null || n == null)
      return !1;
    const a = this.ranges.filter((i) => !i.hasRepeat);
    for (const i of a)
      if (i.intersectsDayRange(t.dayIndex, n.dayIndex))
        return !0;
    const r = this.ranges.filter((i) => i.hasRepeat);
    if (!r.length)
      return !1;
    let s = t;
    for (this.maxRepeatSpan > 1 && (s = this.locale.getDateParts(Re(s.date, -this.maxRepeatSpan))); s.dayIndex <= n.dayIndex; ) {
      for (const i of r)
        if (i.startsOnDay(s))
          return !0;
      s = this.locale.getDateParts(Re(s.date, 1));
    }
    return !1;
  }
}
function Mr(e) {
  document && document.dispatchEvent(
    new CustomEvent("show-popover", {
      detail: e
    })
  );
}
function Mn(e) {
  document && document.dispatchEvent(
    new CustomEvent("hide-popover", {
      detail: e
    })
  );
}
function qo(e) {
  document && document.dispatchEvent(
    new CustomEvent("toggle-popover", {
      detail: e
    })
  );
}
function Go(e) {
  const { visibility: t } = e, n = t === "click", a = t === "hover", r = t === "hover-focus", s = t === "focus";
  e.autoHide = !n;
  let i = !1, l = !1;
  const u = (y) => {
    n && (qo({
      ...e,
      target: e.target || y.currentTarget
    }), y.stopPropagation());
  }, c = (y) => {
    i || (i = !0, (a || r) && Mr({
      ...e,
      target: e.target || y.currentTarget
    }));
  }, d = () => {
    i && (i = !1, (a || r && !l) && Mn(e));
  }, f = (y) => {
    l || (l = !0, (s || r) && Mr({
      ...e,
      target: e.target || y.currentTarget
    }));
  }, v = (y) => {
    l && !Jn(y.currentTarget, y.relatedTarget) && (l = !1, (s || r && !i) && Mn(e));
  }, p = {};
  switch (e.visibility) {
    case "click":
      p.click = u;
      break;
    case "hover":
      p.mousemove = c, p.mouseleave = d;
      break;
    case "focus":
      p.focusin = f, p.focusout = v;
      break;
    case "hover-focus":
      p.mousemove = c, p.mouseleave = d, p.focusin = f, p.focusout = v;
      break;
  }
  return p;
}
const Ws = (e) => {
  const t = da(e);
  if (t == null)
    return;
  const n = t.popoverHandlers;
  !n || !n.length || (n.forEach((a) => a()), delete t.popoverHandlers);
}, Us = (e, t) => {
  const n = da(e);
  if (n == null)
    return;
  const a = [], r = Go(t);
  Object.entries(r).forEach(([s, i]) => {
    a.push(Gt(n, s, i));
  }), n.popoverHandlers = a;
}, Ko = {
  mounted(e, t) {
    const { value: n } = t;
    n && Us(e, n);
  },
  updated(e, t) {
    const { oldValue: n, value: a } = t, r = n == null ? void 0 : n.visibility, s = a == null ? void 0 : a.visibility;
    r !== s && (r && (Ws(e), s || Mn(n)), s && Us(e, a));
  },
  unmounted(e) {
    Ws(e);
  }
}, yw = (e, t, {
  maxSwipeTime: n,
  minHorizontalSwipeDistance: a,
  maxVerticalSwipeDistance: r
}) => {
  if (!e || !e.addEventListener || !p0(t))
    return null;
  let s = 0, i = 0, l = null, u = !1;
  function c(f) {
    const v = f.changedTouches[0];
    s = v.screenX, i = v.screenY, l = (/* @__PURE__ */ new Date()).getTime(), u = !0;
  }
  function d(f) {
    if (!u || !l)
      return;
    u = !1;
    const v = f.changedTouches[0], p = v.screenX - s, y = v.screenY - i;
    if ((/* @__PURE__ */ new Date()).getTime() - l < n && Math.abs(p) >= a && Math.abs(y) <= r) {
      const _ = { toLeft: !1, toRight: !1 };
      p < 0 ? _.toLeft = !0 : _.toRight = !0, t(_);
    }
  }
  return Gt(e, "touchstart", c, { passive: !0 }), Gt(e, "touchend", d, { passive: !0 }), () => {
    qt(e, "touchstart", c), qt(e, "touchend", d);
  };
}, ta = {}, bw = (e, t = 10) => {
  ta[e] = Date.now() + t;
}, _w = (e, t) => {
  if (e in ta) {
    const n = ta[e];
    if (Date.now() < n)
      return;
    delete ta[e];
  }
  t();
};
function Zo() {
  return typeof window < "u";
}
function ww(e) {
  return Zo() && e in window;
}
function $w(e) {
  const t = pe(!1), n = $(() => t.value ? "dark" : "light");
  let a, r;
  function s(p) {
    t.value = p.matches;
  }
  function i() {
    ww("matchMedia") && (a = window.matchMedia("(prefers-color-scheme: dark)"), a.addEventListener("change", s), t.value = a.matches);
  }
  function l() {
    const { selector: p = ":root", darkClass: y = "dark" } = e.value, w = document.querySelector(p);
    t.value = w.classList.contains(y);
  }
  function u(p) {
    const { selector: y = ":root", darkClass: w = "dark" } = p;
    if (Zo() && y && w) {
      const _ = document.querySelector(y);
      _ && (r = new MutationObserver(l), r.observe(_, {
        attributes: !0,
        attributeFilter: ["class"]
      }), t.value = _.classList.contains(w));
    }
  }
  function c() {
    f();
    const p = typeof e.value;
    p === "string" && e.value.toLowerCase() === "system" ? i() : p === "object" ? u(e.value) : t.value = !!e.value;
  }
  const d = Ie(() => e.value, () => c(), {
    immediate: !0
  });
  function f() {
    a && (a.removeEventListener("change", s), a = void 0), r && (r.disconnect(), r = void 0);
  }
  function v() {
    f(), d();
  }
  return Sa(() => v()), {
    isDark: t,
    displayMode: n,
    cleanup: v
  };
}
const Cw = ["base", "start", "end", "startEnd"], xw = [
  "class",
  "wrapperClass",
  "contentClass",
  "style",
  "contentStyle",
  "color",
  "fillMode"
], Sw = { base: {}, start: {}, end: {} };
function y1(e, t, n = Sw) {
  let a = e, r = {};
  t === !0 || _t(t) ? (a = _t(t) ? t : a, r = { ...n }) : Et(t) && (Ms(t, Cw) ? r = { ...t } : r = {
    base: { ...t },
    start: { ...t },
    end: { ...t }
  });
  const s = B0(
    r,
    { start: r.startEnd, end: r.startEnd },
    n
  );
  return Object.entries(s).forEach(([i, l]) => {
    let u = a;
    l === !0 || _t(l) ? (u = _t(l) ? l : u, s[i] = { color: u }) : Et(l) && (Ms(l, xw) ? s[i] = { ...l } : s[i] = {}), B0(s[i], { color: u });
  }), s;
}
class Mw {
  constructor() {
    q(this, "type", "highlight");
  }
  normalizeConfig(t, n) {
    return y1(t, n, {
      base: { fillMode: "light" },
      start: { fillMode: "solid" },
      end: { fillMode: "solid" }
    });
  }
  prepareRender(t) {
    t.highlights = [], t.content || (t.content = []);
  }
  render({ data: t, onStart: n, onEnd: a }, r) {
    const { key: s, highlight: i } = t;
    if (!i)
      return;
    const { highlights: l } = r, { base: u, start: c, end: d } = i;
    n && a ? l.push({
      ...c,
      key: s,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${c.color}`,
      class: [`vc-highlight vc-highlight-bg-${c.fillMode}`, c.class],
      contentClass: [
        `vc-attr vc-highlight-content-${c.fillMode} vc-${c.color}`,
        c.contentClass
      ]
    }) : n ? (l.push({
      ...u,
      key: `${s}-base`,
      wrapperClass: `vc-day-layer vc-day-box-right-center vc-attr vc-${u.color}`,
      class: [
        `vc-highlight vc-highlight-base-start vc-highlight-bg-${u.fillMode}`,
        u.class
      ]
    }), l.push({
      ...c,
      key: s,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${c.color}`,
      class: [`vc-highlight vc-highlight-bg-${c.fillMode}`, c.class],
      contentClass: [
        `vc-attr vc-highlight-content-${c.fillMode} vc-${c.color}`,
        c.contentClass
      ]
    })) : a ? (l.push({
      ...u,
      key: `${s}-base`,
      wrapperClass: `vc-day-layer vc-day-box-left-center vc-attr vc-${u.color}`,
      class: [
        `vc-highlight vc-highlight-base-end vc-highlight-bg-${u.fillMode}`,
        u.class
      ]
    }), l.push({
      ...d,
      key: s,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${d.color}`,
      class: [`vc-highlight vc-highlight-bg-${d.fillMode}`, d.class],
      contentClass: [
        `vc-attr vc-highlight-content-${d.fillMode} vc-${d.color}`,
        d.contentClass
      ]
    })) : l.push({
      ...u,
      key: `${s}-middle`,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${u.color}`,
      class: [
        `vc-highlight vc-highlight-base-middle vc-highlight-bg-${u.fillMode}`,
        u.class
      ],
      contentClass: [
        `vc-attr vc-highlight-content-${u.fillMode} vc-${u.color}`,
        u.contentClass
      ]
    });
  }
}
class b1 {
  constructor(t, n) {
    q(this, "type", ""), q(this, "collectionType", ""), this.type = t, this.collectionType = n;
  }
  normalizeConfig(t, n) {
    return y1(t, n);
  }
  prepareRender(t) {
    t[this.collectionType] = [];
  }
  render({ data: t, onStart: n, onEnd: a }, r) {
    const { key: s } = t, i = t[this.type];
    if (!s || !i)
      return;
    const l = r[this.collectionType], { base: u, start: c, end: d } = i;
    n ? l.push({
      ...c,
      key: s,
      class: [
        `vc-${this.type} vc-${this.type}-start vc-${c.color} vc-attr`,
        c.class
      ]
    }) : a ? l.push({
      ...d,
      key: s,
      class: [
        `vc-${this.type} vc-${this.type}-end vc-${d.color} vc-attr`,
        d.class
      ]
    }) : l.push({
      ...u,
      key: s,
      class: [
        `vc-${this.type} vc-${this.type}-base vc-${u.color} vc-attr`,
        u.class
      ]
    });
  }
}
class Dw extends b1 {
  constructor() {
    super("content", "content");
  }
  normalizeConfig(t, n) {
    return y1("base", n);
  }
}
class kw extends b1 {
  constructor() {
    super("dot", "dots");
  }
}
class Lw extends b1 {
  constructor() {
    super("bar", "bars");
  }
}
class Ow {
  constructor(t) {
    q(this, "color"), q(this, "renderers", [
      new Dw(),
      new Mw(),
      new kw(),
      new Lw()
    ]), this.color = t;
  }
  normalizeGlyphs(t) {
    this.renderers.forEach((n) => {
      const a = n.type;
      t[a] != null && (t[a] = n.normalizeConfig(this.color, t[a]));
    });
  }
  prepareRender(t = {}) {
    return this.renderers.forEach((n) => {
      n.prepareRender(t);
    }), t;
  }
  render(t, n) {
    this.renderers.forEach((a) => {
      a.render(t, n);
    });
  }
}
const Xo = Symbol("__vc_base_context__"), Jo = {
  color: {
    type: String,
    default: () => Jt("color")
  },
  isDark: {
    type: [Boolean, String, Object],
    default: () => Jt("isDark")
  },
  firstDayOfWeek: Number,
  masks: Object,
  locale: [String, Object],
  timezone: String,
  minDate: null,
  maxDate: null,
  disabledDates: null
};
function Qo(e) {
  const t = $(() => e.color ?? ""), n = $(() => e.isDark ?? !1), { displayMode: a } = $w(n), r = $(() => new Ow(t.value)), s = $(() => {
    if (e.locale instanceof ga)
      return e.locale;
    const v = Et(e.locale) ? e.locale : {
      id: e.locale,
      firstDayOfWeek: e.firstDayOfWeek,
      masks: e.masks
    };
    return new ga(v, e.timezone);
  }), i = $(() => s.value.masks), l = $(() => e.minDate), u = $(() => e.maxDate), c = $(() => {
    const v = e.disabledDates ? [...e.disabledDates] : [];
    return l.value != null && v.push({
      start: null,
      end: Re(s.value.toDate(l.value), -1)
    }), u.value != null && v.push({
      start: Re(s.value.toDate(u.value), 1),
      end: null
    }), s.value.ranges(v);
  }), d = $(() => new Uo(
    {
      key: "disabled",
      dates: c.value,
      order: 100
    },
    r.value,
    s.value
  )), f = {
    color: t,
    isDark: n,
    displayMode: a,
    theme: r,
    locale: s,
    masks: i,
    minDate: l,
    maxDate: u,
    disabledDates: c,
    disabledAttribute: d
  };
  return On(Xo, f), f;
}
function Iw(e) {
  return Ln(Xo, () => Qo(e), !0);
}
function el(e) {
  return `__vc_slot_${e}__`;
}
function tl(e, t = {}) {
  Object.keys(e).forEach((n) => {
    On(el(t[n] ?? n), e[n]);
  });
}
function nl(e) {
  return Ln(el(e), null);
}
const Ew = {
  ...Jo,
  view: {
    type: String,
    default: "monthly",
    validator(e) {
      return ["daily", "weekly", "monthly"].includes(e);
    }
  },
  rows: {
    type: Number,
    default: 1
  },
  columns: {
    type: Number,
    default: 1
  },
  step: Number,
  titlePosition: {
    type: String,
    default: () => Jt("titlePosition")
  },
  navVisibility: {
    type: String,
    default: () => Jt("navVisibility")
  },
  showWeeknumbers: [Boolean, String],
  showIsoWeeknumbers: [Boolean, String],
  expanded: Boolean,
  borderless: Boolean,
  transparent: Boolean,
  initialPage: Object,
  initialPagePosition: { type: Number, default: 1 },
  minPage: Object,
  maxPage: Object,
  transition: String,
  attributes: Array,
  trimWeeks: Boolean,
  disablePageSwipe: Boolean
}, Tw = [
  "dayclick",
  "daymouseenter",
  "daymouseleave",
  "dayfocusin",
  "dayfocusout",
  "daykeydown",
  "weeknumberclick",
  "transition-start",
  "transition-end",
  "did-move",
  "update:view",
  "update:pages"
], al = Symbol("__vc_calendar_context__");
function Aw(e, { slots: t, emit: n }) {
  const a = pe(null), r = pe(null), s = pe((/* @__PURE__ */ new Date()).getDate()), i = pe(!1), l = pe(Symbol()), u = pe(Symbol()), c = pe(e.view), d = pe([]), f = pe("");
  let v = null, p = null;
  tl(t);
  const {
    theme: y,
    color: w,
    displayMode: _,
    locale: b,
    masks: N,
    minDate: E,
    maxDate: L,
    disabledAttribute: A,
    disabledDates: D
  } = Iw(e), I = $(() => e.rows * e.columns), F = $(() => e.step || I.value), U = $(() => So(d.value) ?? null), X = $(() => O0(d.value) ?? null), Q = $(
    () => e.minPage || (E.value ? K(E.value) : null)
  ), R = $(
    () => e.maxPage || (L.value ? K(L.value) : null)
  ), G = $(() => e.navVisibility), re = $(() => !!e.showWeeknumbers), W = $(() => !!e.showIsoWeeknumbers), ne = $(() => c.value === "monthly"), oe = $(() => c.value === "weekly"), Ce = $(() => c.value === "daily"), ve = () => {
    i.value = !0, n("transition-start");
  }, O = () => {
    i.value = !1, n("transition-end"), v && (v.resolve(!0), v = null);
  }, le = (M, m, x = c.value) => Eo(M, m, x, b.value), K = (M) => Io(M, c.value, b.value), Se = (M) => {
    !A.value || !Ke.value || (M.isDisabled = Ke.value.cellExists(
      A.value.key,
      M.dayIndex
    ));
  }, de = (M) => {
    M.isFocusable = M.inMonth && M.day === s.value;
  }, Me = (M, m) => {
    for (const x of M)
      for (const V of x.days)
        if (m(V) === !1)
          return;
  }, Te = $(
    () => d.value.reduce((M, m) => (M.push(...m.viewDays), M), [])
  ), De = $(() => {
    const M = [];
    return (e.attributes || []).forEach((m, x) => {
      !m || !m.dates || M.push(
        new Uo(
          {
            ...m,
            order: m.order || 0
          },
          y.value,
          b.value
        )
      );
    }), A.value && M.push(A.value), M;
  }), Ae = $(() => Lt(De.value)), Ke = $(() => {
    const M = new p_();
    return De.value.forEach((m) => {
      m.ranges.forEach((x) => {
        M.render(m, x, Te.value);
      });
    }), M;
  }), kt = $(() => Te.value.reduce((M, m) => (M[m.dayIndex] = { day: m, cells: [] }, M[m.dayIndex].cells.push(...Ke.value.getCells(m)), M), {})), ct = (M, m) => {
    const x = e.showWeeknumbers || e.showIsoWeeknumbers;
    return x == null ? "" : V9(x) ? x ? "left" : "" : x.startsWith("right") ? m > 1 ? "right" : x : M > 1 ? "left" : x;
  }, nt = () => {
    var M, m;
    if (!Ae.value)
      return null;
    const x = De.value.find((_e) => _e.pinPage) || De.value[0];
    if (!x || !x.hasRanges)
      return null;
    const [V] = x.ranges, ee = ((M = V.start) == null ? void 0 : M.date) || ((m = V.end) == null ? void 0 : m.date);
    return ee ? K(ee) : null;
  }, at = () => {
    if (wt(U.value))
      return U.value;
    const M = nt();
    return wt(M) ? M : K(/* @__PURE__ */ new Date());
  }, Vt = (M, m = {}) => {
    const { view: x = c.value, position: V = 1, force: ee } = m, _e = V > 0 ? 1 - V : -(I.value + V);
    let He = le(M, _e, x), Ze = le(He, I.value - 1, x);
    return ee || (xr(He, Q.value) ? He = Q.value : ma(Ze, R.value) && (He = le(R.value, 1 - I.value)), Ze = le(He, I.value - 1)), { fromPage: He, toPage: Ze };
  }, g0 = (M, m, x = "") => {
    if (x === "none" || x === "fade")
      return x;
    if ((M == null ? void 0 : M.view) !== (m == null ? void 0 : m.view))
      return "fade";
    const V = ma(m, M), ee = xr(m, M);
    return !V && !ee ? "fade" : x === "slide-v" ? ee ? "slide-down" : "slide-up" : ee ? "slide-right" : "slide-left";
  }, yt = (M = {}) => new Promise((m, x) => {
    const { position: V = 1, force: ee = !1, transition: _e } = M, He = wt(M.page) ? M.page : at(), { fromPage: Ze } = Vt(He, {
      position: V,
      force: ee
    }), b0 = [];
    for (let _0 = 0; _0 < I.value; _0++) {
      const Ra = le(Ze, _0), je = _0 + 1, Ba = Math.ceil(je / e.columns), Rn = e.rows - Ba + 1, nn = je % e.columns || e.columns, an = e.columns - nn + 1, Pl = ct(nn, an);
      b0.push(
        b.value.getPage({
          ...Ra,
          view: c.value,
          titlePosition: e.titlePosition,
          trimWeeks: e.trimWeeks,
          position: je,
          row: Ba,
          rowFromEnd: Rn,
          column: nn,
          columnFromEnd: an,
          showWeeknumbers: re.value,
          showIsoWeeknumbers: W.value,
          weeknumberPosition: Pl
        })
      );
    }
    f.value = g0(
      d.value[0],
      b0[0],
      _e
    ), d.value = b0, f.value && f.value !== "none" ? v = {
      resolve: m,
      reject: x
    } : m(!0);
  }), t0 = (M) => {
    const m = U.value ?? K(/* @__PURE__ */ new Date());
    return le(m, M);
  }, n0 = (M, m = {}) => {
    const x = wt(M) ? M : K(M);
    return Object.assign(
      m,
      Vt(x, {
        ...m,
        force: !0
      })
    ), d_(
      m.fromPage,
      m.toPage,
      c.value,
      b.value
    ).map((ee) => u_(ee, Q.value, R.value)).some((ee) => ee);
  }, a0 = (M, m = {}) => n0(t0(M), m), dt = $(() => a0(-F.value)), Ht = $(() => a0(F.value)), Nt = async (M, m = {}) => !m.force && !n0(M, m) ? !1 : (m.fromPage && !c_(m.fromPage, U.value) && (Mn({ id: l.value, hideDelay: 0 }), m.view && (bw("view", 10), c.value = m.view), await yt({
    ...m,
    page: m.fromPage,
    position: 1,
    force: !0
  }), n("did-move", d.value)), !0), Rt = (M, m = {}) => Nt(t0(M), m), Bt = () => Rt(-F.value), Ft = () => Rt(F.value), jt = (M) => {
    const m = ne.value ? ".in-month" : "", x = `.id-${b.value.getDayId(M)}${m}`, V = `${x}.vc-focusable, ${x} .vc-focusable`, ee = a.value;
    if (ee) {
      const _e = ee.querySelector(V);
      if (_e)
        return _e.focus(), !0;
    }
    return !1;
  }, r0 = async (M, m = {}) => jt(M) ? !0 : (await Nt(M, m), jt(M)), y0 = (M, m) => {
    s.value = M.day, n("dayclick", M, m);
  }, Va = (M, m) => {
    n("daymouseenter", M, m);
  }, tn = (M, m) => {
    n("daymouseleave", M, m);
  }, Ha = (M, m) => {
    s.value = M.day, r.value = M, M.isFocused = !0, n("dayfocusin", M, m);
  }, Yn = (M, m) => {
    r.value = null, M.isFocused = !1, n("dayfocusout", M, m);
  }, Vn = (M, m) => {
    n("daykeydown", M, m);
    const x = M.noonDate;
    let V = null;
    switch (m.key) {
      case "ArrowLeft": {
        V = Re(x, -1);
        break;
      }
      case "ArrowRight": {
        V = Re(x, 1);
        break;
      }
      case "ArrowUp": {
        V = Re(x, -7);
        break;
      }
      case "ArrowDown": {
        V = Re(x, 7);
        break;
      }
      case "Home": {
        V = Re(x, -M.weekdayPosition + 1);
        break;
      }
      case "End": {
        V = Re(x, M.weekdayPositionFromEnd);
        break;
      }
      case "PageUp": {
        m.altKey ? V = zs(x, -1) : V = va(x, -1);
        break;
      }
      case "PageDown": {
        m.altKey ? V = zs(x, 1) : V = va(x, 1);
        break;
      }
    }
    V && (m.preventDefault(), r0(V).catch());
  }, Na = (M) => {
    const m = r.value;
    m != null && Vn(m, M);
  }, Hn = (M, m) => {
    n("weeknumberclick", M, m);
  };
  yt({
    page: e.initialPage,
    position: e.initialPagePosition
  }), kn(() => {
    !e.disablePageSwipe && a.value && (p = yw(
      a.value,
      ({ toLeft: M = !1, toRight: m = !1 }) => {
        M ? Ft() : m && Bt();
      },
      Jt("touch")
    ));
  }), Sa(() => {
    d.value = [], p && p();
  }), Ie(
    () => b.value,
    () => {
      yt();
    }
  ), Ie(
    () => I.value,
    () => yt()
  ), Ie(
    () => e.view,
    () => c.value = e.view
  ), Ie(
    () => c.value,
    () => {
      _w("view", () => {
        yt();
      }), n("update:view", c.value);
    }
  ), Ie(
    () => s.value,
    () => {
      Me(d.value, (M) => de(M));
    }
  ), ui(() => {
    n("update:pages", d.value), Me(d.value, (M) => {
      Se(M), de(M);
    });
  });
  const Nn = {
    emit: n,
    containerRef: a,
    focusedDay: r,
    inTransition: i,
    navPopoverId: l,
    dayPopoverId: u,
    view: c,
    pages: d,
    transitionName: f,
    theme: y,
    color: w,
    displayMode: _,
    locale: b,
    masks: N,
    attributes: De,
    disabledAttribute: A,
    disabledDates: D,
    attributeContext: Ke,
    days: Te,
    dayCells: kt,
    count: I,
    step: F,
    firstPage: U,
    lastPage: X,
    canMovePrev: dt,
    canMoveNext: Ht,
    minPage: Q,
    maxPage: R,
    isMonthly: ne,
    isWeekly: oe,
    isDaily: Ce,
    navVisibility: G,
    showWeeknumbers: re,
    showIsoWeeknumbers: W,
    getDateAddress: K,
    canMove: n0,
    canMoveBy: a0,
    move: Nt,
    moveBy: Rt,
    movePrev: Bt,
    moveNext: Ft,
    onTransitionBeforeEnter: ve,
    onTransitionAfterEnter: O,
    tryFocusDate: jt,
    focusDate: r0,
    onKeydown: Na,
    onDayKeydown: Vn,
    onDayClick: y0,
    onDayMouseenter: Va,
    onDayMouseleave: tn,
    onDayFocusin: Ha,
    onDayFocusout: Yn,
    onWeeknumberClick: Hn
  };
  return On(al, Nn), Nn;
}
function m0() {
  const e = Ln(al);
  if (e)
    return e;
  throw new Error(
    "Calendar context missing. Please verify this component is nested within a valid context provider."
  );
}
const Pw = Ee({
  inheritAttrs: !1,
  emits: ["before-show", "after-show", "before-hide", "after-hide"],
  props: {
    id: { type: [Number, String, Symbol], required: !0 },
    showDelay: { type: Number, default: 0 },
    hideDelay: { type: Number, default: 110 },
    boundarySelector: { type: String }
  },
  setup(e, { emit: t }) {
    let n;
    const a = pe();
    let r = null, s = null;
    const i = W0({
      isVisible: !1,
      target: null,
      data: null,
      transition: "slide-fade",
      placement: "bottom",
      direction: "",
      positionFixed: !1,
      modifiers: [],
      isInteractive: !0,
      visibility: "click",
      isHovered: !1,
      isFocused: !1,
      autoHide: !1,
      force: !1
    });
    function l(O) {
      O && (i.direction = O.split("-")[0]);
    }
    function u({ placement: O, options: le }) {
      l(O || (le == null ? void 0 : le.placement));
    }
    const c = $(() => ({
      placement: i.placement,
      strategy: i.positionFixed ? "fixed" : "absolute",
      boundary: "",
      modifiers: [
        {
          name: "onUpdate",
          enabled: !0,
          phase: "afterWrite",
          fn: u
        },
        ...i.modifiers || []
      ],
      onFirstUpdate: u
    })), d = $(() => {
      const O = i.direction === "left" || i.direction === "right";
      let le = "";
      if (i.placement) {
        const K = i.placement.split("-");
        K.length > 1 && (le = K[1]);
      }
      return ["start", "top", "left"].includes(le) ? O ? "top" : "left" : ["end", "bottom", "right"].includes(le) ? O ? "bottom" : "right" : O ? "middle" : "center";
    });
    function f() {
      s && (s.destroy(), s = null);
    }
    function v() {
      L0(() => {
        const O = da(i.target);
        !O || !a.value || (s && s.state.elements.reference !== O && f(), s ? s.update() : s = k4(
          O,
          a.value,
          c.value
        ));
      });
    }
    function p(O) {
      Object.assign(i, Do(O, "force"));
    }
    function y(O, le) {
      clearTimeout(n), O > 0 ? n = setTimeout(le, O) : le();
    }
    function w(O) {
      return !O || !s ? !1 : da(O) === s.state.elements.reference;
    }
    async function _(O = {}) {
      i.force || (O.force && (i.force = !0), y(O.showDelay ?? e.showDelay, () => {
        i.isVisible && (i.force = !1), p({
          ...O,
          isVisible: !0
        }), v();
      }));
    }
    function b(O = {}) {
      s && (O.target && !w(O.target) || i.force || (O.force && (i.force = !0), y(O.hideDelay ?? e.hideDelay, () => {
        i.isVisible || (i.force = !1), i.isVisible = !1;
      })));
    }
    function N(O = {}) {
      O.target != null && (i.isVisible && w(O.target) ? b(O) : _(O));
    }
    function E(O) {
      if (!s)
        return;
      const le = s.state.elements.reference;
      if (!a.value || !le)
        return;
      const K = O.target;
      Jn(a.value, K) || Jn(le, K) || b({ force: !0 });
    }
    function L(O) {
      (O.key === "Esc" || O.key === "Escape") && b();
    }
    function A({ detail: O }) {
      !O.id || O.id !== e.id || _(O);
    }
    function D({ detail: O }) {
      !O.id || O.id !== e.id || b(O);
    }
    function I({ detail: O }) {
      !O.id || O.id !== e.id || N(O);
    }
    function F() {
      Gt(document, "keydown", L), Gt(document, "click", E), Gt(document, "show-popover", A), Gt(document, "hide-popover", D), Gt(document, "toggle-popover", I);
    }
    function U() {
      qt(document, "keydown", L), qt(document, "click", E), qt(document, "show-popover", A), qt(document, "hide-popover", D), qt(document, "toggle-popover", I);
    }
    function X(O) {
      t("before-show", O);
    }
    function Q(O) {
      i.force = !1, t("after-show", O);
    }
    function R(O) {
      t("before-hide", O);
    }
    function G(O) {
      i.force = !1, f(), t("after-hide", O);
    }
    function re(O) {
      O.stopPropagation();
    }
    function W() {
      i.isHovered = !0, i.isInteractive && ["hover", "hover-focus"].includes(i.visibility) && _();
    }
    function ne() {
      if (i.isHovered = !1, !s)
        return;
      const O = s.state.elements.reference;
      i.autoHide && !i.isFocused && (!O || O !== document.activeElement) && ["hover", "hover-focus"].includes(i.visibility) && b();
    }
    function oe() {
      i.isFocused = !0, i.isInteractive && ["focus", "hover-focus"].includes(i.visibility) && _();
    }
    function Ce(O) {
      ["focus", "hover-focus"].includes(i.visibility) && (!O.relatedTarget || !Jn(a.value, O.relatedTarget)) && (i.isFocused = !1, !i.isHovered && i.autoHide && b());
    }
    function ve() {
      r != null && (r.disconnect(), r = null);
    }
    return Ie(
      () => a.value,
      (O) => {
        ve(), O && (r = new ResizeObserver(() => {
          s && s.update();
        }), r.observe(O));
      }
    ), Ie(() => i.placement, l, {
      immediate: !0
    }), kn(() => {
      F();
    }), Sa(() => {
      f(), ve(), U();
    }), {
      ...li(i),
      popoverRef: a,
      alignment: d,
      hide: b,
      setupPopper: v,
      beforeEnter: X,
      afterEnter: Q,
      beforeLeave: R,
      afterLeave: G,
      onClick: re,
      onMouseOver: W,
      onMouseLeave: ne,
      onFocusIn: oe,
      onFocusOut: Ce
    };
  }
}), e0 = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, r] of t)
    n[a] = r;
  return n;
};
function zw(e, t, n, a, r, s) {
  return h(), g("div", {
    class: z(["vc-popover-content-wrapper", { "is-interactive": e.isInteractive }]),
    ref: "popoverRef",
    onClick: t[0] || (t[0] = (...i) => e.onClick && e.onClick(...i)),
    onMouseover: t[1] || (t[1] = (...i) => e.onMouseOver && e.onMouseOver(...i)),
    onMouseleave: t[2] || (t[2] = (...i) => e.onMouseLeave && e.onMouseLeave(...i)),
    onFocusin: t[3] || (t[3] = (...i) => e.onFocusIn && e.onFocusIn(...i)),
    onFocusout: t[4] || (t[4] = (...i) => e.onFocusOut && e.onFocusOut(...i))
  }, [
    k($n, {
      name: `vc-${e.transition}`,
      appear: "",
      onBeforeEnter: e.beforeEnter,
      onAfterEnter: e.afterEnter,
      onBeforeLeave: e.beforeLeave,
      onAfterLeave: e.afterLeave
    }, {
      default: P(() => [
        e.isVisible ? (h(), g("div", Xt({
          key: 0,
          tabindex: "-1",
          class: `vc-popover-content direction-${e.direction}`
        }, e.$attrs), [
          ae(e.$slots, "default", {
            direction: e.direction,
            alignment: e.alignment,
            data: e.data,
            hide: e.hide
          }, () => [
            me(j(e.data), 1)
          ]),
          o("span", {
            class: z([
              "vc-popover-caret",
              `direction-${e.direction}`,
              `align-${e.alignment}`
            ])
          }, null, 2)
        ], 16)) : B("", !0)
      ]),
      _: 3
    }, 8, ["name", "onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"])
  ], 34);
}
const Pa = /* @__PURE__ */ e0(Pw, [["render", zw]]), Yw = { class: "vc-day-popover-row" }, Vw = {
  key: 0,
  class: "vc-day-popover-row-indicator"
}, Hw = { class: "vc-day-popover-row-label" }, rl = /* @__PURE__ */ Ee({
  __name: "PopoverRow",
  props: {
    attribute: null
  },
  setup(e) {
    const t = e, n = $(() => {
      const { content: a, highlight: r, dot: s, bar: i, popover: l } = t.attribute;
      return l && l.hideIndicator ? null : a ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${a.base.color}`
      } : r ? {
        class: `vc-highlight-bg-solid vc-day-popover-row-highlight vc-attr vc-${r.base.color}`
      } : s ? {
        class: `vc-dot vc-attr vc-${s.base.color}`
      } : i ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${i.base.color}`
      } : null;
    });
    return (a, r) => (h(), g("div", Yw, [
      C(n) ? (h(), g("div", Vw, [
        o("span", {
          class: z(C(n).class)
        }, null, 2)
      ])) : B("", !0),
      o("div", Hw, [
        ae(a.$slots, "default", {}, () => [
          me(j(e.attribute.popover ? e.attribute.popover.label : "No content provided"), 1)
        ])
      ])
    ]));
  }
}), Nw = {
  inheritAttrs: !1
}, st = /* @__PURE__ */ Ee({
  ...Nw,
  __name: "CalendarSlot",
  props: {
    name: null
  },
  setup(e) {
    const n = nl(e.name);
    return (a, r) => C(n) ? (h(), H(ie(C(n)), pn(Xt({ key: 0 }, a.$attrs)), null, 16)) : ae(a.$slots, "default", { key: 1 });
  }
}), Rw = { class: "vc-day-popover-container" }, Bw = {
  key: 0,
  class: "vc-day-popover-header"
}, Fw = /* @__PURE__ */ Ee({
  __name: "CalendarDayPopover",
  setup(e) {
    const { dayPopoverId: t, displayMode: n, color: a, masks: r, locale: s } = m0();
    function i(u, c) {
      return s.value.formatDate(u, c);
    }
    function l(u) {
      return s.value.formatDate(u.date, r.value.dayPopover);
    }
    return (u, c) => (h(), H(Pa, {
      id: C(t),
      class: z([`vc-${C(a)}`, `vc-${C(n)}`])
    }, {
      default: P(({ data: { day: d, attributes: f }, hide: v }) => [
        k(st, {
          name: "day-popover",
          day: d,
          "day-title": l(d),
          attributes: f,
          format: i,
          masks: C(r),
          hide: v
        }, {
          default: P(() => [
            o("div", Rw, [
              C(r).dayPopover ? (h(), g("div", Bw, j(l(d)), 1)) : B("", !0),
              (h(!0), g(se, null, fe(f, (p) => (h(), H(rl, {
                key: p.key,
                attribute: p
              }, null, 8, ["attribute"]))), 128))
            ])
          ]),
          _: 2
        }, 1032, ["day", "day-title", "attributes", "masks", "hide"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), jw = {}, Ww = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, Uw = /* @__PURE__ */ o("polyline", { points: "9 18 15 12 9 6" }, null, -1), qw = [
  Uw
];
function Gw(e, t) {
  return h(), g("svg", Ww, qw);
}
const Kw = /* @__PURE__ */ e0(jw, [["render", Gw]]), Zw = {}, Xw = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, Jw = /* @__PURE__ */ o("polyline", { points: "15 18 9 12 15 6" }, null, -1), Qw = [
  Jw
];
function e$(e, t) {
  return h(), g("svg", Xw, Qw);
}
const t$ = /* @__PURE__ */ e0(Zw, [["render", e$]]), n$ = {}, a$ = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, r$ = /* @__PURE__ */ o("polyline", { points: "6 9 12 15 18 9" }, null, -1), s$ = [
  r$
];
function i$(e, t) {
  return h(), g("svg", a$, s$);
}
const o$ = /* @__PURE__ */ e0(n$, [["render", i$]]), l$ = {}, u$ = {
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}, c$ = /* @__PURE__ */ o("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" }, null, -1), d$ = [
  c$
];
function f$(e, t) {
  return h(), g("svg", u$, d$);
}
const h$ = /* @__PURE__ */ e0(l$, [["render", f$]]), p$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconChevronDown: o$,
  IconChevronLeft: t$,
  IconChevronRight: Kw,
  IconClock: h$
}, Symbol.toStringTag, { value: "Module" })), F0 = /* @__PURE__ */ Ee({
  __name: "BaseIcon",
  props: {
    name: { type: String, required: !0 },
    width: { type: String },
    height: { type: String },
    size: { type: String, default: "26" },
    viewBox: { type: String }
  },
  setup(e) {
    const t = e, n = $(() => t.width || t.size), a = $(() => t.height || t.size), r = $(() => p$[`Icon${t.name}`]);
    return (s, i) => (h(), H(ie(C(r)), {
      width: C(n),
      height: C(a),
      class: "vc-base-icon"
    }, null, 8, ["width", "height"]));
  }
}), v$ = ["disabled"], m$ = {
  key: 1,
  class: "vc-title-wrapper"
}, g$ = {
  type: "button",
  class: "vc-title"
}, y$ = ["disabled"], sl = /* @__PURE__ */ Ee({
  __name: "CalendarHeader",
  props: {
    page: null,
    layout: null,
    isLg: { type: Boolean },
    isXl: { type: Boolean },
    is2xl: { type: Boolean },
    hideTitle: { type: Boolean },
    hideArrows: { type: Boolean }
  },
  setup(e) {
    const t = e, {
      navPopoverId: n,
      navVisibility: a,
      canMovePrev: r,
      movePrev: s,
      canMoveNext: i,
      moveNext: l
    } = m0(), u = $(() => {
      switch (t.page.titlePosition) {
        case "left":
          return "bottom-start";
        case "right":
          return "bottom-end";
        default:
          return "bottom";
      }
    }), c = $(() => {
      const { page: w } = t;
      return {
        id: n.value,
        visibility: a.value,
        placement: u.value,
        modifiers: [{ name: "flip", options: { fallbackPlacements: ["bottom"] } }],
        data: { page: w },
        isInteractive: !0
      };
    }), d = $(() => t.page.titlePosition.includes("left")), f = $(() => t.page.titlePosition.includes("right")), v = $(() => t.layout ? t.layout : d.value ? "tu-pn" : f.value ? "pn-tu" : "p-tu-n;"), p = $(() => ({
      prev: v.value.includes("p") && !t.hideArrows,
      title: v.value.includes("t") && !t.hideTitle,
      next: v.value.includes("n") && !t.hideArrows
    })), y = $(() => ({ gridTemplateColumns: v.value.split("").map((_) => {
      switch (_) {
        case "p":
          return "[prev] auto";
        case "n":
          return "[next] auto";
        case "t":
          return "[title] auto";
        case "-":
          return "1fr";
        default:
          return "";
      }
    }).join(" ") }));
    return (w, _) => (h(), g("div", {
      class: z(["vc-header", { "is-lg": e.isLg, "is-xl": e.isXl, "is-2xl": e.is2xl }]),
      style: Fe(C(y))
    }, [
      C(p).prev ? (h(), g("button", {
        key: 0,
        type: "button",
        class: "vc-arrow vc-prev vc-focus",
        disabled: !C(r),
        onClick: _[0] || (_[0] = //@ts-ignore
        (...b) => C(s) && C(s)(...b)),
        onKeydown: _[1] || (_[1] = Oe(
          //@ts-ignore
          (...b) => C(s) && C(s)(...b),
          ["space", "enter"]
        ))
      }, [
        k(st, {
          name: "header-prev-button",
          disabled: !C(r)
        }, {
          default: P(() => [
            k(F0, {
              name: "ChevronLeft",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, v$)) : B("", !0),
      C(p).title ? (h(), g("div", m$, [
        k(st, { name: "header-title-wrapper" }, {
          default: P(() => [
            ht((h(), g("button", g$, [
              k(st, {
                name: "header-title",
                title: e.page.title
              }, {
                default: P(() => [
                  o("span", null, j(e.page.title), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ])), [
              [C(Ko), C(c)]
            ])
          ]),
          _: 1
        })
      ])) : B("", !0),
      C(p).next ? (h(), g("button", {
        key: 2,
        type: "button",
        class: "vc-arrow vc-next vc-focus",
        disabled: !C(i),
        onClick: _[2] || (_[2] = //@ts-ignore
        (...b) => C(l) && C(l)(...b)),
        onKeydown: _[3] || (_[3] = Oe(
          //@ts-ignore
          (...b) => C(l) && C(l)(...b),
          ["space", "enter"]
        ))
      }, [
        k(st, {
          name: "header-next-button",
          disabled: !C(i)
        }, {
          default: P(() => [
            k(F0, {
              name: "ChevronRight",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, y$)) : B("", !0)
    ], 6));
  }
}), il = Symbol("__vc_page_context__");
function b$(e) {
  const { locale: t, getDateAddress: n, canMove: a } = m0();
  function r(l, u) {
    const { month: c, year: d } = n(/* @__PURE__ */ new Date());
    return Wo().map((f, v) => {
      const p = v + 1;
      return {
        month: p,
        year: l,
        id: l_(p, l),
        label: t.value.formatDate(f, u),
        ariaLabel: t.value.formatDate(f, "MMMM"),
        isActive: p === e.value.month && l === e.value.year,
        isCurrent: p === c && l === d,
        isDisabled: !a(
          { month: p, year: l },
          { position: e.value.position }
        )
      };
    });
  }
  function s(l, u) {
    const { year: c } = n(/* @__PURE__ */ new Date()), { position: d } = e.value, f = [];
    for (let v = l; v <= u; v += 1) {
      const p = [...Array(12).keys()].some(
        (y) => a({ month: y + 1, year: v }, { position: d })
      );
      f.push({
        year: v,
        id: v.toString(),
        label: v.toString(),
        ariaLabel: v.toString(),
        isActive: v === e.value.year,
        isCurrent: v === c,
        isDisabled: !p
      });
    }
    return f;
  }
  const i = { page: e, getMonthItems: r, getYearItems: s };
  return On(il, i), i;
}
function ol() {
  const e = Ln(il);
  if (e)
    return e;
  throw new Error(
    "Page context missing. Please verify this component is nested within a valid context provider."
  );
}
const _$ = { class: "vc-nav-header" }, w$ = ["disabled"], $$ = ["disabled"], C$ = { class: "vc-nav-items" }, x$ = ["data-id", "aria-label", "disabled", "onClick", "onKeydown"], S$ = /* @__PURE__ */ Ee({
  __name: "CalendarNav",
  setup(e) {
    const { masks: t, move: n } = m0(), { page: a, getMonthItems: r, getYearItems: s } = ol(), i = pe(!0), l = 12, u = pe(a.value.year), c = pe(v(a.value.year)), d = pe(null);
    function f() {
      setTimeout(() => {
        if (d.value == null)
          return;
        const K = d.value.querySelector(
          ".vc-nav-item:not(:disabled)"
        );
        K && K.focus();
      }, 10);
    }
    function v(K) {
      return Math.floor(K / l);
    }
    function p() {
      i.value = !i.value;
    }
    function y(K) {
      return K * l;
    }
    function w(K) {
      return l * (K + 1) - 1;
    }
    function _() {
      oe.value && (i.value && N(), L());
    }
    function b() {
      Ce.value && (i.value && E(), A());
    }
    function N() {
      u.value--;
    }
    function E() {
      u.value++;
    }
    function L() {
      c.value--;
    }
    function A() {
      c.value++;
    }
    const D = $(
      () => r(u.value, t.value.navMonths).map((K) => ({
        ...K,
        click: () => n(
          { month: K.month, year: K.year },
          { position: a.value.position }
        )
      }))
    ), I = $(
      () => r(u.value - 1, t.value.navMonths)
    ), F = $(
      () => I.value.some((K) => !K.isDisabled)
    ), U = $(
      () => r(u.value + 1, t.value.navMonths)
    ), X = $(
      () => U.value.some((K) => !K.isDisabled)
    ), Q = $(
      () => s(
        y(c.value),
        w(c.value)
      ).map((K) => ({
        ...K,
        click: () => {
          u.value = K.year, i.value = !0, f();
        }
      }))
    ), R = $(
      () => s(
        y(c.value - 1),
        w(c.value - 1)
      )
    ), G = $(
      () => R.value.some((K) => !K.isDisabled)
    ), re = $(
      () => s(
        y(c.value + 1),
        w(c.value + 1)
      )
    ), W = $(
      () => re.value.some((K) => !K.isDisabled)
    ), ne = $(
      () => i.value ? D.value : Q.value
    ), oe = $(
      () => i.value ? F.value : G.value
    ), Ce = $(
      () => i.value ? X.value : W.value
    ), ve = $(() => So(Q.value.map((K) => K.year))), O = $(() => O0(Q.value.map((K) => K.year))), le = $(() => i.value ? u.value : `${ve.value} - ${O.value}`);
    return ui(() => {
      u.value = a.value.year, f();
    }), Ie(
      () => u.value,
      (K) => c.value = v(K)
    ), kn(() => f()), (K, Se) => (h(), g("div", {
      class: "vc-nav-container",
      ref_key: "navContainer",
      ref: d
    }, [
      o("div", _$, [
        o("button", {
          type: "button",
          class: "vc-nav-arrow is-left vc-focus",
          disabled: !C(oe),
          onClick: _,
          onKeydown: Se[0] || (Se[0] = (de) => C(Wn)(de, _))
        }, [
          k(st, {
            name: "nav-prev-button",
            move: _,
            disabled: !C(oe)
          }, {
            default: P(() => [
              k(F0, {
                name: "ChevronLeft",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, w$),
        o("button", {
          type: "button",
          class: "vc-nav-title vc-focus",
          onClick: p,
          onKeydown: Se[1] || (Se[1] = (de) => C(Wn)(de, p))
        }, j(C(le)), 33),
        o("button", {
          type: "button",
          class: "vc-nav-arrow is-right vc-focus",
          disabled: !C(Ce),
          onClick: b,
          onKeydown: Se[2] || (Se[2] = (de) => C(Wn)(de, b))
        }, [
          k(st, {
            name: "nav-next-button",
            move: b,
            disabled: !C(Ce)
          }, {
            default: P(() => [
              k(F0, {
                name: "ChevronRight",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, $$)
      ]),
      o("div", C$, [
        (h(!0), g(se, null, fe(C(ne), (de) => (h(), g("button", {
          key: de.label,
          type: "button",
          "data-id": de.id,
          "aria-label": de.ariaLabel,
          class: z(["vc-nav-item vc-focus", [
            de.isActive ? "is-active" : de.isCurrent ? "is-current" : ""
          ]]),
          disabled: de.isDisabled,
          onClick: de.click,
          onKeydown: (Me) => C(Wn)(Me, de.click)
        }, j(de.label), 43, x$))), 128))
      ])
    ], 512));
  }
}), ll = /* @__PURE__ */ Ee({
  __name: "CalendarPageProvider",
  props: {
    page: null
  },
  setup(e) {
    return b$(Zn(e, "page")), (n, a) => ae(n.$slots, "default");
  }
}), M$ = /* @__PURE__ */ Ee({
  __name: "CalendarNavPopover",
  setup(e) {
    const { navPopoverId: t, color: n, displayMode: a } = m0();
    return (r, s) => (h(), H(Pa, {
      id: C(t),
      class: z(["vc-nav-popover-container", `vc-${C(n)}`, `vc-${C(a)}`])
    }, {
      default: P(({ data: i }) => [
        k(ll, {
          page: i.page
        }, {
          default: P(() => [
            k(st, { name: "nav" }, {
              default: P(() => [
                k(S$)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["page"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), D$ = Ee({
  directives: { popover: Ko },
  components: { CalendarSlot: st },
  props: {
    day: { type: Object, required: !0 }
  },
  setup(e) {
    const {
      locale: t,
      theme: n,
      attributeContext: a,
      dayPopoverId: r,
      onDayClick: s,
      onDayMouseenter: i,
      onDayMouseleave: l,
      onDayFocusin: u,
      onDayFocusout: c,
      onDayKeydown: d
    } = m0(), f = $(() => e.day), v = $(() => a.value.getCells(f.value)), p = $(
      () => v.value.map((W) => W.data)
    ), y = $(() => ({
      ...f.value,
      attributes: p.value,
      attributeCells: v.value
    }));
    function w({ data: W }, { popovers: ne }) {
      const { key: oe, customData: Ce, popover: ve } = W;
      if (!ve)
        return;
      const O = ys(
        {
          key: oe,
          customData: Ce,
          attribute: W
        },
        { ...ve },
        {
          visibility: ve.label ? "hover" : "click",
          placement: "bottom",
          isInteractive: !ve.label
        }
      );
      ne.splice(0, 0, O);
    }
    const _ = $(() => {
      const W = {
        ...n.value.prepareRender({}),
        popovers: []
      };
      return v.value.forEach((ne) => {
        n.value.render(ne, W), w(ne, W);
      }), W;
    }), b = $(() => _.value.highlights), N = $(() => !!Lt(b.value)), E = $(() => _.value.content), L = $(() => _.value.dots), A = $(() => !!Lt(L.value)), D = $(() => _.value.bars), I = $(() => !!Lt(D.value)), F = $(() => _.value.popovers), U = $(
      () => F.value.map((W) => W.attribute)
    ), X = nl("day-content"), Q = $(() => [
      "vc-day",
      ...f.value.classes,
      { "vc-day-box-center-center": !X },
      { "is-not-in-month": !e.day.inMonth }
    ]), R = $(() => {
      let W;
      f.value.isFocusable ? W = "0" : W = "-1";
      const ne = [
        "vc-day-content vc-focusable vc-focus vc-attr",
        { "vc-disabled": f.value.isDisabled },
        u0(O0(b.value), "contentClass"),
        u0(O0(E.value), "class") || ""
      ], oe = {
        ...u0(O0(b.value), "contentStyle"),
        ...u0(O0(E.value), "style")
      };
      return {
        class: ne,
        style: oe,
        tabindex: W,
        "aria-label": f.value.ariaLabel,
        "aria-disabled": !!f.value.isDisabled,
        role: "button"
      };
    }), G = $(() => ({
      click(W) {
        s(y.value, W);
      },
      mouseenter(W) {
        i(y.value, W);
      },
      mouseleave(W) {
        l(y.value, W);
      },
      focusin(W) {
        u(y.value, W);
      },
      focusout(W) {
        c(y.value, W);
      },
      keydown(W) {
        d(y.value, W);
      }
    })), re = $(() => Lt(F.value) ? ys(
      {
        id: r.value,
        data: { day: f, attributes: U.value }
      },
      ...F.value
    ) : null);
    return {
      attributes: p,
      attributeCells: v,
      bars: D,
      dayClasses: Q,
      dayContentProps: R,
      dayContentEvents: G,
      dayPopover: re,
      glyphs: _,
      dots: L,
      hasDots: A,
      hasBars: I,
      highlights: b,
      hasHighlights: N,
      locale: t,
      popovers: F
    };
  }
}), k$ = {
  key: 0,
  class: "vc-highlights vc-day-layer"
}, L$ = {
  key: 1,
  class: "vc-day-layer vc-day-box-center-bottom"
}, O$ = { class: "vc-dots" }, I$ = {
  key: 2,
  class: "vc-day-layer vc-day-box-center-bottom"
}, E$ = { class: "vc-bars" };
function T$(e, t, n, a, r, s) {
  const i = Y("CalendarSlot"), l = Tr("popover");
  return h(), g("div", {
    class: z(e.dayClasses)
  }, [
    e.hasHighlights ? (h(), g("div", k$, [
      (h(!0), g(se, null, fe(e.highlights, ({ key: u, wrapperClass: c, class: d, style: f }) => (h(), g("div", {
        key: u,
        class: z(c)
      }, [
        o("div", {
          class: z(d),
          style: Fe(f)
        }, null, 6)
      ], 2))), 128))
    ])) : B("", !0),
    k(i, {
      name: "day-content",
      day: e.day,
      attributes: e.attributes,
      "attribute-cells": e.attributeCells,
      dayProps: e.dayContentProps,
      dayEvents: e.dayContentEvents,
      locale: e.locale
    }, {
      default: P(() => [
        ht((h(), g("div", Xt(e.dayContentProps, hr(e.dayContentEvents, !0)), [
          me(j(e.day.label), 1)
        ], 16)), [
          [l, e.dayPopover]
        ])
      ]),
      _: 1
    }, 8, ["day", "attributes", "attribute-cells", "dayProps", "dayEvents", "locale"]),
    e.hasDots ? (h(), g("div", L$, [
      o("div", O$, [
        (h(!0), g(se, null, fe(e.dots, ({ key: u, class: c, style: d }) => (h(), g("span", {
          key: u,
          class: z(c),
          style: Fe(d)
        }, null, 6))), 128))
      ])
    ])) : B("", !0),
    e.hasBars ? (h(), g("div", I$, [
      o("div", E$, [
        (h(!0), g(se, null, fe(e.bars, ({ key: u, class: c, style: d }) => (h(), g("span", {
          key: u,
          class: z(c),
          style: Fe(d)
        }, null, 6))), 128))
      ])
    ])) : B("", !0)
  ], 2);
}
const A$ = /* @__PURE__ */ e0(D$, [["render", T$]]), P$ = { class: "vc-weekdays" }, z$ = ["onClick"], Y$ = {
  inheritAttrs: !1
}, V$ = /* @__PURE__ */ Ee({
  ...Y$,
  __name: "CalendarPage",
  setup(e) {
    const { page: t } = ol(), { onWeeknumberClick: n } = m0();
    return (a, r) => (h(), g("div", {
      class: z([
        "vc-pane",
        `row-${C(t).row}`,
        `row-from-end-${C(t).rowFromEnd}`,
        `column-${C(t).column}`,
        `column-from-end-${C(t).columnFromEnd}`
      ]),
      ref: "pane"
    }, [
      k(sl, {
        page: C(t),
        "is-lg": "",
        "hide-arrows": ""
      }, null, 8, ["page"]),
      o("div", {
        class: z(["vc-weeks", {
          [`vc-show-weeknumbers-${C(t).weeknumberPosition}`]: C(t).weeknumberPosition
        }])
      }, [
        o("div", P$, [
          (h(!0), g(se, null, fe(C(t).weekdays, ({ weekday: s, label: i }, l) => (h(), g("div", {
            key: l,
            class: z(`vc-weekday vc-weekday-${s}`)
          }, j(i), 3))), 128))
        ]),
        (h(!0), g(se, null, fe(C(t).viewWeeks, (s) => (h(), g("div", {
          key: `weeknumber-${s.weeknumber}`,
          class: "vc-week"
        }, [
          C(t).weeknumberPosition ? (h(), g("div", {
            key: 0,
            class: z(["vc-weeknumber", `is-${C(t).weeknumberPosition}`])
          }, [
            o("span", {
              class: z(["vc-weeknumber-content"]),
              onClick: (i) => C(n)(s, i)
            }, j(s.weeknumberDisplay), 9, z$)
          ], 2)) : B("", !0),
          (h(!0), g(se, null, fe(s.days, (i) => (h(), H(A$, {
            key: i.id,
            day: i
          }, null, 8, ["day"]))), 128))
        ]))), 128))
      ], 2)
    ], 2));
  }
}), H$ = Ee({
  components: {
    CalendarHeader: sl,
    CalendarPage: V$,
    CalendarNavPopover: M$,
    CalendarDayPopover: Fw,
    CalendarPageProvider: ll,
    CalendarSlot: st
  },
  props: Ew,
  emit: Tw,
  setup(e, { emit: t, slots: n }) {
    return Aw(e, { emit: t, slots: n });
  }
}), N$ = { class: "vc-pane-header-wrapper" };
function R$(e, t, n, a, r, s) {
  const i = Y("CalendarHeader"), l = Y("CalendarPage"), u = Y("CalendarSlot"), c = Y("CalendarPageProvider"), d = Y("CalendarDayPopover"), f = Y("CalendarNavPopover");
  return h(), g(se, null, [
    o("div", Xt({ "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year" }, e.$attrs, {
      class: [
        "vc-container",
        `vc-${e.view}`,
        `vc-${e.color}`,
        `vc-${e.displayMode}`,
        {
          "vc-expanded": e.expanded,
          "vc-bordered": !e.borderless,
          "vc-transparent": e.transparent
        }
      ],
      onMouseup: t[0] || (t[0] = xe(() => {
      }, ["prevent"])),
      ref: "containerRef"
    }), [
      o("div", {
        class: z(["vc-pane-container", { "in-transition": e.inTransition }])
      }, [
        o("div", N$, [
          e.firstPage ? (h(), H(i, {
            key: 0,
            page: e.firstPage,
            "is-lg": "",
            "hide-title": ""
          }, null, 8, ["page"])) : B("", !0)
        ]),
        k($n, {
          name: `vc-${e.transitionName}`,
          onBeforeEnter: e.onTransitionBeforeEnter,
          onAfterEnter: e.onTransitionAfterEnter
        }, {
          default: P(() => [
            (h(), g("div", {
              key: e.pages[0].id,
              class: "vc-pane-layout",
              style: Fe({
                gridTemplateColumns: `repeat(${e.columns}, 1fr)`
              })
            }, [
              (h(!0), g(se, null, fe(e.pages, (v) => (h(), H(c, {
                key: v.id,
                page: v
              }, {
                default: P(() => [
                  k(u, {
                    name: "page",
                    page: v
                  }, {
                    default: P(() => [
                      k(l)
                    ]),
                    _: 2
                  }, 1032, ["page"])
                ]),
                _: 2
              }, 1032, ["page"]))), 128))
            ], 4))
          ]),
          _: 1
        }, 8, ["name", "onBeforeEnter", "onAfterEnter"]),
        k(u, { name: "footer" })
      ], 2)
    ], 16),
    k(d),
    k(f)
  ], 64);
}
const ul = /* @__PURE__ */ e0(H$, [["render", R$]]), cl = Symbol("__vc_date_picker_context__"), B$ = {
  ...Jo,
  mode: { type: String, default: "date" },
  modelValue: {
    type: [Number, String, Date, Object]
  },
  modelModifiers: {
    type: Object,
    default: () => ({})
  },
  rules: [String, Object],
  is24hr: Boolean,
  hideTimeHeader: Boolean,
  timeAccuracy: { type: Number, default: 2 },
  isRequired: Boolean,
  isRange: Boolean,
  updateOnInput: {
    type: Boolean,
    default: () => Jt("datePicker.updateOnInput")
  },
  inputDebounce: {
    type: Number,
    default: () => Jt("datePicker.inputDebounce")
  },
  popover: {
    type: [Boolean, Object],
    default: !0
  },
  dragAttribute: Object,
  selectAttribute: Object,
  attributes: [Object, Array]
}, F$ = [
  "update:modelValue",
  "drag",
  "dayclick",
  "daykeydown",
  "popover-will-show",
  "popover-did-show",
  "popover-will-hide",
  "popover-did-hide"
];
function j$(e, { emit: t, slots: n }) {
  tl(n, { footer: "dp-footer" });
  const a = Qo(e), { locale: r, masks: s, disabledAttribute: i } = a, l = pe(!1), u = pe(Symbol()), c = pe(null), d = pe(null), f = pe(["", ""]), v = pe(null), p = pe(null);
  let y, w, _ = !0;
  const b = $(() => e.isRange || e.modelModifiers.range === !0), N = $(
    () => b.value && c.value != null ? c.value.start : null
  ), E = $(
    () => b.value && c.value != null ? c.value.end : null
  ), L = $(() => e.mode.toLowerCase() === "date"), A = $(
    () => e.mode.toLowerCase() === "datetime"
  ), D = $(() => e.mode.toLowerCase() === "time"), I = $(() => !!d.value), F = $(() => {
    let m = "date";
    e.modelModifiers.number && (m = "number"), e.modelModifiers.string && (m = "string");
    const x = s.value.modelValue || "iso";
    return Se({ type: m, mask: x });
  }), U = $(
    () => a0(d.value ?? c.value)
  ), X = $(() => D.value ? e.is24hr ? s.value.inputTime24hr : s.value.inputTime : A.value ? e.is24hr ? s.value.inputDateTime24hr : s.value.inputDateTime : s.value.input), Q = $(() => /[Hh]/g.test(X.value)), R = $(
    () => /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(X.value)
  ), G = $(() => {
    if (Q.value && R.value)
      return "dateTime";
    if (R.value)
      return "date";
    if (Q.value)
      return "time";
  }), re = $(() => {
    var m;
    const x = ((m = v.value) == null ? void 0 : m.$el.previousElementSibling) ?? void 0;
    return B0({}, e.popover, Jt("datePicker.popover"), {
      target: x
    });
  }), W = $(
    () => Go({
      ...re.value,
      id: u.value
    })
  ), ne = $(() => b.value ? {
    start: f.value[0],
    end: f.value[1]
  } : f.value[0]), oe = $(() => {
    const m = ["start", "end"].map((x) => ({
      input: yt(x),
      change: t0(x),
      keyup: n0,
      ...e.popover && W.value
    }));
    return b.value ? {
      start: m[0],
      end: m[1]
    } : m[0];
  }), Ce = $(() => {
    if (!De(c.value))
      return null;
    const m = {
      key: "select-drag",
      ...e.selectAttribute,
      dates: c.value,
      pinPage: !0
    }, { dot: x, bar: V, highlight: ee, content: _e } = m;
    return !x && !V && !ee && !_e && (m.highlight = !0), m;
  }), ve = $(() => {
    if (!b.value || !De(d.value))
      return null;
    const m = {
      key: "select-drag",
      ...e.dragAttribute,
      dates: d.value
    }, { dot: x, bar: V, highlight: ee, content: _e } = m;
    return !x && !V && !ee && !_e && (m.highlight = {
      startEnd: {
        fillMode: "outline"
      }
    }), m;
  }), O = $(() => {
    const m = ot(e.attributes) ? [...e.attributes] : [];
    return ve.value ? m.unshift(ve.value) : Ce.value && m.unshift(Ce.value), m;
  }), le = $(() => Se(
    e.rules === "auto" ? K() : e.rules ?? {}
  ));
  function K() {
    const m = {
      ms: [0, 999],
      sec: [0, 59],
      min: [0, 59],
      hr: [0, 23]
    }, x = L.value ? 0 : e.timeAccuracy;
    return [0, 1].map((V) => {
      switch (x) {
        case 0:
          return {
            hours: m.hr[V],
            minutes: m.min[V],
            seconds: m.sec[V],
            milliseconds: m.ms[V]
          };
        case 1:
          return {
            minutes: m.min[V],
            seconds: m.sec[V],
            milliseconds: m.ms[V]
          };
        case 3:
          return { milliseconds: m.ms[V] };
        case 4:
          return {};
        default:
          return { seconds: m.sec[V], milliseconds: m.ms[V] };
      }
    });
  }
  function Se(m) {
    return ot(m) ? m.length === 1 ? [m[0], m[0]] : m : [m, m];
  }
  function de(m) {
    return Se(m).map(
      (x, V) => ({
        ...x,
        rules: le.value[V]
      })
    );
  }
  function Me(m) {
    return m == null ? !1 : pt(m) ? !isNaN(m) : T0(m) ? !isNaN(m.getTime()) : _t(m) ? m !== "" : m1(m);
  }
  function Te(m) {
    return Et(m) && "start" in m && "end" in m && Me(m.start ?? null) && Me(m.end ?? null);
  }
  function De(m) {
    return Te(m) || Me(m);
  }
  function Ae(m, x) {
    if (m == null && x == null)
      return !0;
    if (m == null || x == null)
      return !1;
    const V = T0(m), ee = T0(x);
    return V && ee ? m.getTime() === x.getTime() : V || ee ? !1 : Ae(m.start, x.start) && Ae(m.end, x.end);
  }
  function Ke(m) {
    return !De(m) || !i.value ? !1 : i.value.intersectsRange(r.value.range(m));
  }
  function kt(m, x, V, ee) {
    if (!De(m))
      return null;
    if (Te(m)) {
      const _e = r.value.toDate(m.start, {
        ...x[0],
        fillDate: N.value ?? void 0,
        patch: V
      }), He = r.value.toDate(m.end, {
        ...x[1],
        fillDate: E.value ?? void 0,
        patch: V
      });
      return Yn({ start: _e, end: He }, ee);
    }
    return r.value.toDateOrNull(m, {
      ...x[0],
      fillDate: c.value,
      patch: V
    });
  }
  function ct(m, x) {
    return Te(m) ? {
      start: r.value.fromDate(m.start, x[0]),
      end: r.value.fromDate(m.end, x[1])
    } : b.value ? null : r.value.fromDate(m, x[0]);
  }
  function nt(m, x = {}) {
    return clearTimeout(y), new Promise((V) => {
      const { debounce: ee = 0, ..._e } = x;
      ee > 0 ? y = window.setTimeout(() => {
        V(at(m, _e));
      }, ee) : V(at(m, _e));
    });
  }
  function at(m, {
    config: x = F.value,
    patch: V = "dateTime",
    clearIfEqual: ee = !1,
    formatInput: _e = !0,
    hidePopover: He = !1,
    dragging: Ze = I.value,
    targetPriority: b0,
    moveToValue: _0 = !1
  } = {}) {
    const Ra = de(x);
    let je = kt(
      m,
      Ra,
      V,
      b0
    );
    if (Ke(je)) {
      if (Ze)
        return null;
      je = c.value, He = !1;
    } else je == null && e.isRequired ? je = c.value : (
      // Clear value if same value was passed
      je != null && Ae(c.value, je) && ee && (je = null)
    );
    const Rn = Ze ? d : c, nn = !Ae(Rn.value, je);
    Rn.value = je, Ze || (d.value = null);
    const an = ct(
      je,
      F.value
    );
    return nn && (_ = !1, t(Ze ? "drag" : "update:modelValue", an), L0(() => _ = !0)), He && !Ze && tn(), _e && Vt(), _0 && L0(() => Hn(b0 ?? "start")), an;
  }
  function Vt() {
    L0(() => {
      const m = de({
        type: "string",
        mask: X.value
      }), x = ct(
        d.value ?? c.value,
        m
      );
      b.value ? f.value = [x && x.start, x && x.end] : f.value = [x, ""];
    });
  }
  function g0(m, x, V) {
    f.value.splice(x === "start" ? 0 : 1, 1, m);
    const ee = b.value ? {
      start: f.value[0],
      end: f.value[1] || f.value[0]
    } : m, _e = {
      type: "string",
      mask: X.value
    };
    nt(ee, {
      ...V,
      config: _e,
      patch: G.value,
      targetPriority: x,
      moveToValue: !0
    });
  }
  function yt(m) {
    return (x) => {
      e.updateOnInput && g0(x.currentTarget.value, m, {
        formatInput: !1,
        hidePopover: !1,
        debounce: e.inputDebounce
      });
    };
  }
  function t0(m) {
    return (x) => {
      g0(x.currentTarget.value, m, {
        formatInput: !0,
        hidePopover: !1
      });
    };
  }
  function n0(m) {
    m.key === "Escape" && nt(c.value, {
      formatInput: !0,
      hidePopover: !0
    });
  }
  function a0(m) {
    return b.value ? [
      m && m.start ? r.value.getDateParts(m.start) : null,
      m && m.end ? r.value.getDateParts(m.end) : null
    ] : [m ? r.value.getDateParts(m) : null];
  }
  function dt() {
    d.value = null, Vt();
  }
  function Ht(m) {
    t("popover-will-show", m);
  }
  function Nt(m) {
    t("popover-did-show", m);
  }
  function Rt(m) {
    dt(), t("popover-will-hide", m);
  }
  function Bt(m) {
    t("popover-did-hide", m);
  }
  function Ft(m) {
    const x = {
      patch: "date",
      formatInput: !0,
      hidePopover: !0
    };
    if (b.value) {
      const V = !I.value;
      V ? w = { start: m.startDate, end: m.endDate } : w != null && (w.end = m.date), nt(w, {
        ...x,
        dragging: V
      });
    } else
      nt(m.date, {
        ...x,
        clearIfEqual: !e.isRequired
      });
  }
  function jt(m, x) {
    Ft(m), t("dayclick", m, x);
  }
  function r0(m, x) {
    switch (x.key) {
      case " ":
      case "Enter": {
        Ft(m), x.preventDefault();
        break;
      }
      case "Escape":
        tn();
    }
    t("daykeydown", m, x);
  }
  function y0(m, x) {
    !I.value || w == null || (w.end = m.date, nt(Yn(w), {
      patch: "date",
      formatInput: !0
    }));
  }
  function Va(m = {}) {
    Mr({
      ...re.value,
      ...m,
      isInteractive: !0,
      id: u.value
    });
  }
  function tn(m = {}) {
    Mn({
      hideDelay: 10,
      force: !0,
      ...re.value,
      ...m,
      id: u.value
    });
  }
  function Ha(m) {
    qo({
      ...re.value,
      ...m,
      isInteractive: !0,
      id: u.value
    });
  }
  function Yn(m, x) {
    const { start: V, end: ee } = m;
    if (V > ee)
      switch (x) {
        case "start":
          return { start: V, end: V };
        case "end":
          return { start: ee, end: ee };
        default:
          return { start: ee, end: V };
      }
    return { start: V, end: ee };
  }
  async function Vn(m, x = {}) {
    return p.value == null ? !1 : p.value.move(m, x);
  }
  async function Na(m, x = {}) {
    return p.value == null ? !1 : p.value.moveBy(m, x);
  }
  async function Hn(m, x = {}) {
    const V = c.value;
    if (p.value == null || !De(V))
      return !1;
    const ee = m !== "end", _e = ee ? 1 : -1, He = Te(V) ? ee ? V.start : V.end : V, Ze = Io(He, "monthly", r.value);
    return p.value.move(Ze, { position: _e, ...x });
  }
  Ie(
    () => e.isRange,
    (m) => {
      m && console.warn(
        "The `is-range` prop will be deprecated in future releases. Please use the `range` modifier."
      );
    },
    { immediate: !0 }
  ), Ie(
    () => b.value,
    () => {
      at(null, { formatInput: !0 });
    }
  ), Ie(
    () => X.value,
    () => Vt()
  ), Ie(
    () => e.modelValue,
    (m) => {
      _ && at(m, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), Ie(
    () => le.value,
    () => {
      Et(e.rules) && at(e.modelValue, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), Ie(
    () => e.timezone,
    () => {
      at(c.value, { formatInput: !0 });
    }
  );
  const Nn = Se(F.value);
  c.value = kt(
    e.modelValue ?? null,
    Nn,
    "dateTime"
  ), kn(() => {
    at(e.modelValue, {
      formatInput: !0,
      hidePopover: !1
    });
  }), L0(() => l.value = !0);
  const M = {
    ...a,
    showCalendar: l,
    datePickerPopoverId: u,
    popoverRef: v,
    popoverEvents: W,
    calendarRef: p,
    isRange: b,
    isTimeMode: D,
    isDateTimeMode: A,
    is24hr: Zn(e, "is24hr"),
    hideTimeHeader: Zn(e, "hideTimeHeader"),
    timeAccuracy: Zn(e, "timeAccuracy"),
    isDragging: I,
    inputValue: ne,
    inputEvents: oe,
    dateParts: U,
    attributes: O,
    rules: le,
    move: Vn,
    moveBy: Na,
    moveToValue: Hn,
    updateValue: nt,
    showPopover: Va,
    hidePopover: tn,
    togglePopover: Ha,
    onDayClick: jt,
    onDayKeydown: r0,
    onDayMouseEnter: y0,
    onPopoverBeforeShow: Ht,
    onPopoverAfterShow: Nt,
    onPopoverBeforeHide: Rt,
    onPopoverAfterHide: Bt
  };
  return On(cl, M), M;
}
function _1() {
  const e = Ln(cl);
  if (e)
    return e;
  throw new Error(
    "DatePicker context missing. Please verify this component is nested within a valid context provider."
  );
}
const W$ = [
  { value: 0, label: "12" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" }
], U$ = [
  { value: 12, label: "12" },
  { value: 13, label: "1" },
  { value: 14, label: "2" },
  { value: 15, label: "3" },
  { value: 16, label: "4" },
  { value: 17, label: "5" },
  { value: 18, label: "6" },
  { value: 19, label: "7" },
  { value: 20, label: "8" },
  { value: 21, label: "9" },
  { value: 22, label: "10" },
  { value: 23, label: "11" }
];
function q$(e) {
  const t = _1(), {
    locale: n,
    isRange: a,
    isTimeMode: r,
    dateParts: s,
    rules: i,
    is24hr: l,
    hideTimeHeader: u,
    timeAccuracy: c,
    updateValue: d
  } = t;
  function f(R) {
    R = Object.assign(p.value, R);
    let G = null;
    if (a.value) {
      const re = v.value ? R : s.value[0], W = v.value ? s.value[1] : R;
      G = { start: re, end: W };
    } else
      G = R;
    d(G, {
      patch: "time",
      targetPriority: v.value ? "start" : "end",
      moveToValue: !0
    });
  }
  const v = $(() => e.position === 0), p = $(
    () => s.value[e.position] || { isValid: !1 }
  ), y = $(() => m1(p.value)), w = $(() => !!p.value.isValid), _ = $(() => !u.value && w.value), b = $(() => {
    if (!y.value)
      return null;
    let R = n.value.toDate(p.value);
    return p.value.hours === 24 && (R = new Date(R.getTime() - 1)), R;
  }), N = $({
    get() {
      return p.value.hours;
    },
    set(R) {
      f({ hours: R });
    }
  }), E = $({
    get() {
      return p.value.minutes;
    },
    set(R) {
      f({ minutes: R });
    }
  }), L = $({
    get() {
      return p.value.seconds;
    },
    set(R) {
      f({ seconds: R });
    }
  }), A = $({
    get() {
      return p.value.milliseconds;
    },
    set(R) {
      f({ milliseconds: R });
    }
  }), D = $({
    get() {
      return p.value.hours < 12;
    },
    set(R) {
      R = String(R).toLowerCase() == "true";
      let G = N.value;
      R && G >= 12 ? G -= 12 : !R && G < 12 && (G += 12), f({ hours: G });
    }
  }), I = $(
    () => hw(p.value, i.value[e.position])
  ), F = $(() => W$.filter(
    (R) => I.value.hours.some((G) => G.value === R.value)
  )), U = $(() => U$.filter(
    (R) => I.value.hours.some((G) => G.value === R.value)
  )), X = $(() => l.value ? I.value.hours : D.value ? F.value : U.value), Q = $(() => {
    const R = [];
    return Lt(F.value) && R.push({ value: !0, label: "AM" }), Lt(U.value) && R.push({ value: !1, label: "PM" }), R;
  });
  return {
    ...t,
    showHeader: _,
    timeAccuracy: c,
    parts: p,
    isValid: w,
    date: b,
    hours: N,
    minutes: E,
    seconds: L,
    milliseconds: A,
    options: I,
    hourOptions: X,
    isAM: D,
    isAMOptions: Q,
    is24hr: l
  };
}
const G$ = ["value"], K$ = ["value", "disabled"], Z$ = {
  key: 1,
  class: "vc-base-sizer",
  "aria-hidden": "true"
}, X$ = {
  inheritAttrs: !1
}, ln = /* @__PURE__ */ Ee({
  ...X$,
  __name: "BaseSelect",
  props: {
    options: null,
    modelValue: null,
    alignRight: { type: Boolean },
    alignLeft: { type: Boolean },
    showIcon: { type: Boolean },
    fitContent: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = $(() => {
      const a = t.options.find((r) => r.value === t.modelValue);
      return a == null ? void 0 : a.label;
    });
    return (a, r) => (h(), g("div", {
      class: z(["vc-base-select", {
        "vc-fit-content": e.fitContent,
        "vc-has-icon": e.showIcon
      }])
    }, [
      o("select", Xt(a.$attrs, {
        value: e.modelValue,
        class: ["vc-focus", {
          "vc-align-right": e.alignRight,
          "vc-align-left": e.alignLeft
        }],
        onChange: r[0] || (r[0] = (s) => a.$emit("update:modelValue", s.target.value))
      }), [
        (h(!0), g(se, null, fe(e.options, (s) => (h(), g("option", {
          key: s.value,
          value: s.value,
          disabled: s.disabled
        }, j(s.label), 9, K$))), 128))
      ], 16, G$),
      e.showIcon ? (h(), H(F0, {
        key: 0,
        name: "ChevronDown",
        size: "18"
      })) : B("", !0),
      e.fitContent ? (h(), g("div", Z$, j(C(n)), 1)) : B("", !0)
    ], 2));
  }
}), J$ = {
  key: 0,
  class: "vc-time-header"
}, Q$ = { class: "vc-time-weekday" }, eC = { class: "vc-time-month" }, tC = { class: "vc-time-day" }, nC = { class: "vc-time-year" }, aC = { class: "vc-time-select-group" }, rC = /* @__PURE__ */ o("span", { class: "vc-time-colon" }, ":", -1), sC = /* @__PURE__ */ o("span", { class: "vc-time-colon" }, ":", -1), iC = /* @__PURE__ */ o("span", { class: "vc-time-decimal" }, ".", -1), qs = /* @__PURE__ */ Ee({
  __name: "TimePicker",
  props: {
    position: null
  },
  setup(e, { expose: t }) {
    const a = q$(e);
    t(a);
    const {
      locale: r,
      isValid: s,
      date: i,
      hours: l,
      minutes: u,
      seconds: c,
      milliseconds: d,
      options: f,
      hourOptions: v,
      isTimeMode: p,
      isAM: y,
      isAMOptions: w,
      is24hr: _,
      showHeader: b,
      timeAccuracy: N
    } = a;
    return (E, L) => (h(), g("div", {
      class: z(["vc-time-picker", [{ "vc-invalid": !C(s), "vc-attached": !C(p) }]])
    }, [
      k(st, { name: "time-header" }, {
        default: P(() => [
          C(b) && C(i) ? (h(), g("div", J$, [
            o("span", Q$, j(C(r).formatDate(C(i), "WWW")), 1),
            o("span", eC, j(C(r).formatDate(C(i), "MMM")), 1),
            o("span", tC, j(C(r).formatDate(C(i), "D")), 1),
            o("span", nC, j(C(r).formatDate(C(i), "YYYY")), 1)
          ])) : B("", !0)
        ]),
        _: 1
      }),
      o("div", aC, [
        k(F0, {
          name: "Clock",
          size: "17"
        }),
        k(ln, {
          modelValue: C(l),
          "onUpdate:modelValue": L[0] || (L[0] = (A) => M0(l) ? l.value = A : null),
          modelModifiers: { number: !0 },
          options: C(v),
          class: "vc-time-select-hours",
          "align-right": ""
        }, null, 8, ["modelValue", "options"]),
        C(N) > 1 ? (h(), g(se, { key: 0 }, [
          rC,
          k(ln, {
            modelValue: C(u),
            "onUpdate:modelValue": L[1] || (L[1] = (A) => M0(u) ? u.value = A : null),
            modelModifiers: { number: !0 },
            options: C(f).minutes,
            class: "vc-time-select-minutes",
            "align-left": C(N) === 2
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : B("", !0),
        C(N) > 2 ? (h(), g(se, { key: 1 }, [
          sC,
          k(ln, {
            modelValue: C(c),
            "onUpdate:modelValue": L[2] || (L[2] = (A) => M0(c) ? c.value = A : null),
            modelModifiers: { number: !0 },
            options: C(f).seconds,
            class: "vc-time-select-seconds",
            "align-left": C(N) === 3
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : B("", !0),
        C(N) > 3 ? (h(), g(se, { key: 2 }, [
          iC,
          k(ln, {
            modelValue: C(d),
            "onUpdate:modelValue": L[3] || (L[3] = (A) => M0(d) ? d.value = A : null),
            modelModifiers: { number: !0 },
            options: C(f).milliseconds,
            class: "vc-time-select-milliseconds",
            "align-left": ""
          }, null, 8, ["modelValue", "options"])
        ], 64)) : B("", !0),
        C(_) ? B("", !0) : (h(), H(ln, {
          key: 3,
          modelValue: C(y),
          "onUpdate:modelValue": L[4] || (L[4] = (A) => M0(y) ? y.value = A : null),
          options: C(w)
        }, null, 8, ["modelValue", "options"]))
      ])
    ], 2));
  }
}), dl = /* @__PURE__ */ Ee({
  __name: "DatePickerBase",
  setup(e) {
    const {
      attributes: t,
      calendarRef: n,
      color: a,
      displayMode: r,
      isDateTimeMode: s,
      isTimeMode: i,
      isRange: l,
      onDayClick: u,
      onDayMouseEnter: c,
      onDayKeydown: d
    } = _1(), f = l.value ? [0, 1] : [0];
    return (v, p) => C(i) ? (h(), g("div", {
      key: 0,
      class: z(`vc-container vc-bordered vc-${C(a)} vc-${C(r)}`)
    }, [
      (h(!0), g(se, null, fe(C(f), (y) => (h(), H(qs, {
        key: y,
        position: y
      }, null, 8, ["position"]))), 128))
    ], 2)) : (h(), H(ul, {
      key: 1,
      attributes: C(t),
      ref_key: "calendarRef",
      ref: n,
      onDayclick: C(u),
      onDaymouseenter: C(c),
      onDaykeydown: C(d)
    }, {
      footer: P(() => [
        C(s) ? (h(!0), g(se, { key: 0 }, fe(C(f), (y) => (h(), H(qs, {
          key: y,
          position: y
        }, null, 8, ["position"]))), 128)) : B("", !0),
        k(st, { name: "dp-footer" })
      ]),
      _: 1
    }, 8, ["attributes", "onDayclick", "onDaymouseenter", "onDaykeydown"]));
  }
}), oC = {
  inheritAttrs: !1
}, lC = /* @__PURE__ */ Ee({
  ...oC,
  __name: "DatePickerPopover",
  setup(e) {
    const {
      datePickerPopoverId: t,
      color: n,
      displayMode: a,
      popoverRef: r,
      onPopoverBeforeShow: s,
      onPopoverAfterShow: i,
      onPopoverBeforeHide: l,
      onPopoverAfterHide: u
    } = _1();
    return (c, d) => (h(), H(Pa, {
      id: C(t),
      placement: "bottom-start",
      class: z(`vc-date-picker-content vc-${C(n)} vc-${C(a)}`),
      ref_key: "popoverRef",
      ref: r,
      onBeforeShow: C(s),
      onAfterShow: C(i),
      onBeforeHide: C(l),
      onAfterHide: C(u)
    }, {
      default: P(() => [
        k(dl, pn(fr(c.$attrs)), null, 16)
      ]),
      _: 1
    }, 8, ["id", "class", "onBeforeShow", "onAfterShow", "onBeforeHide", "onAfterHide"]));
  }
}), uC = Ee({
  inheritAttrs: !1,
  emits: F$,
  props: B$,
  components: { DatePickerBase: dl, DatePickerPopover: lC },
  setup(e, t) {
    const n = j$(e, t), a = W0(Do(n, "calendarRef", "popoverRef"));
    return { ...n, slotCtx: a };
  }
});
function cC(e, t, n, a, r, s) {
  const i = Y("DatePickerPopover"), l = Y("DatePickerBase");
  return e.$slots.default ? (h(), g(se, { key: 0 }, [
    ae(e.$slots, "default", pn(fr(e.slotCtx))),
    k(i, pn(fr(e.$attrs)), null, 16)
  ], 64)) : (h(), H(l, pn(Xt({ key: 1 }, e.$attrs)), null, 16));
}
const Dr = /* @__PURE__ */ e0(uC, [["render", cC]]), Gs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Calendar: ul,
  DatePicker: Dr,
  Popover: Pa,
  PopoverRow: rl
}, Symbol.toStringTag, { value: "Module" })), dC = (e, t = {}) => {
  e.use(z_, t);
  const n = e.config.globalProperties.$VCalendar.componentPrefix;
  for (const a in Gs) {
    const r = Gs[a];
    e.component(`${n}${a}`, r);
  }
}, fC = { install: dC }, hC = /* @__PURE__ */ Object.assign({ name: "LuxDatePicker" }, {
  __name: "LuxDatePicker",
  props: {
    /**
     * Allows for a single date or a date range to be selected. Possible values are: `single, range`.
     */
    mode: {
      type: String,
      default: "single",
      validator: (e) => e.match(/(single|range)/)
    },
    /**
     * The label of the form input field.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Unique identifier of the form input field.
     */
    id: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * The name attribute for the form input field.
     */
    name: {
      type: String,
      default: "",
      required: !0
    },
    /**
     * The width of the form input field.
     * `auto, expand`
     */
    width: {
      type: String,
      default: "auto",
      validator: (e) => e.match(/(auto|expand)/)
    },
    /**
     * Sets the size of the input area `small, medium, large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    },
    /**
     * Whether the form input field is required or not.
     * `true, false`
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Placeholder text to display
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * defaultDate offers a way to add data that may already exist for the field when `mode='single'`.
     * It takes the form of a Javascript Date object.
     * Example: `:defaultDate="new Date(2019, 05, 01)"`
     */
    defaultDate: {
      type: Date,
      default: null,
      required: !1
    },
    /**
     * defaultDates offer a way to add data that may already exist for the field when `mode='range'`.
     * It takes the form of an Object containing two properties (start and,
     * optionally, end date) with values that are Javascript date objects.
     * Example: `:defaultDates="{ start: new Date(2019, 05, 01), end: new Date(2019, 05, 02)}"`
     */
    defaultDates: {
      type: Object,
      default: null,
      required: !1
    },
    /**
     * Disable dates using the date object or date range format. This example makes the
     * month of June 2019 selectable, but nothing else: `[{ start: null, end: new Date(2019, 05, 01)}, { start: new Date(2019, 05, 30), end: null }]`
     * Note: In Javascript, months start at zero, which is why 05 = June.
     */
    disabledDates: {
      type: Array,
      default: null,
      required: !1
    },
    /**
     * Highlight PUL holidays using an array of strings in YYYY-MM-DD format. Example: ["2019-11-28","2019-11-29"]
     */
    holidays: {
      type: Array,
      default: null,
      required: !1
    },
    /**
     * The helper text a user should get.
     */
    helper: {
      type: String,
      default: ""
    }
  },
  emits: ["updateInput", "updateRangeInput"],
  setup(e, { emit: t }) {
    const n = e, a = t, r = pe(n.defaultDate), s = pe(n.defaultDates), i = pe([
      {
        bar: {
          color: "red",
          class: "lux-holiday-highlight"
        },
        dates: n.holidays,
        popover: {
          label: "Official PUL Holiday"
        }
      }
    ]), l = $({
      get() {
        return s.value ? `${f()} - ${d()}` : "";
      },
      set(_) {
        p(_);
      }
    });
    function u(_) {
      if (r.value && y(r.value.toLocaleDateString("en-US"))) {
        let b = r.value.toLocaleDateString("en-US");
        a("updateInput", b);
      }
    }
    function c(_) {
      if (s.value && y(s.value.start.toLocaleDateString("en-US")) && y(s.value.end.toLocaleDateString("en-US"))) {
        let b = f() + " - " + d();
        a("updateRangeInput", b);
      }
    }
    function d() {
      if (s.value.hasOwnProperty("end"))
        return s.value.end.toLocaleDateString("en-US");
    }
    function f() {
      if (s.value.hasOwnProperty("start"))
        return s.value.start.toLocaleDateString("en-US");
    }
    function v(_) {
      if (_.includes("/")) {
        let b = _.split("/");
        return /* @__PURE__ */ new Date(b[2] + "-" + b[0] + "-" + b[1]);
      }
    }
    function p(_) {
      if (w(_)) {
        let b = _.split(" - ");
        y(b[0]) && y(b[1]) && (s.value || (s.value = {}), s.value = {
          start: v(b[0]),
          end: v(b[1])
        }, s.value.end = v(b[1]), a("updateRangeInput", _));
      }
    }
    function y(_) {
      return _.trim().length === 0 ? !0 : /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(_);
    }
    function w(_) {
      return _.includes(" - ") && !_.endsWith(" - ");
    }
    return (_, b) => {
      const N = Y("lux-input-text");
      return h(), g("div", {
        class: z(["lux-date-picker", e.size])
      }, [
        e.mode == "single" ? (h(), H(C(Dr), {
          key: 0,
          mode: "single",
          "disabled-dates": e.disabledDates,
          "update-on-input": !0,
          attributes: i.value,
          modelValue: r.value,
          "onUpdate:modelValue": b[0] || (b[0] = (E) => r.value = E),
          onPopoverDidDisappear: b[1] || (b[1] = (E) => u())
        }, {
          default: P(({ inputValue: E, inputEvents: L }) => [
            k(N, Xt({
              id: e.id,
              label: e.label,
              name: e.name,
              required: e.required,
              width: e.width,
              size: e.size
            }, hr(L), {
              value: E,
              placeholder: e.placeholder,
              helper: e.helper
            }), null, 16, ["id", "label", "name", "required", "width", "size", "value", "placeholder", "helper"])
          ]),
          _: 1
        }, 8, ["disabled-dates", "attributes", "modelValue"])) : B("", !0),
        e.mode == "range" ? (h(), H(C(Dr), {
          key: 1,
          "disabled-dates": e.disabledDates,
          "update-on-input": !0,
          attributes: i.value,
          modelValue: s.value,
          "onUpdate:modelValue": b[3] || (b[3] = (E) => s.value = E),
          modelModifiers: { range: !0 },
          onPopoverDidDisappear: b[4] || (b[4] = (E) => c())
        }, {
          default: P(({ inputEvents: E }) => [
            k(N, Xt({
              id: e.id,
              label: e.label,
              name: e.name,
              width: e.width,
              size: e.size,
              required: e.required
            }, hr(E.start), {
              value: l.value,
              "onUpdate:value": b[2] || (b[2] = (L) => l.value = L),
              placeholder: e.placeholder,
              helper: e.helper
            }), null, 16, ["id", "label", "name", "width", "size", "required", "value", "placeholder", "helper"])
          ]),
          _: 1
        }, 8, ["disabled-dates", "attributes", "modelValue"])) : B("", !0)
      ], 2);
    };
  }
}), pC = ["aria-controls", "aria-expanded", "aria-describedby"], vC = ["id"], mC = /* @__PURE__ */ Object.assign({ name: "LuxDisclosure" }, {
  __name: "LuxDisclosure",
  props: {
    /**
     * A description of the action of showing the full content.
     */
    showLabel: {
      type: String,
      required: !0
    },
    /**
     * A description of the action of hiding the full content.
     */
    hideLabel: {
      type: String,
      required: !0
    },
    /**
     * Used for setting focus and aria-controls.  It must be unique in your page.
     */
    contentId: {
      type: String,
      required: !0
    },
    /**
     * The ID of an element in the DOM that provides further description of the full content.
     *
     * Use this prop if you have multiple disclosures in your page with the same `showLabel` or `hideLabel`.
     */
    descriptionId: {
      type: String
    },
    /**
     * How wide should the disclosure be?  You can use any value accepted by the CSS width property.
     */
    width: {
      type: String,
      default: "var(--card-width-medium)"
    },
    /**
     * What size should the font be?  You can use any value accepted by the CSS font-size property.
     */
    fontSize: {
      type: String,
      default: "var(--font-size-base)"
    }
  },
  setup(e) {
    const t = pe(!1), n = pe();
    function a() {
      t.value = !t.value, t.value === !0 && n.value !== null && setTimeout(() => {
        n.value.focus({ preventScroll: !0 });
      }, 500);
    }
    return (r, s) => (h(), g("div", {
      class: "lux-disclosure",
      style: Fe({ width: e.width })
    }, [
      o("button", {
        onClick: s[0] || (s[0] = (i) => a()),
        "aria-controls": e.contentId,
        "aria-expanded": t.value.toString(),
        "aria-describedby": e.descriptionId,
        class: z({ "lux-disclosure-open-button": t.value }),
        style: Fe({ fontSize: e.fontSize })
      }, [
        o("span", null, j(t.value ? e.hideLabel : e.showLabel), 1),
        k(In, {
          width: "12",
          height: "12",
          iconHide: "true"
        }, {
          default: P(() => [
            t.value ? (h(), H(hi, { key: 0 })) : (h(), H(fi, { key: 1 }))
          ]),
          _: 1
        })
      ], 14, pC),
      t.value ? (h(), g("div", {
        key: 0,
        id: e.contentId,
        ref_key: "contentContainer",
        ref: n,
        class: "lux-disclosure-content",
        tabindex: "-1",
        style: Fe({ fontSize: e.fontSize })
      }, [
        ae(r.$slots, "default")
      ], 12, vC)) : B("", !0)
    ], 4));
  }
});
var gC = Object.defineProperty, ba = Object.getOwnPropertySymbols, fl = Object.prototype.hasOwnProperty, hl = Object.prototype.propertyIsEnumerable, Ks = (e, t, n) => t in e ? gC(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, I0 = (e, t) => {
  for (var n in t || (t = {}))
    fl.call(t, n) && Ks(e, n, t[n]);
  if (ba)
    for (var n of ba(t))
      hl.call(t, n) && Ks(e, n, t[n]);
  return e;
}, pl = (e, t) => {
  var n = {};
  for (var a in e)
    fl.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && ba)
    for (var a of ba(e))
      t.indexOf(a) < 0 && hl.call(e, a) && (n[a] = e[a]);
  return n;
};
const vl = "[vue-draggable-plus]: ";
function yC(e) {
  console.warn(vl + e);
}
function bC(e) {
  console.error(vl + e);
}
function Zs(e, t, n) {
  return n >= 0 && n < e.length && e.splice(n, 0, e.splice(t, 1)[0]), e;
}
function _C(e) {
  return e.replace(/-(\w)/g, (t, n) => n ? n.toUpperCase() : "");
}
function wC(e) {
  return Object.keys(e).reduce((t, n) => (typeof e[n] < "u" && (t[_C(n)] = e[n]), t), {});
}
function $C(e, t) {
  if (Array.isArray(e))
    return e.splice(t, 1);
}
function CC(e, t, n) {
  if (Array.isArray(e))
    return e.splice(t, 0, n);
}
function xC(e) {
  return typeof e > "u";
}
function SC(e) {
  return typeof e == "string";
}
function Xs(e, t, n) {
  const a = e.children[n];
  e.insertBefore(t, a);
}
function tr(e) {
  e.parentNode && e.parentNode.removeChild(e);
}
function MC(e, t = document) {
  var n;
  let a = null;
  return typeof (t == null ? void 0 : t.querySelector) == "function" ? a = (n = t == null ? void 0 : t.querySelector) == null ? void 0 : n.call(t, e) : a = document.querySelector(e), a || yC(`Element not found: ${e}`), a;
}
function DC(e, t, n = null) {
  return function(...a) {
    return e.apply(n, a), t.apply(n, a);
  };
}
function kC(e, t) {
  const n = I0({}, e);
  return Object.keys(t).forEach((a) => {
    n[a] ? n[a] = DC(e[a], t[a]) : n[a] = t[a];
  }), n;
}
function LC(e) {
  return e instanceof HTMLElement;
}
function OC(e, t) {
  Object.keys(e).forEach((n) => {
    t(n, e[n]);
  });
}
/**!
 * Sortable 1.15.1
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function Js(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function St(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Js(Object(n), !0).forEach(function(a) {
      IC(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Js(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function na(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? na = function(t) {
    return typeof t;
  } : na = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, na(e);
}
function IC(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function At() {
  return At = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, At.apply(this, arguments);
}
function EC(e, t) {
  if (e == null)
    return {};
  var n = {}, a = Object.keys(e), r, s;
  for (s = 0; s < a.length; s++)
    r = a[s], !(t.indexOf(r) >= 0) && (n[r] = e[r]);
  return n;
}
function TC(e, t) {
  if (e == null)
    return {};
  var n = EC(e, t), a, r;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      a = s[r], !(t.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(e, a) && (n[a] = e[a]);
  }
  return n;
}
var AC = "1.15.1";
function Ot(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var Yt = Ot(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), Pn = Ot(/Edge/i), Qs = Ot(/firefox/i), gn = Ot(/safari/i) && !Ot(/chrome/i) && !Ot(/android/i), ml = Ot(/iP(ad|od|hone)/i), gl = Ot(/chrome/i) && Ot(/android/i), yl = {
  capture: !1,
  passive: !1
};
function ce(e, t, n) {
  e.addEventListener(t, n, !Yt && yl);
}
function ue(e, t, n) {
  e.removeEventListener(t, n, !Yt && yl);
}
function _a(e, t) {
  if (t) {
    if (t[0] === ">" && (t = t.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(t);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(t);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(t);
      } catch {
        return !1;
      }
    return !1;
  }
}
function PC(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function bt(e, t, n, a) {
  if (e) {
    n = n || document;
    do {
      if (t != null && (t[0] === ">" ? e.parentNode === n && _a(e, t) : _a(e, t)) || a && e === n)
        return e;
      if (e === n)
        break;
    } while (e = PC(e));
  }
  return null;
}
var ei = /\s+/g;
function Xe(e, t, n) {
  if (e && t)
    if (e.classList)
      e.classList[n ? "add" : "remove"](t);
    else {
      var a = (" " + e.className + " ").replace(ei, " ").replace(" " + t + " ", " ");
      e.className = (a + (n ? " " + t : "")).replace(ei, " ");
    }
}
function Z(e, t, n) {
  var a = e && e.style;
  if (a) {
    if (n === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), t === void 0 ? n : n[t];
    !(t in a) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), a[t] = n + (typeof n == "string" ? "" : "px");
  }
}
function z0(e, t) {
  var n = "";
  if (typeof e == "string")
    n = e;
  else
    do {
      var a = Z(e, "transform");
      a && a !== "none" && (n = a + " " + n);
    } while (!t && (e = e.parentNode));
  var r = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return r && new r(n);
}
function bl(e, t, n) {
  if (e) {
    var a = e.getElementsByTagName(t), r = 0, s = a.length;
    if (n)
      for (; r < s; r++)
        n(a[r], r);
    return a;
  }
  return [];
}
function Ct() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function Le(e, t, n, a, r) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var s, i, l, u, c, d, f;
    if (e !== window && e.parentNode && e !== Ct() ? (s = e.getBoundingClientRect(), i = s.top, l = s.left, u = s.bottom, c = s.right, d = s.height, f = s.width) : (i = 0, l = 0, u = window.innerHeight, c = window.innerWidth, d = window.innerHeight, f = window.innerWidth), (t || n) && e !== window && (r = r || e.parentNode, !Yt))
      do
        if (r && r.getBoundingClientRect && (Z(r, "transform") !== "none" || n && Z(r, "position") !== "static")) {
          var v = r.getBoundingClientRect();
          i -= v.top + parseInt(Z(r, "border-top-width")), l -= v.left + parseInt(Z(r, "border-left-width")), u = i + s.height, c = l + s.width;
          break;
        }
      while (r = r.parentNode);
    if (a && e !== window) {
      var p = z0(r || e), y = p && p.a, w = p && p.d;
      p && (i /= w, l /= y, f /= y, d /= w, u = i + d, c = l + f);
    }
    return {
      top: i,
      left: l,
      bottom: u,
      right: c,
      width: f,
      height: d
    };
  }
}
function _l(e) {
  var t = Le(e), n = parseInt(Z(e, "padding-left")), a = parseInt(Z(e, "padding-top")), r = parseInt(Z(e, "padding-right")), s = parseInt(Z(e, "padding-bottom"));
  return t.top += a + parseInt(Z(e, "border-top-width")), t.left += n + parseInt(Z(e, "border-left-width")), t.width = e.clientWidth - n - r, t.height = e.clientHeight - a - s, t.bottom = t.top + t.height, t.right = t.left + t.width, t;
}
function ti(e, t, n) {
  for (var a = Zt(e, !0), r = Le(e)[t]; a; ) {
    var s = Le(a)[n], i = void 0;
    if (i = r >= s, !i)
      return a;
    if (a === Ct())
      break;
    a = Zt(a, !1);
  }
  return !1;
}
function j0(e, t, n, a) {
  for (var r = 0, s = 0, i = e.children; s < i.length; ) {
    if (i[s].style.display !== "none" && i[s] !== J.ghost && (a || i[s] !== J.dragged) && bt(i[s], n.draggable, e, !1)) {
      if (r === t)
        return i[s];
      r++;
    }
    s++;
  }
  return null;
}
function w1(e, t) {
  for (var n = e.lastElementChild; n && (n === J.ghost || Z(n, "display") === "none" || t && !_a(n, t)); )
    n = n.previousElementSibling;
  return n || null;
}
function rt(e, t) {
  var n = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling; )
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== J.clone && (!t || _a(e, t)) && n++;
  return n;
}
function ni(e) {
  var t = 0, n = 0, a = Ct();
  if (e)
    do {
      var r = z0(e), s = r.a, i = r.d;
      t += e.scrollLeft * s, n += e.scrollTop * i;
    } while (e !== a && (e = e.parentNode));
  return [t, n];
}
function zC(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n)) {
      for (var a in t)
        if (t.hasOwnProperty(a) && t[a] === e[n][a])
          return Number(n);
    }
  return -1;
}
function Zt(e, t) {
  if (!e || !e.getBoundingClientRect)
    return Ct();
  var n = e, a = !1;
  do
    if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
      var r = Z(n);
      if (n.clientWidth < n.scrollWidth && (r.overflowX == "auto" || r.overflowX == "scroll") || n.clientHeight < n.scrollHeight && (r.overflowY == "auto" || r.overflowY == "scroll")) {
        if (!n.getBoundingClientRect || n === document.body)
          return Ct();
        if (a || t)
          return n;
        a = !0;
      }
    }
  while (n = n.parentNode);
  return Ct();
}
function YC(e, t) {
  if (e && t)
    for (var n in t)
      t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
}
function nr(e, t) {
  return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var yn;
function wl(e, t) {
  return function() {
    if (!yn) {
      var n = arguments, a = this;
      n.length === 1 ? e.call(a, n[0]) : e.apply(a, n), yn = setTimeout(function() {
        yn = void 0;
      }, t);
    }
  };
}
function VC() {
  clearTimeout(yn), yn = void 0;
}
function $l(e, t, n) {
  e.scrollLeft += t, e.scrollTop += n;
}
function Cl(e) {
  var t = window.Polymer, n = window.jQuery || window.Zepto;
  return t && t.dom ? t.dom(e).cloneNode(!0) : n ? n(e).clone(!0)[0] : e.cloneNode(!0);
}
var et = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function HC() {
  var e = [], t;
  return {
    captureAnimationState: function() {
      if (e = [], !!this.options.animation) {
        var n = [].slice.call(this.el.children);
        n.forEach(function(a) {
          if (!(Z(a, "display") === "none" || a === J.ghost)) {
            e.push({
              target: a,
              rect: Le(a)
            });
            var r = St({}, e[e.length - 1].rect);
            if (a.thisAnimationDuration) {
              var s = z0(a, !0);
              s && (r.top -= s.f, r.left -= s.e);
            }
            a.fromRect = r;
          }
        });
      }
    },
    addAnimationState: function(n) {
      e.push(n);
    },
    removeAnimationState: function(n) {
      e.splice(zC(e, {
        target: n
      }), 1);
    },
    animateAll: function(n) {
      var a = this;
      if (!this.options.animation) {
        clearTimeout(t), typeof n == "function" && n();
        return;
      }
      var r = !1, s = 0;
      e.forEach(function(i) {
        var l = 0, u = i.target, c = u.fromRect, d = Le(u), f = u.prevFromRect, v = u.prevToRect, p = i.rect, y = z0(u, !0);
        y && (d.top -= y.f, d.left -= y.e), u.toRect = d, u.thisAnimationDuration && nr(f, d) && !nr(c, d) && // Make sure animatingRect is on line between toRect & fromRect
        (p.top - d.top) / (p.left - d.left) === (c.top - d.top) / (c.left - d.left) && (l = RC(p, f, v, a.options)), nr(d, c) || (u.prevFromRect = c, u.prevToRect = d, l || (l = a.options.animation), a.animate(u, p, d, l)), l && (r = !0, s = Math.max(s, l), clearTimeout(u.animationResetTimer), u.animationResetTimer = setTimeout(function() {
          u.animationTime = 0, u.prevFromRect = null, u.fromRect = null, u.prevToRect = null, u.thisAnimationDuration = null;
        }, l), u.thisAnimationDuration = l);
      }), clearTimeout(t), r ? t = setTimeout(function() {
        typeof n == "function" && n();
      }, s) : typeof n == "function" && n(), e = [];
    },
    animate: function(n, a, r, s) {
      if (s) {
        Z(n, "transition", ""), Z(n, "transform", "");
        var i = z0(this.el), l = i && i.a, u = i && i.d, c = (a.left - r.left) / (l || 1), d = (a.top - r.top) / (u || 1);
        n.animatingX = !!c, n.animatingY = !!d, Z(n, "transform", "translate3d(" + c + "px," + d + "px,0)"), this.forRepaintDummy = NC(n), Z(n, "transition", "transform " + s + "ms" + (this.options.easing ? " " + this.options.easing : "")), Z(n, "transform", "translate3d(0,0,0)"), typeof n.animated == "number" && clearTimeout(n.animated), n.animated = setTimeout(function() {
          Z(n, "transition", ""), Z(n, "transform", ""), n.animated = !1, n.animatingX = !1, n.animatingY = !1;
        }, s);
      }
    }
  };
}
function NC(e) {
  return e.offsetWidth;
}
function RC(e, t, n, a) {
  return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - n.top, 2) + Math.pow(t.left - n.left, 2)) * a.animation;
}
var C0 = [], ar = {
  initializeByDefault: !0
}, zn = {
  mount: function(e) {
    for (var t in ar)
      ar.hasOwnProperty(t) && !(t in e) && (e[t] = ar[t]);
    C0.forEach(function(n) {
      if (n.pluginName === e.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(e.pluginName, " more than once");
    }), C0.push(e);
  },
  pluginEvent: function(e, t, n) {
    var a = this;
    this.eventCanceled = !1, n.cancel = function() {
      a.eventCanceled = !0;
    };
    var r = e + "Global";
    C0.forEach(function(s) {
      t[s.pluginName] && (t[s.pluginName][r] && t[s.pluginName][r](St({
        sortable: t
      }, n)), t.options[s.pluginName] && t[s.pluginName][e] && t[s.pluginName][e](St({
        sortable: t
      }, n)));
    });
  },
  initializePlugins: function(e, t, n, a) {
    C0.forEach(function(i) {
      var l = i.pluginName;
      if (!(!e.options[l] && !i.initializeByDefault)) {
        var u = new i(e, t, e.options);
        u.sortable = e, u.options = e.options, e[l] = u, At(n, u.defaults);
      }
    });
    for (var r in e.options)
      if (e.options.hasOwnProperty(r)) {
        var s = this.modifyOption(e, r, e.options[r]);
        typeof s < "u" && (e.options[r] = s);
      }
  },
  getEventProperties: function(e, t) {
    var n = {};
    return C0.forEach(function(a) {
      typeof a.eventProperties == "function" && At(n, a.eventProperties.call(t[a.pluginName], e));
    }), n;
  },
  modifyOption: function(e, t, n) {
    var a;
    return C0.forEach(function(r) {
      e[r.pluginName] && r.optionListeners && typeof r.optionListeners[t] == "function" && (a = r.optionListeners[t].call(e[r.pluginName], n));
    }), a;
  }
};
function BC(e) {
  var t = e.sortable, n = e.rootEl, a = e.name, r = e.targetEl, s = e.cloneEl, i = e.toEl, l = e.fromEl, u = e.oldIndex, c = e.newIndex, d = e.oldDraggableIndex, f = e.newDraggableIndex, v = e.originalEvent, p = e.putSortable, y = e.extraEventProperties;
  if (t = t || n && n[et], !!t) {
    var w, _ = t.options, b = "on" + a.charAt(0).toUpperCase() + a.substr(1);
    window.CustomEvent && !Yt && !Pn ? w = new CustomEvent(a, {
      bubbles: !0,
      cancelable: !0
    }) : (w = document.createEvent("Event"), w.initEvent(a, !0, !0)), w.to = i || n, w.from = l || n, w.item = r || n, w.clone = s, w.oldIndex = u, w.newIndex = c, w.oldDraggableIndex = d, w.newDraggableIndex = f, w.originalEvent = v, w.pullMode = p ? p.lastPutMode : void 0;
    var N = St(St({}, y), zn.getEventProperties(a, t));
    for (var E in N)
      w[E] = N[E];
    n && n.dispatchEvent(w), _[b] && _[b].call(t, w);
  }
}
var FC = ["evt"], We = function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = n.evt, r = TC(n, FC);
  zn.pluginEvent.bind(J)(e, t, St({
    dragEl: T,
    parentEl: $e,
    ghostEl: te,
    rootEl: be,
    nextEl: l0,
    lastDownEl: aa,
    cloneEl: we,
    cloneHidden: Kt,
    dragStarted: dn,
    putSortable: Pe,
    activeSortable: J.active,
    originalEvent: a,
    oldIndex: E0,
    oldDraggableIndex: bn,
    newIndex: Qe,
    newDraggableIndex: Ut,
    hideGhostForTarget: Dl,
    unhideGhostForTarget: kl,
    cloneNowHidden: function() {
      Kt = !0;
    },
    cloneNowShown: function() {
      Kt = !1;
    },
    dispatchSortableEvent: function(s) {
      Ne({
        sortable: t,
        name: s,
        originalEvent: a
      });
    }
  }, r));
};
function Ne(e) {
  BC(St({
    putSortable: Pe,
    cloneEl: we,
    targetEl: T,
    rootEl: be,
    oldIndex: E0,
    oldDraggableIndex: bn,
    newIndex: Qe,
    newDraggableIndex: Ut
  }, e));
}
var T, $e, te, be, l0, aa, we, Kt, E0, Qe, bn, Ut, Un, Pe, k0 = !1, wa = !1, $a = [], s0, ft, rr, sr, ai, ri, dn, x0, _n, wn = !1, qn = !1, ra, ze, ir = [], kr = !1, Ca = [], za = typeof document < "u", Gn = ml, si = Pn || Yt ? "cssFloat" : "float", jC = za && !gl && !ml && "draggable" in document.createElement("div"), xl = function() {
  if (za) {
    if (Yt)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
}(), Sl = function(e, t) {
  var n = Z(e), a = parseInt(n.width) - parseInt(n.paddingLeft) - parseInt(n.paddingRight) - parseInt(n.borderLeftWidth) - parseInt(n.borderRightWidth), r = j0(e, 0, t), s = j0(e, 1, t), i = r && Z(r), l = s && Z(s), u = i && parseInt(i.marginLeft) + parseInt(i.marginRight) + Le(r).width, c = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + Le(s).width;
  if (n.display === "flex")
    return n.flexDirection === "column" || n.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (n.display === "grid")
    return n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (r && i.float && i.float !== "none") {
    var d = i.float === "left" ? "left" : "right";
    return s && (l.clear === "both" || l.clear === d) ? "vertical" : "horizontal";
  }
  return r && (i.display === "block" || i.display === "flex" || i.display === "table" || i.display === "grid" || u >= a && n[si] === "none" || s && n[si] === "none" && u + c > a) ? "vertical" : "horizontal";
}, WC = function(e, t, n) {
  var a = n ? e.left : e.top, r = n ? e.right : e.bottom, s = n ? e.width : e.height, i = n ? t.left : t.top, l = n ? t.right : t.bottom, u = n ? t.width : t.height;
  return a === i || r === l || a + s / 2 === i + u / 2;
}, UC = function(e, t) {
  var n;
  return $a.some(function(a) {
    var r = a[et].options.emptyInsertThreshold;
    if (!(!r || w1(a))) {
      var s = Le(a), i = e >= s.left - r && e <= s.right + r, l = t >= s.top - r && t <= s.bottom + r;
      if (i && l)
        return n = a;
    }
  }), n;
}, Ml = function(e) {
  function t(r, s) {
    return function(i, l, u, c) {
      var d = i.options.group.name && l.options.group.name && i.options.group.name === l.options.group.name;
      if (r == null && (s || d))
        return !0;
      if (r == null || r === !1)
        return !1;
      if (s && r === "clone")
        return r;
      if (typeof r == "function")
        return t(r(i, l, u, c), s)(i, l, u, c);
      var f = (s ? i : l).options.group.name;
      return r === !0 || typeof r == "string" && r === f || r.join && r.indexOf(f) > -1;
    };
  }
  var n = {}, a = e.group;
  (!a || na(a) != "object") && (a = {
    name: a
  }), n.name = a.name, n.checkPull = t(a.pull, !0), n.checkPut = t(a.put), n.revertClone = a.revertClone, e.group = n;
}, Dl = function() {
  !xl && te && Z(te, "display", "none");
}, kl = function() {
  !xl && te && Z(te, "display", "");
};
za && !gl && document.addEventListener("click", function(e) {
  if (wa)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), wa = !1, !1;
}, !0);
var i0 = function(e) {
  if (T) {
    e = e.touches ? e.touches[0] : e;
    var t = UC(e.clientX, e.clientY);
    if (t) {
      var n = {};
      for (var a in e)
        e.hasOwnProperty(a) && (n[a] = e[a]);
      n.target = n.rootEl = t, n.preventDefault = void 0, n.stopPropagation = void 0, t[et]._onDragOver(n);
    }
  }
}, qC = function(e) {
  T && T.parentNode[et]._isOutsideThisEl(e.target);
};
function J(e, t) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = t = At({}, t), e[et] = this;
  var n = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return Sl(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(s, i) {
      s.setData("Text", i.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: J.supportPointer !== !1 && "PointerEvent" in window && !gn,
    emptyInsertThreshold: 5
  };
  zn.initializePlugins(this, e, n);
  for (var a in n)
    !(a in t) && (t[a] = n[a]);
  Ml(t);
  for (var r in this)
    r.charAt(0) === "_" && typeof this[r] == "function" && (this[r] = this[r].bind(this));
  this.nativeDraggable = t.forceFallback ? !1 : jC, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? ce(e, "pointerdown", this._onTapStart) : (ce(e, "mousedown", this._onTapStart), ce(e, "touchstart", this._onTapStart)), this.nativeDraggable && (ce(e, "dragover", this), ce(e, "dragenter", this)), $a.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), At(this, HC());
}
J.prototype = /** @lends Sortable.prototype */
{
  constructor: J,
  _isOutsideThisEl: function(e) {
    !this.el.contains(e) && e !== this.el && (x0 = null);
  },
  _getDirection: function(e, t) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, e, t, T) : this.options.direction;
  },
  _onTapStart: function(e) {
    if (e.cancelable) {
      var t = this, n = this.el, a = this.options, r = a.preventOnFilter, s = e.type, i = e.touches && e.touches[0] || e.pointerType && e.pointerType === "touch" && e, l = (i || e).target, u = e.target.shadowRoot && (e.path && e.path[0] || e.composedPath && e.composedPath()[0]) || l, c = a.filter;
      if (tx(n), !T && !(/mousedown|pointerdown/.test(s) && e.button !== 0 || a.disabled) && !u.isContentEditable && !(!this.nativeDraggable && gn && l && l.tagName.toUpperCase() === "SELECT") && (l = bt(l, a.draggable, n, !1), !(l && l.animated) && aa !== l)) {
        if (E0 = rt(l), bn = rt(l, a.draggable), typeof c == "function") {
          if (c.call(this, e, l, this)) {
            Ne({
              sortable: t,
              rootEl: u,
              name: "filter",
              targetEl: l,
              toEl: n,
              fromEl: n
            }), We("filter", t, {
              evt: e
            }), r && e.cancelable && e.preventDefault();
            return;
          }
        } else if (c && (c = c.split(",").some(function(d) {
          if (d = bt(u, d.trim(), n, !1), d)
            return Ne({
              sortable: t,
              rootEl: d,
              name: "filter",
              targetEl: l,
              fromEl: n,
              toEl: n
            }), We("filter", t, {
              evt: e
            }), !0;
        }), c)) {
          r && e.cancelable && e.preventDefault();
          return;
        }
        a.handle && !bt(u, a.handle, n, !1) || this._prepareDragStart(e, i, l);
      }
    }
  },
  _prepareDragStart: function(e, t, n) {
    var a = this, r = a.el, s = a.options, i = r.ownerDocument, l;
    if (n && !T && n.parentNode === r) {
      var u = Le(n);
      if (be = r, T = n, $e = T.parentNode, l0 = T.nextSibling, aa = n, Un = s.group, J.dragged = T, s0 = {
        target: T,
        clientX: (t || e).clientX,
        clientY: (t || e).clientY
      }, ai = s0.clientX - u.left, ri = s0.clientY - u.top, this._lastX = (t || e).clientX, this._lastY = (t || e).clientY, T.style["will-change"] = "all", l = function() {
        if (We("delayEnded", a, {
          evt: e
        }), J.eventCanceled) {
          a._onDrop();
          return;
        }
        a._disableDelayedDragEvents(), !Qs && a.nativeDraggable && (T.draggable = !0), a._triggerDragStart(e, t), Ne({
          sortable: a,
          name: "choose",
          originalEvent: e
        }), Xe(T, s.chosenClass, !0);
      }, s.ignore.split(",").forEach(function(c) {
        bl(T, c.trim(), or);
      }), ce(i, "dragover", i0), ce(i, "mousemove", i0), ce(i, "touchmove", i0), ce(i, "mouseup", a._onDrop), ce(i, "touchend", a._onDrop), ce(i, "touchcancel", a._onDrop), Qs && this.nativeDraggable && (this.options.touchStartThreshold = 4, T.draggable = !0), We("delayStart", this, {
        evt: e
      }), s.delay && (!s.delayOnTouchOnly || t) && (!this.nativeDraggable || !(Pn || Yt))) {
        if (J.eventCanceled) {
          this._onDrop();
          return;
        }
        ce(i, "mouseup", a._disableDelayedDrag), ce(i, "touchend", a._disableDelayedDrag), ce(i, "touchcancel", a._disableDelayedDrag), ce(i, "mousemove", a._delayedDragTouchMoveHandler), ce(i, "touchmove", a._delayedDragTouchMoveHandler), s.supportPointer && ce(i, "pointermove", a._delayedDragTouchMoveHandler), a._dragStartTimer = setTimeout(l, s.delay);
      } else
        l();
    }
  },
  _delayedDragTouchMoveHandler: function(e) {
    var t = e.touches ? e.touches[0] : e;
    Math.max(Math.abs(t.clientX - this._lastX), Math.abs(t.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    T && or(T), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var e = this.el.ownerDocument;
    ue(e, "mouseup", this._disableDelayedDrag), ue(e, "touchend", this._disableDelayedDrag), ue(e, "touchcancel", this._disableDelayedDrag), ue(e, "mousemove", this._delayedDragTouchMoveHandler), ue(e, "touchmove", this._delayedDragTouchMoveHandler), ue(e, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(e, t) {
    t = t || e.pointerType == "touch" && e, !this.nativeDraggable || t ? this.options.supportPointer ? ce(document, "pointermove", this._onTouchMove) : t ? ce(document, "touchmove", this._onTouchMove) : ce(document, "mousemove", this._onTouchMove) : (ce(T, "dragend", this), ce(be, "dragstart", this._onDragStart));
    try {
      document.selection ? sa(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(e, t) {
    if (k0 = !1, be && T) {
      We("dragStarted", this, {
        evt: t
      }), this.nativeDraggable && ce(document, "dragover", qC);
      var n = this.options;
      !e && Xe(T, n.dragClass, !1), Xe(T, n.ghostClass, !0), J.active = this, e && this._appendGhost(), Ne({
        sortable: this,
        name: "start",
        originalEvent: t
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (ft) {
      this._lastX = ft.clientX, this._lastY = ft.clientY, Dl();
      for (var e = document.elementFromPoint(ft.clientX, ft.clientY), t = e; e && e.shadowRoot && (e = e.shadowRoot.elementFromPoint(ft.clientX, ft.clientY), e !== t); )
        t = e;
      if (T.parentNode[et]._isOutsideThisEl(e), t)
        do {
          if (t[et]) {
            var n = void 0;
            if (n = t[et]._onDragOver({
              clientX: ft.clientX,
              clientY: ft.clientY,
              target: e,
              rootEl: t
            }), n && !this.options.dragoverBubble)
              break;
          }
          e = t;
        } while (t = t.parentNode);
      kl();
    }
  },
  _onTouchMove: function(e) {
    if (s0) {
      var t = this.options, n = t.fallbackTolerance, a = t.fallbackOffset, r = e.touches ? e.touches[0] : e, s = te && z0(te, !0), i = te && s && s.a, l = te && s && s.d, u = Gn && ze && ni(ze), c = (r.clientX - s0.clientX + a.x) / (i || 1) + (u ? u[0] - ir[0] : 0) / (i || 1), d = (r.clientY - s0.clientY + a.y) / (l || 1) + (u ? u[1] - ir[1] : 0) / (l || 1);
      if (!J.active && !k0) {
        if (n && Math.max(Math.abs(r.clientX - this._lastX), Math.abs(r.clientY - this._lastY)) < n)
          return;
        this._onDragStart(e, !0);
      }
      if (te) {
        s ? (s.e += c - (rr || 0), s.f += d - (sr || 0)) : s = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: c,
          f: d
        };
        var f = "matrix(".concat(s.a, ",").concat(s.b, ",").concat(s.c, ",").concat(s.d, ",").concat(s.e, ",").concat(s.f, ")");
        Z(te, "webkitTransform", f), Z(te, "mozTransform", f), Z(te, "msTransform", f), Z(te, "transform", f), rr = c, sr = d, ft = r;
      }
      e.cancelable && e.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!te) {
      var e = this.options.fallbackOnBody ? document.body : be, t = Le(T, !0, Gn, !0, e), n = this.options;
      if (Gn) {
        for (ze = e; Z(ze, "position") === "static" && Z(ze, "transform") === "none" && ze !== document; )
          ze = ze.parentNode;
        ze !== document.body && ze !== document.documentElement ? (ze === document && (ze = Ct()), t.top += ze.scrollTop, t.left += ze.scrollLeft) : ze = Ct(), ir = ni(ze);
      }
      te = T.cloneNode(!0), Xe(te, n.ghostClass, !1), Xe(te, n.fallbackClass, !0), Xe(te, n.dragClass, !0), Z(te, "transition", ""), Z(te, "transform", ""), Z(te, "box-sizing", "border-box"), Z(te, "margin", 0), Z(te, "top", t.top), Z(te, "left", t.left), Z(te, "width", t.width), Z(te, "height", t.height), Z(te, "opacity", "0.8"), Z(te, "position", Gn ? "absolute" : "fixed"), Z(te, "zIndex", "100000"), Z(te, "pointerEvents", "none"), J.ghost = te, e.appendChild(te), Z(te, "transform-origin", ai / parseInt(te.style.width) * 100 + "% " + ri / parseInt(te.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(e, t) {
    var n = this, a = e.dataTransfer, r = n.options;
    if (We("dragStart", this, {
      evt: e
    }), J.eventCanceled) {
      this._onDrop();
      return;
    }
    We("setupClone", this), J.eventCanceled || (we = Cl(T), we.removeAttribute("id"), we.draggable = !1, we.style["will-change"] = "", this._hideClone(), Xe(we, this.options.chosenClass, !1), J.clone = we), n.cloneId = sa(function() {
      We("clone", n), !J.eventCanceled && (n.options.removeCloneOnHide || be.insertBefore(we, T), n._hideClone(), Ne({
        sortable: n,
        name: "clone"
      }));
    }), !t && Xe(T, r.dragClass, !0), t ? (wa = !0, n._loopId = setInterval(n._emulateDragOver, 50)) : (ue(document, "mouseup", n._onDrop), ue(document, "touchend", n._onDrop), ue(document, "touchcancel", n._onDrop), a && (a.effectAllowed = "move", r.setData && r.setData.call(n, a, T)), ce(document, "drop", n), Z(T, "transform", "translateZ(0)")), k0 = !0, n._dragStartId = sa(n._dragStarted.bind(n, t, e)), ce(document, "selectstart", n), dn = !0, gn && Z(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(e) {
    var t = this.el, n = e.target, a, r, s, i = this.options, l = i.group, u = J.active, c = Un === l, d = i.sort, f = Pe || u, v, p = this, y = !1;
    if (kr)
      return;
    function w(oe, Ce) {
      We(oe, p, St({
        evt: e,
        isOwner: c,
        axis: v ? "vertical" : "horizontal",
        revert: s,
        dragRect: a,
        targetRect: r,
        canSort: d,
        fromSortable: f,
        target: n,
        completed: b,
        onMove: function(ve, O) {
          return Kn(be, t, T, a, ve, Le(ve), e, O);
        },
        changed: N
      }, Ce));
    }
    function _() {
      w("dragOverAnimationCapture"), p.captureAnimationState(), p !== f && f.captureAnimationState();
    }
    function b(oe) {
      return w("dragOverCompleted", {
        insertion: oe
      }), oe && (c ? u._hideClone() : u._showClone(p), p !== f && (Xe(T, Pe ? Pe.options.ghostClass : u.options.ghostClass, !1), Xe(T, i.ghostClass, !0)), Pe !== p && p !== J.active ? Pe = p : p === J.active && Pe && (Pe = null), f === p && (p._ignoreWhileAnimating = n), p.animateAll(function() {
        w("dragOverAnimationComplete"), p._ignoreWhileAnimating = null;
      }), p !== f && (f.animateAll(), f._ignoreWhileAnimating = null)), (n === T && !T.animated || n === t && !n.animated) && (x0 = null), !i.dragoverBubble && !e.rootEl && n !== document && (T.parentNode[et]._isOutsideThisEl(e.target), !oe && i0(e)), !i.dragoverBubble && e.stopPropagation && e.stopPropagation(), y = !0;
    }
    function N() {
      Qe = rt(T), Ut = rt(T, i.draggable), Ne({
        sortable: p,
        name: "change",
        toEl: t,
        newIndex: Qe,
        newDraggableIndex: Ut,
        originalEvent: e
      });
    }
    if (e.preventDefault !== void 0 && e.cancelable && e.preventDefault(), n = bt(n, i.draggable, t, !0), w("dragOver"), J.eventCanceled)
      return y;
    if (T.contains(e.target) || n.animated && n.animatingX && n.animatingY || p._ignoreWhileAnimating === n)
      return b(!1);
    if (wa = !1, u && !i.disabled && (c ? d || (s = $e !== be) : Pe === this || (this.lastPutMode = Un.checkPull(this, u, T, e)) && l.checkPut(this, u, T, e))) {
      if (v = this._getDirection(e, n) === "vertical", a = Le(T), w("dragOverValid"), J.eventCanceled)
        return y;
      if (s)
        return $e = be, _(), this._hideClone(), w("revert"), J.eventCanceled || (l0 ? be.insertBefore(T, l0) : be.appendChild(T)), b(!0);
      var E = w1(t, i.draggable);
      if (!E || XC(e, v, this) && !E.animated) {
        if (E === T)
          return b(!1);
        if (E && t === e.target && (n = E), n && (r = Le(n)), Kn(be, t, T, a, n, r, e, !!n) !== !1)
          return _(), E && E.nextSibling ? t.insertBefore(T, E.nextSibling) : t.appendChild(T), $e = t, N(), b(!0);
      } else if (E && ZC(e, v, this)) {
        var L = j0(t, 0, i, !0);
        if (L === T)
          return b(!1);
        if (n = L, r = Le(n), Kn(be, t, T, a, n, r, e, !1) !== !1)
          return _(), t.insertBefore(T, L), $e = t, N(), b(!0);
      } else if (n.parentNode === t) {
        r = Le(n);
        var A = 0, D, I = T.parentNode !== t, F = !WC(T.animated && T.toRect || a, n.animated && n.toRect || r, v), U = v ? "top" : "left", X = ti(n, "top", "top") || ti(T, "top", "top"), Q = X ? X.scrollTop : void 0;
        x0 !== n && (D = r[U], wn = !1, qn = !F && i.invertSwap || I), A = JC(e, n, r, v, F ? 1 : i.swapThreshold, i.invertedSwapThreshold == null ? i.swapThreshold : i.invertedSwapThreshold, qn, x0 === n);
        var R;
        if (A !== 0) {
          var G = rt(T);
          do
            G -= A, R = $e.children[G];
          while (R && (Z(R, "display") === "none" || R === te));
        }
        if (A === 0 || R === n)
          return b(!1);
        x0 = n, _n = A;
        var re = n.nextElementSibling, W = !1;
        W = A === 1;
        var ne = Kn(be, t, T, a, n, r, e, W);
        if (ne !== !1)
          return (ne === 1 || ne === -1) && (W = ne === 1), kr = !0, setTimeout(KC, 30), _(), W && !re ? t.appendChild(T) : n.parentNode.insertBefore(T, W ? re : n), X && $l(X, 0, Q - X.scrollTop), $e = T.parentNode, D !== void 0 && !qn && (ra = Math.abs(D - Le(n)[U])), N(), b(!0);
      }
      if (t.contains(T))
        return b(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    ue(document, "mousemove", this._onTouchMove), ue(document, "touchmove", this._onTouchMove), ue(document, "pointermove", this._onTouchMove), ue(document, "dragover", i0), ue(document, "mousemove", i0), ue(document, "touchmove", i0);
  },
  _offUpEvents: function() {
    var e = this.el.ownerDocument;
    ue(e, "mouseup", this._onDrop), ue(e, "touchend", this._onDrop), ue(e, "pointerup", this._onDrop), ue(e, "touchcancel", this._onDrop), ue(document, "selectstart", this);
  },
  _onDrop: function(e) {
    var t = this.el, n = this.options;
    if (Qe = rt(T), Ut = rt(T, n.draggable), We("drop", this, {
      evt: e
    }), $e = T && T.parentNode, Qe = rt(T), Ut = rt(T, n.draggable), J.eventCanceled) {
      this._nulling();
      return;
    }
    k0 = !1, qn = !1, wn = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), Lr(this.cloneId), Lr(this._dragStartId), this.nativeDraggable && (ue(document, "drop", this), ue(t, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), gn && Z(document.body, "user-select", ""), Z(T, "transform", ""), e && (dn && (e.cancelable && e.preventDefault(), !n.dropBubble && e.stopPropagation()), te && te.parentNode && te.parentNode.removeChild(te), (be === $e || Pe && Pe.lastPutMode !== "clone") && we && we.parentNode && we.parentNode.removeChild(we), T && (this.nativeDraggable && ue(T, "dragend", this), or(T), T.style["will-change"] = "", dn && !k0 && Xe(T, Pe ? Pe.options.ghostClass : this.options.ghostClass, !1), Xe(T, this.options.chosenClass, !1), Ne({
      sortable: this,
      name: "unchoose",
      toEl: $e,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: e
    }), be !== $e ? (Qe >= 0 && (Ne({
      rootEl: $e,
      name: "add",
      toEl: $e,
      fromEl: be,
      originalEvent: e
    }), Ne({
      sortable: this,
      name: "remove",
      toEl: $e,
      originalEvent: e
    }), Ne({
      rootEl: $e,
      name: "sort",
      toEl: $e,
      fromEl: be,
      originalEvent: e
    }), Ne({
      sortable: this,
      name: "sort",
      toEl: $e,
      originalEvent: e
    })), Pe && Pe.save()) : Qe !== E0 && Qe >= 0 && (Ne({
      sortable: this,
      name: "update",
      toEl: $e,
      originalEvent: e
    }), Ne({
      sortable: this,
      name: "sort",
      toEl: $e,
      originalEvent: e
    })), J.active && ((Qe == null || Qe === -1) && (Qe = E0, Ut = bn), Ne({
      sortable: this,
      name: "end",
      toEl: $e,
      originalEvent: e
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    We("nulling", this), be = T = $e = te = l0 = we = aa = Kt = s0 = ft = dn = Qe = Ut = E0 = bn = x0 = _n = Pe = Un = J.dragged = J.ghost = J.clone = J.active = null, Ca.forEach(function(e) {
      e.checked = !0;
    }), Ca.length = rr = sr = 0;
  },
  handleEvent: function(e) {
    switch (e.type) {
      case "drop":
      case "dragend":
        this._onDrop(e);
        break;
      case "dragenter":
      case "dragover":
        T && (this._onDragOver(e), GC(e));
        break;
      case "selectstart":
        e.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var e = [], t, n = this.el.children, a = 0, r = n.length, s = this.options; a < r; a++)
      t = n[a], bt(t, s.draggable, this.el, !1) && e.push(t.getAttribute(s.dataIdAttr) || ex(t));
    return e;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(e, t) {
    var n = {}, a = this.el;
    this.toArray().forEach(function(r, s) {
      var i = a.children[s];
      bt(i, this.options.draggable, a, !1) && (n[r] = i);
    }, this), t && this.captureAnimationState(), e.forEach(function(r) {
      n[r] && (a.removeChild(n[r]), a.appendChild(n[r]));
    }), t && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var e = this.options.store;
    e && e.set && e.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(e, t) {
    return bt(e, t || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(e, t) {
    var n = this.options;
    if (t === void 0)
      return n[e];
    var a = zn.modifyOption(this, e, t);
    typeof a < "u" ? n[e] = a : n[e] = t, e === "group" && Ml(n);
  },
  /**
   * Destroy
   */
  destroy: function() {
    We("destroy", this);
    var e = this.el;
    e[et] = null, ue(e, "mousedown", this._onTapStart), ue(e, "touchstart", this._onTapStart), ue(e, "pointerdown", this._onTapStart), this.nativeDraggable && (ue(e, "dragover", this), ue(e, "dragenter", this)), Array.prototype.forEach.call(e.querySelectorAll("[draggable]"), function(t) {
      t.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), $a.splice($a.indexOf(this.el), 1), this.el = e = null;
  },
  _hideClone: function() {
    if (!Kt) {
      if (We("hideClone", this), J.eventCanceled)
        return;
      Z(we, "display", "none"), this.options.removeCloneOnHide && we.parentNode && we.parentNode.removeChild(we), Kt = !0;
    }
  },
  _showClone: function(e) {
    if (e.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (Kt) {
      if (We("showClone", this), J.eventCanceled)
        return;
      T.parentNode == be && !this.options.group.revertClone ? be.insertBefore(we, T) : l0 ? be.insertBefore(we, l0) : be.appendChild(we), this.options.group.revertClone && this.animate(T, we), Z(we, "display", ""), Kt = !1;
    }
  }
};
function GC(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function Kn(e, t, n, a, r, s, i, l) {
  var u, c = e[et], d = c.options.onMove, f;
  return window.CustomEvent && !Yt && !Pn ? u = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (u = document.createEvent("Event"), u.initEvent("move", !0, !0)), u.to = t, u.from = e, u.dragged = n, u.draggedRect = a, u.related = r || t, u.relatedRect = s || Le(t), u.willInsertAfter = l, u.originalEvent = i, e.dispatchEvent(u), d && (f = d.call(c, u, i)), f;
}
function or(e) {
  e.draggable = !1;
}
function KC() {
  kr = !1;
}
function ZC(e, t, n) {
  var a = Le(j0(n.el, 0, n.options, !0)), r = _l(n.el), s = 10;
  return t ? e.clientX < r.left - s || e.clientY < a.top && e.clientX < a.right : e.clientY < r.top - s || e.clientY < a.bottom && e.clientX < a.left;
}
function XC(e, t, n) {
  var a = Le(w1(n.el, n.options.draggable)), r = _l(n.el), s = 10;
  return t ? e.clientX > r.right + s || e.clientY > a.bottom && e.clientX > a.left : e.clientY > r.bottom + s || e.clientX > a.right && e.clientY > a.top;
}
function JC(e, t, n, a, r, s, i, l) {
  var u = a ? e.clientY : e.clientX, c = a ? n.height : n.width, d = a ? n.top : n.left, f = a ? n.bottom : n.right, v = !1;
  if (!i) {
    if (l && ra < c * r) {
      if (!wn && (_n === 1 ? u > d + c * s / 2 : u < f - c * s / 2) && (wn = !0), wn)
        v = !0;
      else if (_n === 1 ? u < d + ra : u > f - ra)
        return -_n;
    } else if (u > d + c * (1 - r) / 2 && u < f - c * (1 - r) / 2)
      return QC(t);
  }
  return v = v || i, v && (u < d + c * s / 2 || u > f - c * s / 2) ? u > d + c / 2 ? 1 : -1 : 0;
}
function QC(e) {
  return rt(T) < rt(e) ? 1 : -1;
}
function ex(e) {
  for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, a = 0; n--; )
    a += t.charCodeAt(n);
  return a.toString(36);
}
function tx(e) {
  Ca.length = 0;
  for (var t = e.getElementsByTagName("input"), n = t.length; n--; ) {
    var a = t[n];
    a.checked && Ca.push(a);
  }
}
function sa(e) {
  return setTimeout(e, 0);
}
function Lr(e) {
  return clearTimeout(e);
}
za && ce(document, "touchmove", function(e) {
  (J.active || k0) && e.cancelable && e.preventDefault();
});
J.utils = {
  on: ce,
  off: ue,
  css: Z,
  find: bl,
  is: function(e, t) {
    return !!bt(e, t, e, !1);
  },
  extend: YC,
  throttle: wl,
  closest: bt,
  toggleClass: Xe,
  clone: Cl,
  index: rt,
  nextTick: sa,
  cancelNextTick: Lr,
  detectDirection: Sl,
  getChild: j0
};
J.get = function(e) {
  return e[et];
};
J.mount = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  t[0].constructor === Array && (t = t[0]), t.forEach(function(a) {
    if (!a.prototype || !a.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(a));
    a.utils && (J.utils = St(St({}, J.utils), a.utils)), zn.mount(a);
  });
};
J.create = function(e, t) {
  return new J(e, t);
};
J.version = AC;
var ke = [], fn, Or, Ir = !1, lr, ur, xa, hn;
function nx() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var t in this)
      t.charAt(0) === "_" && typeof this[t] == "function" && (this[t] = this[t].bind(this));
  }
  return e.prototype = {
    dragStarted: function(t) {
      var n = t.originalEvent;
      this.sortable.nativeDraggable ? ce(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? ce(document, "pointermove", this._handleFallbackAutoScroll) : n.touches ? ce(document, "touchmove", this._handleFallbackAutoScroll) : ce(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(t) {
      var n = t.originalEvent;
      !this.options.dragOverBubble && !n.rootEl && this._handleAutoScroll(n);
    },
    drop: function() {
      this.sortable.nativeDraggable ? ue(document, "dragover", this._handleAutoScroll) : (ue(document, "pointermove", this._handleFallbackAutoScroll), ue(document, "touchmove", this._handleFallbackAutoScroll), ue(document, "mousemove", this._handleFallbackAutoScroll)), ii(), ia(), VC();
    },
    nulling: function() {
      xa = Or = fn = Ir = hn = lr = ur = null, ke.length = 0;
    },
    _handleFallbackAutoScroll: function(t) {
      this._handleAutoScroll(t, !0);
    },
    _handleAutoScroll: function(t, n) {
      var a = this, r = (t.touches ? t.touches[0] : t).clientX, s = (t.touches ? t.touches[0] : t).clientY, i = document.elementFromPoint(r, s);
      if (xa = t, n || this.options.forceAutoScrollFallback || Pn || Yt || gn) {
        cr(t, this.options, i, n);
        var l = Zt(i, !0);
        Ir && (!hn || r !== lr || s !== ur) && (hn && ii(), hn = setInterval(function() {
          var u = Zt(document.elementFromPoint(r, s), !0);
          u !== l && (l = u, ia()), cr(t, a.options, u, n);
        }, 10), lr = r, ur = s);
      } else {
        if (!this.options.bubbleScroll || Zt(i, !0) === Ct()) {
          ia();
          return;
        }
        cr(t, this.options, Zt(i, !1), !1);
      }
    }
  }, At(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function ia() {
  ke.forEach(function(e) {
    clearInterval(e.pid);
  }), ke = [];
}
function ii() {
  clearInterval(hn);
}
var cr = wl(function(e, t, n, a) {
  if (t.scroll) {
    var r = (e.touches ? e.touches[0] : e).clientX, s = (e.touches ? e.touches[0] : e).clientY, i = t.scrollSensitivity, l = t.scrollSpeed, u = Ct(), c = !1, d;
    Or !== n && (Or = n, ia(), fn = t.scroll, d = t.scrollFn, fn === !0 && (fn = Zt(n, !0)));
    var f = 0, v = fn;
    do {
      var p = v, y = Le(p), w = y.top, _ = y.bottom, b = y.left, N = y.right, E = y.width, L = y.height, A = void 0, D = void 0, I = p.scrollWidth, F = p.scrollHeight, U = Z(p), X = p.scrollLeft, Q = p.scrollTop;
      p === u ? (A = E < I && (U.overflowX === "auto" || U.overflowX === "scroll" || U.overflowX === "visible"), D = L < F && (U.overflowY === "auto" || U.overflowY === "scroll" || U.overflowY === "visible")) : (A = E < I && (U.overflowX === "auto" || U.overflowX === "scroll"), D = L < F && (U.overflowY === "auto" || U.overflowY === "scroll"));
      var R = A && (Math.abs(N - r) <= i && X + E < I) - (Math.abs(b - r) <= i && !!X), G = D && (Math.abs(_ - s) <= i && Q + L < F) - (Math.abs(w - s) <= i && !!Q);
      if (!ke[f])
        for (var re = 0; re <= f; re++)
          ke[re] || (ke[re] = {});
      (ke[f].vx != R || ke[f].vy != G || ke[f].el !== p) && (ke[f].el = p, ke[f].vx = R, ke[f].vy = G, clearInterval(ke[f].pid), (R != 0 || G != 0) && (c = !0, ke[f].pid = setInterval((function() {
        a && this.layer === 0 && J.active._onTouchMove(xa);
        var W = ke[this.layer].vy ? ke[this.layer].vy * l : 0, ne = ke[this.layer].vx ? ke[this.layer].vx * l : 0;
        typeof d == "function" && d.call(J.dragged.parentNode[et], ne, W, e, xa, ke[this.layer].el) !== "continue" || $l(ke[this.layer].el, ne, W);
      }).bind({
        layer: f
      }), 24))), f++;
    } while (t.bubbleScroll && v !== u && (v = Zt(v, !1)));
    Ir = c;
  }
}, 30), Ll = function(e) {
  var t = e.originalEvent, n = e.putSortable, a = e.dragEl, r = e.activeSortable, s = e.dispatchSortableEvent, i = e.hideGhostForTarget, l = e.unhideGhostForTarget;
  if (t) {
    var u = n || r;
    i();
    var c = t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t, d = document.elementFromPoint(c.clientX, c.clientY);
    l(), u && !u.el.contains(d) && (s("spill"), this.onSpill({
      dragEl: a,
      putSortable: n
    }));
  }
};
function $1() {
}
$1.prototype = {
  startIndex: null,
  dragStart: function(e) {
    var t = e.oldDraggableIndex;
    this.startIndex = t;
  },
  onSpill: function(e) {
    var t = e.dragEl, n = e.putSortable;
    this.sortable.captureAnimationState(), n && n.captureAnimationState();
    var a = j0(this.sortable.el, this.startIndex, this.options);
    a ? this.sortable.el.insertBefore(t, a) : this.sortable.el.appendChild(t), this.sortable.animateAll(), n && n.animateAll();
  },
  drop: Ll
};
At($1, {
  pluginName: "revertOnSpill"
});
function C1() {
}
C1.prototype = {
  onSpill: function(e) {
    var t = e.dragEl, n = e.putSortable, a = n || this.sortable;
    a.captureAnimationState(), t.parentNode && t.parentNode.removeChild(t), a.animateAll();
  },
  drop: Ll
};
At(C1, {
  pluginName: "removeOnSpill"
});
J.mount(new nx());
J.mount(C1, $1);
function ax(e) {
  return e == null ? e : JSON.parse(JSON.stringify(e));
}
function rx(e) {
  Ar() && Sa(e);
}
function sx(e) {
  Ar() ? kn(e) : L0(e);
}
const oi = Symbol("cloneElement");
function ix(...e) {
  var t, n;
  const a = (t = Ar()) == null ? void 0 : t.proxy, r = e[0];
  let [, s, i] = e;
  Array.isArray(C(s)) || (i = s, s = null);
  let l = null;
  const {
    immediate: u = !0,
    clone: c = ax,
    customUpdate: d
  } = (n = C(i)) != null ? n : {};
  function f(D) {
    var I;
    D.item[oi] = c(C((I = C(s)) == null ? void 0 : I[D.oldIndex]));
  }
  function v(D) {
    const I = D.item[oi];
    xC(I) || (tr(D.item), CC(C(s), D.newDraggableIndex, I));
  }
  function p(D) {
    const { from: I, item: F, oldIndex: U, oldDraggableIndex: X, pullMode: Q, clone: R } = D;
    if (Q === "clone") {
      Xs(I, F, U), tr(R);
      return;
    }
    $C(C(s), X);
  }
  function y(D) {
    if (d) {
      d(D);
      return;
    }
    const { from: I, item: F, oldIndex: U, newIndex: X } = D;
    if (tr(F), Xs(I, F, U), M0(s)) {
      const Q = [...C(s)];
      s.value = Zs(
        Q,
        U,
        X
      );
      return;
    }
    Zs(C(s), U, X);
  }
  const w = {
    onUpdate: y,
    onStart: f,
    onAdd: v,
    onRemove: p
  };
  function _(D) {
    const I = C(r);
    return D || (D = SC(I) ? MC(I, a == null ? void 0 : a.$el) : I), D && !LC(D) && (D = D.$el), D || bC("Root element not found"), D;
  }
  function b() {
    var D;
    const I = (D = C(i)) != null ? D : {}, { immediate: F, clone: U } = I, X = pl(I, ["immediate", "clone"]);
    return kC(
      s === null ? {} : w,
      X
    );
  }
  const N = (D) => {
    D = _(D), l && E.destroy(), l = new J(D, b());
  };
  Ie(
    () => i,
    () => {
      l && OC(b(), (D, I) => {
        l == null || l.option(D, I);
      });
    },
    { deep: !0 }
  );
  const E = {
    option: (D, I) => l == null ? void 0 : l.option(D, I),
    destroy: () => {
      l == null || l.destroy(), l = null;
    },
    save: () => l == null ? void 0 : l.save(),
    toArray: () => l == null ? void 0 : l.toArray(),
    closest: (...D) => l == null ? void 0 : l.closest(...D)
  }, L = () => E == null ? void 0 : E.option("disabled", !0), A = () => E == null ? void 0 : E.option("disabled", !1);
  return sx(() => {
    u && N();
  }), rx(E.destroy), I0({ start: N, pause: L, resume: A }, E);
}
const Er = [
  "update",
  "start",
  "add",
  "remove",
  "choose",
  "unchoose",
  "end",
  "sort",
  "filter",
  "clone",
  "move",
  "change"
], ox = [
  "animation",
  "ghostClass",
  "group",
  "sort",
  "disabled",
  "store",
  "handle",
  "draggable",
  "swapThreshold",
  "invertSwap",
  "invertedSwapThreshold",
  "removeCloneOnHide",
  "direction",
  "chosenClass",
  "dragClass",
  "ignore",
  "filter",
  "preventOnFilter",
  "easing",
  "setData",
  "dropBubble",
  "dragoverBubble",
  "dataIdAttr",
  "delay",
  "delayOnTouchOnly",
  "touchStartThreshold",
  "forceFallback",
  "fallbackClass",
  "fallbackOnBody",
  "fallbackTolerance",
  "fallbackOffset",
  "supportPointer",
  "emptyInsertThreshold",
  "scroll",
  "forceAutoScrollFallback",
  "scrollSensitivity",
  "scrollSpeed",
  "bubbleScroll",
  "modelValue",
  "tag",
  "target",
  "customUpdate",
  ...Er.map((e) => `on${e.replace(/^\S/, (t) => t.toUpperCase())}`)
], lx = Ee({
  name: "VueDraggable",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: ox,
  emits: ["update:modelValue", ...Er],
  setup(e, { slots: t, emit: n, expose: a, attrs: r }) {
    const s = Er.reduce((d, f) => {
      const v = `on${f.replace(/^\S/, (p) => p.toUpperCase())}`;
      return d[v] = (p) => n(f, p), d;
    }, {}), i = $(() => {
      const d = li(e), { modelValue: f } = d, v = pl(d, ["modelValue"]), p = Object.entries(v).reduce((y, [w, _]) => {
        const b = C(_);
        return b !== void 0 && (y[w] = b), y;
      }, {});
      return I0(I0({}, s), wC(I0(I0({}, r), p)));
    }), l = $({
      get: () => e.modelValue,
      set: (d) => n("update:modelValue", d)
    }), u = pe(), c = W0(
      ix(e.target || u, l, i)
    );
    return a(c), () => {
      if (t.default)
        return Yl(e.tag || "div", { ref: u }, t.default(c));
    };
  }
}), ux = {
  name: "LuxGallery",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  components: {
    VueDraggable: lx
  },
  // computed: mapState([
  //   // map this.count to store.state.count
  //   'gallery'
  // ]),
  computed: {
    items: {
      get() {
        return Je.state.gallery.items;
      },
      set(e) {
        Je.commit("SORT_ITEMS", e);
      }
    },
    // ...mapState({
    //   gallery: state => store.gallery.state,
    // }),
    selected() {
      return Je.state.gallery.selected;
    },
    cut() {
      return Je.state.gallery.cut;
    },
    changeList() {
      return Je.state.gallery.changeList;
    },
    ogItems() {
      return Je.state.gallery.ogItems;
    }
  },
  props: {
    /**
     * Gallery items to be displayed in the gallery.
     */
    galleryItems: {
      required: !0,
      type: Array
    },
    /**
     * Pixel width of the cards in the gallery.
     */
    cardPixelWidth: {
      required: !1,
      default: 300
    }
  },
  methods: {
    deselect: function(e) {
      (e.target.className === "lux-gallery" || e.target.className === "lux-gallery lux-galleryWrapper") && this.selectNone();
    },
    selectNone: function() {
      Je.commit("SELECT", []);
    },
    getItemById: function(e) {
      let t = this.getItemIndexById(e);
      return this.items[t];
    },
    getItemIndexById: function(e) {
      return this.items.map(function(t) {
        return t.id;
      }).indexOf(e);
    },
    hasChanged: function(e) {
      return this.changeList.indexOf(e) > -1;
    },
    isDisabled: function(e) {
      return this.cut.indexOf(e) > -1;
    },
    isSelected: function(e) {
      return this.selected.indexOf(e) > -1;
    },
    select: function(e, t) {
      if (this.$emit("card-clicked", t), !this.isDisabled(this.getItemById(e))) {
        let n = [];
        if (t.metaKey)
          n = this.selected, n.push(this.getItemById(e)), Je.commit("SELECT", n);
        else if (this.selected.length === 1 && t.shiftKey) {
          let a = this.getItemIndexById(this.selected[0].id), r = this.getItemIndexById(e), s = Math.min(a, r), i = Math.max(a, r);
          for (let l = s; l <= i; l++)
            n.push(this.items[l]);
          Je.commit("SELECT", n);
        } else
          Je.commit("SELECT", [this.getItemById(e)]);
      }
    }
  },
  beforeMount: function() {
    this.galleryItems && Je.commit("SET_GALLERY", this.galleryItems);
  }
};
function cx(e, t, n, a, r, s) {
  const i = Y("lux-media-image"), l = Y("lux-heading"), u = Y("lux-text-style"), c = Y("lux-card"), d = Y("VueDraggable");
  return h(), H(d, {
    class: "lux-gallery",
    modelValue: s.items,
    "onUpdate:modelValue": t[0] || (t[0] = (f) => s.items = f),
    tag: "div",
    onClick: t[1] || (t[1] = (f) => s.deselect(f)),
    ref: "el"
  }, {
    default: P(() => [
      (h(!0), g(se, null, fe(s.items, (f) => (h(), H(c, {
        key: f.id,
        id: f.id,
        class: "lux-galleryCard",
        cardPixelWidth: n.cardPixelWidth,
        size: "medium",
        selected: s.isSelected(f),
        disabled: s.isDisabled(f),
        edited: s.hasChanged(f.id),
        onClickCapture: (v) => s.select(f.id, v)
      }, {
        default: P(() => [
          k(i, {
            src: f.mediaUrl
          }, null, 8, ["src"]),
          k(l, { level: "h2" }, {
            default: P(() => [
              me(j(f.title), 1)
            ]),
            _: 2
          }, 1024),
          k(u, { variation: "default" }, {
            default: P(() => [
              me(j(f.caption), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["id", "cardPixelWidth", "selected", "disabled", "edited", "onClickCapture"]))), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]);
}
const dx = /* @__PURE__ */ S(ux, [["render", cx]]), fx = {
  name: "LuxGridContainer",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the grid container.
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * Determines how the flexbox container is horizontally aligned. This value defaults to
     * having space between grid items. Options include `start`, `center`, and `end`.
     */
    horizontal: {
      type: String,
      default: ""
    }
  }
};
function hx(e, t, n, a, r, s) {
  return h(), H(ie(n.type), {
    class: z(["lux-flex-container", n.horizontal])
  }, {
    default: P(() => [
      ae(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["class"]);
}
const px = /* @__PURE__ */ S(fx, [["render", hx], ["__scopeId", "data-v-f541e93f"]]), vx = {
  name: "LuxGridItem",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the container.
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * Sets the size of the column. Prefix with `sm-` or `lg-`. Based on a 12 column grid.
     * The inclusion of `auto` will set that grid item to have a width based on the width and height of the content.
     * The inclusion of `fill` will set the grid item to have a width based on the space available.
     */
    columns: {
      type: String,
      default: ""
    },
    /**
     * Sets the order to lay out an item in a grid container.
     */
    order: {
      type: String,
      default: ""
    },
    /**
     * Pushes grid items to the right side of the container.
     */
    offset: {
      type: Boolean,
      default: !1
    },
    /**
     * Sets the vertical alignment of the item. `start`, `center`, or `end`. For horizontal alignment, please look at the grid-container component.
     */
    vertical: {
      type: String,
      default: ""
    }
  }
};
function mx(e, t, n, a, r, s) {
  return h(), H(ie(n.type), {
    class: z(["lux-col", n.columns, n.vertical, { push: n.offset }, n.order])
  }, {
    default: P(() => [
      ae(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]);
}
const gx = /* @__PURE__ */ S(vx, [["render", mx]]), yx = {
  name: "LuxHeading",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The heading level used for the heading.
     * `h1, h2, h3, h4, h5, h6`
     */
    level: {
      type: String,
      default: "h1",
      validator: (e) => e.match(/(h1|h2|h3|h4|h5|h6)/)
    },
    /**
     * The size of the heading.
     * `h1, h2, h3, h4, h5, h6`
     */
    size: {
      type: String,
      default: "h1",
      validator: (e) => e.match(/(h1|h2|h3|h4|h5|h6)/)
    },
    /**
     * Whether the heading is visually hidden or not.
     * `true, false`
     */
    hidden: {
      type: Boolean,
      default: !1
    }
  }
};
function bx(e, t, n, a, r, s) {
  return h(), H(ie(n.level), {
    class: z(["lux-heading", [{ "lux-hidden": n.hidden }, n.size]])
  }, {
    default: P(() => [
      ae(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]);
}
const _x = /* @__PURE__ */ S(yx, [["render", bx]]), wx = {
  name: "LuxLoader",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * Sets the diameter of the circle. `x-small, small, medium, large, x-large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(x-small|small|medium|large|x-large)/)
    },
    /**
     * Determines whether the loader fills the entire screen (with overlay) or the container it's in (no overlay).
     */
    fullscreen: {
      type: Boolean,
      default: !1
    },
    /**
     * The html element name used for the wrapper.
     * `div, section`
     */
    wrapper: {
      type: String,
      default: "div",
      validator: (e) => e.match(/(div|span)/)
    }
  }
}, $x = ["size"];
function Cx(e, t, n, a, r, s) {
  return h(), H(ie(n.wrapper), {
    class: z(["lux-overlay", { "lux-fullscreen": n.fullscreen }])
  }, {
    default: P(() => [
      o("div", {
        class: "lux-loader",
        size: n.size
      }, null, 8, $x)
    ]),
    _: 1
  }, 8, ["class"]);
}
const xx = /* @__PURE__ */ S(wx, [["render", Cx], ["__scopeId", "data-v-83b50a20"]]), Sx = {
  name: "LuxLogoLibrary",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 440
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 97
    },
    /**
     * The color of the logo text.
     */
    color: {
      type: String,
      default: "#ffffff"
    }
  }
}, Mx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 440.06 97",
  preserveAspectRatio: "xMinYMid",
  "aria-labelledby": "lux-logo-library",
  role: "img"
};
function Dx(e, t, n, a, r, s) {
  return h(), g("svg", Mx, [
    t[1] || (t[1] = o("title", { id: "lux-logo-library" }, "Princeton University Library", -1)),
    o("g", null, [
      t[0] || (t[0] = Dn('<clipPath id="clip-path" data-v-d5f9d1c9><path d="M3 .91h90v90H3z" fill="none" data-v-d5f9d1c9></path></clipPath><rect width="96" height="97" rx="12.24" ry="12.24" fill="#ef7622" data-v-d5f9d1c9></rect><g class="pul-logo-c" data-v-d5f9d1c9><g class="pul-logo-c" data-v-d5f9d1c9><path class="pul-logo-d" d="M10.77 83.5V20.15a20.61 20.61 0 0 0 6.59-3.05v59.8h.41a16.4 16.4 0 0 0 3.53-.38 38 38 0 0 0 7.62-2.49c1.24-.54 2.45-1.13 3.67-1.71a17.37 17.37 0 0 1 5.72-1.71 11.78 11.78 0 0 1 6.16.85A7 7 0 0 1 46.74 73a4.24 4.24 0 0 1 1.11 2c0 .06 0 .11.06.2s.05-.07.05-.09A4.16 4.16 0 0 1 49.12 73a7.6 7.6 0 0 1 3.17-1.9 12 12 0 0 1 4.42-.55 16.49 16.49 0 0 1 6.44 1.73c2 1 4 1.89 6 2.66a33.85 33.85 0 0 0 6.22 1.74 14.33 14.33 0 0 0 2.69.23h.33V17.33a.51.51 0 0 1 0-.07v-.07A21.31 21.31 0 0 0 85 20v63.5z" data-v-d5f9d1c9></path><path class="pul-logo-d" d="M24.83 32.7A70.14 70.14 0 0 1 25 17l.41.2a17.26 17.26 0 0 0 4.85 1.69 13.45 13.45 0 0 0 8.91-1.44 19.27 19.27 0 0 0 5-3.93 25.37 25.37 0 0 0 3.55-4.83l.12-.19.21.35a24.49 24.49 0 0 0 5.68 6.73 15.38 15.38 0 0 0 6.35 3.2 13.73 13.73 0 0 0 7.33-.4 19 19 0 0 0 2.91-1.22l.25-.13h.12a70.13 70.13 0 0 1 .16 15.56H24.84M35.7 60.37a50.22 50.22 0 0 1-5.26-8.68l17.42-17.43 17.37 17.4A46.75 46.75 0 0 1 60 60.35l-6.05-6-6.07-6.07L35.7 60.37" data-v-d5f9d1c9></path></g></g>', 3)),
      o("path", {
        style: Fe({ fill: n.color }),
        d: "M118.7 28.26h-3V3.93h8.63q4 0 6 2.2a7.41 7.41 0 0 1 1.92 5 7 7 0 0 1-2.09 5.19 7.5 7.5 0 0 1-5.48 2h-5.9zm0-12.4h5.6a4.75 4.75 0 0 0 3.48-1.29 4.56 4.56 0 0 0 1.32-3.41 5 5 0 0 0-1.18-3.24 4.16 4.16 0 0 0-3.4-1.43h-5.82zm21.15 12.4h-2.8v-18h2.46v4.21a9 9 0 0 1 2.61-3.86 4.75 4.75 0 0 1 2.68-.88 11.06 11.06 0 0 1 1.1.07v2.67h-.57a4.93 4.93 0 0 0-3.85 1.73 7 7 0 0 0-1.64 4.54zm13.36-24.33V7h-3V3.93zm-.09 6.33v18h-2.8v-18zm21.01 18h-2.62V16.69a4.67 4.67 0 0 0-1.09-3.51 3.72 3.72 0 0 0-2.64-1 4.53 4.53 0 0 0-3.59 1.71 6.73 6.73 0 0 0-1.45 4.51v9.87h-2.8v-18h2.6v3.32q2.19-3.81 5.69-3.81a5.63 5.63 0 0 1 3.43 1 5.54 5.54 0 0 1 1.94 2.34 14.25 14.25 0 0 1 .53 4.71zm17.47-6.31l2.53.45a8.06 8.06 0 0 1-2.37 4.67A7.16 7.16 0 0 1 181.51 26a11.29 11.29 0 0 1-2-6.71 11 11 0 0 1 2.06-6.82 6.66 6.66 0 0 1 5.61-2.72 6.41 6.41 0 0 1 4.71 1.76 7.86 7.86 0 0 1 2.2 4.54l-2.53.48q-.71-4.46-4.3-4.46a4 4 0 0 0-3.56 2 9.42 9.42 0 0 0-1.25 5.11 9.87 9.87 0 0 0 1.24 5.37 3.91 3.91 0 0 0 3.48 1.92q3.51-.03 4.43-4.52zm19.49.94l2.6.53a7.32 7.32 0 0 1-2.78 3.82 8 8 0 0 1-4.91 1.52 7.57 7.57 0 0 1-6-2.6 9.93 9.93 0 0 1-2.28-6.81 10 10 0 0 1 2.37-6.95 7.65 7.65 0 0 1 6-2.65 7.19 7.19 0 0 1 5.68 2.44q2.15 2.44 2.2 7.31h-13.05q0 4.08 1.71 5.51a5.57 5.57 0 0 0 3.62 1.43q3.44 0 4.84-3.55zm-.16-5.47a7.83 7.83 0 0 0-.5-2.69 4.6 4.6 0 0 0-1.57-2 4.3 4.3 0 0 0-2.66-.83 4.74 4.74 0 0 0-3.54 1.5 6.19 6.19 0 0 0-1.63 4zm16.5 8.93v2.21a19.86 19.86 0 0 1-2.57.2q-5.22 0-5.22-5.46V12.45h-3.19v-2.19h3.19l.13-4.53 2.6-.25v4.78h4v2.19h-4v11.31q0 2.78 2.89 2.78a13.69 13.69 0 0 0 2.17-.19zm10.2 2.41a6.84 6.84 0 0 1-5.78-2.76 11 11 0 0 1-2.08-6.81 9.82 9.82 0 0 1 2.33-6.87 7.53 7.53 0 0 1 5.81-2.57 7.1 7.1 0 0 1 5.87 2.7 10.51 10.51 0 0 1 2.15 6.75 10.11 10.11 0 0 1-2.32 6.88 7.56 7.56 0 0 1-5.98 2.68zm.21-2.32a4.45 4.45 0 0 0 3.58-1.76q1.44-1.77 1.44-5.49t-1.52-5.43a4.63 4.63 0 0 0-3.55-1.68 4.46 4.46 0 0 0-3.53 1.7q-1.44 1.7-1.45 5.39 0 3.9 1.45 5.59a4.51 4.51 0 0 0 3.59 1.68zm27.73 1.82H263V16.69a4.67 4.67 0 0 0-1.09-3.51 3.72 3.72 0 0 0-2.64-1 4.52 4.52 0 0 0-3.59 1.71 6.73 6.73 0 0 0-1.45 4.51v9.87h-2.8v-18H254v3.32q2.19-3.81 5.69-3.81a5.63 5.63 0 0 1 3.43 1 5.54 5.54 0 0 1 1.88 2.37 14.28 14.28 0 0 1 .53 4.71zm31.32-24.33h2.53v15.89q0 4.78-2.34 6.86a8.91 8.91 0 0 1-6.14 2.08q-4.22 0-6.26-2.14t-2-6.8V3.93h3v15.89a8.65 8.65 0 0 0 .66 4 3.93 3.93 0 0 0 2 1.71 7.24 7.24 0 0 0 2.8.55 5.75 5.75 0 0 0 4.28-1.48q1.46-1.48 1.46-4.78zm23.25 24.33h-2.62V16.69a4.67 4.67 0 0 0-1.09-3.51 3.72 3.72 0 0 0-2.64-1 4.52 4.52 0 0 0-3.59 1.71 6.73 6.73 0 0 0-1.45 4.51v9.87H306v-18h2.6v3.32q2.19-3.81 5.69-3.81a5.63 5.63 0 0 1 3.43 1 5.54 5.54 0 0 1 1.94 2.34 14.27 14.27 0 0 1 .53 4.71zm9.73-24.33V7h-3V3.93zm-.09 6.33v18H327v-18zm20.01 0l-6.22 18h-2.88l-6.45-18h3.11l5 14.63 5-14.63zm15.82 12.63l2.6.53a7.32 7.32 0 0 1-2.78 3.82 8 8 0 0 1-4.87 1.51 7.57 7.57 0 0 1-6-2.6 9.93 9.93 0 0 1-2.28-6.81 10 10 0 0 1 2.37-6.95 7.65 7.65 0 0 1 6-2.65 7.19 7.19 0 0 1 5.68 2.44q2.15 2.44 2.2 7.31h-13.1q0 4.08 1.71 5.51a5.57 5.57 0 0 0 3.62 1.43q3.44.01 4.85-3.54zm-.16-5.47a7.81 7.81 0 0 0-.5-2.69 4.61 4.61 0 0 0-1.57-2 4.31 4.31 0 0 0-2.66-.83 4.74 4.74 0 0 0-3.54 1.5 6.19 6.19 0 0 0-1.63 4zm11.31 10.84H374v-18h2.46v4.21a9 9 0 0 1 2.54-3.86 4.75 4.75 0 0 1 2.68-.88c.29 0 .65 0 1.11.07v2.67h-.57a4.93 4.93 0 0 0-3.85 1.73 7 7 0 0 0-1.64 4.54zm8.24-4.67l2.7-.59q.89 3.4 5.63 3.4a5.34 5.34 0 0 0 3-.78 2.49 2.49 0 0 0 1.21-2.21q0-2.12-3.08-2.69l-3.84-.72a6.93 6.93 0 0 1-3.55-1.68 4.33 4.33 0 0 1-1.32-3.3 4.76 4.76 0 0 1 1.8-3.79 7.25 7.25 0 0 1 4.85-1.52q5.86 0 7.23 4.58l-2.57.55q-1.1-2.82-4.54-2.82a5.11 5.11 0 0 0-2.81.7 2.21 2.21 0 0 0-1.1 2q0 2 2.8 2.51l3.51.63q5.51 1 5.51 5.34a4.77 4.77 0 0 1-2 4 8.92 8.92 0 0 1-5.46 1.53q-6.43.03-7.97-5.14zm23.5-19.66V7h-3V3.93zm-.09 6.33v18h-2.8v-18zm14.99 16.09v2.21a19.87 19.87 0 0 1-2.57.2q-5.22 0-5.22-5.46V12.45h-3.19v-2.19h3.19l.13-4.53 2.6-.25v4.78h4v2.19h-4v11.31q0 2.78 2.89 2.78a13.7 13.7 0 0 0 2.17-.19zm16.66-16.09l-7.22 20.11q-1.57 4.35-5 4.35a8.87 8.87 0 0 1-2.41-.37v-2.21a8.57 8.57 0 0 0 1.87.25 3.33 3.33 0 0 0 2.24-.77q.9-.77 1.79-3.74l-6.23-17.62h2.84l4.83 13.53 4.92-13.53zM116 43.11h7.42V84.2h22v6.51H116zm45.61 0H169v47.6h-7.35zm26.25 0h17.29c8.89 0 13.44 5.39 13.44 12a9 9 0 0 1-6.44 9.17c6.37 1.47 9.73 6 9.73 12.11 0 8.19-5.46 14.35-15.47 14.35h-18.55zm16.94 18.55c4.41 0 6.51-2.45 6.51-6s-2-6-6.65-6h-9.38v12zM206 84.2c5.74 0 8.47-3.36 8.47-8.12S211.53 68 205.65 68h-10.37v16.2zm64.68 6.51h-8.54l-8.54-12.53a38.3 38.3 0 0 1-4 .28h-4.48v12.25h-7.42v-47.6h11.9c13.16 0 20.51 6.86 20.51 17.78 0 7.35-3.29 12.39-9.52 15.12zm-21.36-18.62c9.45 0 13.23-4.13 13.23-11.2s-3.92-11.27-13.23-11.27h-4.2v22.47zm54.25-29.47h.84l20.86 48.09h-7.7L314.85 84h-21.78l-2.73 6.72h-7.14zm8.61 35.14l-6-14.84a71.79 71.79 0 0 1-2.38-7.07 64.14 64.14 0 0 1-2.31 7.07l-6 14.84zm61.04 12.95h-8.54l-8.54-12.53a38.3 38.3 0 0 1-4 .28h-4.48v12.25h-7.42v-47.6h11.9c13.16 0 20.51 6.86 20.51 17.78 0 7.35-3.29 12.39-9.52 15.12zm-21.35-18.62c9.45 0 13.23-4.13 13.23-11.2s-3.92-11.27-13.23-11.27h-4.2v22.47zm50.54 3.57l-18.06-32.55h8.19l10.78 19.6a50.68 50.68 0 0 1 2.87 6.86 63.32 63.32 0 0 1 2.87-6.86l10.43-19.6h7.63l-17.29 32.13v15.47h-7.42z"
      }, null, 4)
    ])
  ]);
}
const Ol = /* @__PURE__ */ S(Sx, [["render", Dx], ["__scopeId", "data-v-d5f9d1c9"]]), kx = {
  name: "LuxLibraryLogo",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * Whether the theme is dark or light.
     */
    theme: {
      type: String,
      default: "dark"
    }
  },
  components: {
    LuxLogoLibrary: Ol
  }
}, Lx = { href: "https://library.princeton.edu" };
function Ox(e, t, n, a, r, s) {
  const i = Y("lux-logo-library");
  return h(), H(ie(n.type), {
    class: z(["lux-library-logo", n.theme])
  }, {
    default: P(() => [
      o("a", Lx, [
        n.theme === "dark" ? (h(), H(i, {
          key: 0,
          class: "full-logo"
        })) : (h(), H(i, {
          key: 1,
          color: "#000000",
          class: "full-logo"
        }))
      ])
    ]),
    _: 1
  }, 8, ["class"]);
}
const x1 = /* @__PURE__ */ S(kx, [["render", Ox], ["__scopeId", "data-v-0ced6934"]]), Ix = {
  name: "LuxSpacer",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    }
  }
};
function Ex(e, t, n, a, r, s) {
  return h(), H(ie(n.type), { class: "lux-spacer" }, {
    default: P(() => [
      ae(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  });
}
const Il = /* @__PURE__ */ S(Ix, [["render", Ex], ["__scopeId", "data-v-1ef72dfa"]]), Tx = {
  name: "LuxWrapper",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the wrapper.
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * The maximum width of the wrapper. Default is set to 1440.
     */
    maxWidth: {
      type: [String, Number],
      default: 1440
    },
    /**
     * Determines whether the wrapper takes up 100% of the parent container.
     */
    fullWidth: {
      type: [String, Boolean],
      default: !1
    },
    /**
     * Determines how the flexbox wrapper is horizontally aligned. This value defaults to
     * having space between grid items. Options include `start`, `center`, and `end`.
     */
    horizontal: {
      type: String,
      default: ""
    }
  }
};
function Ax(e, t, n, a, r, s) {
  return h(), H(ie(n.type), {
    class: z(["lux-wrapper", { "lux-full-width": n.fullWidth }, n.horizontal]),
    style: Fe({ "max-width": n.maxWidth + "px" })
  }, {
    default: P(() => [
      ae(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["class", "style"]);
}
const Ya = /* @__PURE__ */ S(Tx, [["render", Ax], ["__scopeId", "data-v-49c06837"]]), Px = {
  name: "LuxLibraryHeader",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  props: {
    /**
     * The html element name used for the container
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * The name of the application or site
     */
    appName: {
      type: String,
      default: ""
    },
    /**
     * The abbreviation of the application or site's name
     */
    abbrName: {
      type: String,
      default: ""
    },
    /**
     * The URL of landing page for the application or site
     */
    appUrl: {
      type: String,
      default: ""
    },
    /**
     * The maximum width of the wrapper. Default is set to 1440.
     */
    maxWidth: {
      type: Number,
      default: 1440
    },
    /**
     * Whether the header is dark, shade, or light. Default is set to dark.
     */
    theme: {
      type: String,
      default: "dark"
    }
  },
  methods: {
    value: function(e) {
      return e == "light" ? "light" : "dark";
    }
  },
  components: {
    LuxSpacer: Il,
    LuxWrapper: Ya,
    LuxLibraryLogo: x1
  }
}, zx = ["href", "title"], Yx = {
  id: "appName",
  class: "full-name"
}, Vx = { class: "abbr-name" };
function Hx(e, t, n, a, r, s) {
  const i = Y("lux-library-logo"), l = Y("lux-spacer"), u = Y("lux-wrapper");
  return h(), H(ie(n.type), {
    class: z(["lux-library-header", n.theme])
  }, {
    default: P(() => [
      k(u, {
        class: "lux-header-content",
        maxWidth: n.maxWidth
      }, {
        default: P(() => [
          ae(e.$slots, "logo", {}, () => [
            k(i, {
              theme: s.value(n.theme)
            }, null, 8, ["theme"])
          ], !0),
          n.appName ? (h(), g("a", {
            key: 0,
            class: "lux-app-name",
            href: n.appUrl,
            title: n.appName,
            "aria-labelledby": "appName"
          }, [
            o("span", Yx, j(n.appName), 1),
            o("span", Vx, j(n.abbrName), 1)
          ], 8, zx)) : B("", !0),
          k(l),
          ae(e.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["maxWidth"])
    ]),
    _: 3
  }, 8, ["class"]);
}
const Nx = /* @__PURE__ */ S(Px, [["render", Hx], ["__scopeId", "data-v-784b67a5"]]), Rx = {
  name: "LuxLogoInstagram",
  status: "ready",
  release: "5.2.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 24
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 24
    }
  }
}, Bx = ["width", "height"];
function Fx(e, t, n, a, r, s) {
  return h(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: n.width,
    height: n.height,
    viewBox: "0 0 16 16",
    preserveAspectRatio: "xMinYMid",
    "aria-labelledby": "logo-instagram",
    role: "img",
    fill: "currentColor",
    class: "lux-logo-instagram"
  }, t[0] || (t[0] = [
    o("title", {
      id: "logo-instagram",
      lang: "en"
    }, "PUL Instagram", -1),
    o("g", null, [
      o("path", { d: "M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" })
    ], -1)
  ]), 8, Bx);
}
const El = /* @__PURE__ */ S(Rx, [["render", Fx]]), jx = {
  name: "LuxLogoUniversityWhite",
  status: "ready",
  release: "5.2.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 263
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 72
    }
  }
}, Wx = ["width", "height"];
function Ux(e, t, n, a, r, s) {
  return h(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: n.width,
    height: n.height,
    viewBox: "0 0 194 54.892",
    "aria-labelledby": "logo-university-white",
    role: "img"
  }, t[0] || (t[0] = [
    Dn('<title id="logo-university-white" lang="en">Princeton University</title><g><path class="a" d="M193.689,9.9a.6.6,0,0,0-.059-.276h-.448c-.975,0-1.6.042-3.357.042-.6,0-1.5-.042-1.717-.042H187.6c-.059.042-.08.255-.08.332a.516.516,0,0,0,.1.332,8.36,8.36,0,0,1,2.01.566,3.813,3.813,0,0,1,.566,1.993c.018.29.038.584.038,1.385v4.077a7.637,7.637,0,0,1-.038.839c-.332-.371-.8-1.07-1.58-1.951l-6.521-7.22a1.354,1.354,0,0,0-.29-.255c-.157,0-.43-.018-.584-.018-1.252,0-3.514-.059-3.846-.059a.737.737,0,0,0-.08.273,3.348,3.348,0,0,0,.059.371,2.7,2.7,0,0,1,1.465.741,6.662,6.662,0,0,1,1.031,1.231,1.7,1.7,0,0,1,.081.626c0,1.014-.059,2.437-.059,3.8v3.962a8.61,8.61,0,0,1-.115,1.482,4.089,4.089,0,0,1-2.049,1,1.067,1.067,0,0,0-.077.35c0,.059.018.255.056.276h.371c.392,0,1.29-.059,1.874-.059.86,0,1.444.059,2.245.059h1.171c.077-.021.1-.255.1-.332a.915.915,0,0,0-.059-.315,3.738,3.738,0,0,1-2.343-1.21,11.051,11.051,0,0,1-.252-2.419c0-.622-.021-1.483-.021-2.633,0-1.545.021-2.892.038-3.573.119.136.255.311.353.43l9.017,10.129c.094.1.448.115.545.115a.474.474,0,0,0,.234-.038,2.215,2.215,0,0,0,.175-.878c0-.563-.021-1.15-.021-1.444V13.449c0-2.441,1.154-3.126,2.5-3.182a.841.841,0,0,0,.077-.371m-22.367,6.2c0,2.951-.818,5.546-1.93,6.462a3.165,3.165,0,0,1-2.07.7,2.918,2.918,0,0,1-2.594-1.308,10.377,10.377,0,0,1-1.154-5.073c0-2.713.7-4.839,1.951-5.874a3.116,3.116,0,0,1,2.032-.762,3.249,3.249,0,0,1,2.654,1.346,7.523,7.523,0,0,1,1.112,4.507m3.531.374a6.539,6.539,0,0,0-3.472-6.07,7.547,7.547,0,0,0-3.71-1,7.943,7.943,0,0,0-6.577,3.629,7.463,7.463,0,0,0-1.129,3.944,7.26,7.26,0,0,0,2.79,5.717,7.325,7.325,0,0,0,4.451,1.405,8.08,8.08,0,0,0,2.965-.566,7.008,7.008,0,0,0,2.713-1.853,7.539,7.539,0,0,0,1.969-5.21M157.7,14.012V10.033c0-.294-.115-.371-.409-.371-.587,0-3.668.077-6.79.077-2.423,0-4.433-.038-5.524-.038h-1.448c-.252,0-.329.056-.329.332V13.76a.558.558,0,0,0,.311.077,1.629,1.629,0,0,0,.43-.038,6.568,6.568,0,0,1,2.734-3.259c.584-.059,1.734-.077,2.045-.077.021.213.042.9.059,1.717.021,1.4.021,2.01.021,5.325,0,2.871-.021,4.161-.059,4.472-.077.545.021.955-2.322,1.052a1.121,1.121,0,0,0-.059.448,1.59,1.59,0,0,0,.021.315h.759c.724,0,2.419-.08,3.126-.08.563,0,2.381.059,3.57.059h.545a.979.979,0,0,0,.059-.409.732.732,0,0,0-.077-.35,4.044,4.044,0,0,1-2.01-.371,5.991,5.991,0,0,1-.178-1.465c-.018-2.109-.038-2.909-.038-4.315,0-1.815.021-3.042.021-6.42.273,0,.9-.021,1.482,0a3.8,3.8,0,0,1,2.322,1.482A9.658,9.658,0,0,1,157,14.054a1.089,1.089,0,0,0,.332.035.981.981,0,0,0,.371-.077m-16.822,6.343a4.241,4.241,0,0,0-.021-.563.435.435,0,0,0-.294-.059,1.641,1.641,0,0,0-.43.038,7.436,7.436,0,0,1-2.147,2.986,3.02,3.02,0,0,1-1.465.213h-1.6a6.842,6.842,0,0,1-1.287-.1c-.294-.056-.6-.524-.741-.835a2.05,2.05,0,0,1-.217-1.231V16.53h.724a3.1,3.1,0,0,1,1.189.276,1.771,1.771,0,0,1,.878.818,6.673,6.673,0,0,1,.332,1.619,1.319,1.319,0,0,0,.51.077.688.688,0,0,0,.388-.095c0-.528-.119-1.951-.119-2.734,0-.975.136-2.322.2-3.025a.847.847,0,0,0-.388-.077,1.424,1.424,0,0,0-.507.059c-.059.269-.276,1.091-.315,1.15a2.346,2.346,0,0,1-1.325,1.014,5.083,5.083,0,0,1-1.133.157H132.7V13.953c0-1.871.038-2.476.056-2.829.021-.234.059-.486.08-.661a7.709,7.709,0,0,1,1.171-.042c1.129,0,1.657.021,1.832.021a2.18,2.18,0,0,1,1.252.392,8.2,8.2,0,0,1,1.871,2.42,1.578,1.578,0,0,0,.413.038c.115,0,.136-.038.294-.119,0-1.189-.08-2.731-.119-3.22-.021-.2-.059-.252-.448-.252-.157,0-.9-.038-1.678-.038-1.112,0-1.563.018-3.262.018-.916,0-2.811.021-3.612.021-1.168,0-2.164-.038-2.671-.038h-.664a.636.636,0,0,0-.1.311.863.863,0,0,0,.1.388,9.948,9.948,0,0,1,1.427.217,1.6,1.6,0,0,1,.7,1.269c.042.409.059,1.542.059,2.441v4.018c0,.822-.018,2.01-.038,2.5a5.615,5.615,0,0,1-.427,1.853,5.138,5.138,0,0,1-1.759.294,1.129,1.129,0,0,0-.1.43.721.721,0,0,0,.1.35h.643c.626,0,2.927-.059,3.455-.059.489,0,1.427.038,2.556.038.626,0,2.462.119,6.4.119a1.658,1.658,0,0,0,.528-.038.582.582,0,0,0,.077-.315c.042-.388.042-1.542.042-3.122m-16.51.685a.651.651,0,0,0-.664-.468c-.042,0-.1.018-.136.018a4.609,4.609,0,0,1-3.927,2.283A4.27,4.27,0,0,1,115.7,20.3a10.659,10.659,0,0,1-.6-3.549,8.6,8.6,0,0,1,.584-3.416c.86-2.262,2.109-2.969,3.633-2.969a3.994,3.994,0,0,1,3.122,1.759,8.715,8.715,0,0,1,.993,2.364,2.07,2.07,0,0,0,.43.056.989.989,0,0,0,.468-.175c-.017-.217-.213-1.717-.213-2.185,0-.587.154-1.542.154-1.913a1.588,1.588,0,0,0-.759-.217,4.02,4.02,0,0,0-.664.8,6.436,6.436,0,0,0-4.332-1.385,6.676,6.676,0,0,0-4.9,1.93,7.422,7.422,0,0,0-2.087,5.5,7.138,7.138,0,0,0,2.752,5.836,7.762,7.762,0,0,0,4.549,1.311,6.049,6.049,0,0,0,5-2.091,4.066,4.066,0,0,0,.549-.916M109.182,9.9a.64.64,0,0,0-.059-.276h-.451c-.975,0-1.6.042-3.357.042-.6,0-1.5-.042-1.717-.042h-.507c-.059.042-.08.255-.08.332a.5.5,0,0,0,.1.332,8.451,8.451,0,0,1,2.011.566,3.847,3.847,0,0,1,.563,1.993c.021.29.042.584.042,1.385v4.077a6.64,6.64,0,0,1-.042.839c-.329-.371-.8-1.07-1.58-1.951l-6.514-7.22a1.358,1.358,0,0,0-.294-.255c-.157,0-.43-.018-.584-.018-1.252,0-3.514-.059-3.846-.059a.73.73,0,0,0-.077.273,3.328,3.328,0,0,0,.056.371,2.7,2.7,0,0,1,1.465.741,6.548,6.548,0,0,1,1.035,1.231,1.714,1.714,0,0,1,.077.626c0,1.014-.056,2.437-.056,3.8v3.962a8.542,8.542,0,0,1-.119,1.482,4.089,4.089,0,0,1-2.049,1,1.167,1.167,0,0,0-.077.35c0,.059.018.255.056.276h.371c.392,0,1.29-.059,1.874-.059.86,0,1.444.059,2.245.059h1.168c.077-.021.1-.255.1-.332a.911.911,0,0,0-.059-.315,3.731,3.731,0,0,1-2.339-1.21,11.278,11.278,0,0,1-.252-2.419c0-.622-.021-1.483-.021-2.633,0-1.545.021-2.892.038-3.573.119.136.255.311.353.43l9.014,10.129a1.1,1.1,0,0,0,.545.115.461.461,0,0,0,.234-.038,2.216,2.216,0,0,0,.175-.878c0-.563-.021-1.15-.021-1.444V13.449c0-2.441,1.154-3.126,2.5-3.182a.846.846,0,0,0,.08-.371m-19.3,13.524a1.277,1.277,0,0,0-.059-.392,13.548,13.548,0,0,1-1.444-.175,3.084,3.084,0,0,1-.664-1.5c-.017-.937-.038-2.871-.038-4.682v-4.8a1.527,1.527,0,0,1,.353-1.052,3.325,3.325,0,0,1,1.738-.507,1.254,1.254,0,0,0,.056-.371.577.577,0,0,0-.1-.315h-.566c-.818,0-2.731.1-3.4.1-.409,0-2.322-.056-3.182-.077h-.427a.476.476,0,0,0-.1.332,2.479,2.479,0,0,0,.038.371,4.119,4.119,0,0,1,1.521.273,2.156,2.156,0,0,1,.647,1.661c.018.371.035,1.171.056,2.965.021.976.038,2.343.038,3.472,0,.566-.038,1.836-.059,2.521a3.364,3.364,0,0,1-.269,1.171c-.234.192-.472.545-1.9.643a1.5,1.5,0,0,0-.059.409c0,.157.038.234.038.332h.332c.783,0,2.734-.1,3.748-.1.294,0,2.322.059,2.965.059H89.8a.782.782,0,0,0,.077-.332M74.227,13.233a3.041,3.041,0,0,1-1.773,2.832,6.754,6.754,0,0,1-1.6.154,4.809,4.809,0,0,1-.724-.038l-.021-1.661V10.928a.626.626,0,0,1,.119-.43,2,2,0,0,1,.822-.115c1.521,0,2.185.136,2.731,1.056a3.453,3.453,0,0,1,.448,1.794m5.661,10.21a.957.957,0,0,0-.1-.413,3.024,3.024,0,0,1-1.287-.252,4.287,4.287,0,0,1-.332-.489,20.966,20.966,0,0,0-.839-2.245,7.381,7.381,0,0,0-1.444-2.322,6,6,0,0,0-1.465-.643c-.311-.119-.566-.217-.8-.315a6.853,6.853,0,0,1,.8-.115,3.465,3.465,0,0,0,2.147-.724,3.073,3.073,0,0,0,1.21-2.535,3.747,3.747,0,0,0-2.441-3.552A9.513,9.513,0,0,0,73,9.621c-1.465,0-3.514.136-4.489.136-.294,0-1.993-.038-2.675-.038-.294,0-1.035-.038-1.15-.038a1.144,1.144,0,0,0-.1.371,2.043,2.043,0,0,0,.038.353c.332.038.937.115,1.248.175a2.276,2.276,0,0,1,.818,1.052,48.859,48.859,0,0,1,.119,4.979c0,1.989.021,4.294-.077,5.035a1.5,1.5,0,0,1-.8,1.308,11.056,11.056,0,0,1-1.112.136.95.95,0,0,0-.1.388,1.229,1.229,0,0,0,.077.315c.276,0,3.262-.059,3.885-.059,1.248,0,2.3.059,3.416.059a.851.851,0,0,0,.077-.294,1.183,1.183,0,0,0-.077-.409c-.392-.038-.878-.157-1.094-.2a1.467,1.467,0,0,1-.839-1.385L70.151,17a4.861,4.861,0,0,1,.507-.018,1.951,1.951,0,0,1,1.032.311,3.736,3.736,0,0,1,1.545,1.423,11.9,11.9,0,0,1,1.227,4.2c.059.409.213.759.587.8.154.021,1.189.059,1.93.059h2.794a.531.531,0,0,0,.115-.329M58.692,13.33a3.208,3.208,0,0,1-.993,2.441,3.2,3.2,0,0,1-2.031.524,6.351,6.351,0,0,1-.839-.038c-.157-.017-.255-.038-.255-.136l.021-5.717a8.316,8.316,0,0,1,1.133-.1c1.325,0,2.147.332,2.535,1.15a4.157,4.157,0,0,1,.43,1.874m3.493.077A3.738,3.738,0,0,0,60.1,10.012a9.751,9.751,0,0,0-3.493-.448c-1.5,0-3.846.115-4.878.115C51,9.68,49.909,9.6,49.3,9.6a.709.709,0,0,0-.1.311.948.948,0,0,0,.059.392c.371.115.975.213,1.367.311a1.673,1.673,0,0,1,.524,1.112c.059.685.1,1.542.1,3.025,0,4.119-.018,6.287-.077,6.755a1.663,1.663,0,0,1-1.112,1.385,10.841,10.841,0,0,1-1.133.2,2.264,2.264,0,0,0-.038.409.559.559,0,0,0,.056.273c.626,0,2.462-.077,3.164-.077,1.738,0,3.514.077,4.234.077h.49a.548.548,0,0,0,.059-.311.915.915,0,0,0-.042-.353,3.169,3.169,0,0,1-1.832-.622,1.669,1.669,0,0,1-.392-1.154l-.059-4.29c1.171.077,2.42.115,3.1.115a7.446,7.446,0,0,0,2.262-.35,3.584,3.584,0,0,0,2.245-3.4" transform="translate(0)"></path><path class="a" d="M194,31.665c0-.115-.077-.154-.115-.234-.8,0-1.853.059-2.266.059-.993,0-2.2-.08-2.731-.08-.059.119-.08.14-.08.238a.687.687,0,0,0,.042.234c.566.115,1.385.252,1.542.524a1.428,1.428,0,0,1,.175.762,1.872,1.872,0,0,1-.119.724c-.175.486-.545,1.248-1.07,2.322-.9,1.815-1.465,2.944-1.78,3.4-.507-.86-1.636-3.122-1.909-3.706l-1.095-2.381a1.824,1.824,0,0,1-.077-.528,1.286,1.286,0,0,1,.077-.507c.175-.353.78-.392,1.6-.49a.881.881,0,0,0,.056-.294c0-.136-.056-.1-.115-.192h-.35c-1.311,0-.92.056-3.164.056-.955,0-2.109-.056-2.262-.056-.08.136-.119.154-.119.29a.4.4,0,0,0,.08.234c1.3.315,1.7.545,1.832.8l3.416,6.7a7.629,7.629,0,0,1,.626,1.462,10.873,10.873,0,0,1,.157,2.343,1.657,1.657,0,0,1-.626,1.5,9.286,9.286,0,0,1-1.563.255.471.471,0,0,0-.1.273.766.766,0,0,0,.059.234c1,0,2.032-.021,2.615-.021.409,0,1.035.021,2.185.038.664.021,1.171.042,1.521.042a.562.562,0,0,0,.1-.255.431.431,0,0,0-.08-.255,4.656,4.656,0,0,1-1.7-.392,1.5,1.5,0,0,1-.51-1.245l-.154-2.93a1.144,1.144,0,0,1,.077-.468,3.122,3.122,0,0,1,.213-.545l3.007-5.955a4.038,4.038,0,0,1,1.248-1.3,5.365,5.365,0,0,1,1.269-.392.676.676,0,0,0,.077-.255m-15.766,4.021V31.9c0-.294-.119-.371-.413-.371-.584,0-3.28.077-6.4.077-2.42,0-4.039-.038-5.133-.038h-1.444c-.252,0-.332.059-.332.332v3.532a.348.348,0,0,0,.234.08.5.5,0,0,0,.234-.038c.762-1.7,1.15-2.6,2.462-3.262.584-.056,2.633-.077,2.944-.077.021.217.042.9.059,1.717.021,1.405.021,2.168.021,5.486,0,2.867-.021,4.353-.059,4.664-.077.545.021.955-2.322,1.052a.628.628,0,0,0-.059.332.875.875,0,0,0,.021.234h.759c.724,0,1.678-.077,2.381-.077.566,0,1.64.059,2.832.059h.545a.524.524,0,0,0,.059-.294.434.434,0,0,0-.08-.273,4.057,4.057,0,0,1-2.01-.371,6.016,6.016,0,0,1-.175-1.465c-.018-2.108-.038-3.1-.038-4.507,0-1.815.021-3.2.021-6.577.273,0,1.717-.021,2.3,0a3.508,3.508,0,0,1,2.2,1.482,6.211,6.211,0,0,1,.878,2.126.774.774,0,0,0,.294.038.376.376,0,0,0,.217-.077m-16.22,9.64a.638.638,0,0,0-.059-.273,13.7,13.7,0,0,1-1.444-.175,3.084,3.084,0,0,1-.664-1.5c-.017-.937-.038-3.063-.038-4.878V33.539a1.564,1.564,0,0,1,.35-1.052,3.335,3.335,0,0,1,1.738-.511.6.6,0,0,0,.06-.252.327.327,0,0,0-.1-.234h-.563c-.822,0-1.993.1-2.657.1-.409,0-1.58-.059-2.44-.077h-.43a.285.285,0,0,0-.094.252,1.261,1.261,0,0,0,.038.255,4.113,4.113,0,0,1,1.521.273,2.155,2.155,0,0,1,.647,1.661c.018.367.035,1.364.056,3.161.021.976.038,2.3.038,3.434,0,.566-.038,2.028-.059,2.713a3.339,3.339,0,0,1-.269,1.171c-.238.2-.472.545-1.895.643a.8.8,0,0,0-.059.294c0,.157.038.157.038.252h.332c.783,0,1.993-.094,3.007-.094.294,0,1.58.056,2.227.056h.64a.47.47,0,0,0,.081-.255m-9.643-3.591a3.621,3.621,0,0,0-2.206-3.434,10.651,10.651,0,0,0-2.164-.78,14.392,14.392,0,0,1-2.832-1.074,2.348,2.348,0,0,1-1.15-2.129,2.584,2.584,0,0,1,2.752-2.283,3.278,3.278,0,0,1,2.675,1.367,9.913,9.913,0,0,1,1.21,2.224.541.541,0,0,0,.626-.154,15.288,15.288,0,0,1-.157-1.759,10.123,10.123,0,0,1,.178-1.521.6.6,0,0,0-.587-.273,4.215,4.215,0,0,0-.762.7,4.887,4.887,0,0,0-3.318-1.213,3.819,3.819,0,0,0-4.116,3.731,3.932,3.932,0,0,0,.72,2.147,4.234,4.234,0,0,0,1.9,1.423c.563.234,3.1,1,3.451,1.133,1.563.6,2.15,1.133,2.15,2.518a3.052,3.052,0,0,1-.86,1.972,2.729,2.729,0,0,1-2.168.916,4.372,4.372,0,0,1-3.28-1.444,9.248,9.248,0,0,1-1.325-2.636.731.731,0,0,0-.273-.035.66.66,0,0,0-.371.115c0,.255.077,1.542.077,1.93a8.2,8.2,0,0,1-.213,1.741.744.744,0,0,0,.626.388,2.735,2.735,0,0,1,.975-.626.92.92,0,0,1,.465.178,5.661,5.661,0,0,0,3.262.975c2.752,0,4.72-1.388,4.72-4.1M135.1,35a3.155,3.155,0,0,1-2.143,2.909,10.881,10.881,0,0,1-2.031.154c-.234,0-.9,0-1.192-.038l-.018-1.717V32.623c0-.255.059-.392.136-.451a6.59,6.59,0,0,1,1.364-.115c1.836,0,2.675.175,3.339,1.129A3.076,3.076,0,0,1,135.1,35m4.1,10.343a.516.516,0,0,0-.095-.294,3.041,3.041,0,0,1-1.29-.252,4.792,4.792,0,0,1-.332-.49,24.478,24.478,0,0,0-.818-2.437,7.344,7.344,0,0,0-1.444-2.325,5.473,5.473,0,0,0-1.406-.643c-.311-.119-.566-.213-.8-.311a7.589,7.589,0,0,1,.8-.119,3.583,3.583,0,0,0,2.07-.72,3.11,3.11,0,0,0,1.287-2.517,3.727,3.727,0,0,0-2.44-3.535,9.585,9.585,0,0,0-2.343-.213c-1.462,0-2.556.136-3.532.136-.29,0-1.248-.038-1.93-.038-.294,0-1.035-.038-1.154-.038-.056.136-.1.175-.1.252a1.2,1.2,0,0,0,.042.273c.329.042.934.119,1.248.178a2.258,2.258,0,0,1,.818,1.052c.1.626.119,2.381.119,5.133,0,1.989.018,4.489-.08,5.231a1.481,1.481,0,0,1-.8,1.308,10.971,10.971,0,0,1-1.112.136.52.52,0,0,0-.1.273.711.711,0,0,0,.081.234c.273,0,2.517-.059,3.14-.059,1.252,0,1.563.059,2.675.059a.487.487,0,0,0,.08-.213.588.588,0,0,0-.08-.294c-.388-.038-.878-.157-1.094-.192a1.473,1.473,0,0,1-.836-1.388l-.021-4.878c.157-.021.72-.021.878-.021a3.6,3.6,0,0,1,1.559.273,4.392,4.392,0,0,1,1.916,1.58,12.311,12.311,0,0,1,1.231,4.255c.056.409.213.762.584.8a7.561,7.561,0,0,0,1.133.059h2.028a.334.334,0,0,0,.115-.255m-16.374-2.965a5.122,5.122,0,0,0-.018-.566.435.435,0,0,0-.294-.059.6.6,0,0,0-.255.038,5.15,5.15,0,0,1-2.011,2.986,3.649,3.649,0,0,1-1.657.217H116.4a9.206,9.206,0,0,1-1.29-.1c-.29-.059-.6-.528-.738-.839a2.54,2.54,0,0,1-.217-1.346V38.263h.626a3.858,3.858,0,0,1,1.657.273,2.335,2.335,0,0,1,1.052.839,6.55,6.55,0,0,1,.276,1.619.478.478,0,0,0,.311.08.466.466,0,0,0,.311-.1c0-.528-.115-1.951-.115-2.734,0-.975.136-2.164.192-2.867a.5.5,0,0,0-.311-.077.584.584,0,0,0-.311.056c-.059.273-.217,1.094-.252,1.154a2.841,2.841,0,0,1-1.5,1.035,6.408,6.408,0,0,1-1.6.154h-.311V35.784c0-1.874.038-2.633.056-2.986.021-.234.059-.486.08-.664.175-.018.741-.038,1.64-.038,1.129,0,1.969.021,2.147.021a2.2,2.2,0,0,1,1.248.388,4.973,4.973,0,0,1,1.738,2.423.578.578,0,0,0,.234.035c.115,0,.136-.035.29-.115,0-1.189-.077-2.535-.115-3.024-.021-.2-.059-.255-.451-.255-.154,0-.9-.038-1.675-.038-1.115,0-1.563.021-3.262.021-.916,0-2.535.018-3.336.018-1.171,0-1.427-.038-1.934-.038h-.664a.4.4,0,0,0-.1.234.456.456,0,0,0,.1.273,9.873,9.873,0,0,1,1.427.217c.273.234.525.294.7,1.227.038.413.059,1.738.059,2.636v4.021c0,.818-.021,2.168-.042,2.654a5.8,5.8,0,0,1-.43,1.892,5.1,5.1,0,0,1-1.755.294.647.647,0,0,0-.1.315.445.445,0,0,0,.1.269h.643c.626,0,2.189-.056,2.713-.056.49,0,1.15.038,2.283.038.626,0,2.458.119,6.4.119a1.668,1.668,0,0,0,.528-.042.568.568,0,0,0,.077-.311c.038-.388.038-1.346.038-2.927M108.381,31.725c0-.077-.021-.2-.1-.213h-.664c-.468,0-1.21.038-1.542.038-1.581,0-2.147-.1-2.381-.1h-.35c-.042.1-.1.154-.1.252,0,.077.042.136.042.217a7.007,7.007,0,0,1,1.346.29,1.842,1.842,0,0,1,.49,1.231,7.358,7.358,0,0,1-.472,1.776l-3.14,7.727-3.86-9.776a1.464,1.464,0,0,1,.64-1.094,8.718,8.718,0,0,1,1.269-.154.747.747,0,0,0,.077-.273c0-.08-.018-.2-.1-.217h-.489c-.6,0-1.517.08-2.552.08-.448,0-1.325-.042-2.185-.042h-.762a.443.443,0,0,0-.018.472,6.635,6.635,0,0,1,1.64.661,34.521,34.521,0,0,1,1.6,3.552l1.615,3.9c1.346,3.241,2.147,5.409,2.245,5.78.1.059,0,.115.175.115s.157-.038.2-.136l5.035-12.1a3.857,3.857,0,0,1,.7-1.112,3.129,3.129,0,0,1,1.559-.626.882.882,0,0,0,.081-.252m-17.095,13.6a.587.587,0,0,0-.059-.273,13.6,13.6,0,0,1-1.444-.175,3.115,3.115,0,0,1-.664-1.5c-.018-.937-.038-3.063-.038-4.878V33.539a1.526,1.526,0,0,1,.353-1.052,3.321,3.321,0,0,1,1.734-.511.552.552,0,0,0,.059-.252.327.327,0,0,0-.1-.234h-.567c-.818,0-1.989.1-2.654.1-.409,0-1.58-.059-2.437-.077h-.43a.276.276,0,0,0-.1.252,1.248,1.248,0,0,0,.038.255,4.134,4.134,0,0,1,1.521.273,2.155,2.155,0,0,1,.647,1.661c.018.367.038,1.364.056,3.161.021.976.042,2.3.042,3.434,0,.566-.042,2.028-.059,2.713a3.255,3.255,0,0,1-.276,1.171c-.231.2-.465.545-1.892.643a.8.8,0,0,0-.059.294c0,.157.042.157.042.252h.329c.783,0,1.993-.094,3.007-.094.294,0,1.58.056,2.224.056h.647a.462.462,0,0,0,.077-.255m-8.822-13.64a.333.333,0,0,0-.059-.2h-.448c-.975,0-1.406.038-3.161.038-.608,0-1.5-.038-1.717-.038H76.57c-.056.038-.077.175-.077.255a.251.251,0,0,0,.1.213,8.4,8.4,0,0,1,2.01.566,3.834,3.834,0,0,1,.566,1.99c.018.294.038.587.038,1.388V41.7a7.639,7.639,0,0,1-.038.839c-.332-.371-.9-1.091-1.661-1.989L70.053,31.84a1.291,1.291,0,0,0-.294-.252c-.157,0-.35-.021-.507-.021-1.248,0-2.342-.056-2.675-.056a.368.368,0,0,0-.056.192,1.471,1.471,0,0,0,.035.255,3.377,3.377,0,0,1,1.507.545,5.792,5.792,0,0,1,.955,1.154,1.681,1.681,0,0,1,.08.622c0,1.018-.059,2.867-.059,4.238v4.154a8.508,8.508,0,0,1-.119,1.482,4.06,4.06,0,0,1-2.049,1,.577.577,0,0,0-.077.234c0,.059.018.175.056.2h.371c.392,0,1.29-.056,1.878-.056.857,0,1.245.056,2.045.056h1.175c.077-.021.095-.175.095-.255a.363.363,0,0,0-.059-.2,3.742,3.742,0,0,1-2.339-1.206,11.515,11.515,0,0,1-.255-2.462c0-.622-.021-1.64-.021-2.79,0-1.542.021-3.668.042-4.353.115.136.294.353.427.507l9.252,10.836c.1.095.136.115.238.115s.035,0,.115-.038a3,3,0,0,0,.1-.878c0-.566-.021-1.154-.021-1.448V35.12c0-2.437,1.154-3.122,2.5-3.178a.467.467,0,0,0,.077-.255m-18.073.094a.406.406,0,0,0-.1-.252h-.563c-.608,0-1.427.038-2.129.038-.78,0-1.657-.038-2.227-.038h-.7a.476.476,0,0,0-.08.252.671.671,0,0,0,.059.255c.08,0,1.5.021,1.755.371a4.777,4.777,0,0,1,.762,1.444A12.741,12.741,0,0,1,61.329,36c0,1.661,0,2.773-.021,3.357a10.453,10.453,0,0,1-.353,2.6,3.564,3.564,0,0,1-3.822,2.538A5.405,5.405,0,0,1,54.846,44a3.292,3.292,0,0,1-1.892-2.462l-.1-5.853-.017-2.381c0-.448.563-.86.759-1.094a9.3,9.3,0,0,1,1.5-.192.588.588,0,0,0,.1-.273.341.341,0,0,0-.136-.255l-.741.021c-.724.018-1.678.038-2.283.038-.937,0-1.661-.021-2.245-.021h-.818a.335.335,0,0,0-.1.273.31.31,0,0,0,.081.234c.622.08,1.031.136,1.308.2a1.642,1.642,0,0,1,.682.86c.021.252.059.878.059,2.1v4.685a11.96,11.96,0,0,0,.2,2.615,3.857,3.857,0,0,0,1.7,2.4,6.394,6.394,0,0,0,3.573.937,6.752,6.752,0,0,0,3.357-.8,4,4,0,0,0,1.93-2.6,8.863,8.863,0,0,0,.315-2.322V36.368c0-.7.038-1.58.038-1.93a3.924,3.924,0,0,1,.587-2.147,7.816,7.816,0,0,1,1.619-.273.478.478,0,0,0,.077-.238" transform="translate(0)"></path><path class="a" d="M16.65,12.117a.307.307,0,0,0-.273.178L15.8,13.573a.113.113,0,0,1-.045.019c-.018,0-.038-.019-.052-.059s-.084-.224-.234-.572l-.185-.418c-.066-.154-.119-.255-.136-.287a.28.28,0,0,0-.241-.14.056.056,0,0,1-.011-.038.076.076,0,0,1,.007-.037H15c.108,0,.2.005.28.005s.252-.009.357-.009H15.7c.01,0,.014.025.014.033a.1.1,0,0,1-.007.042c-.07.007-.227,0-.227.1a.265.265,0,0,0,.014.086l.378.9.315-.743a.462.462,0,0,0,.042-.2c0-.084-.059-.121-.217-.14a.134.134,0,0,1-.01-.035.149.149,0,0,1,.01-.044h.045c.07,0,.14.009.3.009.028,0,.136-.005.189-.005h.108a.069.069,0,0,1,.014.033A.091.091,0,0,1,16.65,12.117Z" transform="translate(0)"></path><path class="a" d="M18.248,13.549c-.458,0-.706-.012-.769-.012l-.217,0c-.063,0-.21.01-.371.01l-.091,0a.058.058,0,0,1-.007-.033.188.188,0,0,1,0-.044.542.542,0,0,0,.231-.049.435.435,0,0,0,.049-.231c0-.07,0-.147,0-.225,0-.115,0-.255,0-.425V12.3c0-.166-.084-.166-.255-.185a.224.224,0,0,1-.007-.04c0-.009,0-.033.014-.038h.084c.056,0,.206,0,.493,0,.262,0,.518.005.573.005l.157,0c.035,0,.049,0,.049.035l.021.343c-.021.01-.025.014-.042.014a.105.105,0,0,1-.035,0,.7.7,0,0,0-.227-.262.258.258,0,0,0-.133-.038c-.021,0-.073,0-.2,0-.1,0-.157,0-.171.005s-.014,0-.021.058c0,.037-.007.1-.007.3v.2h.052a.744.744,0,0,0,.171-.017.281.281,0,0,0,.154-.108.624.624,0,0,0,.035-.126.093.093,0,0,1,.049-.01.059.059,0,0,1,.038.012c0,.061-.014.177-.014.323,0,.073.007.234.007.3a.055.055,0,0,1-.042.012.169.169,0,0,1-.042-.005c-.014-.129-.035-.217-.143-.262a.408.408,0,0,0-.168-.032.963.963,0,0,0-.1.007v.4a.491.491,0,0,0,.021.178c.011.026.045.079.091.084a.759.759,0,0,0,.14.01h.217A.431.431,0,0,0,18,13.428a.838.838,0,0,0,.241-.323.1.1,0,0,1,.045-.009.12.12,0,0,1,.045.011v.4C18.329,13.544,18.3,13.549,18.248,13.549Z" transform="translate(0)"></path><path class="a" d="M20.067,12.514c-.01,0-.024,0-.042-.005a.975.975,0,0,0-.112-.224.362.362,0,0,0-.28-.147c-.035,0-.119,0-.147,0l0,.666c0,.1,0,.229,0,.458,0,.177.08.177.262.2a.088.088,0,0,1,.014.044.074.074,0,0,1-.01.037h-.067c-.1,0-.315-.007-.381-.007-.045,0-.276.01-.385.01a.05.05,0,0,1-.014-.04.1.1,0,0,1,.011-.04c.241-.018.266-.063.273-.14.007-.049.007-.248.007-.451V12.32a.916.916,0,0,0-.014-.183,1.156,1.156,0,0,0-.234.016.605.605,0,0,0-.3.332.1.1,0,0,1-.038.005.042.042,0,0,1-.035-.016v-.388c0-.035,0-.044.045-.044l.164,0c.052,0,.273,0,.549,0,.364,0,.633-.009.7-.009.035,0,.059,0,.073.012a.283.283,0,0,1,0,.056v.388A.042.042,0,0,1,20.067,12.514Z" transform="translate(0)"></path><path class="a" d="M16.577,14.881c-.014,0-.025,0-.045-.005a.75.75,0,0,0-.112-.224.356.356,0,0,0-.28-.147c-.035,0-.119,0-.147,0l0,.666c0,.1,0,.229,0,.458,0,.177.084.177.266.2a.079.079,0,0,1,.01.044.069.069,0,0,1-.007.037H16.2c-.108,0-.318-.007-.381-.007-.045,0-.276.011-.388.011a.065.065,0,0,1-.01-.04.187.187,0,0,1,.007-.04c.241-.018.266-.063.276-.14,0-.049,0-.248,0-.451v-.552a.963.963,0,0,0-.01-.184,1.189,1.189,0,0,0-.238.016.6.6,0,0,0-.3.332.126.126,0,0,1-.042.005.046.046,0,0,1-.035-.016v-.388c0-.035.007-.044.045-.044l.164,0c.056,0,.276,0,.552,0,.36,0,.633-.009.7-.009.038,0,.063,0,.074.012s0,.035,0,.056v.388A.046.046,0,0,1,16.577,14.881Z" transform="translate(0)"></path><path class="a" d="M18.3,15.916c-.455,0-.706-.012-.766-.012l-.22,0c-.059,0-.21.011-.367.011l-.091,0a.061.061,0,0,1-.01-.033.1.1,0,0,1,.007-.044.5.5,0,0,0,.227-.049c.028-.03.042-.094.049-.231,0-.07.007-.147.007-.226,0-.115,0-.255,0-.425,0-.117,0-.187,0-.236,0-.166-.081-.166-.252-.185a.105.105,0,0,1-.01-.04c0-.009.007-.033.017-.038h.081c.059,0,.206,0,.493,0,.266,0,.517.005.577.005l.154,0c.038,0,.052,0,.052.035l.017.343a.066.066,0,0,1-.042.014.134.134,0,0,1-.035,0,.64.64,0,0,0-.227-.262.241.241,0,0,0-.129-.038c-.021,0-.073,0-.206,0-.1,0-.157,0-.168.005s-.018,0-.025.058c0,.037,0,.1,0,.3v.2h.049a.692.692,0,0,0,.171-.018.29.29,0,0,0,.157-.108.634.634,0,0,0,.031-.126.113.113,0,0,1,.049-.011.063.063,0,0,1,.042.012c0,.061-.017.177-.017.323,0,.073.01.234.01.3a.059.059,0,0,1-.042.012.2.2,0,0,1-.045-.005c-.014-.129-.032-.217-.143-.262a.4.4,0,0,0-.164-.032,1.014,1.014,0,0,0-.1.007v.4a.63.63,0,0,0,.017.178c.014.026.049.079.091.084a.77.77,0,0,0,.14.011h.22a.408.408,0,0,0,.161-.025.8.8,0,0,0,.245-.323.09.09,0,0,1,.045-.009.105.105,0,0,1,.042.01v.4C18.385,15.911,18.36,15.916,18.3,15.916Z" transform="translate(0)"></path><path class="a" d="M19.367,15.949a.858.858,0,0,1-.35-.091.161.161,0,0,0-.056-.012.3.3,0,0,0-.112.058.1.1,0,0,1-.088-.045c0-.032.028-.126.028-.185,0-.035-.01-.2-.014-.245a.081.081,0,0,1,.066-.031.108.108,0,0,1,.025,0c.032.061.095.226.14.292a.465.465,0,0,0,.336.159.334.334,0,0,0,.245-.073.216.216,0,0,0,.084-.184.2.2,0,0,0-.042-.136.363.363,0,0,0-.157-.112c-.066-.032-.3-.089-.385-.135a.59.59,0,0,1-.21-.149.46.46,0,0,1-.088-.275.43.43,0,0,1,.465-.423.557.557,0,0,1,.36.1,1.02,1.02,0,0,1,.087-.086.084.084,0,0,1,.08.04,1.8,1.8,0,0,0-.024.206c0,.04.024.2.024.224a.149.149,0,0,1-.059.021.113.113,0,0,1-.028-.007c-.042-.073-.08-.2-.126-.262a.341.341,0,0,0-.3-.129A.248.248,0,0,0,19,14.7a.256.256,0,0,0,.185.224c.063.025.14.054.227.081a1.99,1.99,0,0,1,.241.093.411.411,0,0,1,.248.4A.489.489,0,0,1,19.367,15.949Z" transform="translate(0)"></path><path class="a" d="M17.186,18.287c-.458,0-.706-.012-.769-.012l-.217,0c-.063,0-.21.011-.371.011l-.091,0a.057.057,0,0,1-.007-.033.2.2,0,0,1,0-.044.541.541,0,0,0,.231-.049.432.432,0,0,0,.049-.231c0-.07,0-.147,0-.226,0-.115,0-.255,0-.425v-.236c0-.166-.084-.166-.255-.185a.209.209,0,0,1-.007-.04c0-.009,0-.033.014-.038h.084c.056,0,.206,0,.493,0,.262,0,.517.005.573.005l.157,0c.035,0,.049,0,.049.035l.021.343c-.021.011-.024.014-.042.014a.1.1,0,0,1-.035,0,.7.7,0,0,0-.227-.262.257.257,0,0,0-.133-.038c-.021,0-.073,0-.2,0-.1,0-.157,0-.171.005s-.014,0-.021.058c0,.037-.007.1-.007.3v.2h.052a.744.744,0,0,0,.171-.017.281.281,0,0,0,.154-.108.624.624,0,0,0,.035-.126.093.093,0,0,1,.049-.011.06.06,0,0,1,.038.012c0,.061-.014.177-.014.323,0,.074.007.234.007.3a.055.055,0,0,1-.042.012.169.169,0,0,1-.042-.005c-.014-.129-.035-.217-.143-.262a.41.41,0,0,0-.168-.031.967.967,0,0,0-.1.007v.4a.491.491,0,0,0,.021.178c.011.026.045.079.091.084a.759.759,0,0,0,.14.01h.217a.427.427,0,0,0,.164-.025.834.834,0,0,0,.241-.323.1.1,0,0,1,.045-.009.118.118,0,0,1,.045.011v.4C17.266,18.281,17.241,18.287,17.186,18.287Z" transform="translate(0)"></path><path class="a" d="M19.388,16.85c-.154.005-.287.089-.287.334l0,.778c0,.03.014.25.014.334a.137.137,0,0,1-.063.025.085.085,0,0,1-.038-.025l-1.066-1.147.011.234,0,.423c0,.033.007.112.014.171a.191.191,0,0,0,.077.161.388.388,0,0,0,.2.066.073.073,0,0,1,.01.035.078.078,0,0,1-.014.038h-.115c-.1,0-.175,0-.276,0-.066,0-.161.007-.227.007h-.049a.128.128,0,0,1,0-.035.1.1,0,0,1,.007-.038.374.374,0,0,0,.241-.1.5.5,0,0,0,.025-.182v-.542c0-.087,0-.131-.007-.217A.264.264,0,0,0,17.79,17a.563.563,0,0,0-.074-.079.774.774,0,0,0-.171-.075.114.114,0,0,1-.01-.035.085.085,0,0,1,.01-.038h.038c.032,0,.2.009.322.009h.073a.148.148,0,0,1,.045.03l.79.864c.059.066.136.154.178.21V17.26a1.642,1.642,0,0,0-.007-.173.424.424,0,0,0-.045-.163c-.024-.038-.171-.059-.248-.075a.112.112,0,0,1-.007-.045.13.13,0,0,1,0-.033h.045c.073,0,.192.011.266.011.182,0,.238-.005.329-.005h.059a.075.075,0,0,1,.007.037A.079.079,0,0,1,19.388,16.85Z" transform="translate(0)"></path><path class="a" d="M24.371,12.112c-.15.005-.287.089-.287.334v.778c0,.03.01.25.01.334a.128.128,0,0,1-.059.025c-.01,0-.021-.009-.042-.025l-1.066-1.147.014.234,0,.423c0,.033.007.112.01.171a.212.212,0,0,0,.077.161.41.41,0,0,0,.2.066.073.073,0,0,1,.01.035.116.116,0,0,1-.01.038h-.119c-.095,0-.171,0-.276,0-.066,0-.157.007-.224.007h-.049a.158.158,0,0,1-.007-.035.069.069,0,0,1,.011-.038.372.372,0,0,0,.238-.1.439.439,0,0,0,.025-.182v-.542c0-.087,0-.131,0-.217a.286.286,0,0,0-.052-.164.685.685,0,0,0-.077-.079.707.707,0,0,0-.171-.075.309.309,0,0,1-.007-.035.167.167,0,0,1,.007-.038h.042c.028,0,.192.009.318.009h.073a.243.243,0,0,1,.049.03l.79.864c.059.066.136.154.178.21v-.622a1.38,1.38,0,0,0-.011-.173.369.369,0,0,0-.045-.163c-.024-.038-.171-.059-.245-.075a.12.12,0,0,1-.01-.045.066.066,0,0,1,.007-.033h.045c.073,0,.192.01.266.01.178,0,.238-.005.329-.005h.056a.084.084,0,0,1,.011.037A.092.092,0,0,1,24.371,12.112Z" transform="translate(0)"></path><path class="a" d="M25.941,13.358a.752.752,0,0,1-1.066.011.771.771,0,0,1-.227-.575.779.779,0,0,1,.227-.572A.757.757,0,0,1,25.406,12a.794.794,0,0,1,.4.112.786.786,0,0,1,.371.67A.838.838,0,0,1,25.941,13.358Zm-.245-1.1a.35.35,0,0,0-.3-.159.32.32,0,0,0-.28.159.867.867,0,0,0-.14.533.92.92,0,0,0,.133.53.336.336,0,0,0,.3.166.348.348,0,0,0,.329-.206.978.978,0,0,0,.1-.484A.874.874,0,0,0,25.7,12.255Z" transform="translate(0)"></path><path class="a" d="M28.088,12.117a.307.307,0,0,0-.269.178l-.573,1.278a.113.113,0,0,1-.045.019c-.018,0-.042-.019-.052-.059s-.084-.224-.238-.572l-.182-.418c-.066-.154-.119-.255-.136-.287a.285.285,0,0,0-.241-.14.046.046,0,0,1-.014-.038.054.054,0,0,1,.011-.037h.094c.1,0,.2.005.276.005s.252-.009.36-.009h.059c.014,0,.017.025.017.033a.1.1,0,0,1-.007.042c-.073.007-.227,0-.227.1a.2.2,0,0,0,.014.086l.374.9.318-.743a.506.506,0,0,0,.038-.2c0-.084-.059-.121-.217-.14a.12.12,0,0,1-.007-.035.15.15,0,0,1,.007-.044h.045c.07,0,.14.009.3.009.025,0,.136-.005.189-.005h.108a.064.064,0,0,1,0,.075Z" transform="translate(0)"></path><path class="a" d="M23.878,14.881c-.014,0-.024,0-.045-.005a.759.759,0,0,0-.112-.224.357.357,0,0,0-.28-.147c-.035,0-.119,0-.147,0l0,.666c0,.1,0,.229,0,.458,0,.177.084.177.266.2a.078.078,0,0,1,.011.044.069.069,0,0,1-.007.037H23.5c-.108,0-.318-.007-.381-.007-.045,0-.276.011-.388.011a.065.065,0,0,1-.011-.04.2.2,0,0,1,.007-.04c.241-.018.266-.063.276-.14,0-.049,0-.248,0-.451v-.552a.947.947,0,0,0-.011-.184,1.189,1.189,0,0,0-.238.016.6.6,0,0,0-.3.332.126.126,0,0,1-.042.005.046.046,0,0,1-.035-.016v-.388c0-.035.007-.044.045-.044l.164,0c.056,0,.276,0,.552,0,.36,0,.633-.009.7-.009.038,0,.063,0,.073.012s0,.035,0,.056v.388A.046.046,0,0,1,23.878,14.881Z" transform="translate(0)"></path><path class="a" d="M25.689,15.914H25.57c-.077,0-.164-.01-.255-.01-.143,0-.325.01-.4.01a.056.056,0,0,1-.011-.038.129.129,0,0,1,.007-.035c.147-.007.206-.032.206-.091a.519.519,0,0,0-.045-.2c-.045-.11-.07-.161-.081-.189-.007-.011-.01-.016-.042-.016h-.475a1.018,1.018,0,0,0-.112.288.328.328,0,0,0-.011.088c0,.049.045.1.213.108a.074.074,0,0,1,.01.042.129.129,0,0,1,0,.035h-.042c-.112,0-.143-.007-.262-.007-.077,0-.262.007-.325.007a.1.1,0,0,1-.007-.032.09.09,0,0,1,.007-.038.324.324,0,0,0,.217-.11,2.53,2.53,0,0,0,.192-.393c.084-.2.185-.456.231-.563.063-.131.084-.175.1-.22.032-.066.066-.133.08-.157a.082.082,0,0,1,.126,0,.461.461,0,0,1,.035.075c.087.208.157.393.266.652.056.131.084.213.143.35.042.086.066.15.108.229.056.114.147.115.238.138,0,.01.014.021.014.035S25.7,15.9,25.689,15.914Zm-.955-1.2h0c-.032.058-.087.189-.108.243-.081.2-.108.262-.122.29h.451C24.916,15.161,24.8,14.883,24.735,14.717Z" transform="translate(0)"></path><path class="a" d="M28.025,15.914l-.612-.007h-.168a.1.1,0,0,1-.011-.038.052.052,0,0,1,.014-.038.77.77,0,0,0,.15-.014c.063-.028.088-.089.088-.18V14.549h0l-.322.7c-.035.077-.077.161-.112.245a3.32,3.32,0,0,0-.133.343.045.045,0,0,1-.049.028c-.021,0-.035-.007-.045-.042-.042-.091-.07-.15-.084-.189l-.5-1.108h-.011v.283l.011.708c0,.215.112.317.283.317a.122.122,0,0,1,.014.037.085.085,0,0,1-.011.037c-.011,0-.045,0-.077,0s-.133-.01-.294-.01c-.045,0-.14,0-.213,0h-.1a.132.132,0,0,1-.007-.037.18.18,0,0,1,.007-.033.784.784,0,0,0,.22-.077c.032-.03.059-.094.059-.243v-.776c0-.124-.017-.171-.077-.213a.679.679,0,0,0-.2-.04.1.1,0,0,1-.01-.042.1.1,0,0,1,.01-.04c.06,0,.164.005.269.005h.367a.09.09,0,0,1,.032.038l.451,1.023.081-.2c.07-.164.171-.411.315-.678l.091-.175.573-.009a.072.072,0,0,1,.014.037.074.074,0,0,1-.011.038c-.063.011-.171.011-.224.1-.018.028-.028.056-.028.18v.729c0,.28.07.308.1.329a.537.537,0,0,0,.154.021.079.079,0,0,1,.01.038C28.035,15.9,28.028,15.9,28.025,15.914Z" transform="translate(0)"></path><path class="a" d="M23.843,17.252c-.014,0-.025,0-.045-.005a.757.757,0,0,0-.112-.224.356.356,0,0,0-.28-.147c-.035,0-.119,0-.147,0l0,.666c0,.1,0,.229,0,.458,0,.177.084.177.266.2a.079.079,0,0,1,.01.044.069.069,0,0,1-.007.037h-.066c-.108,0-.318-.007-.381-.007-.045,0-.276.011-.388.011a.065.065,0,0,1-.01-.04.189.189,0,0,1,.007-.04c.241-.018.266-.063.276-.14,0-.049,0-.248,0-.451v-.552a.961.961,0,0,0-.01-.183,1.189,1.189,0,0,0-.238.016.6.6,0,0,0-.3.332.126.126,0,0,1-.042.005.046.046,0,0,1-.035-.016v-.388c0-.035.007-.044.045-.044l.164,0c.056,0,.276,0,.552,0,.36,0,.633-.009.7-.009.038,0,.063,0,.073.012s0,.035,0,.056v.388A.046.046,0,0,1,23.843,17.252Z" transform="translate(0)"></path><path class="a" d="M25.72,16.855a.306.306,0,0,0-.269.178l-.574,1.278a.113.113,0,0,1-.045.019c-.017,0-.042-.019-.052-.059s-.084-.224-.238-.572l-.182-.418c-.066-.154-.119-.255-.136-.287a.285.285,0,0,0-.241-.14.046.046,0,0,1-.014-.038.054.054,0,0,1,.011-.037h.094c.1,0,.2.005.276.005s.252-.009.36-.009h.059c.014,0,.018.024.018.033a.1.1,0,0,1-.007.042c-.074.007-.227,0-.227.1a.2.2,0,0,0,.014.086l.374.9.318-.743a.5.5,0,0,0,.038-.2c0-.084-.059-.12-.217-.14a.127.127,0,0,1-.007-.035.156.156,0,0,1,.007-.044h.045c.07,0,.14.009.3.009.025,0,.136-.005.189-.005h.108a.062.062,0,0,1,.011.033A.064.064,0,0,1,25.72,16.855Z" transform="translate(0)"></path><path class="a" d="M28.056,18.285l-.608-.007h-.171a.085.085,0,0,1-.007-.038.05.05,0,0,1,.01-.038.821.821,0,0,0,.154-.014c.059-.028.084-.089.084-.18v-.883s0-.159,0-.2h-.007l-.318.7c-.038.077-.077.161-.115.245-.07.164-.112.278-.133.343-.007.028-.032.028-.049.028s-.031-.007-.045-.042c-.038-.091-.067-.15-.081-.189L26.266,16.9h-.01v.283l.01.708c0,.215.112.317.287.317a.1.1,0,0,1,.01.037.075.075,0,0,1-.007.037c-.014,0-.045,0-.08,0s-.129-.01-.29-.01c-.049,0-.143,0-.213,0h-.1a.073.073,0,0,1-.01-.037.086.086,0,0,1,.01-.033.827.827,0,0,0,.22-.077.355.355,0,0,0,.056-.243l0-.357,0-.42c0-.124-.014-.171-.077-.213a.678.678,0,0,0-.2-.04.07.07,0,0,1-.014-.042.073.073,0,0,1,.014-.04c.056,0,.164.005.266.005h.371a.085.085,0,0,1,.028.038l.451,1.023.084-.2a6.945,6.945,0,0,1,.315-.678c.028-.059.07-.135.091-.175l.57-.009c.007.012.018.023.018.037a.079.079,0,0,1-.014.038c-.059.01-.168.01-.22.1-.017.028-.031.056-.031.18v.729c0,.28.07.308.1.329a.5.5,0,0,0,.15.021.058.058,0,0,1,.014.038C28.07,18.269,28.063,18.271,28.056,18.285Z" transform="translate(0)"></path><path class="a" d="M42.539,8.818,42.476,8.1l-.685.208a17.6,17.6,0,0,1-5.136.762A17.312,17.312,0,0,1,21.86.827L21.364,0l-.5.827A17.31,17.31,0,0,1,6.07,9.073,17.56,17.56,0,0,1,.944,8.315L.257,8.107l-.063.715a50.482,50.482,0,0,0,.881,14.787,51.231,51.231,0,0,0,5.5,14.606,52.3,52.3,0,0,0,4.594,6.853A53.073,53.073,0,0,0,21,54.634l.348.259.348-.259A53,53,0,0,0,31.551,45.1a51.781,51.781,0,0,0,4.593-6.843,51.227,51.227,0,0,0,5.343-13.938l.143-.706A50.8,50.8,0,0,0,42.539,8.818ZM30.255,12.713h.857v1.675h-.857Zm0,4.385h.857v1.677h-.857Zm-8.671-6.159a1.585,1.585,0,0,1,1.451-.61l1.654.234,2.178.287a4.323,4.323,0,0,0,1.892-.309v9.1a5.217,5.217,0,0,1-1.892.281l-2.1-.28L23.035,19.4a2.165,2.165,0,0,0-1.451.458Zm-7.455-.381a4.067,4.067,0,0,0,1.815.3l2.182-.289,1.65-.236a1.587,1.587,0,0,1,1.451.61v8.925a2.175,2.175,0,0,0-1.465-.462l-1.731.243-2.087.278c-1.528,0-1.846-.369-1.85-.372S14.126,11.168,14.13,10.558Zm-1.245,1.107c.164-.033.65-.136.888-.187v8.18c.087.187.462.622,2.171.622l2.164-.285,1.654-.236a1.619,1.619,0,0,1,1.469.612l.049-.028h.255l.049.026a1.584,1.584,0,0,1,1.451-.61l1.654.234,2.178.287c1.734,0,2.164-.456,2.21-.507l.032-8.337.79.22v9.037a24.427,24.427,0,0,1-3.133.245,40.032,40.032,0,0,1-4.182-.294l-.2-.028v.612a3.059,3.059,0,0,1-1.014.185,2.755,2.755,0,0,1-.972-.183v-.614l-.2.028a39.99,39.99,0,0,1-4.171.294,24.39,24.39,0,0,1-3.14-.245Zm-1.2,1.049h.839v1.675h-.839Zm0,4.385h.839v1.677h-.839Zm9.664,36.3a52.013,52.013,0,0,1-9.269-9.056c-.011-.014-.021-.032-.032-.045l9.3-9.049,9.322,9.066c-.014.014-.025.035-.038.052A52,52,0,0,1,21.353,53.4Zm19-29.34A50.168,50.168,0,0,1,35.2,37.543L21.357,24.224,7.525,37.515A50.215,50.215,0,0,1,2.243,23.49H40.465Z" transform="translate(0)"></path></g>', 2)
  ]), 8, Wx);
}
const Tl = /* @__PURE__ */ S(jx, [["render", Ux]]), qx = {
  name: "LuxUniversityFooter",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  components: {
    LuxLogoUniversityWhite: Tl,
    LuxUniversityCopyright: Br,
    LuxUniversityPrivacyNotice: Ci,
    LuxWrapper: Ya
  },
  methods: {
    value: function(e) {
      return e == "light" || e == "shade" ? e : "dark";
    }
  },
  props: {
    /**
     * The html element name used for the container
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * The maximum width of the wrapper. Default is set to 1440.
     */
    maxWidth: {
      type: Number,
      default: 1440
    },
    /**
     * Whether the header is dark, shade, or light. Default is set to dark.
     */
    theme: {
      type: String,
      default: "dark"
    },
    /**
     * Links are supplied via an array of objects containting `text` and `href` properties.  If no links are supplied then a default list is displayed.
     * To remove all links pass an empty array.
     */
    links: {
      required: !1,
      type: Array,
      default(e) {
        return [
          {
            text: "Copyright Policy",
            href: "https://library.princeton.edu/about/policies/copyright-and-permissions-policies"
          },
          { text: "Privacy Notice", href: "https://www.princeton.edu/privacy-notice" },
          { text: "Accessibility Help", href: "https://accessibility.princeton.edu/help" }
        ];
      }
    }
  }
}, Gx = { class: "lux-footer-bottom bottom-layout" }, Kx = { class: "lux-university-links" }, Zx = ["href"], Xx = { class: "lux-university-links center-panel" }, Jx = { class: "lux-university-links pu-logo-white" }, Qx = { href: "https://www.princeton.edu" };
function eS(e, t, n, a, r, s) {
  const i = Y("lux-university-copyright"), l = Y("lux-logo-university-white"), u = Y("lux-wrapper");
  return h(), H(ie(n.type), {
    class: z(["lux-university-footer", n.theme])
  }, {
    default: P(() => [
      k(u, {
        class: "lux-footer-content",
        maxWidth: n.maxWidth
      }, {
        default: P(() => [
          o("div", Gx, [
            o("div", Kx, [
              (h(!0), g(se, null, fe(n.links, (c, d) => (h(), g("div", {
                class: "policy-links",
                key: d
              }, [
                o("a", {
                  href: c.href
                }, j(c.text), 9, Zx)
              ]))), 128))
            ]),
            o("div", Xx, [
              k(i, {
                type: "div",
                theme: s.value(n.theme)
              }, null, 8, ["theme"])
            ]),
            o("div", Jx, [
              o("a", Qx, [
                k(l, {
                  width: "200px",
                  height: "72px",
                  type: "div"
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["maxWidth"])
    ]),
    _: 1
  }, 8, ["class"]);
}
const Al = /* @__PURE__ */ S(qx, [["render", eS], ["__scopeId", "data-v-712f0e00"]]), tS = {
  name: "LuxLibraryFooter",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  components: {
    LuxLibraryContactInfo: wi,
    LuxLibraryLogo: x1,
    LuxLogoFacebook: Vr,
    LuxLogoFriends: Rr,
    LuxLogoGovDocs: Nr,
    LuxLogoInstagram: El,
    LuxLogoX: Hr,
    LuxSubscribeNewsletter: bi,
    LuxWrapper: Ya,
    LuxUniversityFooter: Al
  },
  methods: {
    value: function(e) {
      return e == "light" || e == "shade" ? e : "dark";
    }
  },
  props: {
    /**
     * The html element name used for the container
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * The maximum width of the wrapper. Default is set to 1440.
     */
    maxWidth: {
      type: Number,
      default: 1440
    },
    /**
     * Whether the header is dark, shade, or light. Default is set to dark.
     */
    theme: {
      type: String,
      default: "dark"
    }
  }
}, nS = { class: "lux-footer-main" }, aS = { class: "lux-library-links contact-info-layout" }, rS = { class: "lux-library-links subscribe-layout" }, sS = { class: "social-pul-icons" }, iS = { href: "https://x.com/PULibrary" }, oS = { href: "http://www.facebook.com/PULibrary" }, lS = { href: "https://www.instagram.com/PULibrary/" }, uS = { href: "https://libguides.princeton.edu/usgovdocs" }, cS = { href: "https://fpul.princeton.edu/" };
function dS(e, t, n, a, r, s) {
  const i = Y("lux-library-logo"), l = Y("lux-library-contact-info"), u = Y("lux-subscribe-newsletter"), c = Y("lux-logo-x"), d = Y("lux-logo-facebook"), f = Y("lux-logo-instagram"), v = Y("lux-logo-gov-docs"), p = Y("lux-logo-friends"), y = Y("lux-wrapper"), w = Y("lux-university-footer");
  return h(), H(ie(n.type), {
    class: z(["lux-library-footer", n.theme])
  }, {
    default: P(() => [
      k(y, {
        class: "lux-footer-content",
        maxWidth: n.maxWidth
      }, {
        default: P(() => [
          o("div", nS, [
            o("div", aS, [
              o("div", null, [
                k(i, {
                  theme: s.value(n.theme)
                }, null, 8, ["theme"]),
                k(l, {
                  theme: s.value(n.theme)
                }, null, 8, ["theme"])
              ])
            ]),
            o("div", rS, [
              t[0] || (t[0] = o("h2", null, "Subscribe to our Newsletter", -1)),
              k(u, { type: "div" }),
              o("div", sS, [
                o("a", iS, [
                  k(c, {
                    width: "24",
                    height: "24"
                  })
                ]),
                o("a", oS, [
                  k(d, {
                    width: "24",
                    height: "24"
                  })
                ]),
                o("a", lS, [
                  k(f, {
                    width: "24",
                    height: "24"
                  })
                ]),
                o("a", uS, [
                  k(v, {
                    width: "30",
                    height: "30"
                  })
                ]),
                o("a", cS, [
                  k(p, {
                    width: "120",
                    height: "35"
                  })
                ])
              ])
            ]),
            t[1] || (t[1] = o("div", { class: "lux-library-links" }, [
              o("nav", {
                role: "navigation",
                "aria-label": "Library Staff"
              }, [
                o("ul", null, [
                  o("li", null, [
                    o("a", { href: "https://library.princeton.edu/library-staff" }, "For Library Staff")
                  ]),
                  o("li", null, [
                    o("a", { href: "https://library.princeton.edu/about/staff-directory" }, "Staff Directory")
                  ]),
                  o("li", null, [
                    o("a", { href: "https://library.princeton.edu/about/employment" }, "Library Jobs")
                  ])
                ])
              ])
            ], -1))
          ])
        ]),
        _: 1
      }, 8, ["maxWidth"]),
      k(w, {
        theme: s.value(n.theme)
      }, null, 8, ["theme"])
    ]),
    _: 1
  }, 8, ["class"]);
}
const fS = /* @__PURE__ */ S(tS, [["render", dS], ["__scopeId", "data-v-fd75b6ae"]]), hS = {
  name: "LuxSpecialCollectionsFooter",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  components: {
    LuxLibraryContactInfoOld: $i,
    LuxUniversityCopyright: Br,
    LuxUniversityAccessibilityOld: _i
  },
  props: {
    /**
     * The html element name used for the container
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * The maximum width of the wrapper. Default is set to 1170.
     */
    maxWidth: {
      type: Number,
      default: 1170
    }
  }
}, pS = { class: "lux-library-links" };
function vS(e, t, n, a, r, s) {
  const i = Y("lux-library-contact-info-old"), l = Y("lux-logo-university"), u = Y("lux-university-copyright-old"), c = Y("lux-university-accessibility-old"), d = Y("lux-wrapper");
  return h(), H(ie(n.type), {
    class: z(["lux-special-collections-footer"])
  }, {
    default: P(() => [
      k(d, {
        class: "lux-footer-content",
        maxWidth: n.maxWidth
      }, {
        default: P(() => [
          t[0] || (t[0] = o("div", { class: "lux-library-links" }, [
            o("nav", {
              role: "navigation",
              "aria-label": "About Archival Collections"
            }, [
              o("h2", null, [
                o("a", { href: "/research_help" }, "About Archival Collections")
              ]),
              o("ul", null, [
                o("li", null, [
                  o("a", { href: "/research_account" }, "Creating a Research Account")
                ]),
                o("li", null, [
                  o("a", { href: "/requesting_materials" }, "Requesting Materials")
                ]),
                o("li", null, [
                  o("a", { href: "/search_tips" }, "Search Tips")
                ]),
                o("li", null, [
                  o("a", { href: "/av_materials" }, "Statement on Audio Visual Materials")
                ]),
                o("li", null, [
                  o("a", { href: "/faq" }, "Frequently Asked Questions (FAQs)")
                ])
              ])
            ])
          ], -1)),
          t[1] || (t[1] = o("div", { class: "lux-library-links" }, [
            o("nav", {
              role: "navigation",
              "aria-label": "Library Services"
            }, [
              o("h2", null, [
                o("a", { href: "https://library.princeton.edu/services" }, "Library Services")
              ]),
              o("ul", null, [
                o("li", null, [
                  o("a", {
                    href: "https://library.princeton.edu/services/article-express",
                    title: "Use our Interlibrary Loan and Article Express Services"
                  }, "Article Express")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/services/borrowdirect" }, "Borrow Direct")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/services/access/circulation-policies" }, "Circulation")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/services/reserves" }, "Course Reserves")
                ]),
                o("li", null, [
                  o("a", {
                    href: "https://library.princeton.edu/services/interlibrary-services",
                    title: "Interlibrary Loan Services, Article Express"
                  }, "Interlibrary Loan (ILL)")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/services/access" }, "Library Access")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/services/study-spaces" }, "Study Spaces and Lockers")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/accounts" }, "Your Accounts")
                ])
              ])
            ])
          ], -1)),
          t[2] || (t[2] = o("div", { class: "lux-library-links" }, [
            o("nav", {
              role: "navigation",
              "aria-label": "About the Library"
            }, [
              o("h2", null, [
                o("a", { href: "https://library.princeton.edu/about" }, "About the Library")
              ]),
              o("ul", null, [
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/collections-and-collection-development" }, "Collections and Collecting")
                ]),
                o("li", null, [
                  o("a", { href: "https://rbsc.princeton.edu/exhibitions" }, "Exhibitions")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/about/locations" }, "Library Locations")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/alumni" }, "For Alumni")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/staff" }, "For Library Staff")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/staff/directory" }, "Staff Directory")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/about/friends" }, "Friends of the Library")
                ]),
                o("li", null, [
                  o("a", { href: "https://library.princeton.edu/services/technology/off-campus-access" }, "Using the Library Off-Campus")
                ])
              ])
            ])
          ], -1)),
          o("div", pS, [
            k(i),
            k(l, {
              width: "142",
              height: "40"
            }),
            k(u, { type: "div" }),
            k(c, { type: "span" })
          ])
        ]),
        _: 1,
        __: [0, 1, 2]
      }, 8, ["maxWidth"])
    ]),
    _: 1
  });
}
const mS = /* @__PURE__ */ S(hS, [["render", vS], ["__scopeId", "data-v-894636f0"]]), gS = {
  name: "LuxMediaImage",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  data: function() {
    return {
      source: this.src
    };
  },
  props: {
    /**
     * The image displayed
     */
    src: {
      type: String,
      default: null
    },
    /**
     * The alternative text describing the image. Do not include if image is decorative.
     */
    alt: {
      type: String,
      default: ""
    },
    /**
     * Manually define the height of the image for a card
     */
    height: {
      type: String,
      default: ""
    },
    /**
     * Whether the image fills the container maintaining aspect ratio and is cropped
     */
    cover: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the full image is contained within the container maintaining aspect ratio. Note that this property is not recommened for use when the `height` prop is used as it will show the background of the container.
     */
    contain: {
      type: Boolean,
      default: !1
    }
  }
}, yS = ["src", "alt"];
function bS(e, t, n, a, r, s) {
  const i = Y("lux-icon-file"), l = Y("lux-icon-base");
  return h(), g("div", {
    class: z(["lux-media-image", [n.height, { "lux-default-thumbnail": !e.source }]])
  }, [
    e.source ? (h(), g("img", {
      key: 0,
      onError: t[0] || (t[0] = (u) => e.source = null),
      src: e.source,
      alt: n.alt,
      class: z([{ "lux-cover": n.cover }, { "lux-contain": n.contain }])
    }, null, 42, yS)) : (h(), H(l, {
      key: 1,
      width: "50",
      height: "50",
      "icon-name": "file",
      "icon-color": "rgb(225,225,225)",
      "icon-hide": "true"
    }, {
      default: P(() => [
        k(i)
      ]),
      _: 1
    }))
  ], 2);
}
const _S = /* @__PURE__ */ S(gS, [["render", bS], ["__scopeId", "data-v-15c2fa90"]]), wS = {
  name: "LuxMenuBar",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  model: {
    prop: "active"
  },
  data: function() {
    return {
      isVisible: !1,
      activeItem: ""
    };
  },
  props: {
    /**
     * The html element types used for the nav bar. Passing 'href' in menuItems
     * will only work if type = "links".
     * `links, buttons`
     */
    type: {
      type: String,
      default: "links",
      validator: (e) => e.match(/(links|buttons|main-menu)/)
    },
    /**
     * State which tab is active when initiated (using name of the component).
     */
    active: {
      required: !1,
      type: String
    },
    /**
     * Menu items are options to be displayed to the user.  They have several possible properties:
     * <dl><dt><code>name</code></dt><dd>The text that is displayed for this menu item</dd>
     * <dt><code>href</code></dt><dd>If the type is links or main-menu, the url that the menu item links to.</dd>
     * <dt><code>target</code></dt><dd>If the type is links or main-menu, where to display the linked URL (for example, <code>_blank</code> for a new tab).</dd>
     * <dt><code>children</code></dt><dd>An array of items that should display below the current item hierarchically.</dd>
     * <dt><code>disabled</code></dt><dd>If the type is buttons, whether or not the button should be disabled.</dd>
     * <dt><code>component</code></dt><dd>Optional. An identifier you can use in conjunction with the <code>active</code> prop.</dd>
     * <dt><code>unsafe_name</code></dt><dd>Optional. If you need to include some arbitrary HTML in the menu item text, you can here and it will override the label provided in <code>name</code>.  Don't bind the <code>unsafe_name</code> property to any user-provided value, since it does not have Cross-Site Scripting protections (<code>name</code> does have these protections).</dd>
     * <dt><code>method</code></dt><dd>Optional. For use in conjunction with Rails applications that use UJS to link to non-GET HTTP methods, like POST or DELETE.  To mimic a Rails link_to helper for an item, pass the HTTP method with a `method` property.</dd>
     * </dl>
     */
    menuItems: {
      required: !0,
      type: Array
    },
    /**
     * Whether the header is dark, shade, or light. Default is set to dark.
     */
    theme: {
      type: String,
      default: "dark",
      validator: (e) => e.match(/(dark|shade|light)/)
    }
  },
  computed: {
    localActive: {
      get() {
        return this.active;
      },
      set(e) {
        this.$emit("input", e);
      }
    }
  },
  methods: {
    menuItemClicked(e) {
      this.$emit("menu-item-clicked", e);
    },
    setActiveItem(e) {
      this.activeItem === e ? this.activeItem = "" : this.activeItem = e;
    },
    hide: function(e) {
      this.activeItem = "";
    },
    hideIfExitingMenu: function(e) {
      var a, r;
      const t = (a = e.currentTarget) == null ? void 0 : a.closest(".lux-has-children"), n = (r = e.relatedTarget) == null ? void 0 : r.closest(".lux-has-children");
      t !== n && this.hide(e);
    }
  },
  components: {
    "lux-hamburger": gi,
    "lux-menu-bar-label": yi
  },
  directives: {
    "click-outside": {
      beforeMount: function(e, t) {
        const n = t.modifiers.bubble, a = (r) => {
          e.ariaExpanded === "true" && (n || !e.contains(r.target) && e !== r.target) && t.value(r);
        };
        e.__vueClickOutside__ = a, document.addEventListener("click", a);
      },
      unmounted: function(e, t) {
        document.removeEventListener("click", e.__vueClickOutside__), e.__vueClickOutside__ = null;
      }
    }
  },
  emits: ["input", "menu-item-clicked"]
}, $S = ["href", "title", "onClick"], CS = {
  class: "lux-nav-children",
  "aria-label": "submenu"
}, xS = ["href", "title", "target", "onClick"], SS = ["href", "title", "onClick"], MS = ["href", "disabled", "onClick"], DS = ["aria-expanded"], kS = ["aria-expanded", "data-method", "onClick", "onKeydown"], LS = ["href", "title", "target", "data-method", "onClick"], OS = ["title", "data-method", "onClick"], IS = ["href", "title", "data-method", "onClick"];
function ES(e, t, n, a, r, s) {
  const i = Y("lux-menu-bar-label"), l = Y("lux-hamburger"), u = Tr("click-outside");
  return n.type === "links" ? (h(), g("nav", {
    key: 0,
    class: z(["lux-nav", n.theme])
  }, [
    o("ul", null, [
      (h(!0), g(se, null, fe(n.menuItems, (c, d) => (h(), g("li", { key: d }, [
        c.children ? (h(), g(se, { key: 0 }, [
          (h(), g("a", {
            key: d,
            href: c.href,
            title: c.name,
            class: "lux-has-children lux-nav-item",
            "aria-haspopup": "true",
            onClick: (f) => s.menuItemClicked(f, c)
          }, [
            k(i, { item: c }, null, 8, ["item"])
          ], 8, $S)),
          o("ul", CS, [
            (h(!0), g(se, null, fe(c.children, ({ href: f, name: v, index: p, target: y }) => (h(), g("li", { key: p }, [
              o("a", {
                href: f,
                title: v,
                target: y,
                class: "lux-nav-item",
                onClick: (w) => s.menuItemClicked(w, c)
              }, j(v), 9, xS)
            ]))), 128))
          ])
        ], 64)) : (h(), g("a", {
          key: 1,
          href: c.href,
          title: c.name,
          class: "lux-nav-item",
          onClick: (f) => s.menuItemClicked(f, c)
        }, [
          k(i, { item: c }, null, 8, ["item"])
        ], 8, SS))
      ]))), 128))
    ])
  ], 2)) : n.type === "buttons" ? (h(), g("div", {
    key: 1,
    class: z(["lux-menu", n.theme])
  }, [
    o("ul", null, [
      (h(!0), g(se, null, fe(n.menuItems, (c, d) => (h(), g("li", { key: c }, [
        (h(), g("button", {
          key: d,
          href: c.href,
          class: z([
            "lux-menu-item",
            { "lux-active": s.localActive === c.component },
            { "lux-disabled": c.disabled },
            { "lux-is-child": c.hasOwnProperty("parent") === !0 }
          ]),
          disabled: c.disabled,
          onClick: (f) => s.menuItemClicked(f, c)
        }, [
          k(i, { item: c }, null, 8, ["item"])
        ], 10, MS))
      ]))), 128))
    ])
  ], 2)) : n.type === "main-menu" ? (h(), g("nav", {
    key: 2,
    class: z(["lux-main-menu", n.theme]),
    "aria-label": "Main Navigation"
  }, [
    o("button", {
      "aria-haspopup": "true",
      "aria-label": "Main Menu",
      "aria-expanded": e.isVisible ? "true" : "false",
      class: z(["lux-main-menu-toggle", { "is-active": e.isVisible }]),
      onClick: t[0] || (t[0] = (c) => e.isVisible = !e.isVisible)
    }, [
      k(l)
    ], 10, DS),
    o("ul", {
      class: z(["lux-main-menu-list", { "lux-show": e.isVisible }])
    }, [
      (h(!0), g(se, null, fe(n.menuItems, (c, d) => (h(), g("li", {
        key: d,
        class: z({ "lux-has-children": c.children })
      }, [
        c.children ? (h(), g(se, { key: 0 }, [
          ht((h(), g("button", {
            "aria-haspopup": "true",
            "aria-expanded": e.activeItem === d ? "true" : "false",
            class: "lux-submenu-toggle",
            "data-method": c.method,
            onClick: (f) => s.setActiveItem(d),
            onKeydown: Oe((f) => s.setActiveItem(d), ["esc"]),
            onFocusout: t[1] || (t[1] = (...f) => s.hideIfExitingMenu && s.hideIfExitingMenu(...f))
          }, [
            k(i, { item: c }, null, 8, ["item"])
          ], 40, kS)), [
            [u, s.hide]
          ]),
          o("ul", {
            class: z({ "lux-show": d === e.activeItem })
          }, [
            (h(!0), g(se, null, fe(c.children, (f, v) => (h(), g("li", { key: v }, [
              f.href ? (h(), g("a", {
                key: v,
                href: f.href,
                title: f.name,
                target: f.target,
                "data-method": f.method,
                class: "lux-nav-item",
                onClick: (p) => s.menuItemClicked(f),
                onFocusout: t[2] || (t[2] = (...p) => s.hideIfExitingMenu && s.hideIfExitingMenu(...p))
              }, [
                k(i, { item: f }, null, 8, ["item"])
              ], 40, LS)) : (h(), g("button", {
                key: "{{ index }}-button",
                title: f.name,
                "data-method": f.method,
                class: "lux-nav-item",
                onClick: (p) => s.menuItemClicked(f),
                onFocusout: t[3] || (t[3] = (...p) => s.hideIfExitingMenu && s.hideIfExitingMenu(...p))
              }, [
                k(i, { item: f }, null, 8, ["item"])
              ], 40, OS))
            ]))), 128))
          ], 2)
        ], 64)) : (h(), g("a", {
          key: d,
          href: c.href,
          title: c.name,
          "data-method": c.method,
          class: "lux-nav-item",
          onClick: (f) => s.menuItemClicked(c)
        }, [
          k(i, { item: c }, null, 8, ["item"])
        ], 8, IS))
      ], 2))), 128))
    ], 2)
  ], 2)) : B("", !0);
}
const TS = /* @__PURE__ */ S(wS, [["render", ES], ["__scopeId", "data-v-c91cc8b9"]]), AS = {
  name: "LuxTextStyle",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The html element name used for the text
     */
    type: {
      type: String,
      default: "p"
    },
    /**
     * Style variation to give additional meaning.
     * `default, disabled, strong, positive, negative,small,uppercase`
     */
    variation: {
      type: String,
      default: "default",
      validator: (e) => e.match(/(default|disabled|strong|emphasis|positive|negative|small|uppercase)/)
    }
  }
};
function PS(e, t, n, a, r, s) {
  return h(), H(ie(n.type), {
    class: z(["lux-text-style ", n.variation])
  }, {
    default: P(() => [
      ae(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]);
}
const zS = /* @__PURE__ */ S(AS, [["render", PS]]), YS = {
  name: "LuxLogoLibraryIcon",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 97
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 97
    },
    color: {
      type: String,
      default: "var(--color-princeton-orange-on-black)"
    }
  }
}, VS = ["width", "height"];
function HS(e, t, n, a, r, s) {
  return h(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: n.width,
    height: n.height,
    viewBox: "0 0 96 97",
    preserveAspectRatio: "xMinYMid",
    "aria-labelledby": "lux-logo-library-icon",
    role: "img"
  }, [
    t[2] || (t[2] = o("title", { id: "lux-logo-library-icon" }, "Princeton University Library", -1)),
    o("g", null, [
      o("path", {
        d: "M12.2 0h71.5A12.27 12.27 0 0196 12.2v72.5A12.29 12.29 0 0183.7 97H12.2A12.27 12.27 0 010 84.7V12.2A12.25 12.25 0 0112.2 0z",
        style: Fe({ fill: n.color })
      }, null, 4),
      t[0] || (t[0] = o("path", {
        class: "cls-2",
        d: "M10.8 83.5V20.1a22 22 0 006.6-3v59.8h.4a13.42 13.42 0 003.5-.4 39.8 39.8 0 007.6-2.5c1.2-.5 2.4-1.1 3.7-1.7a16.34 16.34 0 015.7-1.7 12 12 0 016.2.8 9.13 9.13 0 012.3 1.5 4.9 4.9 0 011.1 2c0 .1 0 .1.1.2s0-.1 0-.1a4.45 4.45 0 011.2-2.1 8 8 0 013.2-1.9 10.87 10.87 0 014.4-.5 16 16 0 016.4 1.7q3 1.5 6 2.7a27.18 27.18 0 006.2 1.7 12.29 12.29 0 002.7.2h.3V17.1a20.23 20.23 0 006.6 2.8v63.5H10.8z"
      }, null, -1)),
      t[1] || (t[1] = o("path", {
        class: "cls-2",
        d: "M24.8 32.7A74.92 74.92 0 0125 17l.4.2a17.22 17.22 0 004.8 1.7 13.15 13.15 0 008.9-1.4 19.23 19.23 0 005-3.9 22.63 22.63 0 003.5-4.8l.1-.2.3.2a24.47 24.47 0 005.7 6.7 16.37 16.37 0 006.3 3.2 13.91 13.91 0 007.3-.4 14.76 14.76 0 002.9-1.2l.2-.1h.1a74 74 0 01.2 15.6h-46m11 27.8a54.59 54.59 0 01-5.3-8.7l17.4-17.4 17.4 17.4a47.68 47.68 0 01-5.2 8.7l-6-6-6.1-6.1-12.2 12.1"
      }, null, -1))
    ])
  ], 8, VS);
}
const NS = /* @__PURE__ */ S(YS, [["render", HS], ["__scopeId", "data-v-42ec3b35"]]), RS = {
  name: "LuxLogoUniversity",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The width of the logo.
     */
    width: {
      type: [Number, String],
      default: 263
    },
    /**
     * The height of the logo.
     */
    height: {
      type: [Number, String],
      default: 72
    }
  }
}, BS = ["width", "height"];
function FS(e, t, n, a, r, s) {
  return h(), g("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: n.width,
    height: n.height,
    viewBox: "0 0 263 71.84",
    "aria-labelledby": "logo-university",
    role: "img"
  }, t[0] || (t[0] = [
    Dn('<title id="logo-university" lang="en" data-v-48a7eb4f>Princeton University</title><g data-v-48a7eb4f><path class="pu-logo-mc-a" d="M14.97 59.02a70.98 70.98 0 0 0 13.17 12.82 71.14 71.14 0 0 0 13.2-12.78L28.14 46.2z" data-v-48a7eb4f></path><path class="pu-logo-mc-a" d="M8.82 49.84l19.33-18.56L47.5 49.89a68.7 68.7 0 0 0 7.16-18.66l.19-.95H1.46a68.77 68.77 0 0 0 7.36 19.56z" data-v-48a7eb4f></path><path class="pu-logo-mc-a" d="M8.81 49.84a69.87 69.87 0 0 0 6.16 9.18l13.17-12.8 13.2 12.84a69.44 69.44 0 0 0 6.16-9.17L28.14 31.28z" data-v-48a7eb4f></path><path class="pu-logo-mc-b" d="M28.14 45.87L15 58.65a69.87 69.87 0 0 1-5.87-8.77l19.01-18.26L47.2 49.94a69.4 69.4 0 0 1-5.86 8.75z" data-v-48a7eb4f></path><path class="pu-logo-mc-b" d="M28.14 31.97l18.73 18.01a69.18 69.18 0 0 1-5.57 8.33L28.49 45.85l-.35-.33-.35.33-12.77 12.43a69.61 69.61 0 0 1-5.58-8.35l18.7-17.96m0-.7L8.8 49.85a69.87 69.87 0 0 0 6.16 9.18l13.17-12.8 13.2 12.84a69.44 69.44 0 0 0 6.16-9.17L28.14 31.28zM56.06 10.5a24.6 24.6 0 0 1-7.18 1.07A24.12 24.12 0 0 1 28.16 0 24.13 24.13 0 0 1 7.44 11.55 24.7 24.7 0 0 1 .26 10.5a67.64 67.64 0 0 0 1.18 19.8h53.4a68 68 0 0 0 1.22-19.8z" data-v-48a7eb4f></path><path d="M41.31 18.66v-2.27h-1.38v-1.6l-1.46-.4h-.1v-1.37s-.5.6-2.8.6c-2.18 0-3.46-.7-5.19-.7a2.36 2.36 0 0 0-2.18.95v.55h-.06v-.55a2.38 2.38 0 0 0-2.17-.96c-1.74 0-3.02.71-5.2.71-2.3 0-2.7-.6-2.7-.6v1.44h-.1l-1.57.33v1.6H15v2.27h1.4v3.67H15v2.27h1.4v2.82a33.88 33.88 0 0 0 4.5.37c2.55 0 4.02-.37 5.68-.4v.71a3.85 3.85 0 0 0 1.56.33 4.25 4.25 0 0 0 1.61-.33v-.71c1.66.03 3.13.4 5.7.4a33.84 33.84 0 0 0 4.48-.36V24.6h1.4v-2.27h-1.4v-3.67z" style="isolation:isolate;" fill="#fff" data-v-48a7eb4f></path><path class="pu-logo-mc-b" d="M38.59 14.23v-1.74l-.42.45s-.52.52-2.62.52l-2.85-.38-2.35-.33a2.78 2.78 0 0 0-2.2.84 2.8 2.8 0 0 0-2.21-.84l-2.34.33-2.85.38c-2.07 0-2.5-.5-2.51-.5l-.43-.52-.01.66v1.2l-1.69.35V27.7l.2.03a34.02 34.02 0 0 0 4.54.37 51.76 51.76 0 0 0 5.44-.38v.6l.13.07a4.1 4.1 0 0 0 1.67.35 4.46 4.46 0 0 0 1.72-.35l.14-.07v-.6a51.8 51.8 0 0 0 5.45.38 34.05 34.05 0 0 0 4.53-.38l.2-.02V14.66zm-10.2-.17a2.14 2.14 0 0 1 1.96-.83l2.24.32 2.96.4a5.88 5.88 0 0 0 2.57-.43v12.34a7.16 7.16 0 0 1-2.57.38l-2.85-.38-2.35-.33a2.94 2.94 0 0 0-1.96.62zm-10.1-.51a5.53 5.53 0 0 0 2.46.4l2.95-.39 2.24-.32a2.16 2.16 0 0 1 1.97.83v12.09a2.96 2.96 0 0 0-1.99-.63l-2.34.33-2.83.38c-2.07 0-2.5-.5-2.5-.5l.03-12.2zm21.37 13.73a33.04 33.04 0 0 1-4.25.33 53.52 53.52 0 0 1-5.67-.4l-.27-.03V28a4.07 4.07 0 0 1-1.37.26 3.81 3.81 0 0 1-1.32-.25v-.83l-.27.03a53.51 53.51 0 0 1-5.66.4 33.09 33.09 0 0 1-4.25-.33V15.04l1.2-.25v11.09c.12.25.63.84 2.95.84l2.93-.38 2.24-.33a2.18 2.18 0 0 1 1.99.83l.07-.03h.34l.07.03a2.14 2.14 0 0 1 1.96-.83l2.24.32 2.96.39c2.35 0 2.94-.62 3-.69l.04-11.3 1.07.3z" data-v-48a7eb4f></path><path class="pu-logo-mc-b" d="M21.72 15.72a.42.42 0 0 0-.37.24l-.78 1.73a.15.15 0 0 1-.06.03c-.03 0-.05-.03-.07-.08l-.32-.78-.25-.56a4.78 4.78 0 0 0-.19-.39.37.37 0 0 0-.32-.19.08.08 0 0 1-.02-.05.11.11 0 0 1 .01-.05h1.08l.02.04a.13.13 0 0 1-.01.06c-.1 0-.31 0-.31.14a.33.33 0 0 0 .02.11l.51 1.21.43-1a.63.63 0 0 0 .05-.26c0-.12-.08-.17-.3-.2a.18.18 0 0 1 0-.04.23.23 0 0 1 0-.06h.07l.4.01h.4l.02.04a.14.14 0 0 1-.01.05zm2.16 1.94c-.62 0-.95-.02-1.04-.02h-.3l-.5.02h-.12a.09.09 0 0 1 0-.05.26.26 0 0 1 0-.06.82.82 0 0 0 .3-.06.6.6 0 0 0 .07-.32v-1.2c0-.22-.11-.22-.34-.25a.24.24 0 0 1-.01-.05c0-.02 0-.05.02-.05h1.77c.05 0 .07 0 .07.04l.02.47-.05.02a.15.15 0 0 1-.05 0 .92.92 0 0 0-.3-.36.32.32 0 0 0-.19-.05h-.5c-.02 0-.02 0-.03.08l-.01.41v.27h.07a1 1 0 0 0 .23-.02.4.4 0 0 0 .2-.15.92.92 0 0 0 .06-.17.13.13 0 0 1 .06-.02.1.1 0 0 1 .05.02l-.01.44v.4a.07.07 0 0 1-.05.02.24.24 0 0 1-.06 0c-.02-.17-.05-.3-.2-.35a.55.55 0 0 0-.22-.05l-.14.01v.54a.67.67 0 0 0 .03.24.2.2 0 0 0 .12.11 1 1 0 0 0 .2.02h.29a.58.58 0 0 0 .22-.04 1.12 1.12 0 0 0 .33-.44.16.16 0 0 1 .06 0 .17.17 0 0 1 .06 0v.55c0 .04-.03.05-.1.05zm2.47-1.4h-.06a1.29 1.29 0 0 0-.15-.3.48.48 0 0 0-.38-.2h-.2v1.52c0 .24.1.24.35.27a.11.11 0 0 1 .02.06.1.1 0 0 1-.01.05h-.1l-.5-.01-.53.01a.07.07 0 0 1-.02-.05.12.12 0 0 1 .02-.06c.32-.02.36-.08.37-.18V16a1.27 1.27 0 0 0-.01-.25 1.4 1.4 0 0 0-.32.02.81.81 0 0 0-.41.45.2.2 0 0 1-.05 0 .06.06 0 0 1-.05-.02v-.53c0-.04 0-.06.06-.06h.97l.95-.01c.05 0 .08 0 .1.02a.4.4 0 0 1 0 .07v.53a.06.06 0 0 1-.05.02zm-4.73 3.2h-.06a1 1 0 0 0-.16-.3.48.48 0 0 0-.38-.2h-.2v1.52c0 .24.12.24.36.27a.1.1 0 0 1 .02.06.1.1 0 0 1-.01.05h-1.13a.1.1 0 0 1-.02-.05.25.25 0 0 1 .01-.05c.33-.03.36-.09.38-.2V19.2a1.3 1.3 0 0 0-.02-.25 1.45 1.45 0 0 0-.32.02.8.8 0 0 0-.4.45.25.25 0 0 1-.06 0 .06.06 0 0 1-.05-.02v-.52c0-.05 0-.06.06-.06h.97c.5 0 .86-.02.95-.02.05 0 .09 0 .1.02s0 .05 0 .08v.52a.06.06 0 0 1-.04.04zm2.34 1.4H22a.1.1 0 0 1-.02-.04.13.13 0 0 1 .02-.07.76.76 0 0 0 .3-.06c.05-.05.06-.13.07-.32l.01-.3v-.91c0-.22-.1-.22-.34-.25a.12.12 0 0 1-.01-.05c0-.02 0-.05.02-.06h1.77c.05 0 .07 0 .07.05l.02.47a.1.1 0 0 1-.05.02.17.17 0 0 1-.05 0 .85.85 0 0 0-.32-.35.3.3 0 0 0-.17-.05h-.51c-.02 0-.03 0-.03.08v.67h.06a.95.95 0 0 0 .23-.02.4.4 0 0 0 .22-.15.9.9 0 0 0 .04-.17.15.15 0 0 1 .06-.02.1.1 0 0 1 .06.02l-.02.44.01.4a.08.08 0 0 1-.06.02.27.27 0 0 1-.06 0c-.02-.17-.04-.3-.2-.35a.55.55 0 0 0-.21-.05 1.31 1.31 0 0 0-.14.01v.54a.84.84 0 0 0 .02.24c.02.03.07.1.12.11a1.07 1.07 0 0 0 .2.02h.3a.56.56 0 0 0 .21-.04 1.09 1.09 0 0 0 .33-.44.15.15 0 0 1 .07 0 .14.14 0 0 1 .05 0v.55c0 .05-.04.05-.11.05zm1.44.05a1.16 1.16 0 0 1-.47-.12.23.23 0 0 0-.08-.02.42.42 0 0 0-.15.08.13.13 0 0 1-.12-.06c0-.04.04-.17.04-.25l-.02-.33a.11.11 0 0 1 .09-.05h.03a4.29 4.29 0 0 0 .2.4.64.64 0 0 0 .45.22.44.44 0 0 0 .33-.1.29.29 0 0 0 .11-.25.26.26 0 0 0-.05-.19.5.5 0 0 0-.22-.15c-.09-.04-.4-.12-.52-.18a.82.82 0 0 1-.28-.2.63.63 0 0 1-.12-.38.58.58 0 0 1 .63-.57.76.76 0 0 1 .49.14 1.4 1.4 0 0 1 .12-.12.11.11 0 0 1 .1.06 2.24 2.24 0 0 0-.03.28l.04.3a.2.2 0 0 1-.09.03.14.14 0 0 1-.03-.01c-.06-.1-.11-.27-.17-.36a.46.46 0 0 0-.41-.17.34.34 0 0 0-.37.3c0 .17.14.25.25.3l.3.1a2.8 2.8 0 0 1 .33.13.56.56 0 0 1 .34.54.66.66 0 0 1-.72.63zm-2.96 3.17c-.62 0-.95-.02-1.04-.02h-.3l-.5.02h-.12a.09.09 0 0 1 0-.05.24.24 0 0 1 0-.06.83.83 0 0 0 .3-.06.6.6 0 0 0 .07-.32v-1.2c0-.22-.11-.22-.34-.25a.25.25 0 0 1-.01-.05c0-.02 0-.05.02-.05h1.77c.05 0 .07 0 .07.04l.02.47-.05.02a.14.14 0 0 1-.05 0 .92.92 0 0 0-.3-.36.32.32 0 0 0-.19-.05h-.5c-.02 0-.02 0-.03.08l-.01.41v.27h.07a1 1 0 0 0 .23-.03.4.4 0 0 0 .2-.14.9.9 0 0 0 .06-.17.13.13 0 0 1 .06-.02.1.1 0 0 1 .05.02l-.02.44.01.4a.07.07 0 0 1-.05.02.24.24 0 0 1-.06 0c-.02-.18-.05-.3-.2-.36a.55.55 0 0 0-.22-.04 1.3 1.3 0 0 0-.14 0v.54a.67.67 0 0 0 .03.25.2.2 0 0 0 .12.11 1.03 1.03 0 0 0 .2.01h.28a.58.58 0 0 0 .23-.03 1.13 1.13 0 0 0 .32-.44.17.17 0 0 1 .13 0v.54c0 .05-.03.06-.1.06zm2.99-1.95c-.21.01-.4.12-.4.46v1.05l.03.45a.22.22 0 0 1-.09.03.14.14 0 0 1-.05-.03l-1.44-1.55.01.32v.57c0 .04 0 .15.02.23a.26.26 0 0 0 .1.22.53.53 0 0 0 .27.09.1.1 0 0 1 .02.05.12.12 0 0 1-.02.05h-.91a.18.18 0 0 1 0-.04.13.13 0 0 1 .01-.05.5.5 0 0 0 .33-.14.68.68 0 0 0 .03-.25v-1.04a.36.36 0 0 0-.08-.22.74.74 0 0 0-.1-.1 1.18 1.18 0 0 0-.23-.1.16.16 0 0 1-.01-.05.1.1 0 0 1 .01-.06h.05l.44.01h.1a.2.2 0 0 1 .06.05l1.07 1.17.25.28v-.84l-.01-.24a.56.56 0 0 0-.07-.22c-.03-.05-.23-.08-.33-.1a.14.14 0 0 1-.01-.06.16.16 0 0 1 0-.04h.06l.36.01h.53a.11.11 0 0 1 0 .05.1.1 0 0 1 0 .04zm6.75-6.42c-.2 0-.39.12-.39.46v1.05l.01.45a.2.2 0 0 1-.08.03c-.01 0-.02 0-.05-.03l-1.45-1.55.02.32V17l.01.23a.29.29 0 0 0 .1.22.56.56 0 0 0 .28.09.1.1 0 0 1 .01.05.17.17 0 0 1-.01.05h-.9a.2.2 0 0 1-.01-.04.1.1 0 0 1 .01-.05.5.5 0 0 0 .33-.14.59.59 0 0 0 .03-.25v-1.04a.4.4 0 0 0-.07-.22.92.92 0 0 0-.1-.1 1.07 1.07 0 0 0-.24-.1.38.38 0 0 1 0-.05.2.2 0 0 1 0-.05h.59a.31.31 0 0 1 .07.05l1.07 1.17.24.28v-.84a2.03 2.03 0 0 0-.01-.24.5.5 0 0 0-.06-.22c-.04-.05-.24-.08-.34-.1a.15.15 0 0 1-.01-.06.09.09 0 0 1 0-.04h.07l.36.01h.52a.13.13 0 0 1 .01.04.1.1 0 0 1-.01.05zm2.13 1.69a1.02 1.02 0 0 1-1.45.01 1.13 1.13 0 0 1 0-1.55 1.02 1.02 0 0 1 .72-.3 1.1 1.1 0 0 1 .54.14 1.07 1.07 0 0 1 .5.91 1.14 1.14 0 0 1-.31.79zm-.34-1.5a.48.48 0 0 0-.4-.21.44.44 0 0 0-.38.21 1.18 1.18 0 0 0-.2.72 1.23 1.23 0 0 0 .19.72.45.45 0 0 0 .4.23.47.47 0 0 0 .44-.28 1.33 1.33 0 0 0 .14-.66 1.2 1.2 0 0 0-.19-.73zm3.25-.18a.41.41 0 0 0-.37.24l-.78 1.73a.15.15 0 0 1-.06.03c-.02 0-.06-.03-.07-.08l-.32-.78-.25-.56a4.78 4.78 0 0 0-.18-.4.38.38 0 0 0-.33-.18.07.07 0 0 1-.02-.05.08.08 0 0 1 .01-.06h.13l.38.01.49-.01h.08c.02 0 .02.03.02.05a.13.13 0 0 1 0 .05c-.1.01-.32 0-.32.14a.25.25 0 0 0 .02.12l.5 1.21.44-1a.69.69 0 0 0 .05-.27c0-.1-.08-.16-.3-.18a.17.17 0 0 1 0-.05.25.25 0 0 1 0-.06h.07l.4.01h.42a.1.1 0 0 1 0 .1zm-5.7 3.74h-.07a1 1 0 0 0-.15-.3.47.47 0 0 0-.38-.2h-.2v1.52c0 .24.11.24.36.27a.1.1 0 0 1 .01.06.1.1 0 0 1 0 .05h-1.15a.1.1 0 0 1-.01-.05.24.24 0 0 1 0-.05c.33-.03.37-.09.38-.2V19.2a1.32 1.32 0 0 0-.01-.25 1.45 1.45 0 0 0-.33.02.8.8 0 0 0-.4.45.24.24 0 0 1-.06 0 .06.06 0 0 1-.05-.02v-.52c0-.05.01-.06.07-.06h.97c.48 0 .85-.02.94-.02.06 0 .09 0 .1.02s0 .05 0 .08v.52a.06.06 0 0 1-.04.04zm2.45 1.4h-1.05a.08.08 0 0 1-.01-.05.17.17 0 0 1 0-.04c.2-.01.28-.05.28-.13a.7.7 0 0 0-.06-.26c-.06-.16-.1-.22-.1-.26-.02-.01-.02-.02-.06-.02h-.65a1.41 1.41 0 0 0-.15.39.45.45 0 0 0-.02.12c0 .06.07.14.3.14a.1.1 0 0 1 0 .06.17.17 0 0 1 0 .05h-.05l-.35-.01h-.45a.14.14 0 0 1 0-.03.12.12 0 0 1 0-.06.44.44 0 0 0 .3-.15 3.25 3.25 0 0 0 .26-.53l.31-.76.14-.3a4 4 0 0 1 .11-.21.13.13 0 0 1 .08-.04.12.12 0 0 1 .1.04.58.58 0 0 1 .04.1l.36.89.2.47.14.3c.08.16.2.16.32.2l.02.04-.01.05zm-1.3-1.62a3.76 3.76 0 0 0-.15.33 9.13 9.13 0 0 1-.16.4h.6c-.04-.13-.2-.5-.29-.73zm4.46 1.63l-.83-.01h-.23a.15.15 0 0 1-.01-.06.07.07 0 0 1 .02-.05 1.06 1.06 0 0 0 .2-.02c.08-.03.12-.12.12-.24V19l-.44.96-.15.33a4.29 4.29 0 0 0-.18.47.06.06 0 0 1-.07.03c-.03 0-.05 0-.06-.05-.06-.13-.1-.2-.11-.26l-.69-1.5h-.01v.38l.01.96c0 .3.16.43.39.43a.16.16 0 0 1 .02.05.12.12 0 0 1-.02.05H35l-.4-.01h-.42a.2.2 0 0 1-.01-.05.24.24 0 0 1 0-.05 1.06 1.06 0 0 0 .3-.1c.05-.04.09-.13.09-.33v-1.05c0-.16-.03-.23-.1-.29a1.02 1.02 0 0 0-.27-.05.14.14 0 0 1-.02-.05.17.17 0 0 1 .02-.06h.86a.12.12 0 0 1 .05.06l.6 1.38.12-.27c.1-.23.23-.56.42-.92l.12-.24.78-.01a.12.12 0 0 1 .02.05.1.1 0 0 1-.01.05c-.09.02-.24.02-.3.13-.03.04-.04.08-.04.25v.99c0 .38.1.41.14.44a.74.74 0 0 0 .2.03.1.1 0 0 1 .02.05l-.03.06zm-5.67 1.8h-.06a1 1 0 0 0-.15-.3.48.48 0 0 0-.38-.2h-.2v1.53c0 .24.11.24.36.27a.1.1 0 0 1 .01.06.1.1 0 0 1 0 .05h-.1l-.51-.01-.53.01a.1.1 0 0 1-.01-.05.25.25 0 0 1 0-.06c.33-.02.37-.08.38-.18v-1.36a1.3 1.3 0 0 0-.01-.26 1.45 1.45 0 0 0-.32.03.8.8 0 0 0-.41.45.24.24 0 0 1-.06 0 .06.06 0 0 1-.05-.02v-.53c0-.05.01-.06.07-.06h.97c.49 0 .85-.02.94-.02.06 0 .09 0 .1.02s0 .05 0 .08v.52a.06.06 0 0 1-.04.03zm2.55-.53a.41.41 0 0 0-.37.24l-.78 1.73a.15.15 0 0 1-.06.03c-.02 0-.05-.03-.07-.08l-.32-.78-.25-.56a4.69 4.69 0 0 0-.18-.4.38.38 0 0 0-.33-.18.07.07 0 0 1-.02-.05.08.08 0 0 1 .02-.06h.12l.38.01.49-.01h.08c.02 0 .02.03.02.05a.13.13 0 0 1 0 .05c-.1.01-.32 0-.32.14a.25.25 0 0 0 .02.12l.51 1.2.43-1a.69.69 0 0 0 .05-.26c0-.11-.08-.16-.29-.19a.17.17 0 0 1 0-.04.24.24 0 0 1 0-.07h.06c.1 0 .19.02.4.02l.26-.01h.15a.1.1 0 0 1 0 .1zm3.16 1.94l-.82-.01h-.23a.12.12 0 0 1-.01-.05.06.06 0 0 1 .01-.06 1.09 1.09 0 0 0 .2-.01c.09-.04.12-.13.12-.25v-1.48l-.44.96-.15.33a5.46 5.46 0 0 0-.18.46c-.01.04-.05.04-.07.04s-.04 0-.06-.06c-.05-.12-.1-.2-.11-.25l-.69-1.5h-.01v.38l.01.96c0 .3.16.43.4.43a.13.13 0 0 1 0 .05.11.11 0 0 1 0 .05h-.11l-.4-.01h-.42a.1.1 0 0 1-.02-.06.11.11 0 0 1 .02-.04 1.1 1.1 0 0 0 .3-.1.49.49 0 0 0 .07-.33v-1.05c0-.17-.02-.23-.1-.3a1.03 1.03 0 0 0-.26-.04.1.1 0 0 1-.02-.06.12.12 0 0 1 .02-.06l.36.01h.5a.12.12 0 0 1 .04.05l.6 1.39.12-.28a9.22 9.22 0 0 1 .43-.92l.12-.23.77-.02c.01.02.03.03.03.05a.12.12 0 0 1-.02.06c-.08 0-.23 0-.3.13-.03.04-.05.07-.05.24v.99c0 .38.1.42.15.45a.67.67 0 0 0 .2.02.08.08 0 0 1 .02.06c0 .03 0 .04-.02.06zm225.4-12.3a.83.83 0 0 0-.07-.37h-.6c-1.33 0-2.18.05-4.56.05-.82 0-2.04-.05-2.32-.05h-.7c-.07.05-.1.34-.1.45a.7.7 0 0 0 .13.45 11.1 11.1 0 0 1 2.73.76 5.15 5.15 0 0 1 .77 2.7c.02.4.05.8.05 1.88v5.53a10.62 10.62 0 0 1-.05 1.14c-.46-.5-1.09-1.46-2.15-2.65l-8.83-9.79a1.73 1.73 0 0 0-.4-.34l-.8-.02c-1.7 0-4.75-.08-5.2-.08a.97.97 0 0 0-.11.37 4.4 4.4 0 0 0 .08.5 3.63 3.63 0 0 1 1.98 1 8.9 8.9 0 0 1 1.4 1.67 2.3 2.3 0 0 1 .11.84c0 1.38-.08 3.31-.08 5.16v5.37a11.7 11.7 0 0 1-.16 2.01 5.5 5.5 0 0 1-2.77 1.35 1.54 1.54 0 0 0-.1.48c0 .08.02.34.07.36h.5c.53 0 1.75-.08 2.54-.08 1.17 0 1.96.08 3.04.08h1.6c.1-.02.12-.34.12-.45a1.22 1.22 0 0 0-.08-.42 5.09 5.09 0 0 1-3.17-1.64 15.06 15.06 0 0 1-.34-3.28c0-.84-.03-2-.03-3.57 0-2.09.03-3.91.06-4.83l.47.57 12.22 13.73a1.53 1.53 0 0 0 .74.16.63.63 0 0 0 .32-.05 3.05 3.05 0 0 0 .23-1.2l-.02-1.95V16.6c0-3.3 1.56-4.23 3.38-4.31a1.13 1.13 0 0 0 .1-.5m-30.3 8.4c0 4-1.11 7.52-2.62 8.76a4.29 4.29 0 0 1-2.8.96 3.96 3.96 0 0 1-3.51-1.78 14.08 14.08 0 0 1-1.56-6.87c0-3.68.95-6.56 2.64-7.96a4.21 4.21 0 0 1 2.75-1.03 4.4 4.4 0 0 1 3.6 1.82c1 1.38 1.5 3.36 1.5 6.1m4.8.5a8.87 8.87 0 0 0-4.71-8.22 10.22 10.22 0 0 0-5.03-1.35 10.77 10.77 0 0 0-8.91 4.93 10.1 10.1 0 0 0-1.53 5.34 9.86 9.86 0 0 0 3.78 7.75 9.92 9.92 0 0 0 6.03 1.9 10.95 10.95 0 0 0 4.02-.77 9.53 9.53 0 0 0 3.67-2.51 10.21 10.21 0 0 0 2.67-7.06m-23.24-3.33v-5.4c0-.4-.16-.5-.55-.5-.8 0-4.97.1-9.2.1-3.29 0-6.01-.05-7.49-.05h-1.96c-.34 0-.45.08-.45.45V17a.77.77 0 0 0 .43.1 2.02 2.02 0 0 0 .58-.05c1.19-2.4 2.3-3.7 3.7-4.42.79-.07 2.35-.1 2.77-.1.03.3.06 1.22.08 2.33.03 1.9.03 2.72.03 7.22 0 3.89-.03 5.63-.08 6.05-.1.74.02 1.3-3.15 1.44a1.5 1.5 0 0 0-.08.6 2.1 2.1 0 0 0 .03.42h1.02c.98 0 3.28-.1 4.24-.1.76 0 3.22.08 4.83.08h.74a1.33 1.33 0 0 0 .08-.55.99.99 0 0 0-.1-.48 5.48 5.48 0 0 1-2.72-.5 8.08 8.08 0 0 1-.24-1.98c-.03-2.86-.05-3.94-.05-5.85 0-2.45.02-4.12.02-8.7.37 0 1.22-.02 2.01 0a5.18 5.18 0 0 1 3.15 2.01 13.32 13.32 0 0 1 1.4 2.89 1.34 1.34 0 0 0 .45.05 1.42 1.42 0 0 0 .5-.1m-22.8 8.6a5.82 5.82 0 0 0-.02-.77.59.59 0 0 0-.4-.08 2.22 2.22 0 0 0-.58.05 10.1 10.1 0 0 1-2.91 4.03 4.03 4.03 0 0 1-1.99.3h-2.16a9.74 9.74 0 0 1-1.75-.14c-.4-.08-.82-.71-1-1.14a2.77 2.77 0 0 1-.29-1.66v-5.79h.98a4.17 4.17 0 0 1 1.61.37 2.44 2.44 0 0 1 1.2 1.11 9.1 9.1 0 0 1 .44 2.2 1.89 1.89 0 0 0 .7.1.94.94 0 0 0 .52-.14c0-.71-.16-2.64-.16-3.7 0-1.32.18-3.14.26-4.09a1.07 1.07 0 0 0-.52-.1 1.93 1.93 0 0 0-.69.07c-.08.37-.37 1.48-.43 1.56a3.2 3.2 0 0 1-1.8 1.38 7.12 7.12 0 0 1-1.53.2h-.56v-2.45c0-2.54.06-3.36.08-3.84l.1-.9a10.93 10.93 0 0 1 1.6-.05c1.53 0 2.24.02 2.48.02a3.02 3.02 0 0 1 1.7.53 11.22 11.22 0 0 1 2.53 3.28 2.11 2.11 0 0 0 .56.05c.16 0 .18-.05.4-.15 0-1.62-.11-3.7-.16-4.37-.03-.26-.08-.34-.6-.34-.22 0-1.23-.05-2.28-.05-1.5 0-2.12.02-4.42.02l-4.9.03c-1.58 0-2.93-.05-3.62-.05h-.9a.86.86 0 0 0-.13.42 1.19 1.19 0 0 0 .13.53 13.43 13.43 0 0 1 1.94.29 2.17 2.17 0 0 1 .95 1.72c.05.56.08 2.09.08 3.3v5.45c0 1.11-.03 2.73-.06 3.39a7.65 7.65 0 0 1-.58 2.51 6.99 6.99 0 0 1-2.38.4 1.6 1.6 0 0 0-.13.58 1.02 1.02 0 0 0 .13.48h.87c.85 0 3.97-.08 4.69-.08.66 0 1.93.05 3.46.05.85 0 3.33.16 8.67.16a2.25 2.25 0 0 0 .72-.06.8.8 0 0 0 .1-.42c.06-.53.06-2.09.06-4.23m-22.37.92a.88.88 0 0 0-.9-.63l-.19.03c-1.59 2.25-3.33 3.09-5.32 3.09a5.8 5.8 0 0 1-5.34-3.5 14.5 14.5 0 0 1-.82-4.8 11.67 11.67 0 0 1 .8-4.63c1.16-3.07 2.85-4.02 4.92-4.02a5.42 5.42 0 0 1 4.23 2.38 11.87 11.87 0 0 1 1.34 3.2 2.82 2.82 0 0 0 .59.07 1.29 1.29 0 0 0 .63-.23c-.02-.3-.29-2.33-.29-2.97 0-.79.21-2.08.21-2.59a2.1 2.1 0 0 0-1.03-.29 5.18 5.18 0 0 0-.9 1.09 8.7 8.7 0 0 0-5.87-1.88 9.02 9.02 0 0 0-6.64 2.62 10.04 10.04 0 0 0-2.83 7.45 9.67 9.67 0 0 0 3.73 7.91 10.54 10.54 0 0 0 6.16 1.77c3.23 0 5.59-1.21 6.77-2.82a5.54 5.54 0 0 0 .75-1.25m-20.59-15.1a.86.86 0 0 0-.08-.37h-.61c-1.32 0-2.17.05-4.55.05-.82 0-2.04-.05-2.33-.05h-.68c-.08.05-.11.35-.11.45a.69.69 0 0 0 .14.45 11.22 11.22 0 0 1 2.72.77 5.2 5.2 0 0 1 .76 2.7c.03.39.06.79.06 1.87v5.53a9.04 9.04 0 0 1-.06 1.14c-.44-.5-1.08-1.46-2.14-2.65l-8.82-9.78a1.75 1.75 0 0 0-.4-.34l-.79-.03c-1.7 0-4.76-.08-5.21-.08a.97.97 0 0 0-.1.37 4.37 4.37 0 0 0 .07.5 3.62 3.62 0 0 1 1.99 1 8.75 8.75 0 0 1 1.4 1.67 2.3 2.3 0 0 1 .1.84c0 1.38-.07 3.31-.07 5.16v5.37a11.62 11.62 0 0 1-.16 2.01 5.5 5.5 0 0 1-2.78 1.35 1.6 1.6 0 0 0-.1.48c0 .08.02.34.08.37h.5c.53 0 1.74-.09 2.54-.09 1.16 0 1.95.09 3.04.09h1.57c.1-.03.14-.35.14-.45a1.24 1.24 0 0 0-.08-.43 5.08 5.08 0 0 1-3.17-1.64 15.19 15.19 0 0 1-.34-3.28c0-.84-.03-2-.03-3.57 0-2.08.03-3.9.06-4.83.16.18.34.42.47.58l12.21 13.73a1.54 1.54 0 0 0 .74.16.62.62 0 0 0 .32-.05 3.05 3.05 0 0 0 .23-1.2c0-.76-.03-1.56-.03-1.95V16.59c0-3.3 1.57-4.23 3.4-4.31a1.13 1.13 0 0 0 .1-.5M121.91 30.1a1.77 1.77 0 0 0-.08-.53 19.7 19.7 0 0 1-1.95-.23 4.16 4.16 0 0 1-.9-2.04 362.9 362.9 0 0 1-.06-6.35v-6.5a2.1 2.1 0 0 1 .48-1.43 4.55 4.55 0 0 1 2.36-.69 1.66 1.66 0 0 0 .07-.5.78.78 0 0 0-.13-.42h-.77c-1.1 0-3.7.13-4.6.13-.55 0-3.14-.08-4.3-.1h-.58a.63.63 0 0 0-.14.45 3.24 3.24 0 0 0 .05.5 5.55 5.55 0 0 1 2.07.37 2.92 2.92 0 0 1 .87 2.24c.02.5.05 1.59.08 4.02.02 1.33.05 3.17.05 4.7 0 .77-.05 2.49-.08 3.41a4.53 4.53 0 0 1-.37 1.6c-.31.26-.63.73-2.57.86a2.04 2.04 0 0 0-.08.56c0 .21.06.32.06.45h.45c1.06 0 3.7-.14 5.07-.14.4 0 3.15.09 4.02.09h.88a1.06 1.06 0 0 0 .1-.45M100.7 16.3c0 1.64-1.11 3.52-2.4 3.83a8.86 8.86 0 0 1-2.17.22 5.97 5.97 0 0 1-.98-.06l-.03-2.25v-4.86a.84.84 0 0 1 .16-.58 2.64 2.64 0 0 1 1.12-.16c2.06 0 2.96.18 3.7 1.43a4.71 4.71 0 0 1 .6 2.43m7.67 13.83a1.29 1.29 0 0 0-.13-.56 4.04 4.04 0 0 1-1.75-.34 5.34 5.34 0 0 1-.45-.66 28.67 28.67 0 0 0-1.13-3.04 10 10 0 0 0-1.96-3.15 8.43 8.43 0 0 0-1.99-.87 27.45 27.45 0 0 1-1.08-.43 8.26 8.26 0 0 1 1.08-.15c1.96-.24 2.41-.58 2.91-.98a4.17 4.17 0 0 0 1.64-3.44 5.08 5.08 0 0 0-3.3-4.82 12.98 12.98 0 0 0-3.17-.28c-1.99 0-4.76.18-6.08.18-.4 0-2.7-.05-3.63-.05-.4 0-1.4-.05-1.56-.05a1.52 1.52 0 0 0-.13.5 2.94 2.94 0 0 0 .05.47c.45.05 1.27.16 1.7.24a3.13 3.13 0 0 1 1.1 1.43 67.13 67.13 0 0 1 .17 6.74c0 2.7.02 5.82-.1 6.83a2.01 2.01 0 0 1-1.09 1.77 13.67 13.67 0 0 1-1.5.18 1.3 1.3 0 0 0-.14.53 1.64 1.64 0 0 0 .1.42c.37 0 4.42-.07 5.26-.07 1.7 0 3.13.07 4.63.07a1.1 1.1 0 0 0 .1-.4 1.65 1.65 0 0 0-.1-.55c-.53-.05-1.19-.2-1.48-.27a1.98 1.98 0 0 1-1.14-1.87l-.02-6.11a5.52 5.52 0 0 1 .69-.03 2.7 2.7 0 0 1 1.4.42 5.12 5.12 0 0 1 2.09 1.94 16.1 16.1 0 0 1 1.66 5.68c.08.56.3 1.03.8 1.09.2.02 1.6.08 2.61.08h3.79a.73.73 0 0 0 .15-.45m-28.72-13.7a4.33 4.33 0 0 1-1.34 3.3 4.3 4.3 0 0 1-2.76.72 8.66 8.66 0 0 1-1.13-.05c-.21-.03-.35-.05-.35-.19l.03-7.75a12.09 12.09 0 0 1 1.53-.13c1.8 0 2.91.45 3.44 1.56a5.63 5.63 0 0 1 .58 2.54m4.73.1a5.06 5.06 0 0 0-2.82-4.6 13.08 13.08 0 0 0-4.74-.6c-2.03 0-5.2.16-6.6.16-.99 0-2.47-.11-3.29-.11a.97.97 0 0 0-.13.42 1.27 1.27 0 0 0 .08.53c.5.16 1.32.3 1.85.43a2.26 2.26 0 0 1 .71 1.5c.08.93.14 2.1.14 4.1 0 5.59-.03 8.52-.11 9.15a2.24 2.24 0 0 1-1.5 1.88 14.8 14.8 0 0 1-1.54.26 2.8 2.8 0 0 0-.06.56.74.74 0 0 0 .08.37c.85 0 3.34-.1 4.29-.1 2.35 0 4.76.1 5.73.1h.67a.76.76 0 0 0 .08-.42 1.28 1.28 0 0 0-.06-.48 4.3 4.3 0 0 1-2.48-.85 2.25 2.25 0 0 1-.53-1.56l-.08-5.81c1.58.1 3.28.15 4.2.15a9.93 9.93 0 0 0 3.07-.47 4.84 4.84 0 0 0 3.04-4.6M263 41.28c0-.16-.1-.22-.16-.32-1.08 0-2.51.08-3.07.08-1.34 0-2.98-.1-3.7-.1-.08.15-.1.18-.1.3a.94.94 0 0 0 .05.33c.77.15 1.88.34 2.09.71a1.9 1.9 0 0 1 .24 1.03 2.58 2.58 0 0 1-.16.98c-.24.66-.74 1.7-1.45 3.15a52.4 52.4 0 0 1-2.41 4.6 91.87 91.87 0 0 1-2.6-5.02l-1.47-3.23a2.45 2.45 0 0 1-.1-.72 1.76 1.76 0 0 1 .1-.68c.23-.48 1.05-.53 2.17-.67a1.16 1.16 0 0 0 .07-.39c0-.18-.08-.13-.16-.26h-.47c-1.77 0-1.25.08-4.29.08-1.3 0-2.85-.08-3.06-.08-.1.18-.16.2-.16.4a.57.57 0 0 0 .1.31c1.77.42 2.3.74 2.49 1.09l4.63 9.07a10.46 10.46 0 0 1 .84 1.98 14.71 14.71 0 0 1 .22 3.17 2.25 2.25 0 0 1-.85 2.04 12.68 12.68 0 0 1-2.12.34.63.63 0 0 0-.13.37 1.12 1.12 0 0 0 .08.32c1.35 0 2.75-.03 3.54-.03.56 0 1.4.03 2.97.06.9.02 1.58.05 2.06.05a.78.78 0 0 0 .13-.34.58.58 0 0 0-.1-.35 6.33 6.33 0 0 1-2.3-.53 2.03 2.03 0 0 1-.7-1.69l-.2-3.97a1.46 1.46 0 0 1 .1-.63 3.98 3.98 0 0 1 .29-.74l4.07-8.06a5.47 5.47 0 0 1 1.7-1.78 7.42 7.42 0 0 1 1.72-.53.97.97 0 0 0 .1-.34m-21.37 5.45v-5.14c0-.4-.16-.5-.55-.5-.8 0-4.45.1-8.68.1-3.28 0-5.47-.05-6.96-.05h-1.95c-.34 0-.45.08-.45.45v4.79a.47.47 0 0 0 .31.1.69.69 0 0 0 .32-.05c1.03-2.3 1.56-3.52 3.34-4.42.79-.08 3.56-.1 3.99-.1.02.29.05 1.21.08 2.33.03 1.9.03 2.93.03 7.43 0 3.89-.03 5.9-.09 6.32-.1.74.03 1.3-3.14 1.43a.84.84 0 0 0-.08.45 1.22 1.22 0 0 0 .03.31h1.03c.97 0 2.27-.1 3.22-.1.77 0 2.22.08 3.84.08h.74a.7.7 0 0 0 .08-.4.6.6 0 0 0-.11-.37 5.44 5.44 0 0 1-2.72-.5 8.07 8.07 0 0 1-.24-1.98c-.03-2.86-.05-4.2-.05-6.11 0-2.46.02-4.34.02-8.91.37 0 2.33-.03 3.13 0a4.76 4.76 0 0 1 2.98 2 8.48 8.48 0 0 1 1.19 2.89 1.05 1.05 0 0 0 .4.05.5.5 0 0 0 .3-.1M219.65 59.8a.85.85 0 0 0-.08-.37c-.4-.03-1.48-.14-1.96-.24a4.18 4.18 0 0 1-.9-2.04 398.46 398.46 0 0 1-.05-6.61v-6.71a2.12 2.12 0 0 1 .47-1.43 4.51 4.51 0 0 1 2.36-.69.78.78 0 0 0 .08-.34.45.45 0 0 0-.13-.32h-.76c-1.12 0-2.7.13-3.6.13-.56 0-2.15-.08-3.3-.1h-.59a.38.38 0 0 0-.13.34 1.82 1.82 0 0 0 .05.35 5.7 5.7 0 0 1 2.07.37 2.93 2.93 0 0 1 .87 2.25c.03.5.05 1.85.08 4.28.03 1.32.05 3.12.05 4.65 0 .77-.05 2.75-.08 3.68a4.5 4.5 0 0 1-.37 1.58c-.32.27-.63.74-2.56.88a1.06 1.06 0 0 0-.08.4c0 .2.05.2.05.34h.45c1.06 0 2.7-.13 4.07-.13.4 0 2.14.07 3.02.07h.87a.64.64 0 0 0 .1-.34m-13.06-4.86a4.9 4.9 0 0 0-2.99-4.66 14.79 14.79 0 0 0-2.93-1.06 19.17 19.17 0 0 1-3.84-1.45 3.17 3.17 0 0 1-1.56-2.88c0-1.7 1.72-3.1 3.73-3.1a4.43 4.43 0 0 1 3.62 1.85 13.49 13.49 0 0 1 1.64 3.02 1.05 1.05 0 0 0 .27.05.86.86 0 0 0 .58-.26 20.75 20.75 0 0 1-.21-2.38 13.8 13.8 0 0 1 .24-2.07.81.81 0 0 0-.8-.37 5.88 5.88 0 0 0-1.03.96 6.6 6.6 0 0 0-4.5-1.64c-3.25 0-5.58 2.17-5.58 5.05a5.3 5.3 0 0 0 .98 2.9 5.78 5.78 0 0 0 2.57 1.94c.76.31 4.2 1.35 4.68 1.53 2.11.82 2.9 1.53 2.9 3.41a4.13 4.13 0 0 1-1.16 2.67 3.69 3.69 0 0 1-2.93 1.25 5.93 5.93 0 0 1-4.45-1.96 12.6 12.6 0 0 1-1.8-3.57.9.9 0 0 0-.37-.05.94.94 0 0 0-.5.15c0 .35.1 2.1.1 2.62a11.04 11.04 0 0 1-.28 2.36 1 1 0 0 0 .85.53 3.73 3.73 0 0 1 1.32-.85 1.23 1.23 0 0 1 .63.24 7.63 7.63 0 0 0 4.42 1.32c3.73 0 6.4-1.88 6.4-5.55m-23.4-9.13a4.28 4.28 0 0 1-2.9 3.94 14.25 14.25 0 0 1-2.76.22 16.01 16.01 0 0 1-1.61-.06l-.03-2.33v-5c0-.34.08-.53.19-.6a8.55 8.55 0 0 1 1.85-.16c2.48 0 3.62.23 4.52 1.53a4.16 4.16 0 0 1 .74 2.46m5.55 14.01a.7.7 0 0 0-.13-.39 4.06 4.06 0 0 1-1.75-.34 5.94 5.94 0 0 1-.45-.66 33.85 33.85 0 0 0-1.1-3.3 9.87 9.87 0 0 0-1.96-3.16 7.06 7.06 0 0 0-1.9-.87 40.92 40.92 0 0 1-1.09-.42 10.45 10.45 0 0 1 1.09-.16 4.85 4.85 0 0 0 2.8-.98 4.2 4.2 0 0 0 1.74-3.41 5.04 5.04 0 0 0-3.3-4.79 13 13 0 0 0-3.17-.29c-1.99 0-3.47.18-4.8.18-.39 0-1.68-.05-2.6-.05-.4 0-1.4-.05-1.57-.05-.08.19-.13.24-.13.35a1.7 1.7 0 0 0 .05.37c.45.05 1.27.15 1.7.23a3.1 3.1 0 0 1 1.1 1.43c.14.85.16 3.23.16 6.96 0 2.7.03 6.08-.1 7.09a2 2 0 0 1-1.09 1.76 14.9 14.9 0 0 1-1.5.2.68.68 0 0 0-.14.36 1.07 1.07 0 0 0 .1.32c.38 0 3.42-.08 4.27-.08 1.69 0 2.11.08 3.62.08a.65.65 0 0 0 .1-.3.75.75 0 0 0-.1-.39c-.53-.05-1.2-.21-1.48-.26a1.98 1.98 0 0 1-1.14-1.88l-.02-6.61c.2-.03.97-.03 1.18-.03a4.9 4.9 0 0 1 2.12.37 5.93 5.93 0 0 1 2.6 2.14 16.6 16.6 0 0 1 1.66 5.77c.08.55.29 1.03.8 1.08a9.6 9.6 0 0 0 1.53.08h2.75a.45.45 0 0 0 .15-.34m-22.18-4.02a6.94 6.94 0 0 0-.03-.77.59.59 0 0 0-.4-.08.74.74 0 0 0-.34.06 7 7 0 0 1-2.73 4.04 4.98 4.98 0 0 1-2.24.3h-2.96a12.39 12.39 0 0 1-1.75-.14c-.4-.08-.82-.72-1-1.14a3.43 3.43 0 0 1-.3-1.82V50.2h.85a5.22 5.22 0 0 1 2.25.38 3.18 3.18 0 0 1 1.43 1.13 9.06 9.06 0 0 1 .37 2.2.66.66 0 0 0 .42.1.61.61 0 0 0 .43-.14c0-.7-.16-2.64-.16-3.7 0-1.32.18-2.93.26-3.89a.69.69 0 0 0-.42-.1.8.8 0 0 0-.43.08c-.07.37-.29 1.48-.34 1.56a3.85 3.85 0 0 1-2.03 1.4 8.42 8.42 0 0 1-2.17.22h-.43v-2.6c0-2.54.06-3.57.08-4.05l.1-.9c.25-.03 1-.05 2.23-.05 1.53 0 2.67.02 2.9.02a2.98 2.98 0 0 1 1.7.53 6.73 6.73 0 0 1 2.36 3.28.73.73 0 0 0 .31.05c.16 0 .19-.05.4-.15a59 59 0 0 0-.16-4.1c-.03-.27-.08-.34-.6-.34-.22 0-1.22-.06-2.28-.06-1.51 0-2.12.03-4.42.03l-4.52.03c-1.59 0-1.93-.06-2.62-.06h-.9a.54.54 0 0 0-.14.32.63.63 0 0 0 .14.37 13.4 13.4 0 0 1 1.94.3c.37.3.71.4.95 1.66.05.55.08 2.35.08 3.57v5.44c0 1.11-.03 2.94-.05 3.6a8 8 0 0 1-.59 2.57 6.99 6.99 0 0 1-2.39.4.88.88 0 0 0-.13.42.63.63 0 0 0 .13.37h.88c.85 0 2.97-.08 3.68-.08.66 0 1.56.05 3.1.05.85 0 3.33.16 8.68.16a2.24 2.24 0 0 0 .7-.05.8.8 0 0 0 .12-.42c.05-.53.05-1.83.05-3.97m-19.6-14.43c0-.11-.03-.27-.14-.3h-.9c-.63 0-1.64.06-2.09.06-2.14 0-2.9-.14-3.22-.14h-.48c-.05.14-.13.22-.13.35 0 .1.05.18.05.29a9.85 9.85 0 0 1 1.83.4 2.49 2.49 0 0 1 .66 1.66 10.03 10.03 0 0 1-.64 2.41l-4.25 10.47-5.23-13.25a1.99 1.99 0 0 1 .87-1.48 11.6 11.6 0 0 1 1.71-.21.97.97 0 0 0 .1-.37c0-.1-.02-.26-.13-.29h-.66c-.81 0-2.06.1-3.46.1-.6 0-1.8-.05-2.96-.05h-1.03a.55.55 0 0 0-.1.32.57.57 0 0 0 .08.31 9.18 9.18 0 0 1 2.22.9 47.23 47.23 0 0 1 2.17 4.82l2.19 5.3c1.82 4.38 2.9 7.31 3.04 7.82.13.08 0 .15.23.15s.22-.04.27-.18l6.82-16.4a5.26 5.26 0 0 1 .95-1.5 4.2 4.2 0 0 1 2.12-.85 1.25 1.25 0 0 0 .1-.34m-23.15 18.43a.82.82 0 0 0-.08-.37c-.4-.03-1.48-.13-1.96-.24a4.22 4.22 0 0 1-.9-2.04c-.02-1.27-.05-4.15-.05-6.6v-6.72a2.1 2.1 0 0 1 .48-1.44 4.5 4.5 0 0 1 2.35-.68.78.78 0 0 0 .08-.34.43.43 0 0 0-.14-.32h-.76c-1.11 0-2.7.13-3.6.13-.55 0-2.14-.08-3.3-.1h-.58a.37.37 0 0 0-.14.34 1.84 1.84 0 0 0 .05.34 5.68 5.68 0 0 1 2.07.37 2.91 2.91 0 0 1 .87 2.25c.03.5.05 1.86.08 4.29.03 1.32.06 3.12.06 4.65 0 .77-.06 2.75-.09 3.67a4.44 4.44 0 0 1-.37 1.6c-.31.26-.63.73-2.56.87a1.01 1.01 0 0 0-.08.4c0 .2.05.2.05.34h.45c1.06 0 2.7-.14 4.07-.14.4 0 2.14.08 3.02.08h.87a.61.61 0 0 0 .1-.34M111.86 41.3a.42.42 0 0 0-.08-.26h-.6c-1.33 0-1.9.05-4.29.05-.82 0-2.03-.05-2.32-.05h-.7c-.07.05-.1.24-.1.34a.34.34 0 0 0 .14.29 11.36 11.36 0 0 1 2.72.77 5.23 5.23 0 0 1 .77 2.7c.02.39.05.79.05 1.87v7.86a10.42 10.42 0 0 1-.05 1.13c-.45-.5-1.22-1.48-2.25-2.7l-10.1-11.79a1.75 1.75 0 0 0-.4-.34l-.68-.03c-1.7 0-3.18-.08-3.63-.08a.53.53 0 0 0-.07.27 1.99 1.99 0 0 0 .05.34 4.63 4.63 0 0 1 2.04.74 7.7 7.7 0 0 1 1.29 1.56 2.3 2.3 0 0 1 .1.85c0 1.37-.07 3.88-.07 5.73v5.64a11.9 11.9 0 0 1-.16 2 5.55 5.55 0 0 1-2.78 1.36.76.76 0 0 0-.1.32c0 .08.02.23.08.26h.5c.52 0 1.74-.08 2.54-.08 1.16 0 1.69.08 2.77.08h1.6c.1-.03.12-.24.12-.34a.5.5 0 0 0-.08-.27A5.09 5.09 0 0 1 95 57.88a15.54 15.54 0 0 1-.35-3.33l-.02-3.78c0-2.09.02-4.97.05-5.9l.58.69 12.54 14.67a.37.37 0 0 0 .32.16c.13 0 .05 0 .15-.05a4.05 4.05 0 0 0 .14-1.2c0-.76-.03-1.55-.03-1.95V45.96c0-3.3 1.56-4.24 3.39-4.31a.6.6 0 0 0 .1-.35m-24.5.13a.55.55 0 0 0-.12-.34h-.77c-.82 0-1.93.06-2.88.06-1.06 0-2.25-.06-3.02-.06h-.95a.62.62 0 0 0-.1.34.93.93 0 0 0 .07.35c.11 0 2.04.02 2.38.5a6.51 6.51 0 0 1 1.03 1.96 17.27 17.27 0 0 1 .22 2.9c0 2.25 0 3.76-.03 4.55a14.24 14.24 0 0 1-.48 3.52c-.74 2.3-2.45 3.44-5.18 3.44a7.24 7.24 0 0 1-3.1-.66 4.45 4.45 0 0 1-2.56-3.33l-.14-7.94-.02-3.22c0-.61.77-1.17 1.03-1.48a12.54 12.54 0 0 1 2.04-.27.76.76 0 0 0 .13-.37.44.44 0 0 0-.18-.34l-1 .03c-.99.02-2.28.05-3.1.05-1.27 0-2.25-.03-3.04-.03h-1.11a.45.45 0 0 0-.14.37.42.42 0 0 0 .1.32c.85.1 1.4.19 1.78.26a2.23 2.23 0 0 1 .93 1.17c.02.34.07 1.19.07 2.85v6.35a16.25 16.25 0 0 0 .27 3.54 5.22 5.22 0 0 0 2.3 3.25 8.66 8.66 0 0 0 4.84 1.27 9.1 9.1 0 0 0 4.55-1.08 5.42 5.42 0 0 0 2.61-3.52 12.12 12.12 0 0 0 .42-3.14v-5.08c0-.95.06-2.14.06-2.62a5.33 5.33 0 0 1 .8-2.91 10.94 10.94 0 0 1 2.19-.37.65.65 0 0 0 .1-.32" data-v-48a7eb4f></path></g>', 2)
  ]), 8, BS);
}
const jS = /* @__PURE__ */ S(RS, [["render", FS], ["__scopeId", "data-v-48a7eb4f"]]), WS = {
  name: "LuxSearchBox",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  props: {
    /**
     * The html element name used for the container
     */
    type: {
      type: String,
      default: "div"
    },
    /**
     * The name of the input, which will be part of
     * the URL after the search is submitted.
     */
    name: {
      type: String,
      default: "query"
    },
    /**
     * Whether the corners should be rounded (default)
     * or square.
     */
    corners: {
      type: String,
      default: "rounded",
      validator: (e) => ["rounded", "square"].includes(e)
    },
    modelValue: {
      type: String
    }
  },
  emits: ["update:modelValue"],
  components: {
    LuxInputButton: Pr,
    LuxInputText: zr
  }
};
function US(e, t, n, a, r, s) {
  const i = Y("lux-input-text"), l = Y("lux-input-button");
  return h(), H(ie(n.type), {
    class: z({ "lux-search-box": !0, rounded: n.corners === "rounded" })
  }, {
    default: P(() => [
      ae(e.$slots, "default", {}, () => [
        k(i, {
          id: "searchbox",
          name: n.name,
          label: "Search",
          "hide-label": !0,
          size: "large",
          class: "default-input",
          value: n.modelValue,
          onInput: t[0] || (t[0] = (u) => e.$emit("update:modelValue", u.target.value))
        }, null, 8, ["name", "value"]),
        k(l, {
          type: "submit",
          variation: "icon",
          size: "medium",
          icon: "search",
          class: "default-button"
        })
      ], !0)
    ]),
    _: 3
  }, 8, ["class"]);
}
const qS = /* @__PURE__ */ S(WS, [["render", US], ["__scopeId", "data-v-fa20b998"]]), GS = {
  name: "LuxAlert",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  metaInfo: {
    title: "Global alert message to user.",
    htmlAttrs: {
      lang: "en"
    }
  },
  data: function() {
    return {
      alertMessage: "Something happened, but we're not sure what.",
      show: !0
    };
  },
  computed: {
    isSuccess() {
      return this.status === "success";
    },
    isInfo() {
      return this.status === "info";
    },
    isWarning() {
      return this.status === "warning";
    },
    isError() {
      return this.status === "error";
    },
    isFullScreen() {
      return this.type === "alert";
    }
  },
  props: {
    /**
     * The intent of the message. Valid options: `alert, indicator`. Alerts are full page and indicators are “inline”.
     */
    type: {
      type: String,
      default: "indicator",
      validator: (e) => e.match(/(alert|indicator)/)
    },
    /**
     * Severity of the message. Valid options: `info, warning, success, error`
     */
    status: {
      type: String,
      default: "info",
      validator: (e) => e.match(/(info|warning|success|error)/)
    },
    /**
     * Automatically hides the notification after 2 seconds.
     */
    autoclear: {
      type: Boolean,
      default: !1
    },
    /**
     * The number of seconds to wait before autoclearing the
     * notification.  This prop has no effect if autoclear
     * is not true.
     */
    autoclearSeconds: {
      type: Number,
      default: 2
    },
    /**
     * User can manually hide the notification.  This emits a dismissed
     * event that you can bind to if needed (for example, if you want to
     * record that the user hid the notification in a database or localStorage)
     */
    dismissible: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    hideAlert() {
      this.show = !1, this.$emit("dismissed");
    }
  },
  mounted() {
    this.autoclear && setTimeout(() => {
      this.show = !1;
    }, this.autoclearSeconds * 1e3);
  },
  emits: ["dismissed"]
};
function KS(e, t, n, a, r, s) {
  return h(), H($n, { name: "fade" }, {
    default: P(() => [
      e.show ? (h(), g("div", {
        key: 0,
        class: z(["lux-alert", {
          "lux-alert-dismissible": n.dismissible,
          "lux-alert-success": s.isSuccess,
          "lux-alert-warning": s.isWarning,
          "lux-alert-error": s.isError,
          "lux-alert-info": s.isInfo,
          "lux-alert-fullscreen": s.isFullScreen
        }]),
        role: "alert"
      }, [
        o("span", null, [
          ae(e.$slots, "default", {}, () => [
            me(j(e.alertMessage), 1)
          ])
        ]),
        n.dismissible ? (h(), g("button", {
          key: 0,
          type: "button",
          class: "lux-close",
          "data-dismiss": "alert",
          "aria-label": "Close",
          onClick: t[0] || (t[0] = (i) => s.hideAlert())
        }, t[1] || (t[1] = [
          o("span", { "aria-hidden": "true" }, "×", -1)
        ]))) : B("", !0)
      ], 2)) : B("", !0)
    ]),
    _: 3
  });
}
const ZS = /* @__PURE__ */ S(GS, [["render", KS]]), XS = {
  name: "LuxDropdownMenu",
  status: "ready",
  release: "1.0.0",
  type: "Pattern",
  emits: ["button-clicked", "menu-item-clicked"],
  data: function() {
    return {
      isVisible: !1
    };
  },
  props: {
    element: {
      type: String,
      default: "div"
    },
    /**
     * The menu items in the dropdown
     */
    buttonLabel: {
      type: String,
      default: "Dropdown"
    },
    /**
     * Whether the dropdown includes links or buttons as menu items
     * `links, buttons`
     */
    type: {
      type: String,
      default: "buttons",
      validator: (e) => e.match(/(links|buttons)/)
    },
    /**
     * An array of item (and sub-item) options for the DropdownMenu. Properties
     * for menuItems are described in the LuxMenuBar pattern.
     */
    menuItems: {
      type: Array,
      default() {
        return ["div"];
      }
    },
    /**
     * Alignment of menu items (not currently working)
     * `left, right`
     */
    align: {
      type: String,
      default: "left",
      validator: (e) => e.match(/(left|right)/)
    },
    /**
     * Sets the size of the dropdown menu area `small, medium, large`
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    }
  },
  methods: {
    hide: function(e) {
      this.isVisible = !1;
    },
    buttonClicked(e) {
      this.isVisible = !this.isVisible, this.$emit("button-clicked", e);
    },
    menuItemClicked(e) {
      this.isVisible = !1, this.$emit("menu-item-clicked", e);
    }
  },
  directives: {
    "click-outside": {
      beforeMount: function(e, t) {
        const n = t.modifiers.bubble, a = (r) => {
          (n || !e.contains(r.target) && e !== r.target) && t.value(r);
        };
        e.__vueClickOutside__ = a, document.addEventListener("click", a);
      },
      unmounted: function(e, t) {
        document.removeEventListener("click", e.__vueClickOutside__), e.__vueClickOutside__ = null;
      }
    }
  }
};
function JS(e, t, n, a, r, s) {
  const i = Y("lux-input-button"), l = Y("lux-menu-bar"), u = Tr("click-outside");
  return ht((h(), H(ie(n.element), {
    class: z(["lux-dropdown-menu", n.size])
  }, {
    default: P(() => [
      k(i, {
        onButtonClicked: t[0] || (t[0] = (c) => s.buttonClicked(c)),
        class: "lux-dropdown-button",
        variation: "dropdown",
        size: n.size
      }, {
        default: P(() => [
          me(j(n.buttonLabel), 1)
        ]),
        _: 1
      }, 8, ["size"]),
      k(l, {
        class: z({ "lux-show": e.isVisible }),
        onMenuItemClicked: t[1] || (t[1] = (c) => s.menuItemClicked(c)),
        type: n.type,
        active: "All",
        "menu-items": n.menuItems
      }, null, 8, ["class", "type", "menu-items"])
    ]),
    _: 1
  }, 8, ["class"])), [
    [u, s.hide]
  ]);
}
const QS = /* @__PURE__ */ S(XS, [["render", JS], ["__scopeId", "data-v-c9da56f4"]]), eM = {
  name: "LuxAutocompleteInput",
  status: "prototype",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The available items in the autocomplete. This can be a simple array of strings
     * or an array of objects with an id and a label, if id is needed.
     */
    items: {
      type: Array,
      required: !1,
      default() {
        return [""];
      }
    },
    /**
     * The placeholder value for the form input field.
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * The default value for the form input field.
     */
    defaultValue: {
      type: String,
      default: ""
    },
    /**
     * The label of the form input field.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Visually hides the label of the form input field.
     */
    hideLabel: {
      type: Boolean,
      default: !1
    },
    /**
     * The id of the form input field.
     */
    id: {
      type: String,
      default: ""
    },
    /**
     * The name of the form input field.
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Is the data given by an outside ajax request?
     */
    isAsync: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Whether the form input field is required or not.
     * `true, false`
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether the input is focused or not
     * `true, false`
     */
    focused: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["input"],
  data() {
    return {
      isOpen: !1,
      results: [],
      search: "",
      inputValue: "",
      isLoading: !1,
      arrowCounter: -1
    };
  },
  methods: {
    onChange() {
      this.$emit("input", this.search), this.isAsync ? this.isLoading = !0 : (this.filterResults(), this.isOpen = !0);
    },
    filterResults() {
      if (this.items.length && typeof this.items[0] == "object") {
        let e = this.items.filter(
          (t) => t.label.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        );
        this.results = e.map((t) => t.label);
      } else
        this.results = this.items.filter(
          (e) => e.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        );
    },
    setResult(e) {
      if (this.search = e, this.inputValue = e, this.isOpen = !1, this.items.length && typeof this.items[0] == "object") {
        let t = this.items.find((n) => n.label === e);
        typeof t < "u" && (this.inputValue = t.id);
      }
    },
    onArrowDown() {
      this.arrowCounter < this.results.length && (this.arrowCounter = this.arrowCounter + 1);
    },
    onArrowUp() {
      this.arrowCounter > 0 && (this.arrowCounter = this.arrowCounter - 1);
    },
    onEnter() {
      this.setResult(this.results[this.arrowCounter]), this.isOpen = !1, this.arrowCounter = -1;
    },
    onEscape() {
      this.setResult(this.search), this.isOpen = !1;
    },
    handleClickOutside(e) {
      this.$el.contains(e.target) || (this.setResult(this.search), this.isOpen = !1, this.arrowCounter = -1);
    }
  },
  watch: {
    // Once the items content changes, it means the parent component
    // provided the needed data
    items: function(e, t) {
      this.isAsync && (this.results = e, this.isOpen = !0, this.isLoading = !1);
    }
  },
  created() {
    this.setResult(this.defaultValue);
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    let e = this;
    e.$nextTick(function() {
      e.focused && this.$refs.autoComplete.focus();
    });
  },
  unmounted() {
    document.removeEventListener("click", this.handleClickOutside);
  }
}, tM = { class: "lux-autocomplete" }, nM = { class: "lux-autocomplete-input" }, aM = ["required"], rM = { class: "lux-autocomplete-results" }, sM = {
  key: 0,
  class: "loading"
}, iM = ["onClick"], oM = ["name", "id", "value"];
function lM(e, t, n, a, r, s) {
  return h(), g("div", tM, [
    n.label ? (h(), g("label", {
      key: 0,
      class: z({ "lux-hidden": n.hideLabel })
    }, j(n.label), 3)) : B("", !0),
    o("div", nM, [
      ht(o("input", {
        id: "displayInput",
        autocomplete: "off",
        ref: "autoComplete",
        type: "text",
        onInput: t[0] || (t[0] = (...i) => s.onChange && s.onChange(...i)),
        onClick: t[1] || (t[1] = (...i) => s.onChange && s.onChange(...i)),
        onFocus: t[2] || (t[2] = (...i) => s.onChange && s.onChange(...i)),
        "onUpdate:modelValue": t[3] || (t[3] = (i) => r.search = i),
        onKeydown: [
          t[4] || (t[4] = Oe((...i) => s.onArrowDown && s.onArrowDown(...i), ["down"])),
          t[5] || (t[5] = Oe((...i) => s.onArrowUp && s.onArrowUp(...i), ["up"])),
          t[6] || (t[6] = Oe((...i) => s.onEnter && s.onEnter(...i), ["enter"])),
          t[7] || (t[7] = Oe((...i) => s.onEscape && s.onEscape(...i), ["esc"])),
          t[8] || (t[8] = Oe((...i) => s.onEscape && s.onEscape(...i), ["tab"]))
        ],
        onBlur: t[9] || (t[9] = (...i) => s.onEscape && s.onEscape(...i)),
        required: n.required
      }, null, 40, aM), [
        [Vl, r.search]
      ]),
      ht(o("ul", rM, [
        r.isLoading ? (h(), g("li", sM, "Loading results...")) : (h(!0), g(se, { key: 1 }, fe(r.results, (i, l) => (h(), g("li", {
          key: l,
          onClick: (u) => s.setResult(i),
          class: z(["lux-autocomplete-result", { "is-active": l === r.arrowCounter }])
        }, j(i), 11, iM))), 128))
      ], 512), [
        [S0, r.isOpen]
      ]),
      o("input", {
        name: n.name,
        id: n.id,
        type: "hidden",
        value: r.inputValue,
        "data-input-value": ""
      }, null, 8, oM)
    ])
  ]);
}
const uM = /* @__PURE__ */ S(eM, [["render", lM]]), cM = {
  name: "LuxTag",
  status: "ready",
  release: "1.0.0",
  type: "Element",
  props: {
    /**
     * The type of tag. The `filter` option includes
     * a remove icon inside the tag.
     */
    type: {
      type: String,
      default: "tag",
      validator: (e) => e.match(/(tag|filter)/)
    },
    /**
     * Tag items are tags to be displayed to the user.
     * You can pass a `name` and `href` in a tag-items array.
     */
    tagItems: {
      required: !0,
      type: Array
    },
    /**
     * Sets the horizontal alignment of the item. `start`, `center`, or `end`.
     */
    horizontal: {
      type: String,
      validator: (e) => e.match(/(start|center|end)/)
    },
    /**
     * Sets the size of the item.
     */
    size: {
      type: String,
      default: "medium",
      validator: (e) => e.match(/(small|medium|large)/)
    },
    /**
     * Sets the label of the list.
     */
    label: {
      type: String,
      default: ""
    }
  },
  methods: {
    isPill(e) {
      return e === "pill";
    },
    componentType(e) {
      return e.hasOwnProperty("href") ? "a" : "span";
    }
  }
}, dM = ["aria-label"], fM = {
  key: 0,
  class: "prepend-icon"
}, hM = ["innerHTML"], pM = {
  key: 1,
  class: "append-icon"
};
function vM(e, t, n, a, r, s) {
  const i = Y("lux-icon-alert"), l = Y("lux-icon-approved"), u = Y("lux-icon-denied"), c = Y("lux-icon-clock"), d = Y("lux-icon-refresh"), f = Y("lux-icon-reported"), v = Y("lux-icon-base");
  return h(), g("ul", {
    class: z(["lux-tag", [n.type, n.horizontal]]),
    "aria-label": n.label
  }, [
    (h(!0), g(se, null, fe(n.tagItems, (p, y) => (h(), g("li", { key: p }, [
      (h(), H(ie(s.componentType(p)), {
        key: y,
        href: p.href,
        class: z(["lux-tag-item", n.size, p.color, { pill: s.isPill(p.style) }])
      }, {
        default: P(() => [
          p.icon ? (h(), g("span", fM, [
            k(v, {
              width: "14",
              height: "14"
            }, {
              default: P(() => [
                p.icon === "alert" ? (h(), H(i, { key: 0 })) : B("", !0),
                p.icon === "approved" ? (h(), H(l, { key: 1 })) : B("", !0),
                p.icon === "denied" ? (h(), H(u, { key: 2 })) : B("", !0),
                p.icon === "clock" ? (h(), H(c, { key: 3 })) : B("", !0),
                p.icon === "refresh" ? (h(), H(d, { key: 4 })) : B("", !0),
                p.icon === "reported" ? (h(), H(f, { key: 5 })) : B("", !0)
              ]),
              _: 2
            }, 1024)
          ])) : B("", !0),
          o("span", {
            innerHTML: p.name
          }, null, 8, hM),
          n.type === "filter" ? (h(), g("span", pM, [
            k(v, {
              width: "14",
              height: "14"
            }, {
              default: P(() => [
                k(u)
              ]),
              _: 1
            })
          ])) : B("", !0)
        ]),
        _: 2
      }, 1032, ["href", "class"]))
    ]))), 128))
  ], 10, dM);
}
const mM = /* @__PURE__ */ S(cM, [["render", vM]]), dr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LuxAlert: ZS,
  LuxAutocompleteInput: uM,
  LuxBanner: Dd,
  LuxCard: Id,
  LuxCounter: h3,
  LuxDataTable: $3,
  LuxDatePicker: hC,
  LuxDisclosure: mC,
  LuxDropdownMenu: QS,
  LuxGallery: dx,
  LuxGridContainer: px,
  LuxGridItem: gx,
  LuxHeading: _x,
  LuxHyperlink: Yr,
  LuxIconAdd: Rl,
  LuxIconAlert: ci,
  LuxIconApproved: di,
  LuxIconArrowDown: fi,
  LuxIconArrowRight: Zl,
  LuxIconArrowUp: hi,
  LuxIconAscending: t2,
  LuxIconBase: In,
  LuxIconClock: c2,
  LuxIconConsulting: h2,
  LuxIconDelivery: m2,
  LuxIconDenied: pi,
  LuxIconDerivativesHealthy: w2,
  LuxIconDerivativesUnhealthy: x2,
  LuxIconDescending: D2,
  LuxIconEdit: O2,
  LuxIconExclamation: T2,
  LuxIconFile: z2,
  LuxIconFileHealthy: H2,
  LuxIconFileUnhealthy: B2,
  LuxIconFilter: W2,
  LuxIconFlower: G2,
  LuxIconGlobe: X2,
  LuxIconHospital: eu,
  LuxIconInfo: ru,
  LuxIconLockClose: ou,
  LuxIconLockOpen: cu,
  LuxIconNewTab: vi,
  LuxIconNote: vu,
  LuxIconPerson: yu,
  LuxIconPicture: wu,
  LuxIconQuestion: xu,
  LuxIconQuestionFilled: Du,
  LuxIconRefresh: Ou,
  LuxIconRelax: Tu,
  LuxIconReportHealthy: zu,
  LuxIconReportRemove: Hu,
  LuxIconReportUnhealthy: Bu,
  LuxIconReportUserHome: Wu,
  LuxIconReported: Gu,
  LuxIconResearch: Xu,
  LuxIconScales: ec,
  LuxIconSearch: rc,
  LuxIconUnsorted: oc,
  LuxIconVacation: cc,
  LuxIconView: hc,
  LuxInputButton: Pr,
  LuxInputCheckbox: Mc,
  LuxInputMultiselect: Qc,
  LuxInputRadio: o5,
  LuxInputSelect: p5,
  LuxInputText: zr,
  LuxLibraryFooter: fS,
  LuxLibraryHeader: Nx,
  LuxLibraryLogo: x1,
  LuxLoader: xx,
  LuxLogoFacebook: Vr,
  LuxLogoFriends: Rr,
  LuxLogoGovDocs: Nr,
  LuxLogoInstagram: El,
  LuxLogoLibrary: Ol,
  LuxLogoLibraryIcon: NS,
  LuxLogoUniversity: jS,
  LuxLogoUniversityWhite: Tl,
  LuxLogoX: Hr,
  LuxMediaImage: _S,
  LuxMenuBar: TS,
  LuxSearchBox: qS,
  LuxSpacer: Il,
  LuxSpecialCollectionsFooter: mS,
  LuxTag: mM,
  LuxTextStyle: zS,
  LuxUniversityFooter: Al,
  LuxWrapper: Ya,
  _LuxCardContent: S5,
  _LuxCardHeader: k5,
  _LuxCardMedia: I5,
  _LuxHamburger: gi,
  _LuxLibraryContactInfo: wi,
  _LuxLibraryContactInfoOld: $i,
  _LuxMenuBarLabel: yi,
  _LuxSubscribeNewsletter: bi,
  _LuxUniversityAccessibility: W5,
  _LuxUniversityAccessibilityOld: _i,
  _LuxUniversityCopyright: Br,
  _LuxUniversityCopyrightOld: bd,
  _LuxUniversityPrivacyNotice: Ci
}, Symbol.toStringTag, { value: "Module" })), _M = {
  // Vue plugins must expose an install() method, see
  // https://vuejs.org/guide/reusability/plugins.html
  install(e, t) {
    gM(e), yM(e);
  }
};
function gM(e) {
  e.use(fC, {});
}
function yM(e) {
  for (const t in dr)
    e.component(dr[t].name, dr[t]);
}
export {
  ZS as LuxAlert,
  uM as LuxAutocompleteInput,
  Dd as LuxBanner,
  Id as LuxCard,
  h3 as LuxCounter,
  $3 as LuxDataTable,
  hC as LuxDatePicker,
  mC as LuxDisclosure,
  QS as LuxDropdownMenu,
  dx as LuxGallery,
  px as LuxGridContainer,
  gx as LuxGridItem,
  _x as LuxHeading,
  Yr as LuxHyperlink,
  Rl as LuxIconAdd,
  ci as LuxIconAlert,
  di as LuxIconApproved,
  fi as LuxIconArrowDown,
  Zl as LuxIconArrowRight,
  hi as LuxIconArrowUp,
  t2 as LuxIconAscending,
  In as LuxIconBase,
  c2 as LuxIconClock,
  h2 as LuxIconConsulting,
  m2 as LuxIconDelivery,
  pi as LuxIconDenied,
  w2 as LuxIconDerivativesHealthy,
  x2 as LuxIconDerivativesUnhealthy,
  D2 as LuxIconDescending,
  O2 as LuxIconEdit,
  T2 as LuxIconExclamation,
  z2 as LuxIconFile,
  H2 as LuxIconFileHealthy,
  B2 as LuxIconFileUnhealthy,
  W2 as LuxIconFilter,
  G2 as LuxIconFlower,
  X2 as LuxIconGlobe,
  eu as LuxIconHospital,
  ru as LuxIconInfo,
  ou as LuxIconLockClose,
  cu as LuxIconLockOpen,
  vi as LuxIconNewTab,
  vu as LuxIconNote,
  yu as LuxIconPerson,
  wu as LuxIconPicture,
  xu as LuxIconQuestion,
  Du as LuxIconQuestionFilled,
  Ou as LuxIconRefresh,
  Tu as LuxIconRelax,
  zu as LuxIconReportHealthy,
  Hu as LuxIconReportRemove,
  Bu as LuxIconReportUnhealthy,
  Wu as LuxIconReportUserHome,
  Gu as LuxIconReported,
  Xu as LuxIconResearch,
  ec as LuxIconScales,
  rc as LuxIconSearch,
  oc as LuxIconUnsorted,
  cc as LuxIconVacation,
  hc as LuxIconView,
  Pr as LuxInputButton,
  Mc as LuxInputCheckbox,
  Qc as LuxInputMultiselect,
  o5 as LuxInputRadio,
  p5 as LuxInputSelect,
  zr as LuxInputText,
  fS as LuxLibraryFooter,
  Nx as LuxLibraryHeader,
  x1 as LuxLibraryLogo,
  xx as LuxLoader,
  Vr as LuxLogoFacebook,
  Rr as LuxLogoFriends,
  Nr as LuxLogoGovDocs,
  El as LuxLogoInstagram,
  Ol as LuxLogoLibrary,
  NS as LuxLogoLibraryIcon,
  jS as LuxLogoUniversity,
  Tl as LuxLogoUniversityWhite,
  Hr as LuxLogoX,
  _S as LuxMediaImage,
  TS as LuxMenuBar,
  qS as LuxSearchBox,
  Il as LuxSpacer,
  mS as LuxSpecialCollectionsFooter,
  mM as LuxTag,
  zS as LuxTextStyle,
  Al as LuxUniversityFooter,
  Ya as LuxWrapper,
  S5 as _LuxCardContent,
  k5 as _LuxCardHeader,
  I5 as _LuxCardMedia,
  gi as _LuxHamburger,
  wi as _LuxLibraryContactInfo,
  $i as _LuxLibraryContactInfoOld,
  yi as _LuxMenuBarLabel,
  bi as _LuxSubscribeNewsletter,
  W5 as _LuxUniversityAccessibility,
  _i as _LuxUniversityAccessibilityOld,
  Br as _LuxUniversityCopyright,
  bd as _LuxUniversityCopyrightOld,
  Ci as _LuxUniversityPrivacyNotice,
  _M as default
};
